var ml = Object.create
var Os = Object.defineProperty
var pl = Object.getOwnPropertyDescriptor
var gl = Object.getOwnPropertyNames
var vl = Object.getPrototypeOf,
  yl = Object.prototype.hasOwnProperty
var Fn = (t) => {
  throw TypeError(t)
}
var bl = (t, r, e) =>
  r in t
    ? Os(t, r, { enumerable: !0, configurable: !0, writable: !0, value: e })
    : (t[r] = e)
var J = (t, r) => () => (t && (r = t((t = 0))), r)
var Tl = (t, r) => () => (r || t((r = { exports: {} }).exports, r), r.exports),
  Vn = (t, r) => {
    for (var e in r) Os(t, e, { get: r[e], enumerable: !0 })
  },
  Sl = (t, r, e, s) => {
    if ((r && typeof r == 'object') || typeof r == 'function')
      for (let i of gl(r))
        !yl.call(t, i) &&
          i !== e &&
          Os(t, i, {
            get: () => r[i],
            enumerable: !(s = pl(r, i)) || s.enumerable,
          })
    return t
  }
var Rs = (t, r, e) => (
  (e = t != null ? ml(vl(t)) : {}),
  Sl(
    r || !t || !t.__esModule
      ? Os(e, 'default', { value: t, enumerable: !0 })
      : e,
    t,
  )
)
var b = (t, r, e) => bl(t, typeof r != 'symbol' ? r + '' : r, e),
  El = (t, r, e) => r.has(t) || Fn('Cannot ' + e)
var _n = (t, r, e) =>
  r.has(t)
    ? Fn('Cannot add the same private member more than once')
    : r instanceof WeakSet
      ? r.add(t)
      : r.set(t, e)
var xe = (t, r, e) => (El(t, r, 'access private method'), e)
function wa(t) {
  return (
    t !== null &&
    typeof t == 'object' &&
    'constructor' in t &&
    t.constructor === Object
  )
}
function Qi(t = {}, r = {}) {
  let e = ['__proto__', 'constructor', 'prototype']
  Object.keys(r)
    .filter((s) => e.indexOf(s) < 0)
    .forEach((s) => {
      typeof t[s] > 'u'
        ? (t[s] = r[s])
        : wa(r[s]) && wa(t[s]) && Object.keys(r[s]).length > 0 && Qi(t[s], r[s])
    })
}
function te() {
  let t = typeof document < 'u' ? document : {}
  return (Qi(t, Ma), t)
}
function ee() {
  let t = typeof window < 'u' ? window : {}
  return (Qi(t, td), t)
}
var Ma,
  td,
  Ve = J(() => {
    Ma = {
      body: {},
      addEventListener() {},
      removeEventListener() {},
      activeElement: { blur() {}, nodeName: '' },
      querySelector() {
        return null
      },
      querySelectorAll() {
        return []
      },
      getElementById() {
        return null
      },
      createEvent() {
        return { initEvent() {} }
      },
      createElement() {
        return {
          children: [],
          childNodes: [],
          style: {},
          setAttribute() {},
          getElementsByTagName() {
            return []
          },
        }
      },
      createElementNS() {
        return {}
      },
      importNode() {
        return null
      },
      location: {
        hash: '',
        host: '',
        hostname: '',
        href: '',
        origin: '',
        pathname: '',
        protocol: '',
        search: '',
      },
    }
    td = {
      document: Ma,
      navigator: { userAgent: '' },
      location: {
        hash: '',
        host: '',
        hostname: '',
        href: '',
        origin: '',
        pathname: '',
        protocol: '',
        search: '',
      },
      history: { replaceState() {}, pushState() {}, go() {}, back() {} },
      CustomEvent: function () {
        return this
      },
      addEventListener() {},
      removeEventListener() {},
      getComputedStyle() {
        return {
          getPropertyValue() {
            return ''
          },
        }
      },
      Image() {},
      Date() {},
      screen: {},
      setTimeout() {},
      clearTimeout() {},
      matchMedia() {
        return {}
      },
      requestAnimationFrame(t) {
        return typeof setTimeout > 'u' ? (t(), null) : setTimeout(t, 0)
      },
      cancelAnimationFrame(t) {
        typeof setTimeout > 'u' || clearTimeout(t)
      },
    }
  })
function gt(t = '') {
  return t
    .trim()
    .split(' ')
    .filter((r) => !!r.trim())
}
function La(t) {
  let r = t
  Object.keys(r).forEach((e) => {
    try {
      r[e] = null
    } catch {}
    try {
      delete r[e]
    } catch {}
  })
}
function rt(t, r = 0) {
  return setTimeout(t, r)
}
function Le() {
  return Date.now()
}
function rd(t) {
  let r = ee(),
    e
  return (
    r.getComputedStyle && (e = r.getComputedStyle(t, null)),
    !e && t.currentStyle && (e = t.currentStyle),
    e || (e = t.style),
    e
  )
}
function es(t, r = 'x') {
  let e = ee(),
    s,
    i,
    n,
    a = rd(t)
  return (
    e.WebKitCSSMatrix
      ? ((i = a.transform || a.webkitTransform),
        i.split(',').length > 6 &&
          (i = i
            .split(', ')
            .map((l) => l.replace(',', '.'))
            .join(', ')),
        (n = new e.WebKitCSSMatrix(i === 'none' ? '' : i)))
      : ((n =
          a.MozTransform ||
          a.OTransform ||
          a.MsTransform ||
          a.msTransform ||
          a.transform ||
          a
            .getPropertyValue('transform')
            .replace('translate(', 'matrix(1, 0, 0, 1,')),
        (s = n.toString().split(','))),
    r === 'x' &&
      (e.WebKitCSSMatrix
        ? (i = n.m41)
        : s.length === 16
          ? (i = parseFloat(s[12]))
          : (i = parseFloat(s[4]))),
    r === 'y' &&
      (e.WebKitCSSMatrix
        ? (i = n.m42)
        : s.length === 16
          ? (i = parseFloat(s[13]))
          : (i = parseFloat(s[5]))),
    i || 0
  )
}
function dr(t) {
  return (
    typeof t == 'object' &&
    t !== null &&
    t.constructor &&
    Object.prototype.toString.call(t).slice(8, -1) === 'Object'
  )
}
function sd(t) {
  return typeof window < 'u' && typeof window.HTMLElement < 'u'
    ? t instanceof HTMLElement
    : t && (t.nodeType === 1 || t.nodeType === 11)
}
function Oe(...t) {
  let r = Object(t[0])
  for (let e = 1; e < t.length; e += 1) {
    let s = t[e]
    if (s != null && !sd(s)) {
      let i = Object.keys(Object(s)).filter(
        (n) => n !== '__proto__' && n !== 'constructor' && n !== 'prototype',
      )
      for (let n = 0, a = i.length; n < a; n += 1) {
        let l = i[n],
          o = Object.getOwnPropertyDescriptor(s, l)
        o !== void 0 &&
          o.enumerable &&
          (dr(r[l]) && dr(s[l])
            ? s[l].__swiper__
              ? (r[l] = s[l])
              : Oe(r[l], s[l])
            : !dr(r[l]) && dr(s[l])
              ? ((r[l] = {}), s[l].__swiper__ ? (r[l] = s[l]) : Oe(r[l], s[l]))
              : (r[l] = s[l]))
      }
    }
  }
  return r
}
function vt(t, r, e) {
  t.style.setProperty(r, e)
}
function Ji({ swiper: t, targetPosition: r, side: e }) {
  let s = ee(),
    i = -t.translate,
    n = null,
    a,
    l = t.params.speed
  ;((t.wrapperEl.style.scrollSnapType = 'none'),
    s.cancelAnimationFrame(t.cssModeFrameID))
  let o = r > i ? 'next' : 'prev',
    u = (f, m) => (o === 'next' && f >= m) || (o === 'prev' && f <= m),
    h = () => {
      ;((a = new Date().getTime()), n === null && (n = a))
      let f = Math.max(Math.min((a - n) / l, 1), 0),
        m = 0.5 - Math.cos(f * Math.PI) / 2,
        c = i + m * (r - i)
      if ((u(c, r) && (c = r), t.wrapperEl.scrollTo({ [e]: c }), u(c, r))) {
        ;((t.wrapperEl.style.overflow = 'hidden'),
          (t.wrapperEl.style.scrollSnapType = ''),
          setTimeout(() => {
            ;((t.wrapperEl.style.overflow = ''),
              t.wrapperEl.scrollTo({ [e]: c }))
          }),
          s.cancelAnimationFrame(t.cssModeFrameID))
        return
      }
      t.cssModeFrameID = s.requestAnimationFrame(h)
    }
  h()
}
function Re(t) {
  return (
    t.querySelector('.swiper-slide-transform') ||
    (t.shadowRoot && t.shadowRoot.querySelector('.swiper-slide-transform')) ||
    t
  )
}
function ne(t, r = '') {
  let e = ee(),
    s = [...t.children]
  return (
    e.HTMLSlotElement &&
      t instanceof HTMLSlotElement &&
      s.push(...t.assignedElements()),
    r ? s.filter((i) => i.matches(r)) : s
  )
}
function id(t, r) {
  let e = [r]
  for (; e.length > 0; ) {
    let s = e.shift()
    if (t === s) return !0
    e.push(
      ...s.children,
      ...(s.shadowRoot ? s.shadowRoot.children : []),
      ...(s.assignedElements ? s.assignedElements() : []),
    )
  }
}
function Ca(t, r) {
  let e = ee(),
    s = r.contains(t)
  return (
    !s &&
      e.HTMLSlotElement &&
      r instanceof HTMLSlotElement &&
      ((s = [...r.assignedElements()].includes(t)), s || (s = id(t, r))),
    s
  )
}
function ts(t) {
  try {
    console.warn(t)
    return
  } catch {}
}
function he(t, r = []) {
  let e = document.createElement(t)
  return (e.classList.add(...(Array.isArray(r) ? r : gt(r))), e)
}
function Dt(t) {
  let r = ee(),
    e = te(),
    s = t.getBoundingClientRect(),
    i = e.body,
    n = t.clientTop || i.clientTop || 0,
    a = t.clientLeft || i.clientLeft || 0,
    l = t === r ? r.scrollY : t.scrollTop,
    o = t === r ? r.scrollX : t.scrollLeft
  return { top: s.top + l - n, left: s.left + o - a }
}
function Aa(t, r) {
  let e = []
  for (; t.previousElementSibling; ) {
    let s = t.previousElementSibling
    ;(r ? s.matches(r) && e.push(s) : e.push(s), (t = s))
  }
  return e
}
function Ia(t, r) {
  let e = []
  for (; t.nextElementSibling; ) {
    let s = t.nextElementSibling
    ;(r ? s.matches(r) && e.push(s) : e.push(s), (t = s))
  }
  return e
}
function yt(t, r) {
  return ee().getComputedStyle(t, null).getPropertyValue(r)
}
function Et(t) {
  let r = t,
    e
  if (r) {
    for (e = 0; (r = r.previousSibling) !== null; ) r.nodeType === 1 && (e += 1)
    return e
  }
}
function Xe(t, r) {
  let e = [],
    s = t.parentElement
  for (; s; ) (r ? s.matches(r) && e.push(s) : e.push(s), (s = s.parentElement))
  return e
}
function xt(t, r) {
  function e(s) {
    s.target === t && (r.call(t, s), t.removeEventListener('transitionend', e))
  }
  r && t.addEventListener('transitionend', e)
}
function rs(t, r, e) {
  let s = ee()
  return e
    ? t[r === 'width' ? 'offsetWidth' : 'offsetHeight'] +
        parseFloat(
          s
            .getComputedStyle(t, null)
            .getPropertyValue(r === 'width' ? 'margin-right' : 'margin-top'),
        ) +
        parseFloat(
          s
            .getComputedStyle(t, null)
            .getPropertyValue(r === 'width' ? 'margin-left' : 'margin-bottom'),
        )
    : t.offsetWidth
}
function X(t) {
  return (Array.isArray(t) ? t : [t]).filter((r) => !!r)
}
function wt(t) {
  return (r) =>
    Math.abs(r) > 0 &&
    t.browser &&
    t.browser.need3dFix &&
    Math.abs(r) % 90 === 0
      ? r + 0.001
      : r
}
function Ce(t, r = '') {
  typeof trustedTypes < 'u'
    ? (t.innerHTML = trustedTypes
        .createPolicy('html', { createHTML: (e) => e })
        .createHTML(r))
    : (t.innerHTML = r)
}
var re = J(() => {
  Ve()
})
function nd() {
  let t = ee(),
    r = te()
  return {
    smoothScroll:
      r.documentElement &&
      r.documentElement.style &&
      'scrollBehavior' in r.documentElement.style,
    touch: !!(
      'ontouchstart' in t ||
      (t.DocumentTouch && r instanceof t.DocumentTouch)
    ),
  }
}
function Da() {
  return (Zi || (Zi = nd()), Zi)
}
function ad({ userAgent: t } = {}) {
  let r = Da(),
    e = ee(),
    s = e.navigator.platform,
    i = t || e.navigator.userAgent,
    n = { ios: !1, android: !1 },
    a = e.screen.width,
    l = e.screen.height,
    o = i.match(/(Android);?[\s\/]+([\d.]+)?/),
    u = i.match(/(iPad)(?!\1).*OS\s([\d_]+)/),
    h = i.match(/(iPod)(.*OS\s([\d_]+))?/),
    f = !u && i.match(/(iPhone\sOS|iOS)\s([\d_]+)/),
    m = s === 'Win32',
    c = s === 'MacIntel',
    d = [
      '1024x1366',
      '1366x1024',
      '834x1194',
      '1194x834',
      '834x1112',
      '1112x834',
      '768x1024',
      '1024x768',
      '820x1180',
      '1180x820',
      '810x1080',
      '1080x810',
    ]
  return (
    !u &&
      c &&
      r.touch &&
      d.indexOf(`${a}x${l}`) >= 0 &&
      ((u = i.match(/(Version)\/([\d.]+)/)),
      u || (u = [0, 1, '13_0_0']),
      (c = !1)),
    o && !m && ((n.os = 'android'), (n.android = !0)),
    (u || f || h) && ((n.os = 'ios'), (n.ios = !0)),
    n
  )
}
function Ba(t = {}) {
  return (en || (en = ad(t)), en)
}
function od() {
  let t = ee(),
    r = Ba(),
    e = !1
  function s() {
    let l = t.navigator.userAgent.toLowerCase()
    return (
      l.indexOf('safari') >= 0 &&
      l.indexOf('chrome') < 0 &&
      l.indexOf('android') < 0
    )
  }
  if (s()) {
    let l = String(t.navigator.userAgent)
    if (l.includes('Version/')) {
      let [o, u] = l
        .split('Version/')[1]
        .split(' ')[0]
        .split('.')
        .map((h) => Number(h))
      e = o < 16 || (o === 16 && u < 2)
    }
  }
  let i = /(iPhone|iPod|iPad).*AppleWebKit(?!.*Safari)/i.test(
      t.navigator.userAgent,
    ),
    n = s(),
    a = n || (i && r.ios)
  return { isSafari: e || n, needPerspectiveFix: e, need3dFix: a, isWebView: i }
}
function Fa() {
  return (tn || (tn = od()), tn)
}
function ld({ swiper: t, on: r, emit: e }) {
  let s = ee(),
    i = null,
    n = null,
    a = () => {
      !t || t.destroyed || !t.initialized || (e('beforeResize'), e('resize'))
    },
    l = () => {
      !t ||
        t.destroyed ||
        !t.initialized ||
        ((i = new ResizeObserver((h) => {
          n = s.requestAnimationFrame(() => {
            let { width: f, height: m } = t,
              c = f,
              d = m
            ;(h.forEach(({ contentBoxSize: g, contentRect: T, target: p }) => {
              ;(p && p !== t.el) ||
                ((c = T ? T.width : (g[0] || g).inlineSize),
                (d = T ? T.height : (g[0] || g).blockSize))
            }),
              (c !== f || d !== m) && a())
          })
        })),
        i.observe(t.el))
    },
    o = () => {
      ;(n && s.cancelAnimationFrame(n),
        i && i.unobserve && t.el && (i.unobserve(t.el), (i = null)))
    },
    u = () => {
      !t || t.destroyed || !t.initialized || e('orientationchange')
    }
  ;(r('init', () => {
    if (t.params.resizeObserver && typeof s.ResizeObserver < 'u') {
      l()
      return
    }
    ;(s.addEventListener('resize', a),
      s.addEventListener('orientationchange', u))
  }),
    r('destroy', () => {
      ;(o(),
        s.removeEventListener('resize', a),
        s.removeEventListener('orientationchange', u))
    }))
}
function cd({ swiper: t, extendParams: r, on: e, emit: s }) {
  let i = [],
    n = ee(),
    a = (u, h = {}) => {
      let f = n.MutationObserver || n.WebkitMutationObserver,
        m = new f((c) => {
          if (t.__preventObserver__) return
          if (c.length === 1) {
            s('observerUpdate', c[0])
            return
          }
          let d = function () {
            s('observerUpdate', c[0])
          }
          n.requestAnimationFrame
            ? n.requestAnimationFrame(d)
            : n.setTimeout(d, 0)
        })
      ;(m.observe(u, {
        attributes: typeof h.attributes > 'u' ? !0 : h.attributes,
        childList: t.isElement || (typeof h.childList > 'u' ? !0 : h).childList,
        characterData: typeof h.characterData > 'u' ? !0 : h.characterData,
      }),
        i.push(m))
    },
    l = () => {
      if (t.params.observer) {
        if (t.params.observeParents) {
          let u = Xe(t.hostEl)
          for (let h = 0; h < u.length; h += 1) a(u[h])
        }
        ;(a(t.hostEl, { childList: t.params.observeSlideChildren }),
          a(t.wrapperEl, { attributes: !1 }))
      }
    },
    o = () => {
      ;(i.forEach((u) => {
        u.disconnect()
      }),
        i.splice(0, i.length))
    }
  ;(r({ observer: !1, observeParents: !1, observeSlideChildren: !1 }),
    e('init', l),
    e('destroy', o))
}
function ud() {
  let t = this,
    r,
    e,
    s = t.el
  ;(typeof t.params.width < 'u' && t.params.width !== null
    ? (r = t.params.width)
    : (r = s.clientWidth),
    typeof t.params.height < 'u' && t.params.height !== null
      ? (e = t.params.height)
      : (e = s.clientHeight),
    !((r === 0 && t.isHorizontal()) || (e === 0 && t.isVertical())) &&
      ((r =
        r -
        parseInt(yt(s, 'padding-left') || 0, 10) -
        parseInt(yt(s, 'padding-right') || 0, 10)),
      (e =
        e -
        parseInt(yt(s, 'padding-top') || 0, 10) -
        parseInt(yt(s, 'padding-bottom') || 0, 10)),
      Number.isNaN(r) && (r = 0),
      Number.isNaN(e) && (e = 0),
      Object.assign(t, {
        width: r,
        height: e,
        size: t.isHorizontal() ? r : e,
      })))
}
function fd() {
  let t = this
  function r(k, E) {
    return parseFloat(k.getPropertyValue(t.getDirectionLabel(E)) || 0)
  }
  let e = t.params,
    { wrapperEl: s, slidesEl: i, rtlTranslate: n, wrongRTL: a } = t,
    l = t.virtual && e.virtual.enabled,
    o = l ? t.virtual.slides.length : t.slides.length,
    u = ne(i, `.${t.params.slideClass}, swiper-slide`),
    h = l ? t.virtual.slides.length : u.length,
    f = [],
    m = [],
    c = [],
    d = e.slidesOffsetBefore
  typeof d == 'function' && (d = e.slidesOffsetBefore.call(t))
  let g = e.slidesOffsetAfter
  typeof g == 'function' && (g = e.slidesOffsetAfter.call(t))
  let T = t.snapGrid.length,
    p = t.slidesGrid.length,
    v = t.size - d - g,
    y = e.spaceBetween,
    x = -d,
    L = 0,
    M = 0
  if (typeof v > 'u') return
  ;(typeof y == 'string' && y.indexOf('%') >= 0
    ? (y = (parseFloat(y.replace('%', '')) / 100) * v)
    : typeof y == 'string' && (y = parseFloat(y)),
    (t.virtualSize = -y - d - g),
    u.forEach((k) => {
      ;(n ? (k.style.marginLeft = '') : (k.style.marginRight = ''),
        (k.style.marginBottom = ''),
        (k.style.marginTop = ''))
    }),
    e.centeredSlides &&
      e.cssMode &&
      (vt(s, '--swiper-centered-offset-before', ''),
      vt(s, '--swiper-centered-offset-after', '')),
    e.cssMode &&
      (vt(s, '--swiper-slides-offset-before', `${d}px`),
      vt(s, '--swiper-slides-offset-after', `${g}px`)))
  let R = e.grid && e.grid.rows > 1 && t.grid
  R ? t.grid.initSlides(u) : t.grid && t.grid.unsetSlides()
  let w,
    B =
      e.slidesPerView === 'auto' &&
      e.breakpoints &&
      Object.keys(e.breakpoints).filter(
        (k) => typeof e.breakpoints[k].slidesPerView < 'u',
      ).length > 0
  for (let k = 0; k < h; k += 1) {
    w = 0
    let E = u[k]
    if (
      !(E && (R && t.grid.updateSlide(k, E, u), yt(E, 'display') === 'none'))
    ) {
      if (l && e.slidesPerView === 'auto')
        (e.virtual.slidesPerViewAutoSlideSize &&
          (w = e.virtual.slidesPerViewAutoSlideSize),
          w &&
            E &&
            (e.roundLengths && (w = Math.floor(w)),
            (E.style[t.getDirectionLabel('width')] = `${w}px`)))
      else if (e.slidesPerView === 'auto') {
        B && (E.style[t.getDirectionLabel('width')] = '')
        let C = getComputedStyle(E),
          P = E.style.transform,
          H = E.style.webkitTransform
        if (
          (P && (E.style.transform = 'none'),
          H && (E.style.webkitTransform = 'none'),
          e.roundLengths)
        )
          w = t.isHorizontal() ? rs(E, 'width', !0) : rs(E, 'height', !0)
        else {
          let $ = r(C, 'width'),
            I = r(C, 'padding-left'),
            A = r(C, 'padding-right'),
            O = r(C, 'margin-left'),
            q = r(C, 'margin-right'),
            G = C.getPropertyValue('box-sizing')
          if (G && G === 'border-box') w = $ + O + q
          else {
            let { clientWidth: Q, offsetWidth: Ae } = E
            w = $ + I + A + O + q + (Ae - Q)
          }
        }
        ;(P && (E.style.transform = P),
          H && (E.style.webkitTransform = H),
          e.roundLengths && (w = Math.floor(w)))
      } else
        ((w = (v - (e.slidesPerView - 1) * y) / e.slidesPerView),
          e.roundLengths && (w = Math.floor(w)),
          E && (E.style[t.getDirectionLabel('width')] = `${w}px`))
      ;(E && (E.swiperSlideSize = w),
        c.push(w),
        e.centeredSlides
          ? ((x = x + w / 2 + L / 2 + y),
            L === 0 && k !== 0 && (x = x - v / 2 - y),
            k === 0 && (x = x - v / 2 - y),
            Math.abs(x) < 1 / 1e3 && (x = 0),
            e.roundLengths && (x = Math.floor(x)),
            M % e.slidesPerGroup === 0 && f.push(x),
            m.push(x))
          : (e.roundLengths && (x = Math.floor(x)),
            (M - Math.min(t.params.slidesPerGroupSkip, M)) %
              t.params.slidesPerGroup ===
              0 && f.push(x),
            m.push(x),
            (x = x + w + y)),
        (t.virtualSize += w + y),
        (L = w),
        (M += 1))
    }
  }
  if (
    ((t.virtualSize = Math.max(t.virtualSize, v) + g),
    n &&
      a &&
      (e.effect === 'slide' || e.effect === 'coverflow') &&
      (s.style.width = `${t.virtualSize + y}px`),
    e.setWrapperSize &&
      (s.style[t.getDirectionLabel('width')] = `${t.virtualSize + y}px`),
    R && t.grid.updateWrapperSize(w, f),
    !e.centeredSlides)
  ) {
    let k = e.slidesPerView !== 'auto' && e.slidesPerView % 1 !== 0,
      E = e.snapToSlideEdge && !e.loop && (e.slidesPerView === 'auto' || k),
      C = f.length
    if (E) {
      let H
      if (e.slidesPerView === 'auto') {
        H = 1
        let $ = 0
        for (
          let I = c.length - 1;
          I >= 0 && (($ += c[I] + (I < c.length - 1 ? y : 0)), $ <= v);
          I -= 1
        )
          H = c.length - I
      } else H = Math.floor(e.slidesPerView)
      C = Math.max(h - H, 0)
    }
    let P = []
    for (let H = 0; H < f.length; H += 1) {
      let $ = f[H]
      ;(e.roundLengths && ($ = Math.floor($)),
        E ? H <= C && P.push($) : f[H] <= t.virtualSize - v && P.push($))
    }
    ;((f = P),
      Math.floor(t.virtualSize - v) - Math.floor(f[f.length - 1]) > 1 &&
        (E || f.push(t.virtualSize - v)))
  }
  if (l && e.loop) {
    let k = c[0] + y
    if (e.slidesPerGroup > 1) {
      let E = Math.ceil(
          (t.virtual.slidesBefore + t.virtual.slidesAfter) / e.slidesPerGroup,
        ),
        C = k * e.slidesPerGroup
      for (let P = 0; P < E; P += 1) f.push(f[f.length - 1] + C)
    }
    for (let E = 0; E < t.virtual.slidesBefore + t.virtual.slidesAfter; E += 1)
      (e.slidesPerGroup === 1 && f.push(f[f.length - 1] + k),
        m.push(m[m.length - 1] + k),
        (t.virtualSize += k))
  }
  if ((f.length === 0 && (f = [0]), y !== 0)) {
    let k =
      t.isHorizontal() && n ? 'marginLeft' : t.getDirectionLabel('marginRight')
    u.filter((E, C) =>
      !e.cssMode || e.loop ? !0 : C !== u.length - 1,
    ).forEach((E) => {
      E.style[k] = `${y}px`
    })
  }
  if (e.centeredSlides && e.centeredSlidesBounds) {
    let k = 0
    ;(c.forEach((C) => {
      k += C + (y || 0)
    }),
      (k -= y))
    let E = k > v ? k - v : 0
    f = f.map((C) => (C <= 0 ? -d : C > E ? E + g : C))
  }
  if (e.centerInsufficientSlides) {
    let k = 0
    if (
      (c.forEach((E) => {
        k += E + (y || 0)
      }),
      (k -= y),
      k < v)
    ) {
      let E = (v - k) / 2
      ;(f.forEach((C, P) => {
        f[P] = C - E
      }),
        m.forEach((C, P) => {
          m[P] = C + E
        }))
    }
  }
  if (
    (Object.assign(t, {
      slides: u,
      snapGrid: f,
      slidesGrid: m,
      slidesSizesGrid: c,
    }),
    e.centeredSlides && e.cssMode && !e.centeredSlidesBounds)
  ) {
    ;(vt(s, '--swiper-centered-offset-before', `${-f[0]}px`),
      vt(
        s,
        '--swiper-centered-offset-after',
        `${t.size / 2 - c[c.length - 1] / 2}px`,
      ))
    let k = -t.snapGrid[0],
      E = -t.slidesGrid[0]
    ;((t.snapGrid = t.snapGrid.map((C) => C + k)),
      (t.slidesGrid = t.slidesGrid.map((C) => C + E)))
  }
  if (
    (h !== o && t.emit('slidesLengthChange'),
    f.length !== T &&
      (t.params.watchOverflow && t.checkOverflow(),
      t.emit('snapGridLengthChange')),
    m.length !== p && t.emit('slidesGridLengthChange'),
    e.watchSlidesProgress && t.updateSlidesOffset(),
    t.emit('slidesUpdated'),
    !l && !e.cssMode && (e.effect === 'slide' || e.effect === 'fade'))
  ) {
    let k = `${e.containerModifierClass}backface-hidden`,
      E = t.el.classList.contains(k)
    h <= e.maxBackfaceHiddenSlides
      ? E || t.el.classList.add(k)
      : E && t.el.classList.remove(k)
  }
}
function hd(t) {
  let r = this,
    e = [],
    s = r.virtual && r.params.virtual.enabled,
    i = 0,
    n
  typeof t == 'number'
    ? r.setTransition(t)
    : t === !0 && r.setTransition(r.params.speed)
  let a = (l) => (s ? r.slides[r.getSlideIndexByData(l)] : r.slides[l])
  if (r.params.slidesPerView !== 'auto' && r.params.slidesPerView > 1)
    if (r.params.centeredSlides)
      (r.visibleSlides || []).forEach((l) => {
        e.push(l)
      })
    else
      for (n = 0; n < Math.ceil(r.params.slidesPerView); n += 1) {
        let l = r.activeIndex + n
        if (l > r.slides.length && !s) break
        e.push(a(l))
      }
  else e.push(a(r.activeIndex))
  for (n = 0; n < e.length; n += 1)
    if (typeof e[n] < 'u') {
      let l = e[n].offsetHeight
      i = l > i ? l : i
    }
  ;(i || i === 0) && (r.wrapperEl.style.height = `${i}px`)
}
function md() {
  let t = this,
    r = t.slides,
    e = t.isElement
      ? t.isHorizontal()
        ? t.wrapperEl.offsetLeft
        : t.wrapperEl.offsetTop
      : 0
  for (let s = 0; s < r.length; s += 1)
    r[s].swiperSlideOffset =
      (t.isHorizontal() ? r[s].offsetLeft : r[s].offsetTop) -
      e -
      t.cssOverflowAdjustment()
}
function pd(t = (this && this.translate) || 0) {
  let r = this,
    e = r.params,
    { slides: s, rtlTranslate: i, snapGrid: n } = r
  if (s.length === 0) return
  typeof s[0].swiperSlideOffset > 'u' && r.updateSlidesOffset()
  let a = -t
  ;(i && (a = t), (r.visibleSlidesIndexes = []), (r.visibleSlides = []))
  let l = e.spaceBetween
  typeof l == 'string' && l.indexOf('%') >= 0
    ? (l = (parseFloat(l.replace('%', '')) / 100) * r.size)
    : typeof l == 'string' && (l = parseFloat(l))
  for (let o = 0; o < s.length; o += 1) {
    let u = s[o],
      h = u.swiperSlideOffset
    e.cssMode && e.centeredSlides && (h -= s[0].swiperSlideOffset)
    let f =
        (a + (e.centeredSlides ? r.minTranslate() : 0) - h) /
        (u.swiperSlideSize + l),
      m =
        (a - n[0] + (e.centeredSlides ? r.minTranslate() : 0) - h) /
        (u.swiperSlideSize + l),
      c = -(a - h),
      d = c + r.slidesSizesGrid[o],
      g = c >= 0 && c <= r.size - r.slidesSizesGrid[o],
      T =
        (c >= 0 && c < r.size - 1) ||
        (d > 1 && d <= r.size) ||
        (c <= 0 && d >= r.size)
    ;(T && (r.visibleSlides.push(u), r.visibleSlidesIndexes.push(o)),
      Pa(u, T, e.slideVisibleClass),
      Pa(u, g, e.slideFullyVisibleClass),
      (u.progress = i ? -f : f),
      (u.originalProgress = i ? -m : m))
  }
}
function gd(t) {
  let r = this
  if (typeof t > 'u') {
    let h = r.rtlTranslate ? -1 : 1
    t = (r && r.translate && r.translate * h) || 0
  }
  let e = r.params,
    s = r.maxTranslate() - r.minTranslate(),
    { progress: i, isBeginning: n, isEnd: a, progressLoop: l } = r,
    o = n,
    u = a
  if (s === 0) ((i = 0), (n = !0), (a = !0))
  else {
    i = (t - r.minTranslate()) / s
    let h = Math.abs(t - r.minTranslate()) < 1,
      f = Math.abs(t - r.maxTranslate()) < 1
    ;((n = h || i <= 0), (a = f || i >= 1), h && (i = 0), f && (i = 1))
  }
  if (e.loop) {
    let h = r.getSlideIndexByData(0),
      f = r.getSlideIndexByData(r.slides.length - 1),
      m = r.slidesGrid[h],
      c = r.slidesGrid[f],
      d = r.slidesGrid[r.slidesGrid.length - 1],
      g = Math.abs(t)
    ;(g >= m ? (l = (g - m) / d) : (l = (g + d - c) / d), l > 1 && (l -= 1))
  }
  ;(Object.assign(r, {
    progress: i,
    progressLoop: l,
    isBeginning: n,
    isEnd: a,
  }),
    (e.watchSlidesProgress || (e.centeredSlides && e.autoHeight)) &&
      r.updateSlidesProgress(t),
    n && !o && r.emit('reachBeginning toEdge'),
    a && !u && r.emit('reachEnd toEdge'),
    ((o && !n) || (u && !a)) && r.emit('fromEdge'),
    r.emit('progress', i))
}
function vd() {
  let t = this,
    { slides: r, params: e, slidesEl: s, activeIndex: i } = t,
    n = t.virtual && e.virtual.enabled,
    a = t.grid && e.grid && e.grid.rows > 1,
    l = (f) => ne(s, `.${e.slideClass}${f}, swiper-slide${f}`)[0],
    o,
    u,
    h
  if (n)
    if (e.loop) {
      let f = i - t.virtual.slidesBefore
      ;(f < 0 && (f = t.virtual.slides.length + f),
        f >= t.virtual.slides.length && (f -= t.virtual.slides.length),
        (o = l(`[data-swiper-slide-index="${f}"]`)))
    } else o = l(`[data-swiper-slide-index="${i}"]`)
  else
    a
      ? ((o = r.find((f) => f.column === i)),
        (h = r.find((f) => f.column === i + 1)),
        (u = r.find((f) => f.column === i - 1)))
      : (o = r[i])
  ;(o &&
    (a ||
      ((h = Ia(o, `.${e.slideClass}, swiper-slide`)[0]),
      e.loop && !h && (h = r[0]),
      (u = Aa(o, `.${e.slideClass}, swiper-slide`)[0]),
      e.loop && !u === 0 && (u = r[r.length - 1]))),
    r.forEach((f) => {
      ;(rn(f, f === o, e.slideActiveClass),
        rn(f, f === h, e.slideNextClass),
        rn(f, f === u, e.slidePrevClass))
    }),
    t.emitSlidesClasses())
}
function yd(t) {
  let { slidesGrid: r, params: e } = t,
    s = t.rtlTranslate ? t.translate : -t.translate,
    i
  for (let n = 0; n < r.length; n += 1)
    typeof r[n + 1] < 'u'
      ? s >= r[n] && s < r[n + 1] - (r[n + 1] - r[n]) / 2
        ? (i = n)
        : s >= r[n] && s < r[n + 1] && (i = n + 1)
      : s >= r[n] && (i = n)
  return (e.normalizeSlideIndex && (i < 0 || typeof i > 'u') && (i = 0), i)
}
function bd(t) {
  let r = this,
    e = r.rtlTranslate ? r.translate : -r.translate,
    { snapGrid: s, params: i, activeIndex: n, realIndex: a, snapIndex: l } = r,
    o = t,
    u,
    h = (c) => {
      let d = c - r.virtual.slidesBefore
      return (
        d < 0 && (d = r.virtual.slides.length + d),
        d >= r.virtual.slides.length && (d -= r.virtual.slides.length),
        d
      )
    }
  if ((typeof o > 'u' && (o = yd(r)), s.indexOf(e) >= 0)) u = s.indexOf(e)
  else {
    let c = Math.min(i.slidesPerGroupSkip, o)
    u = c + Math.floor((o - c) / i.slidesPerGroup)
  }
  if ((u >= s.length && (u = s.length - 1), o === n && !r.params.loop)) {
    u !== l && ((r.snapIndex = u), r.emit('snapIndexChange'))
    return
  }
  if (o === n && r.params.loop && r.virtual && r.params.virtual.enabled) {
    r.realIndex = h(o)
    return
  }
  let f = r.grid && i.grid && i.grid.rows > 1,
    m
  if (r.virtual && i.virtual.enabled) i.loop ? (m = h(o)) : (m = o)
  else if (f) {
    let c = r.slides.find((g) => g.column === o),
      d = parseInt(c.getAttribute('data-swiper-slide-index'), 10)
    ;(Number.isNaN(d) && (d = Math.max(r.slides.indexOf(c), 0)),
      (m = Math.floor(d / i.grid.rows)))
  } else if (r.slides[o]) {
    let c = r.slides[o].getAttribute('data-swiper-slide-index')
    c ? (m = parseInt(c, 10)) : (m = o)
  } else m = o
  ;(Object.assign(r, {
    previousSnapIndex: l,
    snapIndex: u,
    previousRealIndex: a,
    realIndex: m,
    previousIndex: n,
    activeIndex: o,
  }),
    r.initialized && on(r),
    r.emit('activeIndexChange'),
    r.emit('snapIndexChange'),
    (r.initialized || r.params.runCallbacksOnInit) &&
      (a !== m && r.emit('realIndexChange'), r.emit('slideChange')))
}
function Td(t, r) {
  let e = this,
    s = e.params,
    i = t.closest(`.${s.slideClass}, swiper-slide`)
  !i &&
    e.isElement &&
    r &&
    r.length > 1 &&
    r.includes(t) &&
    [...r.slice(r.indexOf(t) + 1, r.length)].forEach((l) => {
      !i && l.matches && l.matches(`.${s.slideClass}, swiper-slide`) && (i = l)
    })
  let n = !1,
    a
  if (i) {
    for (let l = 0; l < e.slides.length; l += 1)
      if (e.slides[l] === i) {
        ;((n = !0), (a = l))
        break
      }
  }
  if (i && n)
    ((e.clickedSlide = i),
      e.virtual && e.params.virtual.enabled
        ? (e.clickedIndex = parseInt(
            i.getAttribute('data-swiper-slide-index'),
            10,
          ))
        : (e.clickedIndex = a))
  else {
    ;((e.clickedSlide = void 0), (e.clickedIndex = void 0))
    return
  }
  s.slideToClickedSlide &&
    e.clickedIndex !== void 0 &&
    e.clickedIndex !== e.activeIndex &&
    e.slideToClickedSlide()
}
function Ed(t = this.isHorizontal() ? 'x' : 'y') {
  let r = this,
    { params: e, rtlTranslate: s, translate: i, wrapperEl: n } = r
  if (e.virtualTranslate) return s ? -i : i
  if (e.cssMode) return i
  let a = es(n, t)
  return ((a += r.cssOverflowAdjustment()), s && (a = -a), a || 0)
}
function xd(t, r) {
  let e = this,
    { rtlTranslate: s, params: i, wrapperEl: n, progress: a } = e,
    l = 0,
    o = 0,
    u = 0
  ;(e.isHorizontal() ? (l = s ? -t : t) : (o = t),
    i.roundLengths && ((l = Math.floor(l)), (o = Math.floor(o))),
    (e.previousTranslate = e.translate),
    (e.translate = e.isHorizontal() ? l : o),
    i.cssMode
      ? (n[e.isHorizontal() ? 'scrollLeft' : 'scrollTop'] = e.isHorizontal()
          ? -l
          : -o)
      : i.virtualTranslate ||
        (e.isHorizontal()
          ? (l -= e.cssOverflowAdjustment())
          : (o -= e.cssOverflowAdjustment()),
        (n.style.transform = `translate3d(${l}px, ${o}px, ${u}px)`)))
  let h,
    f = e.maxTranslate() - e.minTranslate()
  ;(f === 0 ? (h = 0) : (h = (t - e.minTranslate()) / f),
    h !== a && e.updateProgress(t),
    e.emit('setTranslate', e.translate, r))
}
function wd() {
  return -this.snapGrid[0]
}
function Md() {
  return -this.snapGrid[this.snapGrid.length - 1]
}
function Ld(t = 0, r = this.params.speed, e = !0, s = !0, i) {
  let n = this,
    { params: a, wrapperEl: l } = n
  if (n.animating && a.preventInteractionOnTransition) return !1
  let o = n.minTranslate(),
    u = n.maxTranslate(),
    h
  if (
    (s && t > o ? (h = o) : s && t < u ? (h = u) : (h = t),
    n.updateProgress(h),
    a.cssMode)
  ) {
    let f = n.isHorizontal()
    if (r === 0) l[f ? 'scrollLeft' : 'scrollTop'] = -h
    else {
      if (!n.support.smoothScroll)
        return (
          Ji({ swiper: n, targetPosition: -h, side: f ? 'left' : 'top' }),
          !0
        )
      l.scrollTo({ [f ? 'left' : 'top']: -h, behavior: 'smooth' })
    }
    return !0
  }
  return (
    r === 0
      ? (n.setTransition(0),
        n.setTranslate(h),
        e && (n.emit('beforeTransitionStart', r, i), n.emit('transitionEnd')))
      : (n.setTransition(r),
        n.setTranslate(h),
        e && (n.emit('beforeTransitionStart', r, i), n.emit('transitionStart')),
        n.animating ||
          ((n.animating = !0),
          n.onTranslateToWrapperTransitionEnd ||
            (n.onTranslateToWrapperTransitionEnd = function (m) {
              !n ||
                n.destroyed ||
                (m.target === this &&
                  (n.wrapperEl.removeEventListener(
                    'transitionend',
                    n.onTranslateToWrapperTransitionEnd,
                  ),
                  (n.onTranslateToWrapperTransitionEnd = null),
                  delete n.onTranslateToWrapperTransitionEnd,
                  (n.animating = !1),
                  e && n.emit('transitionEnd')))
            }),
          n.wrapperEl.addEventListener(
            'transitionend',
            n.onTranslateToWrapperTransitionEnd,
          ))),
    !0
  )
}
function Ad(t, r) {
  let e = this
  ;(e.params.cssMode ||
    ((e.wrapperEl.style.transitionDuration = `${t}ms`),
    (e.wrapperEl.style.transitionDelay = t === 0 ? '0ms' : '')),
    e.emit('setTransition', t, r))
}
function Va({ swiper: t, runCallbacks: r, direction: e, step: s }) {
  let { activeIndex: i, previousIndex: n } = t,
    a = e
  ;(a || (i > n ? (a = 'next') : i < n ? (a = 'prev') : (a = 'reset')),
    t.emit(`transition${s}`),
    r && a === 'reset'
      ? t.emit(`slideResetTransition${s}`)
      : r &&
        i !== n &&
        (t.emit(`slideChangeTransition${s}`),
        a === 'next'
          ? t.emit(`slideNextTransition${s}`)
          : t.emit(`slidePrevTransition${s}`)))
}
function Id(t = !0, r) {
  let e = this,
    { params: s } = e
  s.cssMode ||
    (s.autoHeight && e.updateAutoHeight(),
    Va({ swiper: e, runCallbacks: t, direction: r, step: 'Start' }))
}
function Pd(t = !0, r) {
  let e = this,
    { params: s } = e
  ;((e.animating = !1),
    !s.cssMode &&
      (e.setTransition(0),
      Va({ swiper: e, runCallbacks: t, direction: r, step: 'End' })))
}
function Od(t = 0, r, e = !0, s, i) {
  typeof t == 'string' && (t = parseInt(t, 10))
  let n = this,
    a = t
  a < 0 && (a = 0)
  let {
    params: l,
    snapGrid: o,
    slidesGrid: u,
    previousIndex: h,
    activeIndex: f,
    rtlTranslate: m,
    wrapperEl: c,
    enabled: d,
  } = n
  if (
    (!d && !s && !i) ||
    n.destroyed ||
    (n.animating && l.preventInteractionOnTransition)
  )
    return !1
  typeof r > 'u' && (r = n.params.speed)
  let g = Math.min(n.params.slidesPerGroupSkip, a),
    T = g + Math.floor((a - g) / n.params.slidesPerGroup)
  T >= o.length && (T = o.length - 1)
  let p = -o[T]
  if (l.normalizeSlideIndex)
    for (let R = 0; R < u.length; R += 1) {
      let w = -Math.floor(p * 100),
        B = Math.floor(u[R] * 100),
        k = Math.floor(u[R + 1] * 100)
      typeof u[R + 1] < 'u'
        ? w >= B && w < k - (k - B) / 2
          ? (a = R)
          : w >= B && w < k && (a = R + 1)
        : w >= B && (a = R)
    }
  if (
    n.initialized &&
    a !== f &&
    ((!n.allowSlideNext &&
      (m
        ? p > n.translate && p > n.minTranslate()
        : p < n.translate && p < n.minTranslate())) ||
      (!n.allowSlidePrev &&
        p > n.translate &&
        p > n.maxTranslate() &&
        (f || 0) !== a))
  )
    return !1
  ;(a !== (h || 0) && e && n.emit('beforeSlideChangeStart'),
    n.updateProgress(p))
  let v
  a > f ? (v = 'next') : a < f ? (v = 'prev') : (v = 'reset')
  let y = n.virtual && n.params.virtual.enabled
  if (!(y && i) && ((m && -p === n.translate) || (!m && p === n.translate)))
    return (
      n.updateActiveIndex(a),
      l.autoHeight && n.updateAutoHeight(),
      n.updateSlidesClasses(),
      l.effect !== 'slide' && n.setTranslate(p),
      v !== 'reset' && (n.transitionStart(e, v), n.transitionEnd(e, v)),
      !1
    )
  if (l.cssMode) {
    let R = n.isHorizontal(),
      w = m ? p : -p
    if (r === 0)
      (y &&
        ((n.wrapperEl.style.scrollSnapType = 'none'),
        (n._immediateVirtual = !0)),
        y && !n._cssModeVirtualInitialSet && n.params.initialSlide > 0
          ? ((n._cssModeVirtualInitialSet = !0),
            requestAnimationFrame(() => {
              c[R ? 'scrollLeft' : 'scrollTop'] = w
            }))
          : (c[R ? 'scrollLeft' : 'scrollTop'] = w),
        y &&
          requestAnimationFrame(() => {
            ;((n.wrapperEl.style.scrollSnapType = ''),
              (n._immediateVirtual = !1))
          }))
    else {
      if (!n.support.smoothScroll)
        return (
          Ji({ swiper: n, targetPosition: w, side: R ? 'left' : 'top' }),
          !0
        )
      c.scrollTo({ [R ? 'left' : 'top']: w, behavior: 'smooth' })
    }
    return !0
  }
  let M = Fa().isSafari
  return (
    y && !i && M && n.isElement && n.virtual.update(!1, !1, a),
    n.setTransition(r),
    n.setTranslate(p),
    n.updateActiveIndex(a),
    n.updateSlidesClasses(),
    n.emit('beforeTransitionStart', r, s),
    n.transitionStart(e, v),
    r === 0
      ? n.transitionEnd(e, v)
      : n.animating ||
        ((n.animating = !0),
        n.onSlideToWrapperTransitionEnd ||
          (n.onSlideToWrapperTransitionEnd = function (w) {
            !n ||
              n.destroyed ||
              (w.target === this &&
                (n.wrapperEl.removeEventListener(
                  'transitionend',
                  n.onSlideToWrapperTransitionEnd,
                ),
                (n.onSlideToWrapperTransitionEnd = null),
                delete n.onSlideToWrapperTransitionEnd,
                n.transitionEnd(e, v)))
          }),
        n.wrapperEl.addEventListener(
          'transitionend',
          n.onSlideToWrapperTransitionEnd,
        )),
    !0
  )
}
function Rd(t = 0, r, e = !0, s) {
  typeof t == 'string' && (t = parseInt(t, 10))
  let i = this
  if (i.destroyed) return
  typeof r > 'u' && (r = i.params.speed)
  let n = i.grid && i.params.grid && i.params.grid.rows > 1,
    a = t
  if (i.params.loop)
    if (i.virtual && i.params.virtual.enabled) a = a + i.virtual.slidesBefore
    else {
      let l
      if (n) {
        let g = a * i.params.grid.rows
        l = i.slides.find(
          (T) => T.getAttribute('data-swiper-slide-index') * 1 === g,
        ).column
      } else l = i.getSlideIndexByData(a)
      let o = n
          ? Math.ceil(i.slides.length / i.params.grid.rows)
          : i.slides.length,
        {
          centeredSlides: u,
          slidesOffsetBefore: h,
          slidesOffsetAfter: f,
        } = i.params,
        m = u || !!h || !!f,
        c = i.params.slidesPerView
      c === 'auto'
        ? (c = i.slidesPerViewDynamic())
        : ((c = Math.ceil(parseFloat(i.params.slidesPerView, 10))),
          m && c % 2 === 0 && (c = c + 1))
      let d = o - l < c
      if (
        (m && (d = d || l < Math.ceil(c / 2)),
        s && m && i.params.slidesPerView !== 'auto' && !n && (d = !1),
        d)
      ) {
        let g = m
          ? l < i.activeIndex
            ? 'prev'
            : 'next'
          : l - i.activeIndex - 1 < i.params.slidesPerView
            ? 'next'
            : 'prev'
        i.loopFix({
          direction: g,
          slideTo: !0,
          activeSlideIndex: g === 'next' ? l + 1 : l - o + 1,
          slideRealIndex: g === 'next' ? i.realIndex : void 0,
        })
      }
      if (n) {
        let g = a * i.params.grid.rows
        a = i.slides.find(
          (T) => T.getAttribute('data-swiper-slide-index') * 1 === g,
        ).column
      } else a = i.getSlideIndexByData(a)
    }
  return (
    requestAnimationFrame(() => {
      i.slideTo(a, r, e, s)
    }),
    i
  )
}
function Hd(t, r = !0, e) {
  let s = this,
    { enabled: i, params: n, animating: a } = s
  if (!i || s.destroyed) return s
  typeof t > 'u' && (t = s.params.speed)
  let l = n.slidesPerGroup
  n.slidesPerView === 'auto' &&
    n.slidesPerGroup === 1 &&
    n.slidesPerGroupAuto &&
    (l = Math.max(s.slidesPerViewDynamic('current', !0), 1))
  let o = s.activeIndex < n.slidesPerGroupSkip ? 1 : l,
    u = s.virtual && n.virtual.enabled
  if (n.loop) {
    if (a && !u && n.loopPreventsSliding) return !1
    if (
      (s.loopFix({ direction: 'next' }),
      (s._clientLeft = s.wrapperEl.clientLeft),
      s.activeIndex === s.slides.length - 1 && n.cssMode)
    )
      return (
        requestAnimationFrame(() => {
          s.slideTo(s.activeIndex + o, t, r, e)
        }),
        !0
      )
  }
  return n.rewind && s.isEnd
    ? s.slideTo(0, t, r, e)
    : s.slideTo(s.activeIndex + o, t, r, e)
}
function Dd(t, r = !0, e) {
  let s = this,
    {
      params: i,
      snapGrid: n,
      slidesGrid: a,
      rtlTranslate: l,
      enabled: o,
      animating: u,
    } = s
  if (!o || s.destroyed) return s
  typeof t > 'u' && (t = s.params.speed)
  let h = s.virtual && i.virtual.enabled
  if (i.loop) {
    if (u && !h && i.loopPreventsSliding) return !1
    ;(s.loopFix({ direction: 'prev' }),
      (s._clientLeft = s.wrapperEl.clientLeft))
  }
  let f = l ? s.translate : -s.translate
  function m(v) {
    return v < 0 ? -Math.floor(Math.abs(v)) : Math.floor(v)
  }
  let c = m(f),
    d = n.map((v) => m(v)),
    g = i.freeMode && i.freeMode.enabled,
    T = n[d.indexOf(c) - 1]
  if (typeof T > 'u' && (i.cssMode || g)) {
    let v
    ;(n.forEach((y, x) => {
      c >= y && (v = x)
    }),
      typeof v < 'u' && (T = g ? n[v] : n[v > 0 ? v - 1 : v]))
  }
  let p = 0
  if (
    (typeof T < 'u' &&
      ((p = a.indexOf(T)),
      p < 0 && (p = s.activeIndex - 1),
      i.slidesPerView === 'auto' &&
        i.slidesPerGroup === 1 &&
        i.slidesPerGroupAuto &&
        ((p = p - s.slidesPerViewDynamic('previous', !0) + 1),
        (p = Math.max(p, 0)))),
    i.rewind && s.isBeginning)
  ) {
    let v =
      s.params.virtual && s.params.virtual.enabled && s.virtual
        ? s.virtual.slides.length - 1
        : s.slides.length - 1
    return s.slideTo(v, t, r, e)
  } else if (i.loop && s.activeIndex === 0 && i.cssMode)
    return (
      requestAnimationFrame(() => {
        s.slideTo(p, t, r, e)
      }),
      !0
    )
  return s.slideTo(p, t, r, e)
}
function Bd(t, r = !0, e) {
  let s = this
  if (!s.destroyed)
    return (
      typeof t > 'u' && (t = s.params.speed),
      s.slideTo(s.activeIndex, t, r, e)
    )
}
function Fd(t, r = !0, e, s = 0.5) {
  let i = this
  if (i.destroyed) return
  typeof t > 'u' && (t = i.params.speed)
  let n = i.activeIndex,
    a = Math.min(i.params.slidesPerGroupSkip, n),
    l = a + Math.floor((n - a) / i.params.slidesPerGroup),
    o = i.rtlTranslate ? i.translate : -i.translate
  if (o >= i.snapGrid[l]) {
    let u = i.snapGrid[l],
      h = i.snapGrid[l + 1]
    o - u > (h - u) * s && (n += i.params.slidesPerGroup)
  } else {
    let u = i.snapGrid[l - 1],
      h = i.snapGrid[l]
    o - u <= (h - u) * s && (n -= i.params.slidesPerGroup)
  }
  return (
    (n = Math.max(n, 0)),
    (n = Math.min(n, i.slidesGrid.length - 1)),
    i.slideTo(n, t, r, e)
  )
}
function Vd() {
  let t = this
  if (t.destroyed) return
  let { params: r, slidesEl: e } = t,
    s = r.slidesPerView === 'auto' ? t.slidesPerViewDynamic() : r.slidesPerView,
    i = t.getSlideIndexWhenGrid(t.clickedIndex),
    n,
    a = t.isElement ? 'swiper-slide' : `.${r.slideClass}`,
    l = t.grid && t.params.grid && t.params.grid.rows > 1
  if (r.loop) {
    if (t.animating) return
    ;((n = parseInt(
      t.clickedSlide.getAttribute('data-swiper-slide-index'),
      10,
    )),
      r.centeredSlides
        ? t.slideToLoop(n)
        : i >
            (l
              ? (t.slides.length - s) / 2 - (t.params.grid.rows - 1)
              : t.slides.length - s)
          ? (t.loopFix(),
            (i = t.getSlideIndex(
              ne(e, `${a}[data-swiper-slide-index="${n}"]`)[0],
            )),
            rt(() => {
              t.slideTo(i)
            }))
          : t.slideTo(i))
  } else t.slideTo(i)
}
function $d(t, r) {
  let e = this,
    { params: s, slidesEl: i } = e
  if (!s.loop || (e.virtual && e.params.virtual.enabled)) return
  let n = () => {
      ne(i, `.${s.slideClass}, swiper-slide`).forEach((d, g) => {
        d.setAttribute('data-swiper-slide-index', g)
      })
    },
    a = () => {
      let c = ne(i, `.${s.slideBlankClass}`)
      ;(c.forEach((d) => {
        d.remove()
      }),
        c.length > 0 && (e.recalcSlides(), e.updateSlides()))
    },
    l = e.grid && s.grid && s.grid.rows > 1
  s.loopAddBlankSlides && (s.slidesPerGroup > 1 || l) && a()
  let o = s.slidesPerGroup * (l ? s.grid.rows : 1),
    u = e.slides.length % o !== 0,
    h = l && e.slides.length % s.grid.rows !== 0,
    f = (c) => {
      for (let d = 0; d < c; d += 1) {
        let g = e.isElement
          ? he('swiper-slide', [s.slideBlankClass])
          : he('div', [s.slideClass, s.slideBlankClass])
        e.slidesEl.append(g)
      }
    }
  if (u) {
    if (s.loopAddBlankSlides) {
      let c = o - (e.slides.length % o)
      ;(f(c), e.recalcSlides(), e.updateSlides())
    } else
      ts(
        'Swiper Loop Warning: The number of slides is not even to slidesPerGroup, loop mode may not function properly. You need to add more slides (or make duplicates, or empty slides)',
      )
    n()
  } else if (h) {
    if (s.loopAddBlankSlides) {
      let c = s.grid.rows - (e.slides.length % s.grid.rows)
      ;(f(c), e.recalcSlides(), e.updateSlides())
    } else
      ts(
        'Swiper Loop Warning: The number of slides is not even to grid.rows, loop mode may not function properly. You need to add more slides (or make duplicates, or empty slides)',
      )
    n()
  } else n()
  let m = s.centeredSlides || !!s.slidesOffsetBefore || !!s.slidesOffsetAfter
  e.loopFix({ slideRealIndex: t, direction: m ? void 0 : 'next', initial: r })
}
function Nd({
  slideRealIndex: t,
  slideTo: r = !0,
  direction: e,
  setTranslate: s,
  activeSlideIndex: i,
  initial: n,
  byController: a,
  byMousewheel: l,
} = {}) {
  let o = this
  if (!o.params.loop) return
  o.emit('beforeLoopFix')
  let {
      slides: u,
      allowSlidePrev: h,
      allowSlideNext: f,
      slidesEl: m,
      params: c,
    } = o,
    {
      centeredSlides: d,
      slidesOffsetBefore: g,
      slidesOffsetAfter: T,
      initialSlide: p,
    } = c,
    v = d || !!g || !!T
  if (
    ((o.allowSlidePrev = !0),
    (o.allowSlideNext = !0),
    o.virtual && c.virtual.enabled)
  ) {
    ;(r &&
      (!v && o.snapIndex === 0
        ? o.slideTo(o.virtual.slides.length, 0, !1, !0)
        : v && o.snapIndex < c.slidesPerView
          ? o.slideTo(o.virtual.slides.length + o.snapIndex, 0, !1, !0)
          : o.snapIndex === o.snapGrid.length - 1 &&
            o.slideTo(o.virtual.slidesBefore, 0, !1, !0)),
      (o.allowSlidePrev = h),
      (o.allowSlideNext = f),
      o.emit('loopFix'))
    return
  }
  let y = c.slidesPerView
  y === 'auto'
    ? (y = o.slidesPerViewDynamic())
    : ((y = Math.ceil(parseFloat(c.slidesPerView, 10))),
      v && y % 2 === 0 && (y = y + 1))
  let x = c.slidesPerGroupAuto ? y : c.slidesPerGroup,
    L = v ? Math.max(x, Math.ceil(y / 2)) : x
  ;(L % x !== 0 && (L += x - (L % x)),
    (L += c.loopAdditionalSlides),
    (o.loopedSlides = L))
  let M = o.grid && c.grid && c.grid.rows > 1
  u.length < y + L || (o.params.effect === 'cards' && u.length < y + L * 2)
    ? ts(
        'Swiper Loop Warning: The number of slides is not enough for loop mode, it will be disabled or not function properly. You need to add more slides (or make duplicates) or lower the values of slidesPerView and slidesPerGroup parameters',
      )
    : M &&
      c.grid.fill === 'row' &&
      ts(
        'Swiper Loop Warning: Loop mode is not compatible with grid.fill = `row`',
      )
  let R = [],
    w = [],
    B = M ? Math.ceil(u.length / c.grid.rows) : u.length,
    k = n && B - p < y && !v,
    E = k ? p : o.activeIndex
  typeof i > 'u'
    ? (i = o.getSlideIndex(
        u.find((O) => O.classList.contains(c.slideActiveClass)),
      ))
    : (E = i)
  let C = e === 'next' || !e,
    P = e === 'prev' || !e,
    H = 0,
    $ = 0,
    A = (M ? u[i].column : i) + (v && typeof s > 'u' ? -y / 2 + 0.5 : 0)
  if (A < L) {
    H = Math.max(L - A, x)
    for (let O = 0; O < L - A; O += 1) {
      let q = O - Math.floor(O / B) * B
      if (M) {
        let G = B - q - 1
        for (let Q = u.length - 1; Q >= 0; Q -= 1)
          u[Q].column === G && R.push(Q)
      } else R.push(B - q - 1)
    }
  } else if (A + y > B - L) {
    ;(($ = Math.max(A - (B - L * 2), x)), k && ($ = Math.max($, y - B + p + 1)))
    for (let O = 0; O < $; O += 1) {
      let q = O - Math.floor(O / B) * B
      M
        ? u.forEach((G, Q) => {
            G.column === q && w.push(Q)
          })
        : w.push(q)
    }
  }
  if (
    ((o.__preventObserver__ = !0),
    requestAnimationFrame(() => {
      o.__preventObserver__ = !1
    }),
    o.params.effect === 'cards' &&
      u.length < y + L * 2 &&
      (w.includes(i) && w.splice(w.indexOf(i), 1),
      R.includes(i) && R.splice(R.indexOf(i), 1)),
    P &&
      R.forEach((O) => {
        ;((u[O].swiperLoopMoveDOM = !0),
          m.prepend(u[O]),
          (u[O].swiperLoopMoveDOM = !1))
      }),
    C &&
      w.forEach((O) => {
        ;((u[O].swiperLoopMoveDOM = !0),
          m.append(u[O]),
          (u[O].swiperLoopMoveDOM = !1))
      }),
    o.recalcSlides(),
    c.slidesPerView === 'auto'
      ? o.updateSlides()
      : M &&
        ((R.length > 0 && P) || (w.length > 0 && C)) &&
        o.slides.forEach((O, q) => {
          o.grid.updateSlide(q, O, o.slides)
        }),
    c.watchSlidesProgress && o.updateSlidesOffset(),
    r)
  ) {
    if (R.length > 0 && P) {
      if (typeof t > 'u') {
        let O = o.slidesGrid[E],
          G = o.slidesGrid[E + H] - O
        l
          ? o.setTranslate(o.translate - G)
          : (o.slideTo(E + Math.ceil(H), 0, !1, !0),
            s &&
              ((o.touchEventsData.startTranslate =
                o.touchEventsData.startTranslate - G),
              (o.touchEventsData.currentTranslate =
                o.touchEventsData.currentTranslate - G)))
      } else if (s) {
        let O = M ? R.length / c.grid.rows : R.length
        ;(o.slideTo(o.activeIndex + O, 0, !1, !0),
          (o.touchEventsData.currentTranslate = o.translate))
      }
    } else if (w.length > 0 && C)
      if (typeof t > 'u') {
        let O = o.slidesGrid[E],
          G = o.slidesGrid[E - $] - O
        l
          ? o.setTranslate(o.translate - G)
          : (o.slideTo(E - $, 0, !1, !0),
            s &&
              ((o.touchEventsData.startTranslate =
                o.touchEventsData.startTranslate - G),
              (o.touchEventsData.currentTranslate =
                o.touchEventsData.currentTranslate - G)))
      } else {
        let O = M ? w.length / c.grid.rows : w.length
        o.slideTo(o.activeIndex - O, 0, !1, !0)
      }
  }
  if (
    ((o.allowSlidePrev = h),
    (o.allowSlideNext = f),
    o.controller && o.controller.control && !a)
  ) {
    let O = {
      slideRealIndex: t,
      direction: e,
      setTranslate: s,
      activeSlideIndex: i,
      byController: !0,
    }
    Array.isArray(o.controller.control)
      ? o.controller.control.forEach((q) => {
          !q.destroyed &&
            q.params.loop &&
            q.loopFix({
              ...O,
              slideTo: q.params.slidesPerView === c.slidesPerView ? r : !1,
            })
        })
      : o.controller.control instanceof o.constructor &&
        o.controller.control.params.loop &&
        o.controller.control.loopFix({
          ...O,
          slideTo:
            o.controller.control.params.slidesPerView === c.slidesPerView
              ? r
              : !1,
        })
  }
  o.emit('loopFix')
}
function zd() {
  let t = this,
    { params: r, slidesEl: e } = t
  if (!r.loop || !e || (t.virtual && t.params.virtual.enabled)) return
  t.recalcSlides()
  let s = []
  ;(t.slides.forEach((i) => {
    let n =
      typeof i.swiperSlideIndex > 'u'
        ? i.getAttribute('data-swiper-slide-index') * 1
        : i.swiperSlideIndex
    s[n] = i
  }),
    t.slides.forEach((i) => {
      i.removeAttribute('data-swiper-slide-index')
    }),
    s.forEach((i) => {
      e.append(i)
    }),
    t.recalcSlides(),
    t.slideTo(t.realIndex, 0))
}
function Ud(t) {
  let r = this
  if (
    !r.params.simulateTouch ||
    (r.params.watchOverflow && r.isLocked) ||
    r.params.cssMode
  )
    return
  let e = r.params.touchEventsTarget === 'container' ? r.el : r.wrapperEl
  ;(r.isElement && (r.__preventObserver__ = !0),
    (e.style.cursor = 'move'),
    (e.style.cursor = t ? 'grabbing' : 'grab'),
    r.isElement &&
      requestAnimationFrame(() => {
        r.__preventObserver__ = !1
      }))
}
function jd() {
  let t = this
  ;(t.params.watchOverflow && t.isLocked) ||
    t.params.cssMode ||
    (t.isElement && (t.__preventObserver__ = !0),
    (t[
      t.params.touchEventsTarget === 'container' ? 'el' : 'wrapperEl'
    ].style.cursor = ''),
    t.isElement &&
      requestAnimationFrame(() => {
        t.__preventObserver__ = !1
      }))
}
function Gd(t, r = this) {
  function e(s) {
    if (!s || s === te() || s === ee()) return null
    s.assignedSlot && (s = s.assignedSlot)
    let i = s.closest(t)
    return !i && !s.getRootNode ? null : i || e(s.getRootNode().host)
  }
  return e(r)
}
function ka(t, r, e) {
  let s = ee(),
    { params: i } = t,
    n = i.edgeSwipeDetection,
    a = i.edgeSwipeThreshold
  return n && (e <= a || e >= s.innerWidth - a)
    ? n === 'prevent'
      ? (r.preventDefault(), !0)
      : !1
    : !0
}
function Yd(t) {
  let r = this,
    e = te(),
    s = t
  s.originalEvent && (s = s.originalEvent)
  let i = r.touchEventsData
  if (s.type === 'pointerdown') {
    if (i.pointerId !== null && i.pointerId !== s.pointerId) return
    i.pointerId = s.pointerId
  } else
    s.type === 'touchstart' &&
      s.targetTouches.length === 1 &&
      (i.touchId = s.targetTouches[0].identifier)
  if (s.type === 'touchstart') {
    ka(r, s, s.targetTouches[0].pageX)
    return
  }
  let { params: n, touches: a, enabled: l } = r
  if (
    !l ||
    (!n.simulateTouch && s.pointerType === 'mouse') ||
    (r.animating && n.preventInteractionOnTransition)
  )
    return
  !r.animating && n.cssMode && n.loop && r.loopFix()
  let o = s.target
  if (
    (n.touchEventsTarget === 'wrapper' && !Ca(o, r.wrapperEl)) ||
    ('which' in s && s.which === 3) ||
    ('button' in s && s.button > 0) ||
    (i.isTouched && i.isMoved)
  )
    return
  let u = !!n.noSwipingClass && n.noSwipingClass !== '',
    h = s.composedPath ? s.composedPath() : s.path
  u && s.target && s.target.shadowRoot && h && (o = h[0])
  let f = n.noSwipingSelector ? n.noSwipingSelector : `.${n.noSwipingClass}`,
    m = !!(s.target && s.target.shadowRoot)
  if (n.noSwiping && (m ? Gd(f, o) : o.closest(f))) {
    r.allowClick = !0
    return
  }
  if (n.swipeHandler && !o.closest(n.swipeHandler)) return
  ;((a.currentX = s.pageX), (a.currentY = s.pageY))
  let c = a.currentX,
    d = a.currentY
  if (!ka(r, s, c)) return
  ;(Object.assign(i, {
    isTouched: !0,
    isMoved: !1,
    allowTouchCallbacks: !0,
    isScrolling: void 0,
    startMoving: void 0,
  }),
    (a.startX = c),
    (a.startY = d),
    (i.touchStartTime = Le()),
    (r.allowClick = !0),
    r.updateSize(),
    (r.swipeDirection = void 0),
    n.threshold > 0 && (i.allowThresholdMove = !1))
  let g = !0
  ;(o.matches(i.focusableElements) &&
    ((g = !1), o.nodeName === 'SELECT' && (i.isTouched = !1)),
    e.activeElement &&
      e.activeElement.matches(i.focusableElements) &&
      e.activeElement !== o &&
      (s.pointerType === 'mouse' ||
        (s.pointerType !== 'mouse' && !o.matches(i.focusableElements))) &&
      e.activeElement.blur())
  let T = g && r.allowTouchMove && n.touchStartPreventDefault
  ;((n.touchStartForcePreventDefault || T) &&
    !o.isContentEditable &&
    s.preventDefault(),
    n.freeMode &&
      n.freeMode.enabled &&
      r.freeMode &&
      r.animating &&
      !n.cssMode &&
      r.freeMode.onTouchStart(),
    r.emit('touchStart', s))
}
function Kd(t) {
  let r = te(),
    e = this,
    s = e.touchEventsData,
    { params: i, touches: n, rtlTranslate: a, enabled: l } = e
  if (!l || (!i.simulateTouch && t.pointerType === 'mouse')) return
  let o = t
  if (
    (o.originalEvent && (o = o.originalEvent),
    o.type === 'pointermove' &&
      (s.touchId !== null || o.pointerId !== s.pointerId))
  )
    return
  let u
  if (o.type === 'touchmove') {
    if (
      ((u = [...o.changedTouches].find((M) => M.identifier === s.touchId)),
      !u || u.identifier !== s.touchId)
    )
      return
  } else u = o
  if (!s.isTouched) {
    s.startMoving && s.isScrolling && e.emit('touchMoveOpposite', o)
    return
  }
  let h = u.pageX,
    f = u.pageY
  if (o.preventedByNestedSwiper) {
    ;((n.startX = h), (n.startY = f))
    return
  }
  if (!e.allowTouchMove) {
    ;(o.target.matches(s.focusableElements) || (e.allowClick = !1),
      s.isTouched &&
        (Object.assign(n, { startX: h, startY: f, currentX: h, currentY: f }),
        (s.touchStartTime = Le())))
    return
  }
  if (i.touchReleaseOnEdges && !i.loop)
    if (e.isVertical()) {
      if (
        (f < n.startY && e.translate <= e.maxTranslate()) ||
        (f > n.startY && e.translate >= e.minTranslate())
      ) {
        ;((s.isTouched = !1), (s.isMoved = !1))
        return
      }
    } else {
      if (
        a &&
        ((h > n.startX && -e.translate <= e.maxTranslate()) ||
          (h < n.startX && -e.translate >= e.minTranslate()))
      )
        return
      if (
        !a &&
        ((h < n.startX && e.translate <= e.maxTranslate()) ||
          (h > n.startX && e.translate >= e.minTranslate()))
      )
        return
    }
  if (
    (r.activeElement &&
      r.activeElement.matches(s.focusableElements) &&
      r.activeElement !== o.target &&
      o.pointerType !== 'mouse' &&
      r.activeElement.blur(),
    r.activeElement &&
      o.target === r.activeElement &&
      o.target.matches(s.focusableElements))
  ) {
    ;((s.isMoved = !0), (e.allowClick = !1))
    return
  }
  ;(s.allowTouchCallbacks && e.emit('touchMove', o),
    (n.previousX = n.currentX),
    (n.previousY = n.currentY),
    (n.currentX = h),
    (n.currentY = f))
  let m = n.currentX - n.startX,
    c = n.currentY - n.startY
  if (e.params.threshold && Math.sqrt(m ** 2 + c ** 2) < e.params.threshold)
    return
  if (typeof s.isScrolling > 'u') {
    let M
    ;(e.isHorizontal() && n.currentY === n.startY) ||
    (e.isVertical() && n.currentX === n.startX)
      ? (s.isScrolling = !1)
      : m * m + c * c >= 25 &&
        ((M = (Math.atan2(Math.abs(c), Math.abs(m)) * 180) / Math.PI),
        (s.isScrolling = e.isHorizontal()
          ? M > i.touchAngle
          : 90 - M > i.touchAngle))
  }
  if (
    (s.isScrolling && e.emit('touchMoveOpposite', o),
    typeof s.startMoving > 'u' &&
      (n.currentX !== n.startX || n.currentY !== n.startY) &&
      (s.startMoving = !0),
    s.isScrolling ||
      (o.type === 'touchmove' && s.preventTouchMoveFromPointerMove))
  ) {
    s.isTouched = !1
    return
  }
  if (!s.startMoving) return
  ;((e.allowClick = !1),
    !i.cssMode && o.cancelable && o.preventDefault(),
    i.touchMoveStopPropagation && !i.nested && o.stopPropagation())
  let d = e.isHorizontal() ? m : c,
    g = e.isHorizontal() ? n.currentX - n.previousX : n.currentY - n.previousY
  ;(i.oneWayMovement &&
    ((d = Math.abs(d) * (a ? 1 : -1)), (g = Math.abs(g) * (a ? 1 : -1))),
    (n.diff = d),
    (d *= i.touchRatio),
    a && ((d = -d), (g = -g)))
  let T = e.touchesDirection
  ;((e.swipeDirection = d > 0 ? 'prev' : 'next'),
    (e.touchesDirection = g > 0 ? 'prev' : 'next'))
  let p = e.params.loop && !i.cssMode,
    v =
      (e.touchesDirection === 'next' && e.allowSlideNext) ||
      (e.touchesDirection === 'prev' && e.allowSlidePrev)
  if (!s.isMoved) {
    if (
      (p && v && e.loopFix({ direction: e.swipeDirection }),
      (s.startTranslate = e.getTranslate()),
      e.setTransition(0),
      e.animating)
    ) {
      let M = new window.CustomEvent('transitionend', {
        bubbles: !0,
        cancelable: !0,
        detail: { bySwiperTouchMove: !0 },
      })
      e.wrapperEl.dispatchEvent(M)
    }
    ;((s.allowMomentumBounce = !1),
      i.grabCursor &&
        (e.allowSlideNext === !0 || e.allowSlidePrev === !0) &&
        e.setGrabCursor(!0),
      e.emit('sliderFirstMove', o))
  }
  let y
  if (
    (new Date().getTime(),
    i._loopSwapReset !== !1 &&
      s.isMoved &&
      s.allowThresholdMove &&
      T !== e.touchesDirection &&
      p &&
      v &&
      Math.abs(d) >= 1)
  ) {
    ;(Object.assign(n, {
      startX: h,
      startY: f,
      currentX: h,
      currentY: f,
      startTranslate: s.currentTranslate,
    }),
      (s.loopSwapReset = !0),
      (s.startTranslate = s.currentTranslate))
    return
  }
  ;(e.emit('sliderMove', o),
    (s.isMoved = !0),
    (s.currentTranslate = d + s.startTranslate))
  let x = !0,
    L = i.resistanceRatio
  if (
    (i.touchReleaseOnEdges && (L = 0),
    d > 0
      ? (p &&
          v &&
          !y &&
          s.allowThresholdMove &&
          s.currentTranslate >
            (i.centeredSlides
              ? e.minTranslate() -
                e.slidesSizesGrid[e.activeIndex + 1] -
                (i.slidesPerView !== 'auto' &&
                e.slides.length - i.slidesPerView >= 2
                  ? e.slidesSizesGrid[e.activeIndex + 1] + e.params.spaceBetween
                  : 0) -
                e.params.spaceBetween
              : e.minTranslate()) &&
          e.loopFix({
            direction: 'prev',
            setTranslate: !0,
            activeSlideIndex: 0,
          }),
        s.currentTranslate > e.minTranslate() &&
          ((x = !1),
          i.resistance &&
            (s.currentTranslate =
              e.minTranslate() -
              1 +
              (-e.minTranslate() + s.startTranslate + d) ** L)))
      : d < 0 &&
        (p &&
          v &&
          !y &&
          s.allowThresholdMove &&
          s.currentTranslate <
            (i.centeredSlides
              ? e.maxTranslate() +
                e.slidesSizesGrid[e.slidesSizesGrid.length - 1] +
                e.params.spaceBetween +
                (i.slidesPerView !== 'auto' &&
                e.slides.length - i.slidesPerView >= 2
                  ? e.slidesSizesGrid[e.slidesSizesGrid.length - 1] +
                    e.params.spaceBetween
                  : 0)
              : e.maxTranslate()) &&
          e.loopFix({
            direction: 'next',
            setTranslate: !0,
            activeSlideIndex:
              e.slides.length -
              (i.slidesPerView === 'auto'
                ? e.slidesPerViewDynamic()
                : Math.ceil(parseFloat(i.slidesPerView, 10))),
          }),
        s.currentTranslate < e.maxTranslate() &&
          ((x = !1),
          i.resistance &&
            (s.currentTranslate =
              e.maxTranslate() +
              1 -
              (e.maxTranslate() - s.startTranslate - d) ** L))),
    x && (o.preventedByNestedSwiper = !0),
    !e.allowSlideNext &&
      e.swipeDirection === 'next' &&
      s.currentTranslate < s.startTranslate &&
      (s.currentTranslate = s.startTranslate),
    !e.allowSlidePrev &&
      e.swipeDirection === 'prev' &&
      s.currentTranslate > s.startTranslate &&
      (s.currentTranslate = s.startTranslate),
    !e.allowSlidePrev &&
      !e.allowSlideNext &&
      (s.currentTranslate = s.startTranslate),
    i.threshold > 0)
  )
    if (Math.abs(d) > i.threshold || s.allowThresholdMove) {
      if (!s.allowThresholdMove) {
        ;((s.allowThresholdMove = !0),
          (n.startX = n.currentX),
          (n.startY = n.currentY),
          (s.currentTranslate = s.startTranslate),
          (n.diff = e.isHorizontal()
            ? n.currentX - n.startX
            : n.currentY - n.startY))
        return
      }
    } else {
      s.currentTranslate = s.startTranslate
      return
    }
  !i.followFinger ||
    i.cssMode ||
    (((i.freeMode && i.freeMode.enabled && e.freeMode) ||
      i.watchSlidesProgress) &&
      (e.updateActiveIndex(), e.updateSlidesClasses()),
    i.freeMode && i.freeMode.enabled && e.freeMode && e.freeMode.onTouchMove(),
    e.updateProgress(s.currentTranslate),
    e.setTranslate(s.currentTranslate))
}
function Xd(t) {
  let r = this,
    e = r.touchEventsData,
    s = t
  s.originalEvent && (s = s.originalEvent)
  let i
  if (s.type === 'touchend' || s.type === 'touchcancel') {
    if (
      ((i = [...s.changedTouches].find((L) => L.identifier === e.touchId)),
      !i || i.identifier !== e.touchId)
    )
      return
  } else {
    if (e.touchId !== null || s.pointerId !== e.pointerId) return
    i = s
  }
  if (
    ['pointercancel', 'pointerout', 'pointerleave', 'contextmenu'].includes(
      s.type,
    ) &&
    !(
      ['pointercancel', 'contextmenu'].includes(s.type) &&
      (r.browser.isSafari || r.browser.isWebView)
    )
  )
    return
  ;((e.pointerId = null), (e.touchId = null))
  let { params: a, touches: l, rtlTranslate: o, slidesGrid: u, enabled: h } = r
  if (!h || (!a.simulateTouch && s.pointerType === 'mouse')) return
  if (
    (e.allowTouchCallbacks && r.emit('touchEnd', s),
    (e.allowTouchCallbacks = !1),
    !e.isTouched)
  ) {
    ;(e.isMoved && a.grabCursor && r.setGrabCursor(!1),
      (e.isMoved = !1),
      (e.startMoving = !1))
    return
  }
  a.grabCursor &&
    e.isMoved &&
    e.isTouched &&
    (r.allowSlideNext === !0 || r.allowSlidePrev === !0) &&
    r.setGrabCursor(!1)
  let f = Le(),
    m = f - e.touchStartTime
  if (r.allowClick) {
    let L = s.path || (s.composedPath && s.composedPath())
    ;(r.updateClickedSlide((L && L[0]) || s.target, L),
      r.emit('tap click', s),
      m < 300 &&
        f - e.lastClickTime < 300 &&
        r.emit('doubleTap doubleClick', s))
  }
  if (
    ((e.lastClickTime = Le()),
    rt(() => {
      r.destroyed || (r.allowClick = !0)
    }),
    !e.isTouched ||
      !e.isMoved ||
      !r.swipeDirection ||
      (l.diff === 0 && !e.loopSwapReset) ||
      (e.currentTranslate === e.startTranslate && !e.loopSwapReset))
  ) {
    ;((e.isTouched = !1), (e.isMoved = !1), (e.startMoving = !1))
    return
  }
  ;((e.isTouched = !1), (e.isMoved = !1), (e.startMoving = !1))
  let c
  if (
    (a.followFinger
      ? (c = o ? r.translate : -r.translate)
      : (c = -e.currentTranslate),
    a.cssMode)
  )
    return
  if (a.freeMode && a.freeMode.enabled) {
    r.freeMode.onTouchEnd({ currentPos: c })
    return
  }
  let d = c >= -r.maxTranslate() && !r.params.loop,
    g = 0,
    T = r.slidesSizesGrid[0]
  for (
    let L = 0;
    L < u.length;
    L += L < a.slidesPerGroupSkip ? 1 : a.slidesPerGroup
  ) {
    let M = L < a.slidesPerGroupSkip - 1 ? 1 : a.slidesPerGroup
    typeof u[L + M] < 'u'
      ? (d || (c >= u[L] && c < u[L + M])) && ((g = L), (T = u[L + M] - u[L]))
      : (d || c >= u[L]) && ((g = L), (T = u[u.length - 1] - u[u.length - 2]))
  }
  let p = null,
    v = null
  a.rewind &&
    (r.isBeginning
      ? (v =
          a.virtual && a.virtual.enabled && r.virtual
            ? r.virtual.slides.length - 1
            : r.slides.length - 1)
      : r.isEnd && (p = 0))
  let y = (c - u[g]) / T,
    x = g < a.slidesPerGroupSkip - 1 ? 1 : a.slidesPerGroup
  if (m > a.longSwipesMs) {
    if (!a.longSwipes) {
      r.slideTo(r.activeIndex)
      return
    }
    ;(r.swipeDirection === 'next' &&
      (y >= a.longSwipesRatio
        ? r.slideTo(a.rewind && r.isEnd ? p : g + x)
        : r.slideTo(g)),
      r.swipeDirection === 'prev' &&
        (y > 1 - a.longSwipesRatio
          ? r.slideTo(g + x)
          : v !== null && y < 0 && Math.abs(y) > a.longSwipesRatio
            ? r.slideTo(v)
            : r.slideTo(g)))
  } else {
    if (!a.shortSwipes) {
      r.slideTo(r.activeIndex)
      return
    }
    r.navigation &&
    (s.target === r.navigation.nextEl || s.target === r.navigation.prevEl)
      ? s.target === r.navigation.nextEl
        ? r.slideTo(g + x)
        : r.slideTo(g)
      : (r.swipeDirection === 'next' && r.slideTo(p !== null ? p : g + x),
        r.swipeDirection === 'prev' && r.slideTo(v !== null ? v : g))
  }
}
function Oa() {
  let t = this,
    { params: r, el: e } = t
  if (e && e.offsetWidth === 0) return
  r.breakpoints && t.setBreakpoint()
  let { allowSlideNext: s, allowSlidePrev: i, snapGrid: n } = t,
    a = t.virtual && t.params.virtual.enabled
  ;((t.allowSlideNext = !0),
    (t.allowSlidePrev = !0),
    t.updateSize(),
    t.updateSlides(),
    t.updateSlidesClasses())
  let l = a && r.loop
  ;((r.slidesPerView === 'auto' || r.slidesPerView > 1) &&
  t.isEnd &&
  !t.isBeginning &&
  !t.params.centeredSlides &&
  !l
    ? t.slideTo(t.slides.length - 1, 0, !1, !0)
    : t.params.loop && !a
      ? t.slideToLoop(t.realIndex, 0, !1, !0)
      : t.slideTo(t.activeIndex, 0, !1, !0),
    t.autoplay &&
      t.autoplay.running &&
      t.autoplay.paused &&
      (clearTimeout(t.autoplay.resizeTimeout),
      (t.autoplay.resizeTimeout = setTimeout(() => {
        t.autoplay &&
          t.autoplay.running &&
          t.autoplay.paused &&
          t.autoplay.resume()
      }, 500))),
    (t.allowSlidePrev = i),
    (t.allowSlideNext = s),
    t.params.watchOverflow && n !== t.snapGrid && t.checkOverflow())
}
function Qd(t) {
  let r = this
  r.enabled &&
    (r.allowClick ||
      (r.params.preventClicks && t.preventDefault(),
      r.params.preventClicksPropagation &&
        r.animating &&
        (t.stopPropagation(), t.stopImmediatePropagation())))
}
function Jd() {
  let t = this,
    { wrapperEl: r, rtlTranslate: e, enabled: s } = t
  if (!s) return
  ;((t.previousTranslate = t.translate),
    t.isHorizontal()
      ? (t.translate = -r.scrollLeft)
      : (t.translate = -r.scrollTop),
    t.translate === 0 && (t.translate = 0),
    t.updateActiveIndex(),
    t.updateSlidesClasses())
  let i,
    n = t.maxTranslate() - t.minTranslate()
  ;(n === 0 ? (i = 0) : (i = (t.translate - t.minTranslate()) / n),
    i !== t.progress && t.updateProgress(e ? -t.translate : t.translate),
    t.emit('setTranslate', t.translate, !1))
}
function Zd(t) {
  let r = this
  ;(Us(r, t.target),
    !(
      r.params.cssMode ||
      (r.params.slidesPerView !== 'auto' && !r.params.autoHeight)
    ) && r.update())
}
function eu() {
  let t = this
  t.documentTouchHandlerProceeded ||
    ((t.documentTouchHandlerProceeded = !0),
    t.params.touchReleaseOnEdges && (t.el.style.touchAction = 'auto'))
}
function tu() {
  let t = this,
    { params: r } = t
  ;((t.onTouchStart = Yd.bind(t)),
    (t.onTouchMove = Kd.bind(t)),
    (t.onTouchEnd = Xd.bind(t)),
    (t.onDocumentTouchStart = eu.bind(t)),
    r.cssMode && (t.onScroll = Jd.bind(t)),
    (t.onClick = Qd.bind(t)),
    (t.onLoad = Zd.bind(t)),
    _a(t, 'on'))
}
function ru() {
  _a(this, 'off')
}
function iu() {
  let t = this,
    { realIndex: r, initialized: e, params: s, el: i } = t,
    n = s.breakpoints
  if (!n || (n && Object.keys(n).length === 0)) return
  let a = te(),
    l =
      s.breakpointsBase === 'window' || !s.breakpointsBase
        ? s.breakpointsBase
        : 'container',
    o =
      ['window', 'container'].includes(s.breakpointsBase) || !s.breakpointsBase
        ? t.el
        : a.querySelector(s.breakpointsBase),
    u = t.getBreakpoint(n, l, o)
  if (!u || t.currentBreakpoint === u) return
  let f = (u in n ? n[u] : void 0) || t.originalParams,
    m = Ra(t, s),
    c = Ra(t, f),
    d = t.params.grabCursor,
    g = f.grabCursor,
    T = s.enabled
  ;(m && !c
    ? (i.classList.remove(
        `${s.containerModifierClass}grid`,
        `${s.containerModifierClass}grid-column`,
      ),
      t.emitContainerClasses())
    : !m &&
      c &&
      (i.classList.add(`${s.containerModifierClass}grid`),
      ((f.grid.fill && f.grid.fill === 'column') ||
        (!f.grid.fill && s.grid.fill === 'column')) &&
        i.classList.add(`${s.containerModifierClass}grid-column`),
      t.emitContainerClasses()),
    d && !g ? t.unsetGrabCursor() : !d && g && t.setGrabCursor(),
    ['navigation', 'pagination', 'scrollbar'].forEach((M) => {
      if (typeof f[M] > 'u') return
      let R = s[M] && s[M].enabled,
        w = f[M] && f[M].enabled
      ;(R && !w && t[M].disable(), !R && w && t[M].enable())
    }))
  let p = f.direction && f.direction !== s.direction,
    v = s.loop && (f.slidesPerView !== s.slidesPerView || p),
    y = s.loop
  ;(p && e && t.changeDirection(), Oe(t.params, f))
  let x = t.params.enabled,
    L = t.params.loop
  ;(Object.assign(t, {
    allowTouchMove: t.params.allowTouchMove,
    allowSlideNext: t.params.allowSlideNext,
    allowSlidePrev: t.params.allowSlidePrev,
  }),
    T && !x ? t.disable() : !T && x && t.enable(),
    (t.currentBreakpoint = u),
    t.emit('_beforeBreakpoint', f),
    e &&
      (v
        ? (t.loopDestroy(), t.loopCreate(r), t.updateSlides())
        : !y && L
          ? (t.loopCreate(r), t.updateSlides())
          : y && !L && t.loopDestroy()),
    t.emit('breakpoint', f))
}
function nu(t, r = 'window', e) {
  if (!t || (r === 'container' && !e)) return
  let s = !1,
    i = ee(),
    n = r === 'window' ? i.innerHeight : e.clientHeight,
    a = Object.keys(t).map((l) => {
      if (typeof l == 'string' && l.indexOf('@') === 0) {
        let o = parseFloat(l.substr(1))
        return { value: n * o, point: l }
      }
      return { value: l, point: l }
    })
  a.sort((l, o) => parseInt(l.value, 10) - parseInt(o.value, 10))
  for (let l = 0; l < a.length; l += 1) {
    let { point: o, value: u } = a[l]
    r === 'window'
      ? i.matchMedia(`(min-width: ${u}px)`).matches && (s = o)
      : u <= e.clientWidth && (s = o)
  }
  return s || 'max'
}
function ou(t, r) {
  let e = []
  return (
    t.forEach((s) => {
      typeof s == 'object'
        ? Object.keys(s).forEach((i) => {
            s[i] && e.push(r + i)
          })
        : typeof s == 'string' && e.push(r + s)
    }),
    e
  )
}
function lu() {
  let t = this,
    { classNames: r, params: e, rtl: s, el: i, device: n } = t,
    a = ou(
      [
        'initialized',
        e.direction,
        { 'free-mode': t.params.freeMode && e.freeMode.enabled },
        { autoheight: e.autoHeight },
        { rtl: s },
        { grid: e.grid && e.grid.rows > 1 },
        {
          'grid-column': e.grid && e.grid.rows > 1 && e.grid.fill === 'column',
        },
        { android: n.android },
        { ios: n.ios },
        { 'css-mode': e.cssMode },
        { centered: e.cssMode && e.centeredSlides },
        { 'watch-progress': e.watchSlidesProgress },
      ],
      e.containerModifierClass,
    )
  ;(r.push(...a), i.classList.add(...r), t.emitContainerClasses())
}
function cu() {
  let t = this,
    { el: r, classNames: e } = t
  !r ||
    typeof r == 'string' ||
    (r.classList.remove(...e), t.emitContainerClasses())
}
function uu() {
  let t = this,
    { isLocked: r, params: e } = t,
    { slidesOffsetBefore: s } = e
  if (s) {
    let i = t.slides.length - 1,
      n = t.slidesGrid[i] + t.slidesSizesGrid[i] + s * 2
    t.isLocked = t.size > n
  } else t.isLocked = t.snapGrid.length === 1
  ;(e.allowSlideNext === !0 && (t.allowSlideNext = !t.isLocked),
    e.allowSlidePrev === !0 && (t.allowSlidePrev = !t.isLocked),
    r && r !== t.isLocked && (t.isEnd = !1),
    r !== t.isLocked && t.emit(t.isLocked ? 'lock' : 'unlock'))
}
function hu(t, r) {
  return function (s = {}) {
    let i = Object.keys(s)[0],
      n = s[i]
    if (typeof n != 'object' || n === null) {
      Oe(r, s)
      return
    }
    if (
      (t[i] === !0 && (t[i] = { enabled: !0 }),
      i === 'navigation' &&
        t[i] &&
        t[i].enabled &&
        !t[i].prevEl &&
        !t[i].nextEl &&
        (t[i].auto = !0),
      ['pagination', 'scrollbar'].indexOf(i) >= 0 &&
        t[i] &&
        t[i].enabled &&
        !t[i].el &&
        (t[i].auto = !0),
      !(i in t && 'enabled' in n))
    ) {
      Oe(r, s)
      return
    }
    ;(typeof t[i] == 'object' && !('enabled' in t[i]) && (t[i].enabled = !0),
      t[i] || (t[i] = { enabled: !1 }),
      Oe(r, s))
  }
}
var Zi,
  en,
  tn,
  dd,
  Pa,
  rn,
  Us,
  sn,
  on,
  Sd,
  Cd,
  kd,
  _d,
  qd,
  Wd,
  _a,
  su,
  Ra,
  au,
  du,
  fu,
  Ha,
  nn,
  an,
  qe,
  $a = J(() => {
    Ve()
    re()
    dd = {
      on(t, r, e) {
        let s = this
        if (!s.eventsListeners || s.destroyed || typeof r != 'function')
          return s
        let i = e ? 'unshift' : 'push'
        return (
          t.split(' ').forEach((n) => {
            ;(s.eventsListeners[n] || (s.eventsListeners[n] = []),
              s.eventsListeners[n][i](r))
          }),
          s
        )
      },
      once(t, r, e) {
        let s = this
        if (!s.eventsListeners || s.destroyed || typeof r != 'function')
          return s
        function i(...n) {
          ;(s.off(t, i),
            i.__emitterProxy && delete i.__emitterProxy,
            r.apply(s, n))
        }
        return ((i.__emitterProxy = r), s.on(t, i, e))
      },
      onAny(t, r) {
        let e = this
        if (!e.eventsListeners || e.destroyed || typeof t != 'function')
          return e
        let s = r ? 'unshift' : 'push'
        return (
          e.eventsAnyListeners.indexOf(t) < 0 && e.eventsAnyListeners[s](t),
          e
        )
      },
      offAny(t) {
        let r = this
        if (!r.eventsListeners || r.destroyed || !r.eventsAnyListeners) return r
        let e = r.eventsAnyListeners.indexOf(t)
        return (e >= 0 && r.eventsAnyListeners.splice(e, 1), r)
      },
      off(t, r) {
        let e = this
        return (
          !e.eventsListeners ||
            e.destroyed ||
            !e.eventsListeners ||
            t.split(' ').forEach((s) => {
              typeof r > 'u'
                ? (e.eventsListeners[s] = [])
                : e.eventsListeners[s] &&
                  e.eventsListeners[s].forEach((i, n) => {
                    ;(i === r ||
                      (i.__emitterProxy && i.__emitterProxy === r)) &&
                      e.eventsListeners[s].splice(n, 1)
                  })
            }),
          e
        )
      },
      emit(...t) {
        let r = this
        if (!r.eventsListeners || r.destroyed || !r.eventsListeners) return r
        let e, s, i
        return (
          typeof t[0] == 'string' || Array.isArray(t[0])
            ? ((e = t[0]), (s = t.slice(1, t.length)), (i = r))
            : ((e = t[0].events), (s = t[0].data), (i = t[0].context || r)),
          s.unshift(i),
          (Array.isArray(e) ? e : e.split(' ')).forEach((a) => {
            ;(r.eventsAnyListeners &&
              r.eventsAnyListeners.length &&
              r.eventsAnyListeners.forEach((l) => {
                l.apply(i, [a, ...s])
              }),
              r.eventsListeners &&
                r.eventsListeners[a] &&
                r.eventsListeners[a].forEach((l) => {
                  l.apply(i, s)
                }))
          }),
          r
        )
      },
    }
    Pa = (t, r, e) => {
      r && !t.classList.contains(e)
        ? t.classList.add(e)
        : !r && t.classList.contains(e) && t.classList.remove(e)
    }
    rn = (t, r, e) => {
      r && !t.classList.contains(e)
        ? t.classList.add(e)
        : !r && t.classList.contains(e) && t.classList.remove(e)
    }
    ;((Us = (t, r) => {
      if (!t || t.destroyed || !t.params) return
      let e = () => (t.isElement ? 'swiper-slide' : `.${t.params.slideClass}`),
        s = r.closest(e())
      if (s) {
        let i = s.querySelector(`.${t.params.lazyPreloaderClass}`)
        ;(!i &&
          t.isElement &&
          (s.shadowRoot
            ? (i = s.shadowRoot.querySelector(
                `.${t.params.lazyPreloaderClass}`,
              ))
            : requestAnimationFrame(() => {
                s.shadowRoot &&
                  ((i = s.shadowRoot.querySelector(
                    `.${t.params.lazyPreloaderClass}`,
                  )),
                  i && !i.lazyPreloaderManaged && i.remove())
              })),
          i && !i.lazyPreloaderManaged && i.remove())
      }
    }),
      (sn = (t, r) => {
        if (!t.slides[r]) return
        let e = t.slides[r].querySelector('[loading="lazy"]')
        e && e.removeAttribute('loading')
      }),
      (on = (t) => {
        if (!t || t.destroyed || !t.params) return
        let r = t.params.lazyPreloadPrevNext,
          e = t.slides.length
        if (!e || !r || r < 0) return
        r = Math.min(r, e)
        let s =
            t.params.slidesPerView === 'auto'
              ? t.slidesPerViewDynamic()
              : Math.ceil(t.params.slidesPerView),
          i = t.activeIndex
        if (t.params.grid && t.params.grid.rows > 1) {
          let a = i,
            l = [a - r]
          ;(l.push(...Array.from({ length: r }).map((o, u) => a + s + u)),
            t.slides.forEach((o, u) => {
              l.includes(o.column) && sn(t, u)
            }))
          return
        }
        let n = i + s - 1
        if (t.params.rewind || t.params.loop)
          for (let a = i - r; a <= n + r; a += 1) {
            let l = ((a % e) + e) % e
            ;(l < i || l > n) && sn(t, l)
          }
        else
          for (let a = Math.max(i - r, 0); a <= Math.min(n + r, e - 1); a += 1)
            a !== i && (a > n || a < i) && sn(t, a)
      }))
    Sd = {
      updateSize: ud,
      updateSlides: fd,
      updateAutoHeight: hd,
      updateSlidesOffset: md,
      updateSlidesProgress: pd,
      updateProgress: gd,
      updateSlidesClasses: vd,
      updateActiveIndex: bd,
      updateClickedSlide: Td,
    }
    Cd = {
      getTranslate: Ed,
      setTranslate: xd,
      minTranslate: wd,
      maxTranslate: Md,
      translateTo: Ld,
    }
    kd = { setTransition: Ad, transitionStart: Id, transitionEnd: Pd }
    _d = {
      slideTo: Od,
      slideToLoop: Rd,
      slideNext: Hd,
      slidePrev: Dd,
      slideReset: Bd,
      slideToClosest: Fd,
      slideToClickedSlide: Vd,
    }
    qd = { loopCreate: $d, loopFix: Nd, loopDestroy: zd }
    Wd = { setGrabCursor: Ud, unsetGrabCursor: jd }
    _a = (t, r) => {
      let e = te(),
        { params: s, el: i, wrapperEl: n, device: a } = t,
        l = !!s.nested,
        o = r === 'on' ? 'addEventListener' : 'removeEventListener',
        u = r
      !i ||
        typeof i == 'string' ||
        (e[o]('touchstart', t.onDocumentTouchStart, {
          passive: !1,
          capture: l,
        }),
        i[o]('touchstart', t.onTouchStart, { passive: !1 }),
        i[o]('pointerdown', t.onTouchStart, { passive: !1 }),
        e[o]('touchmove', t.onTouchMove, { passive: !1, capture: l }),
        e[o]('pointermove', t.onTouchMove, { passive: !1, capture: l }),
        e[o]('touchend', t.onTouchEnd, { passive: !0 }),
        e[o]('pointerup', t.onTouchEnd, { passive: !0 }),
        e[o]('pointercancel', t.onTouchEnd, { passive: !0 }),
        e[o]('touchcancel', t.onTouchEnd, { passive: !0 }),
        e[o]('pointerout', t.onTouchEnd, { passive: !0 }),
        e[o]('pointerleave', t.onTouchEnd, { passive: !0 }),
        e[o]('contextmenu', t.onTouchEnd, { passive: !0 }),
        (s.preventClicks || s.preventClicksPropagation) &&
          i[o]('click', t.onClick, !0),
        s.cssMode && n[o]('scroll', t.onScroll),
        s.updateOnWindowResize
          ? t[u](
              a.ios || a.android
                ? 'resize orientationchange observerUpdate'
                : 'resize observerUpdate',
              Oa,
              !0,
            )
          : t[u]('observerUpdate', Oa, !0),
        i[o]('load', t.onLoad, { capture: !0 }))
    }
    ;((su = { attachEvents: tu, detachEvents: ru }),
      (Ra = (t, r) => t.grid && r.grid && r.grid.rows > 1))
    au = { setBreakpoint: iu, getBreakpoint: nu }
    du = { addClasses: lu, removeClasses: cu }
    ;((fu = { checkOverflow: uu }),
      (Ha = {
        init: !0,
        direction: 'horizontal',
        oneWayMovement: !1,
        swiperElementNodeName: 'SWIPER-CONTAINER',
        touchEventsTarget: 'wrapper',
        initialSlide: 0,
        speed: 300,
        cssMode: !1,
        updateOnWindowResize: !0,
        resizeObserver: !0,
        nested: !1,
        createElements: !1,
        eventsPrefix: 'swiper',
        enabled: !0,
        focusableElements:
          'input, select, option, textarea, button, video, label',
        width: null,
        height: null,
        preventInteractionOnTransition: !1,
        userAgent: null,
        url: null,
        edgeSwipeDetection: !1,
        edgeSwipeThreshold: 20,
        autoHeight: !1,
        setWrapperSize: !1,
        virtualTranslate: !1,
        effect: 'slide',
        breakpoints: void 0,
        breakpointsBase: 'window',
        spaceBetween: 0,
        slidesPerView: 1,
        slidesPerGroup: 1,
        slidesPerGroupSkip: 0,
        slidesPerGroupAuto: !1,
        centeredSlides: !1,
        centeredSlidesBounds: !1,
        slidesOffsetBefore: 0,
        slidesOffsetAfter: 0,
        normalizeSlideIndex: !0,
        centerInsufficientSlides: !1,
        snapToSlideEdge: !1,
        watchOverflow: !0,
        roundLengths: !1,
        touchRatio: 1,
        touchAngle: 45,
        simulateTouch: !0,
        shortSwipes: !0,
        longSwipes: !0,
        longSwipesRatio: 0.5,
        longSwipesMs: 300,
        followFinger: !0,
        allowTouchMove: !0,
        threshold: 5,
        touchMoveStopPropagation: !1,
        touchStartPreventDefault: !0,
        touchStartForcePreventDefault: !1,
        touchReleaseOnEdges: !1,
        uniqueNavElements: !0,
        resistance: !0,
        resistanceRatio: 0.85,
        watchSlidesProgress: !1,
        grabCursor: !1,
        preventClicks: !0,
        preventClicksPropagation: !0,
        slideToClickedSlide: !1,
        loop: !1,
        loopAddBlankSlides: !0,
        loopAdditionalSlides: 0,
        loopPreventsSliding: !0,
        rewind: !1,
        allowSlidePrev: !0,
        allowSlideNext: !0,
        swipeHandler: null,
        noSwiping: !0,
        noSwipingClass: 'swiper-no-swiping',
        noSwipingSelector: null,
        passiveListeners: !0,
        maxBackfaceHiddenSlides: 10,
        containerModifierClass: 'swiper-',
        slideClass: 'swiper-slide',
        slideBlankClass: 'swiper-slide-blank',
        slideActiveClass: 'swiper-slide-active',
        slideVisibleClass: 'swiper-slide-visible',
        slideFullyVisibleClass: 'swiper-slide-fully-visible',
        slideNextClass: 'swiper-slide-next',
        slidePrevClass: 'swiper-slide-prev',
        wrapperClass: 'swiper-wrapper',
        lazyPreloaderClass: 'swiper-lazy-preloader',
        lazyPreloadPrevNext: 0,
        runCallbacksOnInit: !0,
        _emitClasses: !1,
      }))
    ;((nn = {
      eventsEmitter: dd,
      update: Sd,
      translate: Cd,
      transition: kd,
      slide: _d,
      loop: qd,
      grabCursor: Wd,
      events: su,
      breakpoints: au,
      checkOverflow: fu,
      classes: du,
    }),
      (an = {}),
      (qe = class t {
        constructor(...r) {
          let e, s
          ;(r.length === 1 &&
          r[0].constructor &&
          Object.prototype.toString.call(r[0]).slice(8, -1) === 'Object'
            ? (s = r[0])
            : ([e, s] = r),
            s || (s = {}),
            (s = Oe({}, s)),
            e && !s.el && (s.el = e))
          let i = te()
          if (
            s.el &&
            typeof s.el == 'string' &&
            i.querySelectorAll(s.el).length > 1
          ) {
            let o = []
            return (
              i.querySelectorAll(s.el).forEach((u) => {
                let h = Oe({}, s, { el: u })
                o.push(new t(h))
              }),
              o
            )
          }
          let n = this
          ;((n.__swiper__ = !0),
            (n.support = Da()),
            (n.device = Ba({ userAgent: s.userAgent })),
            (n.browser = Fa()),
            (n.eventsListeners = {}),
            (n.eventsAnyListeners = []),
            (n.modules = [...n.__modules__]),
            s.modules &&
              Array.isArray(s.modules) &&
              s.modules.forEach((o) => {
                typeof o == 'function' &&
                  n.modules.indexOf(o) < 0 &&
                  n.modules.push(o)
              }))
          let a = {}
          n.modules.forEach((o) => {
            o({
              params: s,
              swiper: n,
              extendParams: hu(s, a),
              on: n.on.bind(n),
              once: n.once.bind(n),
              off: n.off.bind(n),
              emit: n.emit.bind(n),
            })
          })
          let l = Oe({}, Ha, a)
          return (
            (n.params = Oe({}, l, an, s)),
            (n.originalParams = Oe({}, n.params)),
            (n.passedParams = Oe({}, s)),
            n.params &&
              n.params.on &&
              Object.keys(n.params.on).forEach((o) => {
                n.on(o, n.params.on[o])
              }),
            n.params && n.params.onAny && n.onAny(n.params.onAny),
            Object.assign(n, {
              enabled: n.params.enabled,
              el: e,
              classNames: [],
              slides: [],
              slidesGrid: [],
              snapGrid: [],
              slidesSizesGrid: [],
              isHorizontal() {
                return n.params.direction === 'horizontal'
              },
              isVertical() {
                return n.params.direction === 'vertical'
              },
              activeIndex: 0,
              realIndex: 0,
              isBeginning: !0,
              isEnd: !1,
              translate: 0,
              previousTranslate: 0,
              progress: 0,
              velocity: 0,
              animating: !1,
              cssOverflowAdjustment() {
                return Math.trunc(this.translate / 2 ** 23) * 2 ** 23
              },
              allowSlideNext: n.params.allowSlideNext,
              allowSlidePrev: n.params.allowSlidePrev,
              touchEventsData: {
                isTouched: void 0,
                isMoved: void 0,
                allowTouchCallbacks: void 0,
                touchStartTime: void 0,
                isScrolling: void 0,
                currentTranslate: void 0,
                startTranslate: void 0,
                allowThresholdMove: void 0,
                focusableElements: n.params.focusableElements,
                lastClickTime: 0,
                clickTimeout: void 0,
                velocities: [],
                allowMomentumBounce: void 0,
                startMoving: void 0,
                pointerId: null,
                touchId: null,
              },
              allowClick: !0,
              allowTouchMove: n.params.allowTouchMove,
              touches: {
                startX: 0,
                startY: 0,
                currentX: 0,
                currentY: 0,
                diff: 0,
              },
              imagesToLoad: [],
              imagesLoaded: 0,
            }),
            n.emit('_swiper'),
            n.params.init && n.init(),
            n
          )
        }
        getDirectionLabel(r) {
          return this.isHorizontal()
            ? r
            : {
                width: 'height',
                'margin-top': 'margin-left',
                'margin-bottom ': 'margin-right',
                'margin-left': 'margin-top',
                'margin-right': 'margin-bottom',
                'padding-left': 'padding-top',
                'padding-right': 'padding-bottom',
                marginRight: 'marginBottom',
              }[r]
        }
        getSlideIndex(r) {
          let { slidesEl: e, params: s } = this,
            i = ne(e, `.${s.slideClass}, swiper-slide`),
            n = Et(i[0])
          return Et(r) - n
        }
        getSlideIndexByData(r) {
          return this.getSlideIndex(
            this.slides.find(
              (e) => e.getAttribute('data-swiper-slide-index') * 1 === r,
            ),
          )
        }
        getSlideIndexWhenGrid(r) {
          return (
            this.grid &&
              this.params.grid &&
              this.params.grid.rows > 1 &&
              (this.params.grid.fill === 'column'
                ? (r = Math.floor(r / this.params.grid.rows))
                : this.params.grid.fill === 'row' &&
                  (r =
                    r % Math.ceil(this.slides.length / this.params.grid.rows))),
            r
          )
        }
        recalcSlides() {
          let r = this,
            { slidesEl: e, params: s } = r
          r.slides = ne(e, `.${s.slideClass}, swiper-slide`)
        }
        enable() {
          let r = this
          r.enabled ||
            ((r.enabled = !0),
            r.params.grabCursor && r.setGrabCursor(),
            r.emit('enable'))
        }
        disable() {
          let r = this
          r.enabled &&
            ((r.enabled = !1),
            r.params.grabCursor && r.unsetGrabCursor(),
            r.emit('disable'))
        }
        setProgress(r, e) {
          let s = this
          r = Math.min(Math.max(r, 0), 1)
          let i = s.minTranslate(),
            a = (s.maxTranslate() - i) * r + i
          ;(s.translateTo(a, typeof e > 'u' ? 0 : e),
            s.updateActiveIndex(),
            s.updateSlidesClasses())
        }
        emitContainerClasses() {
          let r = this
          if (!r.params._emitClasses || !r.el) return
          let e = r.el.className
            .split(' ')
            .filter(
              (s) =>
                s.indexOf('swiper') === 0 ||
                s.indexOf(r.params.containerModifierClass) === 0,
            )
          r.emit('_containerClasses', e.join(' '))
        }
        getSlideClasses(r) {
          let e = this
          return e.destroyed
            ? ''
            : r.className
                .split(' ')
                .filter(
                  (s) =>
                    s.indexOf('swiper-slide') === 0 ||
                    s.indexOf(e.params.slideClass) === 0,
                )
                .join(' ')
        }
        emitSlidesClasses() {
          let r = this
          if (!r.params._emitClasses || !r.el) return
          let e = []
          ;(r.slides.forEach((s) => {
            let i = r.getSlideClasses(s)
            ;(e.push({ slideEl: s, classNames: i }),
              r.emit('_slideClass', s, i))
          }),
            r.emit('_slideClasses', e))
        }
        slidesPerViewDynamic(r = 'current', e = !1) {
          let s = this,
            {
              params: i,
              slides: n,
              slidesGrid: a,
              slidesSizesGrid: l,
              size: o,
              activeIndex: u,
            } = s,
            h = 1
          if (typeof i.slidesPerView == 'number') return i.slidesPerView
          if (i.centeredSlides) {
            let f = n[u] ? Math.ceil(n[u].swiperSlideSize) : 0,
              m
            for (let c = u + 1; c < n.length; c += 1)
              n[c] &&
                !m &&
                ((f += Math.ceil(n[c].swiperSlideSize)),
                (h += 1),
                f > o && (m = !0))
            for (let c = u - 1; c >= 0; c -= 1)
              n[c] &&
                !m &&
                ((f += n[c].swiperSlideSize), (h += 1), f > o && (m = !0))
          } else if (r === 'current')
            for (let f = u + 1; f < n.length; f += 1)
              (e ? a[f] + l[f] - a[u] < o : a[f] - a[u] < o) && (h += 1)
          else for (let f = u - 1; f >= 0; f -= 1) a[u] - a[f] < o && (h += 1)
          return h
        }
        update() {
          let r = this
          if (!r || r.destroyed) return
          let { snapGrid: e, params: s } = r
          ;(s.breakpoints && r.setBreakpoint(),
            [...r.el.querySelectorAll('[loading="lazy"]')].forEach((a) => {
              a.complete && Us(r, a)
            }),
            r.updateSize(),
            r.updateSlides(),
            r.updateProgress(),
            r.updateSlidesClasses())
          function i() {
            let a = r.rtlTranslate ? r.translate * -1 : r.translate,
              l = Math.min(Math.max(a, r.maxTranslate()), r.minTranslate())
            ;(r.setTranslate(l), r.updateActiveIndex(), r.updateSlidesClasses())
          }
          let n
          if (s.freeMode && s.freeMode.enabled && !s.cssMode)
            (i(), s.autoHeight && r.updateAutoHeight())
          else {
            if (
              (s.slidesPerView === 'auto' || s.slidesPerView > 1) &&
              r.isEnd &&
              !s.centeredSlides
            ) {
              let a =
                r.virtual && s.virtual.enabled ? r.virtual.slides : r.slides
              n = r.slideTo(a.length - 1, 0, !1, !0)
            } else n = r.slideTo(r.activeIndex, 0, !1, !0)
            n || i()
          }
          ;(s.watchOverflow && e !== r.snapGrid && r.checkOverflow(),
            r.emit('update'))
        }
        changeDirection(r, e = !0) {
          let s = this,
            i = s.params.direction
          return (
            r || (r = i === 'horizontal' ? 'vertical' : 'horizontal'),
            r === i ||
              (r !== 'horizontal' && r !== 'vertical') ||
              (s.el.classList.remove(`${s.params.containerModifierClass}${i}`),
              s.el.classList.add(`${s.params.containerModifierClass}${r}`),
              s.emitContainerClasses(),
              (s.params.direction = r),
              s.slides.forEach((n) => {
                r === 'vertical' ? (n.style.width = '') : (n.style.height = '')
              }),
              s.emit('changeDirection'),
              e && s.update()),
            s
          )
        }
        changeLanguageDirection(r) {
          let e = this
          ;(e.rtl && r === 'rtl') ||
            (!e.rtl && r === 'ltr') ||
            ((e.rtl = r === 'rtl'),
            (e.rtlTranslate = e.params.direction === 'horizontal' && e.rtl),
            e.rtl
              ? (e.el.classList.add(`${e.params.containerModifierClass}rtl`),
                (e.el.dir = 'rtl'))
              : (e.el.classList.remove(`${e.params.containerModifierClass}rtl`),
                (e.el.dir = 'ltr')),
            e.update())
        }
        mount(r) {
          let e = this
          if (e.mounted) return !0
          let s = r || e.params.el
          if ((typeof s == 'string' && (s = document.querySelector(s)), !s))
            return !1
          ;((s.swiper = e),
            s.parentNode &&
              s.parentNode.host &&
              s.parentNode.host.nodeName ===
                e.params.swiperElementNodeName.toUpperCase() &&
              (e.isElement = !0))
          let i = () =>
              `.${(e.params.wrapperClass || '').trim().split(' ').join('.')}`,
            a =
              s && s.shadowRoot && s.shadowRoot.querySelector
                ? s.shadowRoot.querySelector(i())
                : ne(s, i())[0]
          return (
            !a &&
              e.params.createElements &&
              ((a = he('div', e.params.wrapperClass)),
              s.append(a),
              ne(s, `.${e.params.slideClass}`).forEach((l) => {
                a.append(l)
              })),
            Object.assign(e, {
              el: s,
              wrapperEl: a,
              slidesEl:
                e.isElement && !s.parentNode.host.slideSlots
                  ? s.parentNode.host
                  : a,
              hostEl: e.isElement ? s.parentNode.host : s,
              mounted: !0,
              rtl:
                s.dir.toLowerCase() === 'rtl' || yt(s, 'direction') === 'rtl',
              rtlTranslate:
                e.params.direction === 'horizontal' &&
                (s.dir.toLowerCase() === 'rtl' || yt(s, 'direction') === 'rtl'),
              wrongRTL: yt(a, 'display') === '-webkit-box',
            }),
            !0
          )
        }
        init(r) {
          let e = this
          if (e.initialized || e.mount(r) === !1) return e
          ;(e.emit('beforeInit'),
            e.params.breakpoints && e.setBreakpoint(),
            e.addClasses(),
            e.updateSize(),
            e.updateSlides(),
            e.params.watchOverflow && e.checkOverflow(),
            e.params.grabCursor && e.enabled && e.setGrabCursor(),
            e.params.loop && e.virtual && e.params.virtual.enabled
              ? e.slideTo(
                  e.params.initialSlide + e.virtual.slidesBefore,
                  0,
                  e.params.runCallbacksOnInit,
                  !1,
                  !0,
                )
              : e.slideTo(
                  e.params.initialSlide,
                  0,
                  e.params.runCallbacksOnInit,
                  !1,
                  !0,
                ),
            e.params.loop && e.loopCreate(void 0, !0),
            e.attachEvents())
          let i = [...e.el.querySelectorAll('[loading="lazy"]')]
          return (
            e.isElement &&
              i.push(...e.hostEl.querySelectorAll('[loading="lazy"]')),
            i.forEach((n) => {
              n.complete
                ? Us(e, n)
                : n.addEventListener('load', (a) => {
                    Us(e, a.target)
                  })
            }),
            on(e),
            (e.initialized = !0),
            on(e),
            e.emit('init'),
            e.emit('afterInit'),
            e
          )
        }
        destroy(r = !0, e = !0) {
          let s = this,
            { params: i, el: n, wrapperEl: a, slides: l } = s
          return (
            typeof s.params > 'u' ||
              s.destroyed ||
              (s.emit('beforeDestroy'),
              (s.initialized = !1),
              s.detachEvents(),
              i.loop && s.loopDestroy(),
              e &&
                (s.removeClasses(),
                n && typeof n != 'string' && n.removeAttribute('style'),
                a && a.removeAttribute('style'),
                l &&
                  l.length &&
                  l.forEach((o) => {
                    ;(o.classList.remove(
                      i.slideVisibleClass,
                      i.slideFullyVisibleClass,
                      i.slideActiveClass,
                      i.slideNextClass,
                      i.slidePrevClass,
                    ),
                      o.removeAttribute('style'),
                      o.removeAttribute('data-swiper-slide-index'))
                  })),
              s.emit('destroy'),
              Object.keys(s.eventsListeners).forEach((o) => {
                s.off(o)
              }),
              r !== !1 &&
                (s.el && typeof s.el != 'string' && (s.el.swiper = null),
                La(s)),
              (s.destroyed = !0)),
            null
          )
        }
        static extendDefaults(r) {
          Oe(an, r)
        }
        static get extendedDefaults() {
          return an
        }
        static get defaults() {
          return Ha
        }
        static installModule(r) {
          t.prototype.__modules__ || (t.prototype.__modules__ = [])
          let e = t.prototype.__modules__
          typeof r == 'function' && e.indexOf(r) < 0 && e.push(r)
        }
        static use(r) {
          return Array.isArray(r)
            ? (r.forEach((e) => t.installModule(e)), t)
            : (t.installModule(r), t)
        }
      }))
    Object.keys(nn).forEach((t) => {
      Object.keys(nn[t]).forEach((r) => {
        qe.prototype[r] = nn[t][r]
      })
    })
    qe.use([ld, cd])
  })
var js = {}
Vn(js, { Swiper: () => qe, default: () => qe })
var ur = J(() => {
  $a()
})
function Na({ swiper: t, extendParams: r, on: e, emit: s }) {
  r({
    virtual: {
      enabled: !1,
      slides: [],
      cache: !0,
      slidesPerViewAutoSlideSize: 320,
      renderSlide: null,
      renderExternal: null,
      renderExternalUpdate: !0,
      addSlidesBefore: 0,
      addSlidesAfter: 0,
    },
  })
  let i,
    n = te()
  t.virtual = {
    cache: {},
    from: void 0,
    to: void 0,
    slides: [],
    offset: 0,
    slidesGrid: [],
  }
  let a = n.createElement('div')
  function l(c, d) {
    let g = t.params.virtual
    if (g.cache && t.virtual.cache[d]) return t.virtual.cache[d]
    let T
    return (
      g.renderSlide
        ? ((T = g.renderSlide.call(t, c, d)),
          typeof T == 'string' && (Ce(a, T), (T = a.children[0])))
        : t.isElement
          ? (T = he('swiper-slide'))
          : (T = he('div', t.params.slideClass)),
      T.setAttribute('data-swiper-slide-index', d),
      g.renderSlide || Ce(T, c),
      g.cache && (t.virtual.cache[d] = T),
      T
    )
  }
  function o(c, d, g) {
    let {
      slidesPerGroup: T,
      centeredSlides: p,
      slidesPerView: v,
      loop: y,
      initialSlide: x,
    } = t.params
    if (d && !y && x > 0) return
    let {
        addSlidesBefore: L,
        addSlidesAfter: M,
        slidesPerViewAutoSlideSize: R,
      } = t.params.virtual,
      { from: w, to: B, slides: k, slidesGrid: E, offset: C } = t.virtual
    t.params.cssMode || t.updateActiveIndex()
    let P = typeof g > 'u' ? t.activeIndex || 0 : g,
      H
    t.rtlTranslate ? (H = 'right') : (H = t.isHorizontal() ? 'left' : 'top')
    let $
    if (v === 'auto')
      if (R) {
        let N = t.size
        ;(N ||
          (N = t.isHorizontal()
            ? t.el.getBoundingClientRect().width
            : t.el.getBoundingClientRect().height),
          ($ = Math.max(1, Math.ceil(N / R))))
      } else $ = 1
    else $ = v
    let I, A
    p
      ? ((I = Math.floor($ / 2) + T + M), (A = Math.floor($ / 2) + T + L))
      : ((I = $ + (T - 1) + M), (A = (y ? $ : T) + L))
    let O = P - A,
      q = P + I
    y || ((O = Math.max(O, 0)), (q = Math.min(q, k.length - 1)))
    let G = (t.slidesGrid[O] || 0) - (t.slidesGrid[0] || 0)
    ;(y && P >= A
      ? ((O -= A), p || (G += t.slidesGrid[0]))
      : y && P < A && ((O = -A), p && (G += t.slidesGrid[0])),
      Object.assign(t.virtual, {
        from: O,
        to: q,
        offset: G,
        slidesGrid: t.slidesGrid,
        slidesBefore: A,
        slidesAfter: I,
      }))
    function Q() {
      ;(t.updateSlides(),
        t.updateProgress(),
        t.updateSlidesClasses(),
        s('virtualUpdate'))
    }
    if (w === O && B === q && !c) {
      ;(t.slidesGrid !== E &&
        G !== C &&
        t.slides.forEach((N) => {
          N.style[H] = `${G - Math.abs(t.cssOverflowAdjustment())}px`
        }),
        t.updateProgress(),
        s('virtualUpdate'))
      return
    }
    if (t.params.virtual.renderExternal) {
      ;(t.params.virtual.renderExternal.call(t, {
        offset: G,
        from: O,
        to: q,
        slides: (function () {
          let W = []
          for (let pe = O; pe <= q; pe += 1) W.push(k[pe])
          return W
        })(),
      }),
        t.params.virtual.renderExternalUpdate ? Q() : s('virtualUpdate'))
      return
    }
    let Ae = [],
      Z = [],
      F = (N) => {
        let W = N
        return (
          N < 0 ? (W = k.length + N) : W >= k.length && (W = W - k.length),
          W
        )
      }
    if (c)
      t.slides
        .filter((N) => N.matches(`.${t.params.slideClass}, swiper-slide`))
        .forEach((N) => {
          N.remove()
        })
    else
      for (let N = w; N <= B; N += 1)
        if (N < O || N > q) {
          let W = F(N)
          t.slides
            .filter((pe) =>
              pe.matches(
                `.${t.params.slideClass}[data-swiper-slide-index="${W}"], swiper-slide[data-swiper-slide-index="${W}"]`,
              ),
            )
            .forEach((pe) => {
              pe.remove()
            })
        }
    let V = y ? -k.length : 0,
      z = y ? k.length * 2 : k.length
    for (let N = V; N < z; N += 1)
      if (N >= O && N <= q) {
        let W = F(N)
        typeof B > 'u' || c
          ? Z.push(W)
          : (N > B && Z.push(W), N < w && Ae.push(W))
      }
    if (
      (Z.forEach((N) => {
        t.slidesEl.append(l(k[N], N))
      }),
      y)
    )
      for (let N = Ae.length - 1; N >= 0; N -= 1) {
        let W = Ae[N]
        t.slidesEl.prepend(l(k[W], W))
      }
    else
      (Ae.sort((N, W) => W - N),
        Ae.forEach((N) => {
          t.slidesEl.prepend(l(k[N], N))
        }))
    ;(ne(t.slidesEl, '.swiper-slide, swiper-slide').forEach((N) => {
      N.style[H] = `${G - Math.abs(t.cssOverflowAdjustment())}px`
    }),
      Q())
  }
  function u(c) {
    if (typeof c == 'object' && 'length' in c)
      for (let d = 0; d < c.length; d += 1) c[d] && t.virtual.slides.push(c[d])
    else t.virtual.slides.push(c)
    o(!0)
  }
  function h(c) {
    let d = t.activeIndex,
      g = d + 1,
      T = 1
    if (Array.isArray(c)) {
      for (let p = 0; p < c.length; p += 1)
        c[p] && t.virtual.slides.unshift(c[p])
      ;((g = d + c.length), (T = c.length))
    } else t.virtual.slides.unshift(c)
    if (t.params.virtual.cache) {
      let p = t.virtual.cache,
        v = {}
      ;(Object.keys(p).forEach((y) => {
        let x = p[y],
          L = x.getAttribute('data-swiper-slide-index')
        ;(L && x.setAttribute('data-swiper-slide-index', parseInt(L, 10) + T),
          (v[parseInt(y, 10) + T] = x))
      }),
        (t.virtual.cache = v))
    }
    ;(o(!0), t.slideTo(g, 0))
  }
  function f(c) {
    if (typeof c > 'u' || c === null) return
    let d = t.activeIndex
    if (Array.isArray(c))
      for (let g = c.length - 1; g >= 0; g -= 1)
        (t.params.virtual.cache &&
          (delete t.virtual.cache[c[g]],
          Object.keys(t.virtual.cache).forEach((T) => {
            T > c &&
              ((t.virtual.cache[T - 1] = t.virtual.cache[T]),
              t.virtual.cache[T - 1].setAttribute(
                'data-swiper-slide-index',
                T - 1,
              ),
              delete t.virtual.cache[T])
          })),
          t.virtual.slides.splice(c[g], 1),
          c[g] < d && (d -= 1),
          (d = Math.max(d, 0)))
    else
      (t.params.virtual.cache &&
        (delete t.virtual.cache[c],
        Object.keys(t.virtual.cache).forEach((g) => {
          g > c &&
            ((t.virtual.cache[g - 1] = t.virtual.cache[g]),
            t.virtual.cache[g - 1].setAttribute(
              'data-swiper-slide-index',
              g - 1,
            ),
            delete t.virtual.cache[g])
        })),
        t.virtual.slides.splice(c, 1),
        c < d && (d -= 1),
        (d = Math.max(d, 0)))
    ;(o(!0), t.slideTo(d, 0))
  }
  function m() {
    ;((t.virtual.slides = []),
      t.params.virtual.cache && (t.virtual.cache = {}),
      o(!0),
      t.slideTo(0, 0))
  }
  ;(e('beforeInit', () => {
    if (!t.params.virtual.enabled) return
    let c
    if (typeof t.passedParams.virtual.slides > 'u') {
      let d = [...t.slidesEl.children].filter((g) =>
        g.matches(`.${t.params.slideClass}, swiper-slide`),
      )
      d &&
        d.length &&
        ((t.virtual.slides = [...d]),
        (c = !0),
        d.forEach((g, T) => {
          ;(g.setAttribute('data-swiper-slide-index', T),
            (t.virtual.cache[T] = g),
            g.remove())
        }))
    }
    ;(c || (t.virtual.slides = t.params.virtual.slides),
      t.classNames.push(`${t.params.containerModifierClass}virtual`),
      (t.params.watchSlidesProgress = !0),
      (t.originalParams.watchSlidesProgress = !0),
      o(!1, !0))
  }),
    e('setTranslate', () => {
      t.params.virtual.enabled &&
        (t.params.cssMode && !t._immediateVirtual
          ? (clearTimeout(i),
            (i = setTimeout(() => {
              o()
            }, 100)))
          : o())
    }),
    e('init update resize', () => {
      t.params.virtual.enabled &&
        t.params.cssMode &&
        vt(t.wrapperEl, '--swiper-virtual-size', `${t.virtualSize}px`)
    }),
    Object.assign(t.virtual, {
      appendSlide: u,
      prependSlide: h,
      removeSlide: f,
      removeAllSlides: m,
      update: o,
    }))
}
var za = J(() => {
  Ve()
  re()
})
function qa({ swiper: t, extendParams: r, on: e, emit: s }) {
  let i = te(),
    n = ee()
  ;((t.keyboard = { enabled: !1 }),
    r({
      keyboard: {
        enabled: !1,
        onlyInViewport: !0,
        pageUpDown: !0,
        speed: void 0,
      },
    }))
  function a(u) {
    if (!t.enabled) return
    let { rtlTranslate: h } = t,
      f = u
    f.originalEvent && (f = f.originalEvent)
    let m = f.keyCode || f.charCode,
      c = t.params.keyboard.pageUpDown,
      d = c && m === 33,
      g = c && m === 34,
      T = m === 37,
      p = m === 39,
      v = m === 38,
      y = m === 40
    if (
      (!t.allowSlideNext &&
        ((t.isHorizontal() && p) || (t.isVertical() && y) || g)) ||
      (!t.allowSlidePrev &&
        ((t.isHorizontal() && T) || (t.isVertical() && v) || d))
    )
      return !1
    if (
      f.shiftKey ||
      f.altKey ||
      f.ctrlKey ||
      f.metaKey ||
      (i.activeElement &&
        (i.activeElement.isContentEditable ||
          (i.activeElement.nodeName &&
            (i.activeElement.nodeName.toLowerCase() === 'input' ||
              i.activeElement.nodeName.toLowerCase() === 'textarea'))))
    )
      return
    if (t.params.keyboard.onlyInViewport && (d || g || T || p || v || y)) {
      let L = !1
      if (
        Xe(t.el, `.${t.params.slideClass}, swiper-slide`).length > 0 &&
        Xe(t.el, `.${t.params.slideActiveClass}`).length === 0
      )
        return
      let M = t.el,
        R = M.clientWidth,
        w = M.clientHeight,
        B = n.innerWidth,
        k = n.innerHeight,
        E = Dt(M)
      h && (E.left -= M.scrollLeft)
      let C = [
        [E.left, E.top],
        [E.left + R, E.top],
        [E.left, E.top + w],
        [E.left + R, E.top + w],
      ]
      for (let P = 0; P < C.length; P += 1) {
        let H = C[P]
        if (H[0] >= 0 && H[0] <= B && H[1] >= 0 && H[1] <= k) {
          if (H[0] === 0 && H[1] === 0) continue
          L = !0
        }
      }
      if (!L) return
    }
    let x = t.params.keyboard.speed
    ;(t.isHorizontal()
      ? ((d || g || T || p) &&
          (f.preventDefault ? f.preventDefault() : (f.returnValue = !1)),
        (((g || p) && !h) || ((d || T) && h)) && t.slideNext(x),
        (((d || T) && !h) || ((g || p) && h)) && t.slidePrev(x))
      : ((d || g || v || y) &&
          (f.preventDefault ? f.preventDefault() : (f.returnValue = !1)),
        (g || y) && t.slideNext(x),
        (d || v) && t.slidePrev(x)),
      s('keyPress', m))
  }
  function l() {
    t.keyboard.enabled ||
      (i.addEventListener('keydown', a), (t.keyboard.enabled = !0))
  }
  function o() {
    t.keyboard.enabled &&
      (i.removeEventListener('keydown', a), (t.keyboard.enabled = !1))
  }
  ;(e('init', () => {
    t.params.keyboard.enabled && l()
  }),
    e('destroy', () => {
      t.keyboard.enabled && o()
    }),
    Object.assign(t.keyboard, { enable: l, disable: o }))
}
var Ua = J(() => {
  Ve()
  re()
})
function ja({ swiper: t, extendParams: r, on: e, emit: s }) {
  let i = ee()
  ;(r({
    mousewheel: {
      enabled: !1,
      releaseOnEdges: !1,
      invert: !1,
      forceToAxis: !1,
      sensitivity: 1,
      eventsTarget: 'container',
      thresholdDelta: null,
      thresholdTime: null,
      noMousewheelClass: 'swiper-no-mousewheel',
    },
  }),
    (t.mousewheel = { enabled: !1 }))
  let n,
    a = Le(),
    l,
    o = []
  function u(v) {
    let M = 0,
      R = 0,
      w = 0,
      B = 0
    return (
      'detail' in v && (R = v.detail),
      'wheelDelta' in v && (R = -v.wheelDelta / 120),
      'wheelDeltaY' in v && (R = -v.wheelDeltaY / 120),
      'wheelDeltaX' in v && (M = -v.wheelDeltaX / 120),
      'axis' in v && v.axis === v.HORIZONTAL_AXIS && ((M = R), (R = 0)),
      (w = M * 10),
      (B = R * 10),
      'deltaY' in v && (B = v.deltaY),
      'deltaX' in v && (w = v.deltaX),
      v.shiftKey && !w && ((w = B), (B = 0)),
      (w || B) &&
        v.deltaMode &&
        (v.deltaMode === 1 ? ((w *= 40), (B *= 40)) : ((w *= 800), (B *= 800))),
      w && !M && (M = w < 1 ? -1 : 1),
      B && !R && (R = B < 1 ? -1 : 1),
      { spinX: M, spinY: R, pixelX: w, pixelY: B }
    )
  }
  function h() {
    t.enabled && (t.mouseEntered = !0)
  }
  function f() {
    t.enabled && (t.mouseEntered = !1)
  }
  function m(v) {
    return (t.params.mousewheel.thresholdDelta &&
      v.delta < t.params.mousewheel.thresholdDelta) ||
      (t.params.mousewheel.thresholdTime &&
        Le() - a < t.params.mousewheel.thresholdTime)
      ? !1
      : v.delta >= 6 && Le() - a < 60
        ? !0
        : (v.direction < 0
            ? (!t.isEnd || t.params.loop) &&
              !t.animating &&
              (t.slideNext(), s('scroll', v.raw))
            : (!t.isBeginning || t.params.loop) &&
              !t.animating &&
              (t.slidePrev(), s('scroll', v.raw)),
          (a = new i.Date().getTime()),
          !1)
  }
  function c(v) {
    let y = t.params.mousewheel
    if (v.direction < 0) {
      if (t.isEnd && !t.params.loop && y.releaseOnEdges) return !0
    } else if (t.isBeginning && !t.params.loop && y.releaseOnEdges) return !0
    return !1
  }
  function d(v) {
    let y = v,
      x = !0
    if (
      !t.enabled ||
      v.target.closest(`.${t.params.mousewheel.noMousewheelClass}`)
    )
      return
    let L = t.params.mousewheel
    t.params.cssMode && y.preventDefault()
    let M = t.el
    t.params.mousewheel.eventsTarget !== 'container' &&
      (M = document.querySelector(t.params.mousewheel.eventsTarget))
    let R = M && M.contains(y.target)
    if (!t.mouseEntered && !R && !L.releaseOnEdges) return !0
    y.originalEvent && (y = y.originalEvent)
    let w = 0,
      B = t.rtlTranslate ? -1 : 1,
      k = u(y)
    if (L.forceToAxis)
      if (t.isHorizontal())
        if (Math.abs(k.pixelX) > Math.abs(k.pixelY)) w = -k.pixelX * B
        else return !0
      else if (Math.abs(k.pixelY) > Math.abs(k.pixelX)) w = -k.pixelY
      else return !0
    else w = Math.abs(k.pixelX) > Math.abs(k.pixelY) ? -k.pixelX * B : -k.pixelY
    if (w === 0) return !0
    L.invert && (w = -w)
    let E = t.getTranslate() + w * L.sensitivity
    if (
      (E >= t.minTranslate() && (E = t.minTranslate()),
      E <= t.maxTranslate() && (E = t.maxTranslate()),
      (x = t.params.loop
        ? !0
        : !(E === t.minTranslate() || E === t.maxTranslate())),
      x && t.params.nested && y.stopPropagation(),
      !t.params.freeMode || !t.params.freeMode.enabled)
    ) {
      let C = {
        time: Le(),
        delta: Math.abs(w),
        direction: Math.sign(w),
        raw: v,
      }
      o.length >= 2 && o.shift()
      let P = o.length ? o[o.length - 1] : void 0
      if (
        (o.push(C),
        P
          ? (C.direction !== P.direction ||
              C.delta > P.delta ||
              C.time > P.time + 150) &&
            m(C)
          : m(C),
        c(C))
      )
        return !0
    } else {
      let C = { time: Le(), delta: Math.abs(w), direction: Math.sign(w) },
        P =
          l &&
          C.time < l.time + 500 &&
          C.delta <= l.delta &&
          C.direction === l.direction
      if (!P) {
        l = void 0
        let H = t.getTranslate() + w * L.sensitivity,
          $ = t.isBeginning,
          I = t.isEnd
        if (
          (H >= t.minTranslate() && (H = t.minTranslate()),
          H <= t.maxTranslate() && (H = t.maxTranslate()),
          t.setTransition(0),
          t.setTranslate(H),
          t.updateProgress(),
          t.updateActiveIndex(),
          t.updateSlidesClasses(),
          ((!$ && t.isBeginning) || (!I && t.isEnd)) && t.updateSlidesClasses(),
          t.params.loop &&
            t.loopFix({
              direction: C.direction < 0 ? 'next' : 'prev',
              byMousewheel: !0,
            }),
          t.params.freeMode.sticky)
        ) {
          ;(clearTimeout(n), (n = void 0), o.length >= 15 && o.shift())
          let A = o.length ? o[o.length - 1] : void 0,
            O = o[0]
          if (
            (o.push(C), A && (C.delta > A.delta || C.direction !== A.direction))
          )
            o.splice(0)
          else if (
            o.length >= 15 &&
            C.time - O.time < 500 &&
            O.delta - C.delta >= 1 &&
            C.delta <= 6
          ) {
            let q = w > 0 ? 0.8 : 0.2
            ;((l = C),
              o.splice(0),
              (n = rt(() => {
                t.destroyed ||
                  !t.params ||
                  t.slideToClosest(t.params.speed, !0, void 0, q)
              }, 0)))
          }
          n ||
            (n = rt(() => {
              if (t.destroyed || !t.params) return
              let q = 0.5
              ;((l = C),
                o.splice(0),
                t.slideToClosest(t.params.speed, !0, void 0, q))
            }, 500))
        }
        if (
          (P || s('scroll', y),
          t.params.autoplay &&
            t.params.autoplay.disableOnInteraction &&
            t.autoplay.stop(),
          L.releaseOnEdges &&
            (H === t.minTranslate() || H === t.maxTranslate()))
        )
          return !0
      }
    }
    return (y.preventDefault ? y.preventDefault() : (y.returnValue = !1), !1)
  }
  function g(v) {
    let y = t.el
    ;(t.params.mousewheel.eventsTarget !== 'container' &&
      (y = document.querySelector(t.params.mousewheel.eventsTarget)),
      y[v]('mouseenter', h),
      y[v]('mouseleave', f),
      y[v]('wheel', d))
  }
  function T() {
    return t.params.cssMode
      ? (t.wrapperEl.removeEventListener('wheel', d), !0)
      : t.mousewheel.enabled
        ? !1
        : (g('addEventListener'), (t.mousewheel.enabled = !0), !0)
  }
  function p() {
    return t.params.cssMode
      ? (t.wrapperEl.addEventListener(event, d), !0)
      : t.mousewheel.enabled
        ? (g('removeEventListener'), (t.mousewheel.enabled = !1), !0)
        : !1
  }
  ;(e('init', () => {
    ;(!t.params.mousewheel.enabled && t.params.cssMode && p(),
      t.params.mousewheel.enabled && T())
  }),
    e('destroy', () => {
      ;(t.params.cssMode && T(), t.mousewheel.enabled && p())
    }),
    Object.assign(t.mousewheel, { enable: T, disable: p }))
}
var Wa = J(() => {
  Ve()
  re()
})
function fr(t, r, e, s) {
  return (
    t.params.createElements &&
      Object.keys(s).forEach((i) => {
        if (!e[i] && e.auto === !0) {
          let n = ne(t.el, `.${s[i]}`)[0]
          ;(n || ((n = he('div', s[i])), (n.className = s[i]), t.el.append(n)),
            (e[i] = n),
            (r[i] = n))
        }
      }),
    e
  )
}
var Ws = J(() => {
  re()
})
function hr({ swiper: t, extendParams: r, on: e, emit: s }) {
  ;(r({
    navigation: {
      nextEl: null,
      prevEl: null,
      addIcons: !0,
      hideOnClick: !1,
      disabledClass: 'swiper-button-disabled',
      hiddenClass: 'swiper-button-hidden',
      lockClass: 'swiper-button-lock',
      navigationDisabledClass: 'swiper-navigation-disabled',
    },
  }),
    (t.navigation = { nextEl: null, prevEl: null, arrowSvg: Ga }))
  function i(c) {
    let d
    return c &&
      typeof c == 'string' &&
      t.isElement &&
      ((d = t.el.querySelector(c) || t.hostEl.querySelector(c)), d)
      ? d
      : (c &&
          (typeof c == 'string' && (d = [...document.querySelectorAll(c)]),
          t.params.uniqueNavElements &&
          typeof c == 'string' &&
          d &&
          d.length > 1 &&
          t.el.querySelectorAll(c).length === 1
            ? (d = t.el.querySelector(c))
            : d && d.length === 1 && (d = d[0])),
        c && !d ? c : d)
  }
  function n(c, d) {
    let g = t.params.navigation
    ;((c = X(c)),
      c.forEach((T) => {
        T &&
          (T.classList[d ? 'add' : 'remove'](...g.disabledClass.split(' ')),
          T.tagName === 'BUTTON' && (T.disabled = d),
          t.params.watchOverflow &&
            t.enabled &&
            T.classList[t.isLocked ? 'add' : 'remove'](g.lockClass))
      }))
  }
  function a() {
    let { nextEl: c, prevEl: d } = t.navigation
    if (t.params.loop) {
      ;(n(d, !1), n(c, !1))
      return
    }
    ;(n(d, t.isBeginning && !t.params.rewind),
      n(c, t.isEnd && !t.params.rewind))
  }
  function l(c) {
    ;(c.preventDefault(),
      !(t.isBeginning && !t.params.loop && !t.params.rewind) &&
        (t.slidePrev(), s('navigationPrev')))
  }
  function o(c) {
    ;(c.preventDefault(),
      !(t.isEnd && !t.params.loop && !t.params.rewind) &&
        (t.slideNext(), s('navigationNext')))
  }
  function u() {
    let c = t.params.navigation
    if (
      ((t.params.navigation = fr(
        t,
        t.originalParams.navigation,
        t.params.navigation,
        { nextEl: 'swiper-button-next', prevEl: 'swiper-button-prev' },
      )),
      !(c.nextEl || c.prevEl))
    )
      return
    let d = i(c.nextEl),
      g = i(c.prevEl)
    ;(Object.assign(t.navigation, { nextEl: d, prevEl: g }),
      (d = X(d)),
      (g = X(g)))
    let T = (p, v) => {
      if (p) {
        if (
          c.addIcons &&
          p.matches('.swiper-button-next,.swiper-button-prev') &&
          !p.querySelector('svg')
        ) {
          let y = document.createElement('div')
          ;(Ce(y, Ga), p.appendChild(y.querySelector('svg')), y.remove())
        }
        p.addEventListener('click', v === 'next' ? o : l)
      }
      !t.enabled && p && p.classList.add(...c.lockClass.split(' '))
    }
    ;(d.forEach((p) => T(p, 'next')), g.forEach((p) => T(p, 'prev')))
  }
  function h() {
    let { nextEl: c, prevEl: d } = t.navigation
    ;((c = X(c)), (d = X(d)))
    let g = (T, p) => {
      ;(T.removeEventListener('click', p === 'next' ? o : l),
        T.classList.remove(...t.params.navigation.disabledClass.split(' ')))
    }
    ;(c.forEach((T) => g(T, 'next')), d.forEach((T) => g(T, 'prev')))
  }
  ;(e('init', () => {
    t.params.navigation.enabled === !1 ? m() : (u(), a())
  }),
    e('toEdge fromEdge lock unlock', () => {
      a()
    }),
    e('destroy', () => {
      h()
    }),
    e('enable disable', () => {
      let { nextEl: c, prevEl: d } = t.navigation
      if (((c = X(c)), (d = X(d)), t.enabled)) {
        a()
        return
      }
      ;[...c, ...d]
        .filter((g) => !!g)
        .forEach((g) => g.classList.add(t.params.navigation.lockClass))
    }),
    e('click', (c, d) => {
      let { nextEl: g, prevEl: T } = t.navigation
      ;((g = X(g)), (T = X(T)))
      let p = d.target,
        v = T.includes(p) || g.includes(p)
      if (t.isElement && !v) {
        let y = d.path || (d.composedPath && d.composedPath())
        y && (v = y.find((x) => g.includes(x) || T.includes(x)))
      }
      if (t.params.navigation.hideOnClick && !v) {
        if (
          t.pagination &&
          t.params.pagination &&
          t.params.pagination.clickable &&
          (t.pagination.el === p || t.pagination.el.contains(p))
        )
          return
        let y
        ;(g.length
          ? (y = g[0].classList.contains(t.params.navigation.hiddenClass))
          : T.length &&
            (y = T[0].classList.contains(t.params.navigation.hiddenClass)),
          s(y === !0 ? 'navigationShow' : 'navigationHide'),
          [...g, ...T]
            .filter((x) => !!x)
            .forEach((x) =>
              x.classList.toggle(t.params.navigation.hiddenClass),
            ))
      }
    }))
  let f = () => {
      ;(t.el.classList.remove(
        ...t.params.navigation.navigationDisabledClass.split(' '),
      ),
        u(),
        a())
    },
    m = () => {
      ;(t.el.classList.add(
        ...t.params.navigation.navigationDisabledClass.split(' '),
      ),
        h())
    }
  Object.assign(t.navigation, {
    enable: f,
    disable: m,
    update: a,
    init: u,
    destroy: h,
  })
}
var Ga,
  Ya = J(() => {
    Ws()
    re()
    Ga =
      '<svg class="swiper-navigation-icon" width="11" height="20" viewBox="0 0 11 20" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M0.38296 20.0762C0.111788 19.805 0.111788 19.3654 0.38296 19.0942L9.19758 10.2796L0.38296 1.46497C0.111788 1.19379 0.111788 0.754138 0.38296 0.482966C0.654131 0.211794 1.09379 0.211794 1.36496 0.482966L10.4341 9.55214C10.8359 9.9539 10.8359 10.6053 10.4341 11.007L1.36496 20.0762C1.09379 20.3474 0.654131 20.3474 0.38296 20.0762Z" fill="currentColor"/></svg>'
  })
function Ue(t = '') {
  return `.${t
    .trim()
    .replace(/([\.:!+\/()[\]#>~*^$|=,'"@{}\\])/g, '\\$1')
    .replace(/ /g, '.')}`
}
var Gs = J(() => {})
function Ys({ swiper: t, extendParams: r, on: e, emit: s }) {
  let i = 'swiper-pagination'
  ;(r({
    pagination: {
      el: null,
      bulletElement: 'span',
      clickable: !1,
      hideOnClick: !1,
      renderBullet: null,
      renderProgressbar: null,
      renderFraction: null,
      renderCustom: null,
      progressbarOpposite: !1,
      type: 'bullets',
      dynamicBullets: !1,
      dynamicMainBullets: 1,
      formatFractionCurrent: (p) => p,
      formatFractionTotal: (p) => p,
      bulletClass: `${i}-bullet`,
      bulletActiveClass: `${i}-bullet-active`,
      modifierClass: `${i}-`,
      currentClass: `${i}-current`,
      totalClass: `${i}-total`,
      hiddenClass: `${i}-hidden`,
      progressbarFillClass: `${i}-progressbar-fill`,
      progressbarOppositeClass: `${i}-progressbar-opposite`,
      clickableClass: `${i}-clickable`,
      lockClass: `${i}-lock`,
      horizontalClass: `${i}-horizontal`,
      verticalClass: `${i}-vertical`,
      paginationDisabledClass: `${i}-disabled`,
    },
  }),
    (t.pagination = { el: null, bullets: [] }))
  let n,
    a = 0
  function l() {
    return (
      !t.params.pagination.el ||
      !t.pagination.el ||
      (Array.isArray(t.pagination.el) && t.pagination.el.length === 0)
    )
  }
  function o(p, v) {
    let { bulletActiveClass: y } = t.params.pagination
    p &&
      ((p = p[`${v === 'prev' ? 'previous' : 'next'}ElementSibling`]),
      p &&
        (p.classList.add(`${y}-${v}`),
        (p = p[`${v === 'prev' ? 'previous' : 'next'}ElementSibling`]),
        p && p.classList.add(`${y}-${v}-${v}`)))
  }
  function u(p, v, y) {
    if (((p = p % y), (v = v % y), v === p + 1)) return 'next'
    if (v === p - 1) return 'previous'
  }
  function h(p) {
    let v = p.target.closest(Ue(t.params.pagination.bulletClass))
    if (!v) return
    p.preventDefault()
    let y = Et(v) * t.params.slidesPerGroup
    if (t.params.loop) {
      if (t.realIndex === y) return
      let x = u(t.realIndex, y, t.slides.length)
      x === 'next'
        ? t.slideNext()
        : x === 'previous'
          ? t.slidePrev()
          : t.slideToLoop(y)
    } else t.slideTo(y)
  }
  function f() {
    let p = t.rtl,
      v = t.params.pagination
    if (l()) return
    let y = t.pagination.el
    y = X(y)
    let x,
      L,
      M =
        t.virtual && t.params.virtual.enabled
          ? t.virtual.slides.length
          : t.slides.length,
      R = t.params.loop
        ? Math.ceil(M / t.params.slidesPerGroup)
        : t.snapGrid.length
    if (
      (t.params.loop
        ? ((L = t.previousRealIndex || 0),
          (x =
            t.params.slidesPerGroup > 1
              ? Math.floor(t.realIndex / t.params.slidesPerGroup)
              : t.realIndex))
        : typeof t.snapIndex < 'u'
          ? ((x = t.snapIndex), (L = t.previousSnapIndex))
          : ((L = t.previousIndex || 0), (x = t.activeIndex || 0)),
      v.type === 'bullets' &&
        t.pagination.bullets &&
        t.pagination.bullets.length > 0)
    ) {
      let w = t.pagination.bullets,
        B,
        k,
        E
      if (
        (v.dynamicBullets &&
          ((n = rs(w[0], t.isHorizontal() ? 'width' : 'height', !0)),
          y.forEach((C) => {
            C.style[t.isHorizontal() ? 'width' : 'height'] =
              `${n * (v.dynamicMainBullets + 4)}px`
          }),
          v.dynamicMainBullets > 1 &&
            L !== void 0 &&
            ((a += x - (L || 0)),
            a > v.dynamicMainBullets - 1
              ? (a = v.dynamicMainBullets - 1)
              : a < 0 && (a = 0)),
          (B = Math.max(x - a, 0)),
          (k = B + (Math.min(w.length, v.dynamicMainBullets) - 1)),
          (E = (k + B) / 2)),
        w.forEach((C) => {
          let P = [
            ...['', '-next', '-next-next', '-prev', '-prev-prev', '-main'].map(
              (H) => `${v.bulletActiveClass}${H}`,
            ),
          ]
            .map((H) =>
              typeof H == 'string' && H.includes(' ') ? H.split(' ') : H,
            )
            .flat()
          C.classList.remove(...P)
        }),
        y.length > 1)
      )
        w.forEach((C) => {
          let P = Et(C)
          ;(P === x
            ? C.classList.add(...v.bulletActiveClass.split(' '))
            : t.isElement && C.setAttribute('part', 'bullet'),
            v.dynamicBullets &&
              (P >= B &&
                P <= k &&
                C.classList.add(...`${v.bulletActiveClass}-main`.split(' ')),
              P === B && o(C, 'prev'),
              P === k && o(C, 'next')))
        })
      else {
        let C = w[x]
        if (
          (C && C.classList.add(...v.bulletActiveClass.split(' ')),
          t.isElement &&
            w.forEach((P, H) => {
              P.setAttribute('part', H === x ? 'bullet-active' : 'bullet')
            }),
          v.dynamicBullets)
        ) {
          let P = w[B],
            H = w[k]
          for (let $ = B; $ <= k; $ += 1)
            w[$] &&
              w[$].classList.add(...`${v.bulletActiveClass}-main`.split(' '))
          ;(o(P, 'prev'), o(H, 'next'))
        }
      }
      if (v.dynamicBullets) {
        let C = Math.min(w.length, v.dynamicMainBullets + 4),
          P = (n * C - n) / 2 - E * n,
          H = p ? 'right' : 'left'
        w.forEach(($) => {
          $.style[t.isHorizontal() ? H : 'top'] = `${P}px`
        })
      }
    }
    y.forEach((w, B) => {
      if (
        (v.type === 'fraction' &&
          (w.querySelectorAll(Ue(v.currentClass)).forEach((k) => {
            k.textContent = v.formatFractionCurrent(x + 1)
          }),
          w.querySelectorAll(Ue(v.totalClass)).forEach((k) => {
            k.textContent = v.formatFractionTotal(R)
          })),
        v.type === 'progressbar')
      ) {
        let k
        v.progressbarOpposite
          ? (k = t.isHorizontal() ? 'vertical' : 'horizontal')
          : (k = t.isHorizontal() ? 'horizontal' : 'vertical')
        let E = (x + 1) / R,
          C = 1,
          P = 1
        ;(k === 'horizontal' ? (C = E) : (P = E),
          w.querySelectorAll(Ue(v.progressbarFillClass)).forEach((H) => {
            ;((H.style.transform = `translate3d(0,0,0) scaleX(${C}) scaleY(${P})`),
              (H.style.transitionDuration = `${t.params.speed}ms`))
          }))
      }
      ;(v.type === 'custom' && v.renderCustom
        ? (Ce(w, v.renderCustom(t, x + 1, R)),
          B === 0 && s('paginationRender', w))
        : (B === 0 && s('paginationRender', w), s('paginationUpdate', w)),
        t.params.watchOverflow &&
          t.enabled &&
          w.classList[t.isLocked ? 'add' : 'remove'](v.lockClass))
    })
  }
  function m() {
    let p = t.params.pagination
    if (l()) return
    let v =
        t.virtual && t.params.virtual.enabled
          ? t.virtual.slides.length
          : t.grid && t.params.grid.rows > 1
            ? t.slides.length / Math.ceil(t.params.grid.rows)
            : t.slides.length,
      y = t.pagination.el
    y = X(y)
    let x = ''
    if (p.type === 'bullets') {
      let L = t.params.loop
        ? Math.ceil(v / t.params.slidesPerGroup)
        : t.snapGrid.length
      t.params.freeMode && t.params.freeMode.enabled && L > v && (L = v)
      for (let M = 0; M < L; M += 1)
        p.renderBullet
          ? (x += p.renderBullet.call(t, M, p.bulletClass))
          : (x += `<${p.bulletElement} ${t.isElement ? 'part="bullet"' : ''} class="${p.bulletClass}"></${p.bulletElement}>`)
    }
    ;(p.type === 'fraction' &&
      (p.renderFraction
        ? (x = p.renderFraction.call(t, p.currentClass, p.totalClass))
        : (x = `<span class="${p.currentClass}"></span> / <span class="${p.totalClass}"></span>`)),
      p.type === 'progressbar' &&
        (p.renderProgressbar
          ? (x = p.renderProgressbar.call(t, p.progressbarFillClass))
          : (x = `<span class="${p.progressbarFillClass}"></span>`)),
      (t.pagination.bullets = []),
      y.forEach((L) => {
        ;(p.type !== 'custom' && Ce(L, x || ''),
          p.type === 'bullets' &&
            t.pagination.bullets.push(...L.querySelectorAll(Ue(p.bulletClass))))
      }),
      p.type !== 'custom' && s('paginationRender', y[0]))
  }
  function c() {
    t.params.pagination = fr(
      t,
      t.originalParams.pagination,
      t.params.pagination,
      { el: 'swiper-pagination' },
    )
    let p = t.params.pagination
    if (!p.el) return
    let v
    ;(typeof p.el == 'string' && t.isElement && (v = t.el.querySelector(p.el)),
      !v &&
        typeof p.el == 'string' &&
        (v = [...document.querySelectorAll(p.el)]),
      v || (v = p.el),
      !(!v || v.length === 0) &&
        (t.params.uniqueNavElements &&
          typeof p.el == 'string' &&
          Array.isArray(v) &&
          v.length > 1 &&
          ((v = [...t.el.querySelectorAll(p.el)]),
          v.length > 1 && (v = v.find((y) => Xe(y, '.swiper')[0] === t.el))),
        Array.isArray(v) && v.length === 1 && (v = v[0]),
        Object.assign(t.pagination, { el: v }),
        (v = X(v)),
        v.forEach((y) => {
          ;(p.type === 'bullets' &&
            p.clickable &&
            y.classList.add(...(p.clickableClass || '').split(' ')),
            y.classList.add(p.modifierClass + p.type),
            y.classList.add(
              t.isHorizontal() ? p.horizontalClass : p.verticalClass,
            ),
            p.type === 'bullets' &&
              p.dynamicBullets &&
              (y.classList.add(`${p.modifierClass}${p.type}-dynamic`),
              (a = 0),
              p.dynamicMainBullets < 1 && (p.dynamicMainBullets = 1)),
            p.type === 'progressbar' &&
              p.progressbarOpposite &&
              y.classList.add(p.progressbarOppositeClass),
            p.clickable && y.addEventListener('click', h),
            t.enabled || y.classList.add(p.lockClass))
        })))
  }
  function d() {
    let p = t.params.pagination
    if (l()) return
    let v = t.pagination.el
    ;(v &&
      ((v = X(v)),
      v.forEach((y) => {
        ;(y.classList.remove(p.hiddenClass),
          y.classList.remove(p.modifierClass + p.type),
          y.classList.remove(
            t.isHorizontal() ? p.horizontalClass : p.verticalClass,
          ),
          p.clickable &&
            (y.classList.remove(...(p.clickableClass || '').split(' ')),
            y.removeEventListener('click', h)))
      })),
      t.pagination.bullets &&
        t.pagination.bullets.forEach((y) =>
          y.classList.remove(...p.bulletActiveClass.split(' ')),
        ))
  }
  ;(e('changeDirection', () => {
    if (!t.pagination || !t.pagination.el) return
    let p = t.params.pagination,
      { el: v } = t.pagination
    ;((v = X(v)),
      v.forEach((y) => {
        ;(y.classList.remove(p.horizontalClass, p.verticalClass),
          y.classList.add(
            t.isHorizontal() ? p.horizontalClass : p.verticalClass,
          ))
      }))
  }),
    e('init', () => {
      t.params.pagination.enabled === !1 ? T() : (c(), m(), f())
    }),
    e('activeIndexChange', () => {
      typeof t.snapIndex > 'u' && f()
    }),
    e('snapIndexChange', () => {
      f()
    }),
    e('snapGridLengthChange', () => {
      ;(m(), f())
    }),
    e('destroy', () => {
      d()
    }),
    e('enable disable', () => {
      let { el: p } = t.pagination
      p &&
        ((p = X(p)),
        p.forEach((v) =>
          v.classList[t.enabled ? 'remove' : 'add'](
            t.params.pagination.lockClass,
          ),
        ))
    }),
    e('lock unlock', () => {
      f()
    }),
    e('click', (p, v) => {
      let y = v.target,
        x = X(t.pagination.el)
      if (
        t.params.pagination.el &&
        t.params.pagination.hideOnClick &&
        x &&
        x.length > 0 &&
        !y.classList.contains(t.params.pagination.bulletClass)
      ) {
        if (
          t.navigation &&
          ((t.navigation.nextEl && y === t.navigation.nextEl) ||
            (t.navigation.prevEl && y === t.navigation.prevEl))
        )
          return
        let L = x[0].classList.contains(t.params.pagination.hiddenClass)
        ;(s(L === !0 ? 'paginationShow' : 'paginationHide'),
          x.forEach((M) => M.classList.toggle(t.params.pagination.hiddenClass)))
      }
    }))
  let g = () => {
      t.el.classList.remove(t.params.pagination.paginationDisabledClass)
      let { el: p } = t.pagination
      ;(p &&
        ((p = X(p)),
        p.forEach((v) =>
          v.classList.remove(t.params.pagination.paginationDisabledClass),
        )),
        c(),
        m(),
        f())
    },
    T = () => {
      t.el.classList.add(t.params.pagination.paginationDisabledClass)
      let { el: p } = t.pagination
      ;(p &&
        ((p = X(p)),
        p.forEach((v) =>
          v.classList.add(t.params.pagination.paginationDisabledClass),
        )),
        d())
    }
  Object.assign(t.pagination, {
    enable: g,
    disable: T,
    render: m,
    update: f,
    init: c,
    destroy: d,
  })
}
var Ka = J(() => {
  Gs()
  Ws()
  re()
})
function Ks({ swiper: t, extendParams: r, on: e, emit: s }) {
  let i = te(),
    n = !1,
    a = null,
    l = null,
    o,
    u,
    h,
    f
  ;(r({
    scrollbar: {
      el: null,
      dragSize: 'auto',
      hide: !1,
      draggable: !1,
      snapOnRelease: !0,
      lockClass: 'swiper-scrollbar-lock',
      dragClass: 'swiper-scrollbar-drag',
      scrollbarDisabledClass: 'swiper-scrollbar-disabled',
      horizontalClass: 'swiper-scrollbar-horizontal',
      verticalClass: 'swiper-scrollbar-vertical',
    },
  }),
    (t.scrollbar = { el: null, dragEl: null }))
  function m() {
    if (!t.params.scrollbar.el || !t.scrollbar.el) return
    let { scrollbar: E, rtlTranslate: C } = t,
      { dragEl: P, el: H } = E,
      $ = t.params.scrollbar,
      I = t.params.loop ? t.progressLoop : t.progress,
      A = u,
      O = (h - u) * I
    ;(C
      ? ((O = -O), O > 0 ? ((A = u - O), (O = 0)) : -O + u > h && (A = h + O))
      : O < 0
        ? ((A = u + O), (O = 0))
        : O + u > h && (A = h - O),
      t.isHorizontal()
        ? ((P.style.transform = `translate3d(${O}px, 0, 0)`),
          (P.style.width = `${A}px`))
        : ((P.style.transform = `translate3d(0px, ${O}px, 0)`),
          (P.style.height = `${A}px`)),
      $.hide &&
        (clearTimeout(a),
        (H.style.opacity = 1),
        (a = setTimeout(() => {
          ;((H.style.opacity = 0), (H.style.transitionDuration = '400ms'))
        }, 1e3))))
  }
  function c(E) {
    !t.params.scrollbar.el ||
      !t.scrollbar.el ||
      (t.scrollbar.dragEl.style.transitionDuration = `${E}ms`)
  }
  function d() {
    if (!t.params.scrollbar.el || !t.scrollbar.el) return
    let { scrollbar: E } = t,
      { dragEl: C, el: P } = E
    ;((C.style.width = ''),
      (C.style.height = ''),
      (h = t.isHorizontal() ? P.offsetWidth : P.offsetHeight),
      (f =
        t.size /
        (t.virtualSize +
          t.params.slidesOffsetBefore -
          (t.params.centeredSlides ? t.snapGrid[0] : 0))),
      t.params.scrollbar.dragSize === 'auto'
        ? (u = h * f)
        : (u = parseInt(t.params.scrollbar.dragSize, 10)),
      t.isHorizontal()
        ? (C.style.width = `${u}px`)
        : (C.style.height = `${u}px`),
      f >= 1 ? (P.style.display = 'none') : (P.style.display = ''),
      t.params.scrollbar.hide && (P.style.opacity = 0),
      t.params.watchOverflow &&
        t.enabled &&
        E.el.classList[t.isLocked ? 'add' : 'remove'](
          t.params.scrollbar.lockClass,
        ))
  }
  function g(E) {
    return t.isHorizontal() ? E.clientX : E.clientY
  }
  function T(E) {
    let { scrollbar: C, rtlTranslate: P } = t,
      { el: H } = C,
      $
    ;(($ =
      (g(E) -
        Dt(H)[t.isHorizontal() ? 'left' : 'top'] -
        (o !== null ? o : u / 2)) /
      (h - u)),
      ($ = Math.max(Math.min($, 1), 0)),
      P && ($ = 1 - $))
    let I = t.minTranslate() + (t.maxTranslate() - t.minTranslate()) * $
    ;(t.updateProgress(I),
      t.setTranslate(I),
      t.updateActiveIndex(),
      t.updateSlidesClasses())
  }
  function p(E) {
    let C = t.params.scrollbar,
      { scrollbar: P, wrapperEl: H } = t,
      { el: $, dragEl: I } = P
    ;((n = !0),
      (o =
        E.target === I
          ? g(E) -
            E.target.getBoundingClientRect()[t.isHorizontal() ? 'left' : 'top']
          : null),
      E.preventDefault(),
      E.stopPropagation(),
      (H.style.transitionDuration = '100ms'),
      (I.style.transitionDuration = '100ms'),
      T(E),
      clearTimeout(l),
      ($.style.transitionDuration = '0ms'),
      C.hide && ($.style.opacity = 1),
      t.params.cssMode && (t.wrapperEl.style['scroll-snap-type'] = 'none'),
      s('scrollbarDragStart', E))
  }
  function v(E) {
    let { scrollbar: C, wrapperEl: P } = t,
      { el: H, dragEl: $ } = C
    n &&
      (E.preventDefault && E.cancelable
        ? E.preventDefault()
        : (E.returnValue = !1),
      T(E),
      (P.style.transitionDuration = '0ms'),
      (H.style.transitionDuration = '0ms'),
      ($.style.transitionDuration = '0ms'),
      s('scrollbarDragMove', E))
  }
  function y(E) {
    let C = t.params.scrollbar,
      { scrollbar: P, wrapperEl: H } = t,
      { el: $ } = P
    n &&
      ((n = !1),
      t.params.cssMode &&
        ((t.wrapperEl.style['scroll-snap-type'] = ''),
        (H.style.transitionDuration = '')),
      C.hide &&
        (clearTimeout(l),
        (l = rt(() => {
          ;(($.style.opacity = 0), ($.style.transitionDuration = '400ms'))
        }, 1e3))),
      s('scrollbarDragEnd', E),
      C.snapOnRelease && t.slideToClosest())
  }
  function x(E) {
    let { scrollbar: C, params: P } = t,
      H = C.el
    if (!H) return
    let $ = H,
      I = P.passiveListeners ? { passive: !1, capture: !1 } : !1,
      A = P.passiveListeners ? { passive: !0, capture: !1 } : !1
    if (!$) return
    let O = E === 'on' ? 'addEventListener' : 'removeEventListener'
    ;($[O]('pointerdown', p, I),
      i[O]('pointermove', v, I),
      i[O]('pointerup', y, A))
  }
  function L() {
    !t.params.scrollbar.el || !t.scrollbar.el || x('on')
  }
  function M() {
    !t.params.scrollbar.el || !t.scrollbar.el || x('off')
  }
  function R() {
    let { scrollbar: E, el: C } = t
    t.params.scrollbar = fr(t, t.originalParams.scrollbar, t.params.scrollbar, {
      el: 'swiper-scrollbar',
    })
    let P = t.params.scrollbar
    if (!P.el) return
    let H
    if (
      (typeof P.el == 'string' && t.isElement && (H = t.el.querySelector(P.el)),
      !H && typeof P.el == 'string')
    ) {
      if (((H = i.querySelectorAll(P.el)), !H.length)) return
    } else H || (H = P.el)
    ;(t.params.uniqueNavElements &&
      typeof P.el == 'string' &&
      H.length > 1 &&
      C.querySelectorAll(P.el).length === 1 &&
      (H = C.querySelector(P.el)),
      H.length > 0 && (H = H[0]),
      H.classList.add(t.isHorizontal() ? P.horizontalClass : P.verticalClass))
    let $
    ;(H &&
      (($ = H.querySelector(Ue(t.params.scrollbar.dragClass))),
      $ || (($ = he('div', t.params.scrollbar.dragClass)), H.append($))),
      Object.assign(E, { el: H, dragEl: $ }),
      P.draggable && L(),
      H &&
        H.classList[t.enabled ? 'remove' : 'add'](
          ...gt(t.params.scrollbar.lockClass),
        ))
  }
  function w() {
    let E = t.params.scrollbar,
      C = t.scrollbar.el
    ;(C &&
      C.classList.remove(
        ...gt(t.isHorizontal() ? E.horizontalClass : E.verticalClass),
      ),
      M())
  }
  ;(e('changeDirection', () => {
    if (!t.scrollbar || !t.scrollbar.el) return
    let E = t.params.scrollbar,
      { el: C } = t.scrollbar
    ;((C = X(C)),
      C.forEach((P) => {
        ;(P.classList.remove(E.horizontalClass, E.verticalClass),
          P.classList.add(
            t.isHorizontal() ? E.horizontalClass : E.verticalClass,
          ))
      }))
  }),
    e('init', () => {
      t.params.scrollbar.enabled === !1 ? k() : (R(), d(), m())
    }),
    e('update resize observerUpdate lock unlock changeDirection', () => {
      d()
    }),
    e('setTranslate', () => {
      m()
    }),
    e('setTransition', (E, C) => {
      c(C)
    }),
    e('enable disable', () => {
      let { el: E } = t.scrollbar
      E &&
        E.classList[t.enabled ? 'remove' : 'add'](
          ...gt(t.params.scrollbar.lockClass),
        )
    }),
    e('destroy', () => {
      w()
    }))
  let B = () => {
      ;(t.el.classList.remove(...gt(t.params.scrollbar.scrollbarDisabledClass)),
        t.scrollbar.el &&
          t.scrollbar.el.classList.remove(
            ...gt(t.params.scrollbar.scrollbarDisabledClass),
          ),
        R(),
        d(),
        m())
    },
    k = () => {
      ;(t.el.classList.add(...gt(t.params.scrollbar.scrollbarDisabledClass)),
        t.scrollbar.el &&
          t.scrollbar.el.classList.add(
            ...gt(t.params.scrollbar.scrollbarDisabledClass),
          ),
        w())
    }
  Object.assign(t.scrollbar, {
    enable: B,
    disable: k,
    updateSize: d,
    setTranslate: m,
    init: R,
    destroy: w,
  })
}
var Xa = J(() => {
  Ve()
  re()
  Ws()
  Gs()
})
function Qa({ swiper: t, extendParams: r, on: e }) {
  r({ parallax: { enabled: !1 } })
  let s =
      '[data-swiper-parallax], [data-swiper-parallax-x], [data-swiper-parallax-y], [data-swiper-parallax-opacity], [data-swiper-parallax-scale]',
    i = (l, o) => {
      let { rtl: u } = t,
        h = u ? -1 : 1,
        f = l.getAttribute('data-swiper-parallax') || '0',
        m = l.getAttribute('data-swiper-parallax-x'),
        c = l.getAttribute('data-swiper-parallax-y'),
        d = l.getAttribute('data-swiper-parallax-scale'),
        g = l.getAttribute('data-swiper-parallax-opacity'),
        T = l.getAttribute('data-swiper-parallax-rotate')
      if (
        (m || c
          ? ((m = m || '0'), (c = c || '0'))
          : t.isHorizontal()
            ? ((m = f), (c = '0'))
            : ((c = f), (m = '0')),
        m.indexOf('%') >= 0
          ? (m = `${parseInt(m, 10) * o * h}%`)
          : (m = `${m * o * h}px`),
        c.indexOf('%') >= 0
          ? (c = `${parseInt(c, 10) * o}%`)
          : (c = `${c * o}px`),
        typeof g < 'u' && g !== null)
      ) {
        let v = g - (g - 1) * (1 - Math.abs(o))
        l.style.opacity = v
      }
      let p = `translate3d(${m}, ${c}, 0px)`
      if (typeof d < 'u' && d !== null) {
        let v = d - (d - 1) * (1 - Math.abs(o))
        p += ` scale(${v})`
      }
      if (T && typeof T < 'u' && T !== null) {
        let v = T * o * -1
        p += ` rotate(${v}deg)`
      }
      l.style.transform = p
    },
    n = () => {
      let { el: l, slides: o, progress: u, snapGrid: h, isElement: f } = t,
        m = ne(l, s)
      ;(t.isElement && m.push(...ne(t.hostEl, s)),
        m.forEach((c) => {
          i(c, u)
        }),
        o.forEach((c, d) => {
          let g = c.progress
          ;(t.params.slidesPerGroup > 1 &&
            t.params.slidesPerView !== 'auto' &&
            (g += Math.ceil(d / 2) - u * (h.length - 1)),
            (g = Math.min(Math.max(g, -1), 1)),
            c
              .querySelectorAll(`${s}, [data-swiper-parallax-rotate]`)
              .forEach((T) => {
                i(T, g)
              }))
        }))
    },
    a = (l = t.params.speed) => {
      let { el: o, hostEl: u } = t,
        h = [...o.querySelectorAll(s)]
      ;(t.isElement && h.push(...u.querySelectorAll(s)),
        h.forEach((f) => {
          let m =
            parseInt(f.getAttribute('data-swiper-parallax-duration'), 10) || l
          ;(l === 0 && (m = 0), (f.style.transitionDuration = `${m}ms`))
        }))
    }
  ;(e('beforeInit', () => {
    t.params.parallax.enabled &&
      ((t.params.watchSlidesProgress = !0),
      (t.originalParams.watchSlidesProgress = !0))
  }),
    e('init', () => {
      t.params.parallax.enabled && n()
    }),
    e('setTranslate', () => {
      t.params.parallax.enabled && n()
    }),
    e('setTransition', (l, o) => {
      t.params.parallax.enabled && a(o)
    }))
}
var Ja = J(() => {
  re()
})
function Za({ swiper: t, extendParams: r, on: e, emit: s }) {
  let i = ee()
  ;(r({
    zoom: {
      enabled: !1,
      limitToOriginalSize: !1,
      maxRatio: 3,
      minRatio: 1,
      panOnMouseMove: !1,
      toggle: !0,
      containerClass: 'swiper-zoom-container',
      zoomedSlideClass: 'swiper-slide-zoomed',
    },
  }),
    (t.zoom = { enabled: !1 }))
  let n = 1,
    a = !1,
    l = !1,
    o = { x: 0, y: 0 },
    u = -3,
    h,
    f,
    m = [],
    c = {
      originX: 0,
      originY: 0,
      slideEl: void 0,
      slideWidth: void 0,
      slideHeight: void 0,
      imageEl: void 0,
      imageWrapEl: void 0,
      maxRatio: 3,
    },
    d = {
      isTouched: void 0,
      isMoved: void 0,
      currentX: void 0,
      currentY: void 0,
      minX: void 0,
      minY: void 0,
      maxX: void 0,
      maxY: void 0,
      width: void 0,
      height: void 0,
      startX: void 0,
      startY: void 0,
      touchesStart: {},
      touchesCurrent: {},
    },
    g = {
      x: void 0,
      y: void 0,
      prevPositionX: void 0,
      prevPositionY: void 0,
      prevTime: void 0,
    },
    T = 1
  Object.defineProperty(t.zoom, 'scale', {
    get() {
      return T
    },
    set(F) {
      if (T !== F) {
        let V = c.imageEl,
          z = c.slideEl
        s('zoomChange', F, V, z)
      }
      T = F
    },
  })
  function p() {
    if (m.length < 2) return 1
    let F = m[0].pageX,
      V = m[0].pageY,
      z = m[1].pageX,
      N = m[1].pageY
    return Math.sqrt((z - F) ** 2 + (N - V) ** 2)
  }
  function v() {
    let F = t.params.zoom,
      V = c.imageWrapEl.getAttribute('data-swiper-zoom') || F.maxRatio
    if (F.limitToOriginalSize && c.imageEl && c.imageEl.naturalWidth) {
      let z = c.imageEl.naturalWidth / c.imageEl.offsetWidth
      return Math.min(z, V)
    }
    return V
  }
  function y() {
    if (m.length < 2) return { x: null, y: null }
    let F = c.imageEl.getBoundingClientRect()
    return [
      (m[0].pageX + (m[1].pageX - m[0].pageX) / 2 - F.x - i.scrollX) / n,
      (m[0].pageY + (m[1].pageY - m[0].pageY) / 2 - F.y - i.scrollY) / n,
    ]
  }
  function x() {
    return t.isElement ? 'swiper-slide' : `.${t.params.slideClass}`
  }
  function L(F) {
    let V = x()
    return !!(
      F.target.matches(V) ||
      t.slides.filter((z) => z.contains(F.target)).length > 0
    )
  }
  function M(F) {
    let V = `.${t.params.zoom.containerClass}`
    return !!(
      F.target.matches(V) ||
      [...t.hostEl.querySelectorAll(V)].filter((z) => z.contains(F.target))
        .length > 0
    )
  }
  function R(F) {
    if ((F.pointerType === 'mouse' && m.splice(0, m.length), !L(F))) return
    let V = t.params.zoom
    if (((h = !1), (f = !1), m.push(F), !(m.length < 2))) {
      if (((h = !0), (c.scaleStart = p()), !c.slideEl)) {
        ;((c.slideEl = F.target.closest(
          `.${t.params.slideClass}, swiper-slide`,
        )),
          c.slideEl || (c.slideEl = t.slides[t.activeIndex]))
        let z = c.slideEl.querySelector(`.${V.containerClass}`)
        if (
          (z &&
            (z = z.querySelectorAll(
              'picture, img, svg, canvas, .swiper-zoom-target',
            )[0]),
          (c.imageEl = z),
          z
            ? (c.imageWrapEl = Xe(c.imageEl, `.${V.containerClass}`)[0])
            : (c.imageWrapEl = void 0),
          !c.imageWrapEl)
        ) {
          c.imageEl = void 0
          return
        }
        c.maxRatio = v()
      }
      if (c.imageEl) {
        let [z, N] = y()
        ;((c.originX = z),
          (c.originY = N),
          (c.imageEl.style.transitionDuration = '0ms'))
      }
      a = !0
    }
  }
  function w(F) {
    if (!L(F)) return
    let V = t.params.zoom,
      z = t.zoom,
      N = m.findIndex((W) => W.pointerId === F.pointerId)
    ;(N >= 0 && (m[N] = F),
      !(m.length < 2) &&
        ((f = !0),
        (c.scaleMove = p()),
        c.imageEl &&
          ((z.scale = (c.scaleMove / c.scaleStart) * n),
          z.scale > c.maxRatio &&
            (z.scale = c.maxRatio - 1 + (z.scale - c.maxRatio + 1) ** 0.5),
          z.scale < V.minRatio &&
            (z.scale = V.minRatio + 1 - (V.minRatio - z.scale + 1) ** 0.5),
          (c.imageEl.style.transform = `translate3d(0,0,0) scale(${z.scale})`))))
  }
  function B(F) {
    if (!L(F) || (F.pointerType === 'mouse' && F.type === 'pointerout')) return
    let V = t.params.zoom,
      z = t.zoom,
      N = m.findIndex((W) => W.pointerId === F.pointerId)
    ;(N >= 0 && m.splice(N, 1),
      !(!h || !f) &&
        ((h = !1),
        (f = !1),
        c.imageEl &&
          ((z.scale = Math.max(Math.min(z.scale, c.maxRatio), V.minRatio)),
          (c.imageEl.style.transitionDuration = `${t.params.speed}ms`),
          (c.imageEl.style.transform = `translate3d(0,0,0) scale(${z.scale})`),
          (n = z.scale),
          (a = !1),
          z.scale > 1 && c.slideEl
            ? c.slideEl.classList.add(`${V.zoomedSlideClass}`)
            : z.scale <= 1 &&
              c.slideEl &&
              c.slideEl.classList.remove(`${V.zoomedSlideClass}`),
          z.scale === 1 &&
            ((c.originX = 0), (c.originY = 0), (c.slideEl = void 0)))))
  }
  let k
  function E() {
    t.touchEventsData.preventTouchMoveFromPointerMove = !1
  }
  function C() {
    ;(clearTimeout(k),
      (t.touchEventsData.preventTouchMoveFromPointerMove = !0),
      (k = setTimeout(() => {
        t.destroyed || E()
      })))
  }
  function P(F) {
    let V = t.device
    if (!c.imageEl || d.isTouched) return
    ;(V.android && F.cancelable && F.preventDefault(), (d.isTouched = !0))
    let z = m.length > 0 ? m[0] : F
    ;((d.touchesStart.x = z.pageX), (d.touchesStart.y = z.pageY))
  }
  function H(F) {
    let z = F.pointerType === 'mouse' && t.params.zoom.panOnMouseMove
    if (!L(F) || !M(F)) return
    let N = t.zoom
    if (!c.imageEl) return
    if (!d.isTouched || !c.slideEl) {
      z && A(F)
      return
    }
    if (z) {
      A(F)
      return
    }
    d.isMoved ||
      ((d.width = c.imageEl.offsetWidth || c.imageEl.clientWidth),
      (d.height = c.imageEl.offsetHeight || c.imageEl.clientHeight),
      (d.startX = es(c.imageWrapEl, 'x') || 0),
      (d.startY = es(c.imageWrapEl, 'y') || 0),
      (c.slideWidth = c.slideEl.offsetWidth),
      (c.slideHeight = c.slideEl.offsetHeight),
      (c.imageWrapEl.style.transitionDuration = '0ms'))
    let W = d.width * N.scale,
      pe = d.height * N.scale
    if (
      ((d.minX = Math.min(c.slideWidth / 2 - W / 2, 0)),
      (d.maxX = -d.minX),
      (d.minY = Math.min(c.slideHeight / 2 - pe / 2, 0)),
      (d.maxY = -d.minY),
      (d.touchesCurrent.x = m.length > 0 ? m[0].pageX : F.pageX),
      (d.touchesCurrent.y = m.length > 0 ? m[0].pageY : F.pageY),
      Math.max(
        Math.abs(d.touchesCurrent.x - d.touchesStart.x),
        Math.abs(d.touchesCurrent.y - d.touchesStart.y),
      ) > 5 && (t.allowClick = !1),
      !d.isMoved && !a)
    ) {
      if (
        t.isHorizontal() &&
        ((Math.floor(d.minX) === Math.floor(d.startX) &&
          d.touchesCurrent.x < d.touchesStart.x) ||
          (Math.floor(d.maxX) === Math.floor(d.startX) &&
            d.touchesCurrent.x > d.touchesStart.x))
      ) {
        ;((d.isTouched = !1), E())
        return
      }
      if (
        !t.isHorizontal() &&
        ((Math.floor(d.minY) === Math.floor(d.startY) &&
          d.touchesCurrent.y < d.touchesStart.y) ||
          (Math.floor(d.maxY) === Math.floor(d.startY) &&
            d.touchesCurrent.y > d.touchesStart.y))
      ) {
        ;((d.isTouched = !1), E())
        return
      }
    }
    ;(F.cancelable && F.preventDefault(),
      F.stopPropagation(),
      C(),
      (d.isMoved = !0))
    let $e = (N.scale - n) / (c.maxRatio - t.params.zoom.minRatio),
      { originX: Ge, originY: se } = c
    ;((d.currentX =
      d.touchesCurrent.x -
      d.touchesStart.x +
      d.startX +
      $e * (d.width - Ge * 2)),
      (d.currentY =
        d.touchesCurrent.y -
        d.touchesStart.y +
        d.startY +
        $e * (d.height - se * 2)),
      d.currentX < d.minX &&
        (d.currentX = d.minX + 1 - (d.minX - d.currentX + 1) ** 0.8),
      d.currentX > d.maxX &&
        (d.currentX = d.maxX - 1 + (d.currentX - d.maxX + 1) ** 0.8),
      d.currentY < d.minY &&
        (d.currentY = d.minY + 1 - (d.minY - d.currentY + 1) ** 0.8),
      d.currentY > d.maxY &&
        (d.currentY = d.maxY - 1 + (d.currentY - d.maxY + 1) ** 0.8),
      g.prevPositionX || (g.prevPositionX = d.touchesCurrent.x),
      g.prevPositionY || (g.prevPositionY = d.touchesCurrent.y),
      g.prevTime || (g.prevTime = Date.now()),
      (g.x =
        (d.touchesCurrent.x - g.prevPositionX) / (Date.now() - g.prevTime) / 2),
      (g.y =
        (d.touchesCurrent.y - g.prevPositionY) / (Date.now() - g.prevTime) / 2),
      Math.abs(d.touchesCurrent.x - g.prevPositionX) < 2 && (g.x = 0),
      Math.abs(d.touchesCurrent.y - g.prevPositionY) < 2 && (g.y = 0),
      (g.prevPositionX = d.touchesCurrent.x),
      (g.prevPositionY = d.touchesCurrent.y),
      (g.prevTime = Date.now()),
      (c.imageWrapEl.style.transform = `translate3d(${d.currentX}px, ${d.currentY}px,0)`))
  }
  function $() {
    let F = t.zoom
    if (((m.length = 0), !c.imageEl)) return
    if (!d.isTouched || !d.isMoved) {
      ;((d.isTouched = !1), (d.isMoved = !1))
      return
    }
    ;((d.isTouched = !1), (d.isMoved = !1))
    let V = 300,
      z = 300,
      N = g.x * V,
      W = d.currentX + N,
      pe = g.y * z,
      _e = d.currentY + pe
    ;(g.x !== 0 && (V = Math.abs((W - d.currentX) / g.x)),
      g.y !== 0 && (z = Math.abs((_e - d.currentY) / g.y)))
    let $e = Math.max(V, z)
    ;((d.currentX = W), (d.currentY = _e))
    let Ge = d.width * F.scale,
      se = d.height * F.scale
    ;((d.minX = Math.min(c.slideWidth / 2 - Ge / 2, 0)),
      (d.maxX = -d.minX),
      (d.minY = Math.min(c.slideHeight / 2 - se / 2, 0)),
      (d.maxY = -d.minY),
      (d.currentX = Math.max(Math.min(d.currentX, d.maxX), d.minX)),
      (d.currentY = Math.max(Math.min(d.currentY, d.maxY), d.minY)),
      (c.imageWrapEl.style.transitionDuration = `${$e}ms`),
      (c.imageWrapEl.style.transform = `translate3d(${d.currentX}px, ${d.currentY}px,0)`))
  }
  function I() {
    let F = t.zoom
    c.slideEl &&
      t.activeIndex !== t.slides.indexOf(c.slideEl) &&
      (c.imageEl && (c.imageEl.style.transform = 'translate3d(0,0,0) scale(1)'),
      c.imageWrapEl && (c.imageWrapEl.style.transform = 'translate3d(0,0,0)'),
      c.slideEl.classList.remove(`${t.params.zoom.zoomedSlideClass}`),
      (F.scale = 1),
      (n = 1),
      (c.slideEl = void 0),
      (c.imageEl = void 0),
      (c.imageWrapEl = void 0),
      (c.originX = 0),
      (c.originY = 0))
  }
  function A(F) {
    if (n <= 1 || !c.imageWrapEl || !L(F) || !M(F)) return
    let V = i.getComputedStyle(c.imageWrapEl).transform,
      z = new i.DOMMatrix(V)
    if (!l) {
      ;((l = !0),
        (o.x = F.clientX),
        (o.y = F.clientY),
        (d.startX = z.e),
        (d.startY = z.f),
        (d.width = c.imageEl.offsetWidth || c.imageEl.clientWidth),
        (d.height = c.imageEl.offsetHeight || c.imageEl.clientHeight),
        (c.slideWidth = c.slideEl.offsetWidth),
        (c.slideHeight = c.slideEl.offsetHeight))
      return
    }
    let N = (F.clientX - o.x) * u,
      W = (F.clientY - o.y) * u,
      pe = d.width * n,
      _e = d.height * n,
      $e = c.slideWidth,
      Ge = c.slideHeight,
      se = Math.min($e / 2 - pe / 2, 0),
      be = -se,
      He = Math.min(Ge / 2 - _e / 2, 0),
      St = -He,
      Ze = Math.max(Math.min(d.startX + N, be), se),
      De = Math.max(Math.min(d.startY + W, St), He)
    ;((c.imageWrapEl.style.transitionDuration = '0ms'),
      (c.imageWrapEl.style.transform = `translate3d(${Ze}px, ${De}px, 0)`),
      (o.x = F.clientX),
      (o.y = F.clientY),
      (d.startX = Ze),
      (d.startY = De),
      (d.currentX = Ze),
      (d.currentY = De))
  }
  function O(F) {
    let V = t.zoom,
      z = t.params.zoom
    if (!c.slideEl) {
      ;(F &&
        F.target &&
        (c.slideEl = F.target.closest(`.${t.params.slideClass}, swiper-slide`)),
        c.slideEl ||
          (t.params.virtual && t.params.virtual.enabled && t.virtual
            ? (c.slideEl = ne(t.slidesEl, `.${t.params.slideActiveClass}`)[0])
            : (c.slideEl = t.slides[t.activeIndex])))
      let ft = c.slideEl.querySelector(`.${z.containerClass}`)
      ;(ft &&
        (ft = ft.querySelectorAll(
          'picture, img, svg, canvas, .swiper-zoom-target',
        )[0]),
        (c.imageEl = ft),
        ft
          ? (c.imageWrapEl = Xe(c.imageEl, `.${z.containerClass}`)[0])
          : (c.imageWrapEl = void 0))
    }
    if (!c.imageEl || !c.imageWrapEl) return
    ;((c.maxRatio = v()),
      t.params.cssMode &&
        ((t.wrapperEl.style.overflow = 'hidden'),
        (t.wrapperEl.style.touchAction = 'none')),
      c.slideEl.classList.add(`${z.zoomedSlideClass}`))
    let N, W, pe, _e, $e, Ge, se, be, He, St, Ze, De, ct, dt, Zt, er, tr, kt
    typeof d.touchesStart.x > 'u' && F
      ? ((N = F.pageX), (W = F.pageY))
      : ((N = d.touchesStart.x), (W = d.touchesStart.y))
    let ut = n,
      Be = typeof F == 'number' ? F : null
    n === 1 &&
      Be &&
      ((N = void 0),
      (W = void 0),
      (d.touchesStart.x = void 0),
      (d.touchesStart.y = void 0))
    let Fe = v()
    ;((V.scale = Be || Fe),
      (n = Be || Fe),
      F && !(n === 1 && Be)
        ? ((tr = c.slideEl.offsetWidth),
          (kt = c.slideEl.offsetHeight),
          (pe = Dt(c.slideEl).left + i.scrollX),
          (_e = Dt(c.slideEl).top + i.scrollY),
          ($e = pe + tr / 2 - N),
          (Ge = _e + kt / 2 - W),
          (He = c.imageEl.offsetWidth || c.imageEl.clientWidth),
          (St = c.imageEl.offsetHeight || c.imageEl.clientHeight),
          (Ze = He * V.scale),
          (De = St * V.scale),
          (ct = Math.min(tr / 2 - Ze / 2, 0)),
          (dt = Math.min(kt / 2 - De / 2, 0)),
          (Zt = -ct),
          (er = -dt),
          ut > 0 &&
          Be &&
          typeof d.currentX == 'number' &&
          typeof d.currentY == 'number'
            ? ((se = (d.currentX * V.scale) / ut),
              (be = (d.currentY * V.scale) / ut))
            : ((se = $e * V.scale), (be = Ge * V.scale)),
          se < ct && (se = ct),
          se > Zt && (se = Zt),
          be < dt && (be = dt),
          be > er && (be = er))
        : ((se = 0), (be = 0)),
      Be && V.scale === 1 && ((c.originX = 0), (c.originY = 0)),
      (d.currentX = se),
      (d.currentY = be),
      (c.imageWrapEl.style.transitionDuration = '300ms'),
      (c.imageWrapEl.style.transform = `translate3d(${se}px, ${be}px,0)`),
      (c.imageEl.style.transitionDuration = '300ms'),
      (c.imageEl.style.transform = `translate3d(0,0,0) scale(${V.scale})`))
  }
  function q() {
    let F = t.zoom,
      V = t.params.zoom
    if (!c.slideEl) {
      t.params.virtual && t.params.virtual.enabled && t.virtual
        ? (c.slideEl = ne(t.slidesEl, `.${t.params.slideActiveClass}`)[0])
        : (c.slideEl = t.slides[t.activeIndex])
      let z = c.slideEl.querySelector(`.${V.containerClass}`)
      ;(z &&
        (z = z.querySelectorAll(
          'picture, img, svg, canvas, .swiper-zoom-target',
        )[0]),
        (c.imageEl = z),
        z
          ? (c.imageWrapEl = Xe(c.imageEl, `.${V.containerClass}`)[0])
          : (c.imageWrapEl = void 0))
    }
    !c.imageEl ||
      !c.imageWrapEl ||
      ((c.maxRatio = v()),
      t.params.cssMode &&
        ((t.wrapperEl.style.overflow = ''),
        (t.wrapperEl.style.touchAction = '')),
      (F.scale = 1),
      (n = 1),
      (d.currentX = void 0),
      (d.currentY = void 0),
      (d.touchesStart.x = void 0),
      (d.touchesStart.y = void 0),
      (c.imageWrapEl.style.transitionDuration = '300ms'),
      (c.imageWrapEl.style.transform = 'translate3d(0,0,0)'),
      (c.imageEl.style.transitionDuration = '300ms'),
      (c.imageEl.style.transform = 'translate3d(0,0,0) scale(1)'),
      c.slideEl.classList.remove(`${V.zoomedSlideClass}`),
      (c.slideEl = void 0),
      (c.originX = 0),
      (c.originY = 0),
      t.params.zoom.panOnMouseMove &&
        ((o = { x: 0, y: 0 }), l && ((l = !1), (d.startX = 0), (d.startY = 0))))
  }
  function G(F) {
    let V = t.zoom
    V.scale && V.scale !== 1 ? q() : O(F)
  }
  function Q() {
    let F = t.params.passiveListeners ? { passive: !0, capture: !1 } : !1,
      V = t.params.passiveListeners ? { passive: !1, capture: !0 } : !0
    return { passiveListener: F, activeListenerWithCapture: V }
  }
  function Ae() {
    let F = t.zoom
    if (F.enabled) return
    F.enabled = !0
    let { passiveListener: V, activeListenerWithCapture: z } = Q()
    ;(t.wrapperEl.addEventListener('pointerdown', R, V),
      t.wrapperEl.addEventListener('pointermove', w, z),
      ['pointerup', 'pointercancel', 'pointerout'].forEach((N) => {
        t.wrapperEl.addEventListener(N, B, V)
      }),
      t.wrapperEl.addEventListener('pointermove', H, z))
  }
  function Z() {
    let F = t.zoom
    if (!F.enabled) return
    F.enabled = !1
    let { passiveListener: V, activeListenerWithCapture: z } = Q()
    ;(t.wrapperEl.removeEventListener('pointerdown', R, V),
      t.wrapperEl.removeEventListener('pointermove', w, z),
      ['pointerup', 'pointercancel', 'pointerout'].forEach((N) => {
        t.wrapperEl.removeEventListener(N, B, V)
      }),
      t.wrapperEl.removeEventListener('pointermove', H, z))
  }
  ;(e('init', () => {
    t.params.zoom.enabled && Ae()
  }),
    e('destroy', () => {
      Z()
    }),
    e('touchStart', (F, V) => {
      t.zoom.enabled && P(V)
    }),
    e('touchEnd', (F, V) => {
      t.zoom.enabled && $()
    }),
    e('doubleTap', (F, V) => {
      !t.animating &&
        t.params.zoom.enabled &&
        t.zoom.enabled &&
        t.params.zoom.toggle &&
        G(V)
    }),
    e('transitionEnd', () => {
      t.zoom.enabled && t.params.zoom.enabled && I()
    }),
    e('slideChange', () => {
      t.zoom.enabled && t.params.zoom.enabled && t.params.cssMode && I()
    }),
    Object.assign(t.zoom, { enable: Ae, disable: Z, in: O, out: q, toggle: G }))
}
var eo = J(() => {
  Ve()
  re()
})
function to({ swiper: t, extendParams: r, on: e }) {
  ;(r({ controller: { control: void 0, inverse: !1, by: 'slide' } }),
    (t.controller = { control: void 0 }))
  function s(o, u) {
    let h = (function () {
      let d, g, T
      return (p, v) => {
        for (g = -1, d = p.length; d - g > 1; )
          ((T = (d + g) >> 1), p[T] <= v ? (g = T) : (d = T))
        return d
      }
    })()
    ;((this.x = o), (this.y = u), (this.lastIndex = o.length - 1))
    let f, m
    return (
      (this.interpolate = function (d) {
        return d
          ? ((m = h(this.x, d)),
            (f = m - 1),
            ((d - this.x[f]) * (this.y[m] - this.y[f])) /
              (this.x[m] - this.x[f]) +
              this.y[f])
          : 0
      }),
      this
    )
  }
  function i(o) {
    t.controller.spline = t.params.loop
      ? new s(t.slidesGrid, o.slidesGrid)
      : new s(t.snapGrid, o.snapGrid)
  }
  function n(o, u) {
    let h = t.controller.control,
      f,
      m,
      c = t.constructor
    function d(g) {
      if (g.destroyed) return
      let T = t.rtlTranslate ? -t.translate : t.translate
      ;(t.params.controller.by === 'slide' &&
        (i(g), (m = -t.controller.spline.interpolate(-T))),
        (!m || t.params.controller.by === 'container') &&
          ((f =
            (g.maxTranslate() - g.minTranslate()) /
            (t.maxTranslate() - t.minTranslate())),
          (Number.isNaN(f) || !Number.isFinite(f)) && (f = 1),
          (m = (T - t.minTranslate()) * f + g.minTranslate())),
        t.params.controller.inverse && (m = g.maxTranslate() - m),
        g.updateProgress(m),
        g.setTranslate(m, t),
        g.updateActiveIndex(),
        g.updateSlidesClasses())
    }
    if (Array.isArray(h))
      for (let g = 0; g < h.length; g += 1)
        h[g] !== u && h[g] instanceof c && d(h[g])
    else h instanceof c && u !== h && d(h)
  }
  function a(o, u) {
    let h = t.constructor,
      f = t.controller.control,
      m
    function c(d) {
      d.destroyed ||
        (d.setTransition(o, t),
        o !== 0 &&
          (d.transitionStart(),
          d.params.autoHeight &&
            rt(() => {
              d.updateAutoHeight()
            }),
          xt(d.wrapperEl, () => {
            f && d.transitionEnd()
          })))
    }
    if (Array.isArray(f))
      for (m = 0; m < f.length; m += 1)
        f[m] !== u && f[m] instanceof h && c(f[m])
    else f instanceof h && u !== f && c(f)
  }
  function l() {
    t.controller.control &&
      t.controller.spline &&
      ((t.controller.spline = void 0), delete t.controller.spline)
  }
  ;(e('beforeInit', () => {
    if (
      typeof window < 'u' &&
      (typeof t.params.controller.control == 'string' ||
        t.params.controller.control instanceof HTMLElement)
    ) {
      ;(typeof t.params.controller.control == 'string'
        ? [...document.querySelectorAll(t.params.controller.control)]
        : [t.params.controller.control]
      ).forEach((u) => {
        if (
          (t.controller.control || (t.controller.control = []), u && u.swiper)
        )
          t.controller.control.push(u.swiper)
        else if (u) {
          let h = `${t.params.eventsPrefix}init`,
            f = (m) => {
              ;(t.controller.control.push(m.detail[0]),
                t.update(),
                u.removeEventListener(h, f))
            }
          u.addEventListener(h, f)
        }
      })
      return
    }
    t.controller.control = t.params.controller.control
  }),
    e('update', () => {
      l()
    }),
    e('resize', () => {
      l()
    }),
    e('observerUpdate', () => {
      l()
    }),
    e('setTranslate', (o, u, h) => {
      !t.controller.control ||
        t.controller.control.destroyed ||
        t.controller.setTranslate(u, h)
    }),
    e('setTransition', (o, u, h) => {
      !t.controller.control ||
        t.controller.control.destroyed ||
        t.controller.setTransition(u, h)
    }),
    Object.assign(t.controller, { setTranslate: n, setTransition: a }))
}
var ro = J(() => {
  re()
})
function so({ swiper: t, extendParams: r, on: e }) {
  ;(r({
    a11y: {
      enabled: !0,
      notificationClass: 'swiper-notification',
      prevSlideMessage: 'Previous slide',
      nextSlideMessage: 'Next slide',
      firstSlideMessage: 'This is the first slide',
      lastSlideMessage: 'This is the last slide',
      paginationBulletMessage: 'Go to slide {{index}}',
      slideLabelMessage: '{{index}} / {{slidesLength}}',
      containerMessage: null,
      containerRoleDescriptionMessage: null,
      containerRole: null,
      itemRoleDescriptionMessage: null,
      slideRole: 'group',
      id: null,
      scrollOnFocus: !0,
      wrapperLiveRegion: !0,
    },
  }),
    (t.a11y = { clicked: !1 }))
  let s = null,
    i,
    n,
    a = new Date().getTime()
  function l(I) {
    let A = s
    A.length !== 0 && Ce(A, I)
  }
  function o(I = 16) {
    let A = () => Math.round(16 * Math.random()).toString(16)
    return 'x'.repeat(I).replace(/x/g, A)
  }
  function u(I) {
    ;((I = X(I)),
      I.forEach((A) => {
        A.setAttribute('tabIndex', '0')
      }))
  }
  function h(I) {
    ;((I = X(I)),
      I.forEach((A) => {
        A.setAttribute('tabIndex', '-1')
      }))
  }
  function f(I, A) {
    ;((I = X(I)),
      I.forEach((O) => {
        O.setAttribute('role', A)
      }))
  }
  function m(I, A) {
    ;((I = X(I)),
      I.forEach((O) => {
        O.setAttribute('aria-roledescription', A)
      }))
  }
  function c(I, A) {
    ;((I = X(I)),
      I.forEach((O) => {
        O.setAttribute('aria-controls', A)
      }))
  }
  function d(I, A) {
    ;((I = X(I)),
      I.forEach((O) => {
        O.setAttribute('aria-label', A)
      }))
  }
  function g(I, A) {
    ;((I = X(I)),
      I.forEach((O) => {
        O.setAttribute('id', A)
      }))
  }
  function T(I, A) {
    ;((I = X(I)),
      I.forEach((O) => {
        O.setAttribute('aria-live', A)
      }))
  }
  function p(I) {
    ;((I = X(I)),
      I.forEach((A) => {
        A.setAttribute('aria-disabled', !0)
      }))
  }
  function v(I) {
    ;((I = X(I)),
      I.forEach((A) => {
        A.setAttribute('aria-disabled', !1)
      }))
  }
  function y(I) {
    if (I.keyCode !== 13 && I.keyCode !== 32) return
    let A = t.params.a11y,
      O = I.target
    if (
      !(
        t.pagination &&
        t.pagination.el &&
        (O === t.pagination.el || t.pagination.el.contains(I.target)) &&
        !I.target.matches(Ue(t.params.pagination.bulletClass))
      )
    ) {
      if (t.navigation && t.navigation.prevEl && t.navigation.nextEl) {
        let q = X(t.navigation.prevEl)
        ;(X(t.navigation.nextEl).includes(O) &&
          ((t.isEnd && !t.params.loop) || t.slideNext(),
          t.isEnd ? l(A.lastSlideMessage) : l(A.nextSlideMessage)),
          q.includes(O) &&
            ((t.isBeginning && !t.params.loop) || t.slidePrev(),
            t.isBeginning ? l(A.firstSlideMessage) : l(A.prevSlideMessage)))
      }
      t.pagination &&
        O.matches(Ue(t.params.pagination.bulletClass)) &&
        O.click()
    }
  }
  function x() {
    if (t.params.loop || t.params.rewind || !t.navigation) return
    let { nextEl: I, prevEl: A } = t.navigation
    ;(A && (t.isBeginning ? (p(A), h(A)) : (v(A), u(A))),
      I && (t.isEnd ? (p(I), h(I)) : (v(I), u(I))))
  }
  function L() {
    return t.pagination && t.pagination.bullets && t.pagination.bullets.length
  }
  function M() {
    return L() && t.params.pagination.clickable
  }
  function R() {
    let I = t.params.a11y
    L() &&
      t.pagination.bullets.forEach((A) => {
        ;(t.params.pagination.clickable &&
          (u(A),
          t.params.pagination.renderBullet ||
            (f(A, 'button'),
            d(
              A,
              I.paginationBulletMessage.replace(/\{\{index\}\}/, Et(A) + 1),
            ))),
          A.matches(Ue(t.params.pagination.bulletActiveClass))
            ? A.setAttribute('aria-current', 'true')
            : A.removeAttribute('aria-current'))
      })
  }
  let w = (I, A, O) => {
      ;(u(I),
        I.tagName !== 'BUTTON' &&
          (f(I, 'button'), I.addEventListener('keydown', y)),
        d(I, O),
        c(I, A))
    },
    B = (I) => {
      ;(n && n !== I.target && !n.contains(I.target) && (i = !0),
        (t.a11y.clicked = !0))
    },
    k = () => {
      ;((i = !1),
        requestAnimationFrame(() => {
          requestAnimationFrame(() => {
            t.destroyed || (t.a11y.clicked = !1)
          })
        }))
    },
    E = (I) => {
      a = new Date().getTime()
    },
    C = (I) => {
      if (
        t.a11y.clicked ||
        !t.params.a11y.scrollOnFocus ||
        new Date().getTime() - a < 100
      )
        return
      let A = I.target.closest(`.${t.params.slideClass}, swiper-slide`)
      if (!A || !t.slides.includes(A)) return
      n = A
      let O = t.virtual && t.params.virtual.enabled,
        q =
          (O
            ? parseInt(A.getAttribute('data-swiper-slide-index'), 10)
            : t.slides.indexOf(A)) === t.activeIndex,
        G =
          t.params.watchSlidesProgress &&
          t.visibleSlides &&
          t.visibleSlides.includes(A)
      q ||
        G ||
        (I.sourceCapabilities && I.sourceCapabilities.firesTouchEvents) ||
        (t.isHorizontal() ? (t.el.scrollLeft = 0) : (t.el.scrollTop = 0),
        requestAnimationFrame(() => {
          i ||
            (t.params.loop
              ? t.slideToLoop(
                  t.getSlideIndexWhenGrid(
                    parseInt(A.getAttribute('data-swiper-slide-index')),
                  ),
                  0,
                )
              : O
                ? t.slideTo(
                    t.getSlideIndexWhenGrid(
                      parseInt(A.getAttribute('data-swiper-slide-index'), 10),
                    ),
                    0,
                  )
                : t.slideTo(t.getSlideIndexWhenGrid(t.slides.indexOf(A)), 0),
            (i = !1))
        }))
    },
    P = () => {
      let I = t.params.a11y
      ;(I.itemRoleDescriptionMessage &&
        m(t.slides, I.itemRoleDescriptionMessage),
        I.slideRole && f(t.slides, I.slideRole))
      let A = t.slides.length
      I.slideLabelMessage &&
        t.slides.forEach((O, q) => {
          let G = t.params.loop
              ? parseInt(O.getAttribute('data-swiper-slide-index'), 10)
              : q,
            Q = I.slideLabelMessage
              .replace(/\{\{index\}\}/, G + 1)
              .replace(/\{\{slidesLength\}\}/, A)
          d(O, Q)
        })
    },
    H = () => {
      let I = t.params.a11y
      t.el.append(s)
      let A = t.el
      ;(I.containerRoleDescriptionMessage &&
        m(A, I.containerRoleDescriptionMessage),
        I.containerMessage && d(A, I.containerMessage),
        I.containerRole && f(A, I.containerRole))
      let O = t.wrapperEl,
        q = I.id || O.getAttribute('id') || `swiper-wrapper-${o(16)}`
      if ((g(O, q), I.wrapperLiveRegion)) {
        let Z =
          t.params.autoplay && t.params.autoplay.enabled ? 'off' : 'polite'
        T(O, Z)
      }
      P()
      let { nextEl: G, prevEl: Q } = t.navigation ? t.navigation : {}
      ;((G = X(G)),
        (Q = X(Q)),
        G && G.forEach((Z) => w(Z, q, I.nextSlideMessage)),
        Q && Q.forEach((Z) => w(Z, q, I.prevSlideMessage)),
        M() &&
          X(t.pagination.el).forEach((F) => {
            F.addEventListener('keydown', y)
          }),
        te().addEventListener('visibilitychange', E),
        t.el.addEventListener('focus', C, !0),
        t.el.addEventListener('pointerdown', B, !0),
        t.el.addEventListener('pointerup', k, !0))
    }
  function $() {
    s && s.remove()
    let { nextEl: I, prevEl: A } = t.navigation ? t.navigation : {}
    ;((I = X(I)),
      (A = X(A)),
      I && I.forEach((q) => q.removeEventListener('keydown', y)),
      A && A.forEach((q) => q.removeEventListener('keydown', y)),
      M() &&
        X(t.pagination.el).forEach((G) => {
          G.removeEventListener('keydown', y)
        }),
      te().removeEventListener('visibilitychange', E),
      t.el &&
        typeof t.el != 'string' &&
        (t.el.removeEventListener('focus', C, !0),
        t.el.removeEventListener('pointerdown', B, !0),
        t.el.removeEventListener('pointerup', k, !0)))
  }
  ;(e('beforeInit', () => {
    ;((s = he('span', t.params.a11y.notificationClass)),
      s.setAttribute('aria-live', 'assertive'),
      s.setAttribute('aria-atomic', 'true'))
  }),
    e('afterInit', () => {
      t.params.a11y.enabled && H()
    }),
    e('slidesLengthChange snapGridLengthChange slidesGridLengthChange', () => {
      t.params.a11y.enabled && P()
    }),
    e('fromEdge toEdge afterInit lock unlock', () => {
      t.params.a11y.enabled && x()
    }),
    e('paginationUpdate', () => {
      t.params.a11y.enabled && R()
    }),
    e('destroy', () => {
      t.params.a11y.enabled && $()
    }))
}
var io = J(() => {
  Ve()
  Gs()
  re()
})
function no({ swiper: t, extendParams: r, on: e }) {
  r({
    history: {
      enabled: !1,
      root: '',
      replaceState: !1,
      key: 'slides',
      keepQuery: !1,
    },
  })
  let s = !1,
    i = {},
    n = (m) =>
      m
        .toString()
        .replace(/\s+/g, '-')
        .replace(/[^\w-]+/g, '')
        .replace(/--+/g, '-')
        .replace(/^-+/, '')
        .replace(/-+$/, ''),
    a = (m) => {
      let c = ee(),
        d
      m ? (d = new URL(m)) : (d = c.location)
      let g = d.pathname
          .slice(1)
          .split('/')
          .filter((y) => y !== ''),
        T = g.length,
        p = g[T - 2],
        v = g[T - 1]
      return { key: p, value: v }
    },
    l = (m, c) => {
      let d = ee()
      if (!s || !t.params.history.enabled) return
      let g
      t.params.url ? (g = new URL(t.params.url)) : (g = d.location)
      let T =
          t.virtual && t.params.virtual.enabled
            ? t.slidesEl.querySelector(`[data-swiper-slide-index="${c}"]`)
            : t.slides[c],
        p = n(T.getAttribute('data-history'))
      if (t.params.history.root.length > 0) {
        let y = t.params.history.root
        ;(y[y.length - 1] === '/' && (y = y.slice(0, y.length - 1)),
          (p = `${y}/${m ? `${m}/` : ''}${p}`))
      } else g.pathname.includes(m) || (p = `${m ? `${m}/` : ''}${p}`)
      t.params.history.keepQuery && (p += g.search)
      let v = d.history.state
      ;(v && v.value === p) ||
        (t.params.history.replaceState
          ? d.history.replaceState({ value: p }, null, p)
          : d.history.pushState({ value: p }, null, p))
    },
    o = (m, c, d) => {
      if (c)
        for (let g = 0, T = t.slides.length; g < T; g += 1) {
          let p = t.slides[g]
          if (n(p.getAttribute('data-history')) === c) {
            let y = t.getSlideIndex(p)
            t.slideTo(y, m, d)
          }
        }
      else t.slideTo(0, m, d)
    },
    u = () => {
      ;((i = a(t.params.url)), o(t.params.speed, i.value, !1))
    },
    h = () => {
      let m = ee()
      if (t.params.history) {
        if (!m.history || !m.history.pushState) {
          ;((t.params.history.enabled = !1),
            (t.params.hashNavigation.enabled = !0))
          return
        }
        if (((s = !0), (i = a(t.params.url)), !i.key && !i.value)) {
          t.params.history.replaceState || m.addEventListener('popstate', u)
          return
        }
        ;(o(0, i.value, t.params.runCallbacksOnInit),
          t.params.history.replaceState || m.addEventListener('popstate', u))
      }
    },
    f = () => {
      let m = ee()
      t.params.history.replaceState || m.removeEventListener('popstate', u)
    }
  ;(e('init', () => {
    t.params.history.enabled && h()
  }),
    e('destroy', () => {
      t.params.history.enabled && f()
    }),
    e('transitionEnd _freeModeNoMomentumRelease', () => {
      s && l(t.params.history.key, t.activeIndex)
    }),
    e('slideChange', () => {
      s && t.params.cssMode && l(t.params.history.key, t.activeIndex)
    }))
}
var ao = J(() => {
  Ve()
})
function oo({ swiper: t, extendParams: r, emit: e, on: s }) {
  let i = !1,
    n = te(),
    a = ee()
  r({
    hashNavigation: {
      enabled: !1,
      replaceState: !1,
      watchState: !1,
      getSlideIndex(f, m) {
        if (t.virtual && t.params.virtual.enabled) {
          let c = t.slides.find((g) => g.getAttribute('data-hash') === m)
          return c ? parseInt(c.getAttribute('data-swiper-slide-index'), 10) : 0
        }
        return t.getSlideIndex(
          ne(
            t.slidesEl,
            `.${t.params.slideClass}[data-hash="${m}"], swiper-slide[data-hash="${m}"]`,
          )[0],
        )
      },
    },
  })
  let l = () => {
      e('hashChange')
      let f = n.location.hash.replace('#', ''),
        m =
          t.virtual && t.params.virtual.enabled
            ? t.slidesEl.querySelector(
                `[data-swiper-slide-index="${t.activeIndex}"]`,
              )
            : t.slides[t.activeIndex],
        c = m ? m.getAttribute('data-hash') : ''
      if (f !== c) {
        let d = t.params.hashNavigation.getSlideIndex(t, f)
        if (typeof d > 'u' || Number.isNaN(d)) return
        t.slideTo(d)
      }
    },
    o = () => {
      if (!i || !t.params.hashNavigation.enabled) return
      let f =
          t.virtual && t.params.virtual.enabled
            ? t.slidesEl.querySelector(
                `[data-swiper-slide-index="${t.activeIndex}"]`,
              )
            : t.slides[t.activeIndex],
        m = f
          ? f.getAttribute('data-hash') || f.getAttribute('data-history')
          : ''
      t.params.hashNavigation.replaceState &&
      a.history &&
      a.history.replaceState
        ? (a.history.replaceState(null, null, `#${m}` || ''), e('hashSet'))
        : ((n.location.hash = m || ''), e('hashSet'))
    },
    u = () => {
      if (
        !t.params.hashNavigation.enabled ||
        (t.params.history && t.params.history.enabled)
      )
        return
      i = !0
      let f = n.location.hash.replace('#', '')
      if (f) {
        let c = t.params.hashNavigation.getSlideIndex(t, f)
        t.slideTo(c || 0, 0, t.params.runCallbacksOnInit, !0)
      }
      t.params.hashNavigation.watchState && a.addEventListener('hashchange', l)
    },
    h = () => {
      t.params.hashNavigation.watchState &&
        a.removeEventListener('hashchange', l)
    }
  ;(s('init', () => {
    t.params.hashNavigation.enabled && u()
  }),
    s('destroy', () => {
      t.params.hashNavigation.enabled && h()
    }),
    s('transitionEnd _freeModeNoMomentumRelease', () => {
      i && o()
    }),
    s('slideChange', () => {
      i && t.params.cssMode && o()
    }))
}
var lo = J(() => {
  Ve()
  re()
})
function co({ swiper: t, extendParams: r, on: e, emit: s, params: i }) {
  ;((t.autoplay = { running: !1, paused: !1, timeLeft: 0 }),
    r({
      autoplay: {
        enabled: !1,
        delay: 3e3,
        waitForTransition: !0,
        disableOnInteraction: !1,
        stopOnLastSlide: !1,
        reverseDirection: !1,
        pauseOnMouseEnter: !1,
      },
    }))
  let n,
    a,
    l = i && i.autoplay ? i.autoplay.delay : 3e3,
    o = i && i.autoplay ? i.autoplay.delay : 3e3,
    u,
    h = new Date().getTime(),
    f,
    m,
    c,
    d,
    g,
    T
  function p(A) {
    !t ||
      t.destroyed ||
      !t.wrapperEl ||
      (A.target === t.wrapperEl &&
        (t.wrapperEl.removeEventListener('transitionend', p),
        !(T || (A.detail && A.detail.bySwiperTouchMove)) && B()))
  }
  let v = () => {
      if (t.destroyed || !t.autoplay.running) return
      t.autoplay.paused ? (f = !0) : f && ((o = u), (f = !1))
      let A = t.autoplay.paused ? u : h + o - new Date().getTime()
      ;((t.autoplay.timeLeft = A),
        s('autoplayTimeLeft', A, A / l),
        (a = requestAnimationFrame(() => {
          v()
        })))
    },
    y = () => {
      let A
      return (
        t.virtual && t.params.virtual.enabled
          ? (A = t.slides.find((q) =>
              q.classList.contains('swiper-slide-active'),
            ))
          : (A = t.slides[t.activeIndex]),
        A ? parseInt(A.getAttribute('data-swiper-autoplay'), 10) : void 0
      )
    },
    x = () => {
      let A = t.params.autoplay.delay,
        O = y()
      return (!Number.isNaN(O) && O > 0 && (A = O), A)
    },
    L = (A) => {
      if (t.destroyed || !t.autoplay.running) return
      ;(cancelAnimationFrame(a), v())
      let O = A
      ;(typeof O > 'u' && ((O = x()), (l = O), (o = O)), (u = O))
      let q = t.params.speed,
        G = () => {
          !t ||
            t.destroyed ||
            (t.params.autoplay.reverseDirection
              ? !t.isBeginning || t.params.loop || t.params.rewind
                ? (t.slidePrev(q, !0, !0), s('autoplay'))
                : t.params.autoplay.stopOnLastSlide ||
                  (t.slideTo(t.slides.length - 1, q, !0, !0), s('autoplay'))
              : !t.isEnd || t.params.loop || t.params.rewind
                ? (t.slideNext(q, !0, !0), s('autoplay'))
                : t.params.autoplay.stopOnLastSlide ||
                  (t.slideTo(0, q, !0, !0), s('autoplay')),
            t.params.cssMode &&
              ((h = new Date().getTime()),
              requestAnimationFrame(() => {
                L()
              })))
        }
      return (
        O > 0
          ? (clearTimeout(n),
            (n = setTimeout(() => {
              G()
            }, O)))
          : requestAnimationFrame(() => {
              G()
            }),
        O
      )
    },
    M = () => {
      ;((h = new Date().getTime()),
        (t.autoplay.running = !0),
        L(),
        s('autoplayStart'))
    },
    R = () => {
      ;((t.autoplay.running = !1),
        clearTimeout(n),
        cancelAnimationFrame(a),
        s('autoplayStop'))
    },
    w = (A, O) => {
      if (t.destroyed || !t.autoplay.running) return
      ;(clearTimeout(n), A || (g = !0))
      let q = () => {
        ;(s('autoplayPause'),
          t.params.autoplay.waitForTransition
            ? t.wrapperEl.addEventListener('transitionend', p)
            : B())
      }
      if (((t.autoplay.paused = !0), O)) {
        q()
        return
      }
      ;((u = (u || t.params.autoplay.delay) - (new Date().getTime() - h)),
        !(t.isEnd && u < 0 && !t.params.loop) && (u < 0 && (u = 0), q()))
    },
    B = () => {
      ;(t.isEnd && u < 0 && !t.params.loop) ||
        t.destroyed ||
        !t.autoplay.running ||
        ((h = new Date().getTime()),
        g ? ((g = !1), L(u)) : L(),
        (t.autoplay.paused = !1),
        s('autoplayResume'))
    },
    k = () => {
      if (t.destroyed || !t.autoplay.running) return
      let A = te()
      ;(A.visibilityState === 'hidden' && ((g = !0), w(!0)),
        A.visibilityState === 'visible' && B())
    },
    E = (A) => {
      A.pointerType === 'mouse' &&
        ((g = !0), (T = !0), !(t.animating || t.autoplay.paused) && w(!0))
    },
    C = (A) => {
      A.pointerType === 'mouse' && ((T = !1), t.autoplay.paused && B())
    },
    P = () => {
      t.params.autoplay.pauseOnMouseEnter &&
        (t.el.addEventListener('pointerenter', E),
        t.el.addEventListener('pointerleave', C))
    },
    H = () => {
      t.el &&
        typeof t.el != 'string' &&
        (t.el.removeEventListener('pointerenter', E),
        t.el.removeEventListener('pointerleave', C))
    },
    $ = () => {
      te().addEventListener('visibilitychange', k)
    },
    I = () => {
      te().removeEventListener('visibilitychange', k)
    }
  ;(e('init', () => {
    t.params.autoplay.enabled && (P(), $(), M())
  }),
    e('destroy', () => {
      ;(H(), I(), t.autoplay.running && R())
    }),
    e('_freeModeStaticRelease', () => {
      ;(c || g) && B()
    }),
    e('_freeModeNoMomentumRelease', () => {
      t.params.autoplay.disableOnInteraction ? R() : w(!0, !0)
    }),
    e('beforeTransitionStart', (A, O, q) => {
      t.destroyed ||
        !t.autoplay.running ||
        (q || !t.params.autoplay.disableOnInteraction ? w(!0, !0) : R())
    }),
    e('sliderFirstMove', () => {
      if (!(t.destroyed || !t.autoplay.running)) {
        if (t.params.autoplay.disableOnInteraction) {
          R()
          return
        }
        ;((m = !0),
          (c = !1),
          (g = !1),
          (d = setTimeout(() => {
            ;((g = !0), (c = !0), w(!0))
          }, 200)))
      }
    }),
    e('touchEnd', () => {
      if (!(t.destroyed || !t.autoplay.running || !m)) {
        if (
          (clearTimeout(d),
          clearTimeout(n),
          t.params.autoplay.disableOnInteraction)
        ) {
          ;((c = !1), (m = !1))
          return
        }
        ;(c && t.params.cssMode && B(), (c = !1), (m = !1))
      }
    }),
    e('slideChange', () => {
      t.destroyed ||
        !t.autoplay.running ||
        (t.autoplay.paused && ((u = x()), (l = x())))
    }),
    Object.assign(t.autoplay, { start: M, stop: R, pause: w, resume: B }))
}
var uo = J(() => {
  Ve()
})
function fo({ swiper: t, extendParams: r, on: e }) {
  r({
    thumbs: {
      swiper: null,
      multipleActiveThumbs: !0,
      autoScrollOffset: 0,
      slideThumbActiveClass: 'swiper-slide-thumb-active',
      thumbsContainerClass: 'swiper-thumbs',
    },
  })
  let s = !1,
    i = !1
  t.thumbs = { swiper: null }
  function n() {
    let h = t.thumbs.swiper
    return !h || h.destroyed ? !1 : h.params.virtual && h.params.virtual.enabled
  }
  function a() {
    let h = t.thumbs.swiper
    if (!h || h.destroyed) return
    let f = h.clickedIndex,
      m = h.clickedSlide
    if (
      (m && m.classList.contains(t.params.thumbs.slideThumbActiveClass)) ||
      typeof f > 'u' ||
      f === null
    )
      return
    let c
    ;(h.params.loop
      ? (c = parseInt(
          h.clickedSlide.getAttribute('data-swiper-slide-index'),
          10,
        ))
      : (c = f),
      t.params.loop ? t.slideToLoop(c) : t.slideTo(c))
  }
  function l() {
    let { thumbs: h } = t.params
    if (s) return !1
    s = !0
    let f = t.constructor
    if (h.swiper instanceof f) {
      if (h.swiper.destroyed) return ((s = !1), !1)
      ;((t.thumbs.swiper = h.swiper),
        Object.assign(t.thumbs.swiper.originalParams, {
          watchSlidesProgress: !0,
          slideToClickedSlide: !1,
        }),
        Object.assign(t.thumbs.swiper.params, {
          watchSlidesProgress: !0,
          slideToClickedSlide: !1,
        }),
        t.thumbs.swiper.update())
    } else if (dr(h.swiper)) {
      let m = Object.assign({}, h.swiper)
      ;(Object.assign(m, { watchSlidesProgress: !0, slideToClickedSlide: !1 }),
        (t.thumbs.swiper = new f(m)),
        (i = !0))
    }
    return (
      t.thumbs.swiper.el.classList.add(t.params.thumbs.thumbsContainerClass),
      t.thumbs.swiper.on('tap', a),
      n() &&
        t.thumbs.swiper.on('virtualUpdate', () => {
          o(!1, { autoScroll: !1 })
        }),
      !0
    )
  }
  function o(h, f) {
    let m = t.thumbs.swiper
    if (!m || m.destroyed) return
    let c = 1,
      d = t.params.thumbs.slideThumbActiveClass
    if (
      (t.params.slidesPerView > 1 &&
        !t.params.centeredSlides &&
        (c = t.params.slidesPerView),
      t.params.thumbs.multipleActiveThumbs || (c = 1),
      (c = Math.floor(c)),
      m.slides.forEach((g) => g.classList.remove(d)),
      m.params.loop || n())
    )
      for (let g = 0; g < c; g += 1)
        ne(
          m.slidesEl,
          `[data-swiper-slide-index="${t.realIndex + g}"]`,
        ).forEach((T) => {
          T.classList.add(d)
        })
    else
      for (let g = 0; g < c; g += 1)
        m.slides[t.realIndex + g] && m.slides[t.realIndex + g].classList.add(d)
    ;(f?.autoScroll ?? !0) && u(h ? 0 : void 0)
  }
  function u(h) {
    let f = t.thumbs.swiper
    if (!f || f.destroyed) return
    let m =
        f.params.slidesPerView === 'auto'
          ? f.slidesPerViewDynamic()
          : f.params.slidesPerView,
      c = t.params.thumbs.autoScrollOffset,
      d = c && !f.params.loop
    if (t.realIndex !== f.realIndex || d) {
      let g = f.activeIndex,
        T,
        p
      if (f.params.loop) {
        let v = f.slides.find(
          (y) => y.getAttribute('data-swiper-slide-index') === `${t.realIndex}`,
        )
        ;((T = f.slides.indexOf(v)),
          (p = t.activeIndex > t.previousIndex ? 'next' : 'prev'))
      } else ((T = t.realIndex), (p = T > t.previousIndex ? 'next' : 'prev'))
      ;(d && (T += p === 'next' ? c : -1 * c),
        f.visibleSlidesIndexes &&
          f.visibleSlidesIndexes.indexOf(T) < 0 &&
          (f.params.centeredSlides
            ? T > g
              ? (T = T - Math.floor(m / 2) + 1)
              : (T = T + Math.floor(m / 2) - 1)
            : T > g && f.params.slidesPerGroup,
          f.slideTo(T, h)))
    }
  }
  ;(e('beforeInit', () => {
    let { thumbs: h } = t.params
    if (!(!h || !h.swiper))
      if (typeof h.swiper == 'string' || h.swiper instanceof HTMLElement) {
        let f = te(),
          m = () => {
            let d =
              typeof h.swiper == 'string' ? f.querySelector(h.swiper) : h.swiper
            if (d && d.swiper) ((h.swiper = d.swiper), l(), o(!0))
            else if (d) {
              let g = `${t.params.eventsPrefix}init`,
                T = (p) => {
                  ;((h.swiper = p.detail[0]),
                    d.removeEventListener(g, T),
                    l(),
                    o(!0),
                    h.swiper.update(),
                    t.update())
                }
              d.addEventListener(g, T)
            }
            return d
          },
          c = () => {
            if (t.destroyed) return
            m() || requestAnimationFrame(c)
          }
        requestAnimationFrame(c)
      } else (l(), o(!0))
  }),
    e('slideChange update resize observerUpdate', () => {
      o()
    }),
    e('setTransition', (h, f) => {
      let m = t.thumbs.swiper
      !m || m.destroyed || m.setTransition(f)
    }),
    e('beforeDestroy', () => {
      let h = t.thumbs.swiper
      !h || h.destroyed || (i && h.destroy())
    }),
    Object.assign(t.thumbs, { init: l, update: o }))
}
var ho = J(() => {
  Ve()
  re()
})
function mo({ swiper: t, extendParams: r, emit: e, once: s }) {
  r({
    freeMode: {
      enabled: !1,
      momentum: !0,
      momentumRatio: 1,
      momentumBounce: !0,
      momentumBounceRatio: 1,
      momentumVelocityRatio: 1,
      sticky: !1,
      minimumVelocity: 0.02,
    },
  })
  function i() {
    if (t.params.cssMode) return
    let l = t.getTranslate()
    ;(t.setTranslate(l),
      t.setTransition(0),
      (t.touchEventsData.velocities.length = 0),
      t.freeMode.onTouchEnd({ currentPos: t.rtl ? t.translate : -t.translate }))
  }
  function n() {
    if (t.params.cssMode) return
    let { touchEventsData: l, touches: o } = t
    ;(l.velocities.length === 0 &&
      l.velocities.push({
        position: o[t.isHorizontal() ? 'startX' : 'startY'],
        time: l.touchStartTime,
      }),
      l.velocities.push({
        position: o[t.isHorizontal() ? 'currentX' : 'currentY'],
        time: Le(),
      }))
  }
  function a({ currentPos: l }) {
    if (t.params.cssMode) return
    let {
        params: o,
        wrapperEl: u,
        rtlTranslate: h,
        snapGrid: f,
        touchEventsData: m,
      } = t,
      d = Le() - m.touchStartTime
    if (l < -t.minTranslate()) {
      t.slideTo(t.activeIndex)
      return
    }
    if (l > -t.maxTranslate()) {
      t.slides.length < f.length
        ? t.slideTo(f.length - 1)
        : t.slideTo(t.slides.length - 1)
      return
    }
    if (o.freeMode.momentum) {
      if (m.velocities.length > 1) {
        let M = m.velocities.pop(),
          R = m.velocities.pop(),
          w = M.position - R.position,
          B = M.time - R.time
        ;((t.velocity = w / B),
          (t.velocity /= 2),
          Math.abs(t.velocity) < o.freeMode.minimumVelocity && (t.velocity = 0),
          (B > 150 || Le() - M.time > 300) && (t.velocity = 0))
      } else t.velocity = 0
      ;((t.velocity *= o.freeMode.momentumVelocityRatio),
        (m.velocities.length = 0))
      let g = 1e3 * o.freeMode.momentumRatio,
        T = t.velocity * g,
        p = t.translate + T
      h && (p = -p)
      let v = !1,
        y,
        x = Math.abs(t.velocity) * 20 * o.freeMode.momentumBounceRatio,
        L
      if (p < t.maxTranslate())
        (o.freeMode.momentumBounce
          ? (p + t.maxTranslate() < -x && (p = t.maxTranslate() - x),
            (y = t.maxTranslate()),
            (v = !0),
            (m.allowMomentumBounce = !0))
          : (p = t.maxTranslate()),
          o.loop && o.centeredSlides && (L = !0))
      else if (p > t.minTranslate())
        (o.freeMode.momentumBounce
          ? (p - t.minTranslate() > x && (p = t.minTranslate() + x),
            (y = t.minTranslate()),
            (v = !0),
            (m.allowMomentumBounce = !0))
          : (p = t.minTranslate()),
          o.loop && o.centeredSlides && (L = !0))
      else if (o.freeMode.sticky) {
        let M
        for (let R = 0; R < f.length; R += 1)
          if (f[R] > -p) {
            M = R
            break
          }
        ;(Math.abs(f[M] - p) < Math.abs(f[M - 1] - p) ||
        t.swipeDirection === 'next'
          ? (p = f[M])
          : (p = f[M - 1]),
          (p = -p))
      }
      if (
        (L &&
          s('transitionEnd', () => {
            t.loopFix()
          }),
        t.velocity !== 0)
      ) {
        if (
          (h
            ? (g = Math.abs((-p - t.translate) / t.velocity))
            : (g = Math.abs((p - t.translate) / t.velocity)),
          o.freeMode.sticky)
        ) {
          let M = Math.abs((h ? -p : p) - t.translate),
            R = t.slidesSizesGrid[t.activeIndex]
          M < R
            ? (g = o.speed)
            : M < 2 * R
              ? (g = o.speed * 1.5)
              : (g = o.speed * 2.5)
        }
      } else if (o.freeMode.sticky) {
        t.slideToClosest()
        return
      }
      ;(o.freeMode.momentumBounce && v
        ? (t.updateProgress(y),
          t.setTransition(g),
          t.setTranslate(p),
          t.transitionStart(!0, t.swipeDirection),
          (t.animating = !0),
          xt(u, () => {
            !t ||
              t.destroyed ||
              !m.allowMomentumBounce ||
              (e('momentumBounce'),
              t.setTransition(o.speed),
              setTimeout(() => {
                ;(t.setTranslate(y),
                  xt(u, () => {
                    !t || t.destroyed || t.transitionEnd()
                  }))
              }, 0))
          }))
        : t.velocity
          ? (e('_freeModeNoMomentumRelease'),
            t.updateProgress(p),
            t.setTransition(g),
            t.setTranslate(p),
            t.transitionStart(!0, t.swipeDirection),
            t.animating ||
              ((t.animating = !0),
              xt(u, () => {
                !t || t.destroyed || t.transitionEnd()
              })))
          : t.updateProgress(p),
        t.updateActiveIndex(),
        t.updateSlidesClasses())
    } else if (o.freeMode.sticky) {
      t.slideToClosest()
      return
    } else o.freeMode && e('_freeModeNoMomentumRelease')
    ;(!o.freeMode.momentum || d >= o.longSwipesMs) &&
      (e('_freeModeStaticRelease'),
      t.updateProgress(),
      t.updateActiveIndex(),
      t.updateSlidesClasses())
  }
  Object.assign(t, {
    freeMode: { onTouchStart: i, onTouchMove: n, onTouchEnd: a },
  })
}
var po = J(() => {
  re()
})
function go({ swiper: t, extendParams: r, on: e }) {
  r({ grid: { rows: 1, fill: 'column' } })
  let s,
    i,
    n,
    a,
    l = () => {
      let d = t.params.spaceBetween
      return (
        typeof d == 'string' && d.indexOf('%') >= 0
          ? (d = (parseFloat(d.replace('%', '')) / 100) * t.size)
          : typeof d == 'string' && (d = parseFloat(d)),
        d
      )
    },
    o = (d) => {
      let { slidesPerView: g } = t.params,
        { rows: T, fill: p } = t.params.grid,
        v =
          t.virtual && t.params.virtual.enabled
            ? t.virtual.slides.length
            : d.length
      ;((n = Math.floor(v / T)),
        Math.floor(v / T) === v / T ? (s = v) : (s = Math.ceil(v / T) * T),
        g !== 'auto' && p === 'row' && (s = Math.max(s, g * T)),
        (i = s / T))
    },
    u = () => {
      t.slides &&
        t.slides.forEach((d) => {
          d.swiperSlideGridSet &&
            ((d.style.height = ''),
            (d.style[t.getDirectionLabel('margin-top')] = ''))
        })
    },
    h = (d, g, T) => {
      let { slidesPerGroup: p } = t.params,
        v = l(),
        { rows: y, fill: x } = t.params.grid,
        L =
          t.virtual && t.params.virtual.enabled
            ? t.virtual.slides.length
            : T.length,
        M,
        R,
        w
      if (x === 'row' && p > 1) {
        let B = Math.floor(d / (p * y)),
          k = d - y * p * B,
          E = B === 0 ? p : Math.min(Math.ceil((L - B * y * p) / y), p)
        ;((w = Math.floor(k / E)),
          (R = k - w * E + B * p),
          (M = R + (w * s) / y),
          (g.style.order = M))
      } else
        x === 'column'
          ? ((R = Math.floor(d / y)),
            (w = d - R * y),
            (R > n || (R === n && w === y - 1)) &&
              ((w += 1), w >= y && ((w = 0), (R += 1))))
          : ((w = Math.floor(d / i)), (R = d - w * i))
      ;((g.row = w),
        (g.column = R),
        (g.style.height = `calc((100% - ${(y - 1) * v}px) / ${y})`),
        (g.style[t.getDirectionLabel('margin-top')] =
          w !== 0 ? v && `${v}px` : ''),
        (g.swiperSlideGridSet = !0))
    },
    f = (d, g) => {
      let { centeredSlides: T, roundLengths: p } = t.params,
        v = l(),
        { rows: y } = t.params.grid
      if (
        ((t.virtualSize = (d + v) * s),
        (t.virtualSize = Math.ceil(t.virtualSize / y) - v),
        t.params.cssMode ||
          (t.wrapperEl.style[t.getDirectionLabel('width')] =
            `${t.virtualSize + v}px`),
        T)
      ) {
        let x = []
        for (let L = 0; L < g.length; L += 1) {
          let M = g[L]
          ;(p && (M = Math.floor(M)), g[L] < t.virtualSize + g[0] && x.push(M))
        }
        ;(g.splice(0, g.length), g.push(...x))
      }
    },
    m = () => {
      a = t.params.grid && t.params.grid.rows > 1
    },
    c = () => {
      let { params: d, el: g } = t,
        T = d.grid && d.grid.rows > 1
      ;(a && !T
        ? (g.classList.remove(
            `${d.containerModifierClass}grid`,
            `${d.containerModifierClass}grid-column`,
          ),
          (n = 1),
          t.emitContainerClasses())
        : !a &&
          T &&
          (g.classList.add(`${d.containerModifierClass}grid`),
          d.grid.fill === 'column' &&
            g.classList.add(`${d.containerModifierClass}grid-column`),
          t.emitContainerClasses()),
        (a = T))
    }
  ;(e('init', m),
    e('update', c),
    (t.grid = {
      initSlides: o,
      unsetSlides: u,
      updateSlide: h,
      updateWrapperSize: f,
    }))
}
var vo = J(() => {})
function mu(t) {
  let r = this,
    { params: e, slidesEl: s } = r
  e.loop && r.loopDestroy()
  let i = (n) => {
    if (typeof n == 'string') {
      let a = document.createElement('div')
      ;(Ce(a, n), s.append(a.children[0]), Ce(a, ''))
    } else s.append(n)
  }
  if (typeof t == 'object' && 'length' in t)
    for (let n = 0; n < t.length; n += 1) t[n] && i(t[n])
  else i(t)
  ;(r.recalcSlides(),
    e.loop && r.loopCreate(),
    (!e.observer || r.isElement) && r.update())
}
function pu(t) {
  let r = this,
    { params: e, activeIndex: s, slidesEl: i } = r
  e.loop && r.loopDestroy()
  let n = s + 1,
    a = (l) => {
      if (typeof l == 'string') {
        let o = document.createElement('div')
        ;(Ce(o, l), i.prepend(o.children[0]), Ce(o, ''))
      } else i.prepend(l)
    }
  if (typeof t == 'object' && 'length' in t) {
    for (let l = 0; l < t.length; l += 1) t[l] && a(t[l])
    n = s + t.length
  } else a(t)
  ;(r.recalcSlides(),
    e.loop && r.loopCreate(),
    (!e.observer || r.isElement) && r.update(),
    r.slideTo(n, 0, !1))
}
function gu(t, r) {
  let e = this,
    { params: s, activeIndex: i, slidesEl: n } = e,
    a = i
  s.loop && ((a -= e.loopedSlides), e.loopDestroy(), e.recalcSlides())
  let l = e.slides.length
  if (t <= 0) {
    e.prependSlide(r)
    return
  }
  if (t >= l) {
    e.appendSlide(r)
    return
  }
  let o = a > t ? a + 1 : a,
    u = []
  for (let h = l - 1; h >= t; h -= 1) {
    let f = e.slides[h]
    ;(f.remove(), u.unshift(f))
  }
  if (typeof r == 'object' && 'length' in r) {
    for (let h = 0; h < r.length; h += 1) r[h] && n.append(r[h])
    o = a > t ? a + r.length : a
  } else n.append(r)
  for (let h = 0; h < u.length; h += 1) n.append(u[h])
  ;(e.recalcSlides(),
    s.loop && e.loopCreate(),
    (!s.observer || e.isElement) && e.update(),
    s.loop ? e.slideTo(o + e.loopedSlides, 0, !1) : e.slideTo(o, 0, !1))
}
function vu(t) {
  let r = this,
    { params: e, activeIndex: s } = r,
    i = s
  e.loop && ((i -= r.loopedSlides), r.loopDestroy())
  let n = i,
    a
  if (typeof t == 'object' && 'length' in t) {
    for (let l = 0; l < t.length; l += 1)
      ((a = t[l]), r.slides[a] && r.slides[a].remove(), a < n && (n -= 1))
    n = Math.max(n, 0)
  } else
    ((a = t),
      r.slides[a] && r.slides[a].remove(),
      a < n && (n -= 1),
      (n = Math.max(n, 0)))
  ;(r.recalcSlides(),
    e.loop && r.loopCreate(),
    (!e.observer || r.isElement) && r.update(),
    e.loop ? r.slideTo(n + r.loopedSlides, 0, !1) : r.slideTo(n, 0, !1))
}
function yu() {
  let t = this,
    r = []
  for (let e = 0; e < t.slides.length; e += 1) r.push(e)
  t.removeSlide(r)
}
function yo({ swiper: t }) {
  Object.assign(t, {
    appendSlide: mu.bind(t),
    prependSlide: pu.bind(t),
    addSlide: gu.bind(t),
    removeSlide: vu.bind(t),
    removeAllSlides: yu.bind(t),
  })
}
var bo = J(() => {
  re()
})
function je(t) {
  let {
    effect: r,
    swiper: e,
    on: s,
    setTranslate: i,
    setTransition: n,
    overwriteParams: a,
    perspective: l,
    recreateShadows: o,
    getEffectParams: u,
  } = t
  ;(s('beforeInit', () => {
    if (e.params.effect !== r) return
    ;(e.classNames.push(`${e.params.containerModifierClass}${r}`),
      l && l() && e.classNames.push(`${e.params.containerModifierClass}3d`))
    let f = a ? a() : {}
    ;(Object.assign(e.params, f), Object.assign(e.originalParams, f))
  }),
    s('setTranslate _virtualUpdated', () => {
      e.params.effect === r && i()
    }),
    s('setTransition', (f, m) => {
      e.params.effect === r && n(m)
    }),
    s('transitionEnd', () => {
      if (e.params.effect === r && o) {
        if (!u || !u().slideShadows) return
        ;(e.slides.forEach((f) => {
          f.querySelectorAll(
            '.swiper-slide-shadow-top, .swiper-slide-shadow-right, .swiper-slide-shadow-bottom, .swiper-slide-shadow-left',
          ).forEach((m) => m.remove())
        }),
          o())
      }
    }))
  let h
  s('virtualUpdate', () => {
    e.params.effect === r &&
      (e.slides.length || (h = !0),
      requestAnimationFrame(() => {
        h && e.slides && e.slides.length && (i(), (h = !1))
      }))
  })
}
var Bt = J(() => {})
function st(t, r) {
  let e = Re(r)
  return (
    e !== r &&
      ((e.style.backfaceVisibility = 'hidden'),
      (e.style['-webkit-backface-visibility'] = 'hidden')),
    e
  )
}
var mr = J(() => {
  re()
})
function Mt({ swiper: t, duration: r, transformElements: e, allSlides: s }) {
  let { activeIndex: i } = t,
    n = (a) =>
      a.parentElement
        ? a.parentElement
        : t.slides.find((o) => o.shadowRoot && o.shadowRoot === a.parentNode)
  if (t.params.virtualTranslate && r !== 0) {
    let a = !1,
      l
    ;(s
      ? (l = e)
      : (l = e.filter((o) => {
          let u = o.classList.contains('swiper-slide-transform') ? n(o) : o
          return t.getSlideIndex(u) === i
        })),
      l.forEach((o) => {
        xt(o, () => {
          if (a || !t || t.destroyed) return
          ;((a = !0), (t.animating = !1))
          let u = new window.CustomEvent('transitionend', {
            bubbles: !0,
            cancelable: !0,
          })
          t.wrapperEl.dispatchEvent(u)
        })
      }))
  }
}
var ss = J(() => {
  re()
})
function To({ swiper: t, extendParams: r, on: e }) {
  ;(r({ fadeEffect: { crossFade: !1 } }),
    je({
      effect: 'fade',
      swiper: t,
      on: e,
      setTranslate: () => {
        let { slides: n } = t,
          a = t.params.fadeEffect
        for (let l = 0; l < n.length; l += 1) {
          let o = t.slides[l],
            h = -o.swiperSlideOffset
          t.params.virtualTranslate || (h -= t.translate)
          let f = 0
          t.isHorizontal() || ((f = h), (h = 0))
          let m = t.params.fadeEffect.crossFade
              ? Math.max(1 - Math.abs(o.progress), 0)
              : 1 + Math.min(Math.max(o.progress, -1), 0),
            c = st(a, o)
          ;((c.style.opacity = m),
            (c.style.transform = `translate3d(${h}px, ${f}px, 0px)`))
        }
      },
      setTransition: (n) => {
        let a = t.slides.map((l) => Re(l))
        ;(a.forEach((l) => {
          l.style.transitionDuration = `${n}ms`
        }),
          Mt({ swiper: t, duration: n, transformElements: a, allSlides: !0 }))
      },
      overwriteParams: () => ({
        slidesPerView: 1,
        slidesPerGroup: 1,
        watchSlidesProgress: !0,
        spaceBetween: 0,
        virtualTranslate: !t.params.cssMode,
      }),
    }))
}
var So = J(() => {
  Bt()
  mr()
  ss()
  re()
})
function Eo({ swiper: t, extendParams: r, on: e }) {
  r({
    cubeEffect: {
      slideShadows: !0,
      shadow: !0,
      shadowOffset: 20,
      shadowScale: 0.94,
    },
  })
  let s = (l, o, u) => {
    let h = u
        ? l.querySelector('.swiper-slide-shadow-left')
        : l.querySelector('.swiper-slide-shadow-top'),
      f = u
        ? l.querySelector('.swiper-slide-shadow-right')
        : l.querySelector('.swiper-slide-shadow-bottom')
    ;(h ||
      ((h = he(
        'div',
        `swiper-slide-shadow-cube swiper-slide-shadow-${u ? 'left' : 'top'}`.split(
          ' ',
        ),
      )),
      l.append(h)),
      f ||
        ((f = he(
          'div',
          `swiper-slide-shadow-cube swiper-slide-shadow-${u ? 'right' : 'bottom'}`.split(
            ' ',
          ),
        )),
        l.append(f)),
      h && (h.style.opacity = Math.max(-o, 0)),
      f && (f.style.opacity = Math.max(o, 0)))
  }
  je({
    effect: 'cube',
    swiper: t,
    on: e,
    setTranslate: () => {
      let {
          el: l,
          wrapperEl: o,
          slides: u,
          width: h,
          height: f,
          rtlTranslate: m,
          size: c,
          browser: d,
        } = t,
        g = wt(t),
        T = t.params.cubeEffect,
        p = t.isHorizontal(),
        v = t.virtual && t.params.virtual.enabled,
        y = 0,
        x
      T.shadow &&
        (p
          ? ((x = t.wrapperEl.querySelector('.swiper-cube-shadow')),
            x || ((x = he('div', 'swiper-cube-shadow')), t.wrapperEl.append(x)),
            (x.style.height = `${h}px`))
          : ((x = l.querySelector('.swiper-cube-shadow')),
            x || ((x = he('div', 'swiper-cube-shadow')), l.append(x))))
      for (let M = 0; M < u.length; M += 1) {
        let R = u[M],
          w = M
        v && (w = parseInt(R.getAttribute('data-swiper-slide-index'), 10))
        let B = w * 90,
          k = Math.floor(B / 360)
        m && ((B = -B), (k = Math.floor(-B / 360)))
        let E = Math.max(Math.min(R.progress, 1), -1),
          C = 0,
          P = 0,
          H = 0
        ;(w % 4 === 0
          ? ((C = -k * 4 * c), (H = 0))
          : (w - 1) % 4 === 0
            ? ((C = 0), (H = -k * 4 * c))
            : (w - 2) % 4 === 0
              ? ((C = c + k * 4 * c), (H = c))
              : (w - 3) % 4 === 0 && ((C = -c), (H = 3 * c + c * 4 * k)),
          m && (C = -C),
          p || ((P = C), (C = 0)))
        let $ = `rotateX(${g(p ? 0 : -B)}deg) rotateY(${g(p ? B : 0)}deg) translate3d(${C}px, ${P}px, ${H}px)`
        ;(E <= 1 &&
          E > -1 &&
          ((y = w * 90 + E * 90), m && (y = -w * 90 - E * 90)),
          (R.style.transform = $),
          T.slideShadows && s(R, E, p))
      }
      if (
        ((o.style.transformOrigin = `50% 50% -${c / 2}px`),
        (o.style['-webkit-transform-origin'] = `50% 50% -${c / 2}px`),
        T.shadow)
      )
        if (p)
          x.style.transform = `translate3d(0px, ${h / 2 + T.shadowOffset}px, ${-h / 2}px) rotateX(89.99deg) rotateZ(0deg) scale(${T.shadowScale})`
        else {
          let M = Math.abs(y) - Math.floor(Math.abs(y) / 90) * 90,
            R =
              1.5 -
              (Math.sin((M * 2 * Math.PI) / 360) / 2 +
                Math.cos((M * 2 * Math.PI) / 360) / 2),
            w = T.shadowScale,
            B = T.shadowScale / R,
            k = T.shadowOffset
          x.style.transform = `scale3d(${w}, 1, ${B}) translate3d(0px, ${f / 2 + k}px, ${-f / 2 / B}px) rotateX(-89.99deg)`
        }
      let L = (d.isSafari || d.isWebView) && d.needPerspectiveFix ? -c / 2 : 0
      ;((o.style.transform = `translate3d(0px,0,${L}px) rotateX(${g(t.isHorizontal() ? 0 : y)}deg) rotateY(${g(t.isHorizontal() ? -y : 0)}deg)`),
        o.style.setProperty('--swiper-cube-translate-z', `${L}px`))
    },
    setTransition: (l) => {
      let { el: o, slides: u } = t
      if (
        (u.forEach((h) => {
          ;((h.style.transitionDuration = `${l}ms`),
            h
              .querySelectorAll(
                '.swiper-slide-shadow-top, .swiper-slide-shadow-right, .swiper-slide-shadow-bottom, .swiper-slide-shadow-left',
              )
              .forEach((f) => {
                f.style.transitionDuration = `${l}ms`
              }))
        }),
        t.params.cubeEffect.shadow && !t.isHorizontal())
      ) {
        let h = o.querySelector('.swiper-cube-shadow')
        h && (h.style.transitionDuration = `${l}ms`)
      }
    },
    recreateShadows: () => {
      let l = t.isHorizontal()
      t.slides.forEach((o) => {
        let u = Math.max(Math.min(o.progress, 1), -1)
        s(o, u, l)
      })
    },
    getEffectParams: () => t.params.cubeEffect,
    perspective: () => !0,
    overwriteParams: () => ({
      slidesPerView: 1,
      slidesPerGroup: 1,
      watchSlidesProgress: !0,
      resistanceRatio: 0,
      spaceBetween: 0,
      centeredSlides: !1,
      virtualTranslate: !0,
    }),
  })
}
var xo = J(() => {
  Bt()
  re()
})
function it(t, r, e) {
  let s = `swiper-slide-shadow${e ? `-${e}` : ''}${t ? ` swiper-slide-shadow-${t}` : ''}`,
    i = Re(r),
    n = i.querySelector(`.${s.split(' ').join('.')}`)
  return (n || ((n = he('div', s.split(' '))), i.append(n)), n)
}
var is = J(() => {
  re()
})
function wo({ swiper: t, extendParams: r, on: e }) {
  r({ flipEffect: { slideShadows: !0, limitRotation: !0 } })
  let s = (l, o) => {
    let u = t.isHorizontal()
        ? l.querySelector('.swiper-slide-shadow-left')
        : l.querySelector('.swiper-slide-shadow-top'),
      h = t.isHorizontal()
        ? l.querySelector('.swiper-slide-shadow-right')
        : l.querySelector('.swiper-slide-shadow-bottom')
    ;(u || (u = it('flip', l, t.isHorizontal() ? 'left' : 'top')),
      h || (h = it('flip', l, t.isHorizontal() ? 'right' : 'bottom')),
      u && (u.style.opacity = Math.max(-o, 0)),
      h && (h.style.opacity = Math.max(o, 0)))
  }
  je({
    effect: 'flip',
    swiper: t,
    on: e,
    setTranslate: () => {
      let { slides: l, rtlTranslate: o } = t,
        u = t.params.flipEffect,
        h = wt(t)
      for (let f = 0; f < l.length; f += 1) {
        let m = l[f],
          c = m.progress
        t.params.flipEffect.limitRotation &&
          (c = Math.max(Math.min(m.progress, 1), -1))
        let d = m.swiperSlideOffset,
          T = -180 * c,
          p = 0,
          v = t.params.cssMode ? -d - t.translate : -d,
          y = 0
        ;(t.isHorizontal()
          ? o && (T = -T)
          : ((y = v), (v = 0), (p = -T), (T = 0)),
          (m.style.zIndex = -Math.abs(Math.round(c)) + l.length),
          u.slideShadows && s(m, c))
        let x = `translate3d(${v}px, ${y}px, 0px) rotateX(${h(p)}deg) rotateY(${h(T)}deg)`,
          L = st(u, m)
        L.style.transform = x
      }
    },
    setTransition: (l) => {
      let o = t.slides.map((u) => Re(u))
      ;(o.forEach((u) => {
        ;((u.style.transitionDuration = `${l}ms`),
          u
            .querySelectorAll(
              '.swiper-slide-shadow-top, .swiper-slide-shadow-right, .swiper-slide-shadow-bottom, .swiper-slide-shadow-left',
            )
            .forEach((h) => {
              h.style.transitionDuration = `${l}ms`
            }))
      }),
        Mt({ swiper: t, duration: l, transformElements: o }))
    },
    recreateShadows: () => {
      ;(t.params.flipEffect,
        t.slides.forEach((l) => {
          let o = l.progress
          ;(t.params.flipEffect.limitRotation &&
            (o = Math.max(Math.min(l.progress, 1), -1)),
            s(l, o))
        }))
    },
    getEffectParams: () => t.params.flipEffect,
    perspective: () => !0,
    overwriteParams: () => ({
      slidesPerView: 1,
      slidesPerGroup: 1,
      watchSlidesProgress: !0,
      spaceBetween: 0,
      virtualTranslate: !t.params.cssMode,
    }),
  })
}
var Mo = J(() => {
  is()
  Bt()
  mr()
  ss()
  re()
})
function Lo({ swiper: t, extendParams: r, on: e }) {
  ;(r({
    coverflowEffect: {
      rotate: 50,
      stretch: 0,
      depth: 100,
      scale: 1,
      modifier: 1,
      slideShadows: !0,
    },
  }),
    je({
      effect: 'coverflow',
      swiper: t,
      on: e,
      setTranslate: () => {
        let { width: n, height: a, slides: l, slidesSizesGrid: o } = t,
          u = t.params.coverflowEffect,
          h = t.isHorizontal(),
          f = t.translate,
          m = h ? -f + n / 2 : -f + a / 2,
          c = h ? u.rotate : -u.rotate,
          d = u.depth,
          g = wt(t)
        for (let T = 0, p = l.length; T < p; T += 1) {
          let v = l[T],
            y = o[T],
            x = v.swiperSlideOffset,
            L = (m - x - y / 2) / y,
            M =
              typeof u.modifier == 'function' ? u.modifier(L) : L * u.modifier,
            R = h ? c * M : 0,
            w = h ? 0 : c * M,
            B = -d * Math.abs(M),
            k = u.stretch
          typeof k == 'string' &&
            k.indexOf('%') !== -1 &&
            (k = (parseFloat(u.stretch) / 100) * y)
          let E = h ? 0 : k * M,
            C = h ? k * M : 0,
            P = 1 - (1 - u.scale) * Math.abs(M)
          ;(Math.abs(C) < 0.001 && (C = 0),
            Math.abs(E) < 0.001 && (E = 0),
            Math.abs(B) < 0.001 && (B = 0),
            Math.abs(R) < 0.001 && (R = 0),
            Math.abs(w) < 0.001 && (w = 0),
            Math.abs(P) < 0.001 && (P = 0))
          let H = `translate3d(${C}px,${E}px,${B}px)  rotateX(${g(w)}deg) rotateY(${g(R)}deg) scale(${P})`,
            $ = st(u, v)
          if (
            (($.style.transform = H),
            (v.style.zIndex = -Math.abs(Math.round(M)) + 1),
            u.slideShadows)
          ) {
            let I = h
                ? v.querySelector('.swiper-slide-shadow-left')
                : v.querySelector('.swiper-slide-shadow-top'),
              A = h
                ? v.querySelector('.swiper-slide-shadow-right')
                : v.querySelector('.swiper-slide-shadow-bottom')
            ;(I || (I = it('coverflow', v, h ? 'left' : 'top')),
              A || (A = it('coverflow', v, h ? 'right' : 'bottom')),
              I && (I.style.opacity = M > 0 ? M : 0),
              A && (A.style.opacity = -M > 0 ? -M : 0))
          }
        }
      },
      setTransition: (n) => {
        t.slides
          .map((l) => Re(l))
          .forEach((l) => {
            ;((l.style.transitionDuration = `${n}ms`),
              l
                .querySelectorAll(
                  '.swiper-slide-shadow-top, .swiper-slide-shadow-right, .swiper-slide-shadow-bottom, .swiper-slide-shadow-left',
                )
                .forEach((o) => {
                  o.style.transitionDuration = `${n}ms`
                }))
          })
      },
      perspective: () => !0,
      overwriteParams: () => ({ watchSlidesProgress: !0 }),
    }))
}
var Co = J(() => {
  is()
  Bt()
  mr()
  re()
})
function Ao({ swiper: t, extendParams: r, on: e }) {
  r({
    creativeEffect: {
      limitProgress: 1,
      shadowPerProgress: !1,
      progressMultiplier: 1,
      perspective: !0,
      prev: { translate: [0, 0, 0], rotate: [0, 0, 0], opacity: 1, scale: 1 },
      next: { translate: [0, 0, 0], rotate: [0, 0, 0], opacity: 1, scale: 1 },
    },
  })
  let s = (a) => (typeof a == 'string' ? a : `${a}px`)
  je({
    effect: 'creative',
    swiper: t,
    on: e,
    setTranslate: () => {
      let { slides: a, wrapperEl: l, slidesSizesGrid: o } = t,
        u = t.params.creativeEffect,
        { progressMultiplier: h } = u,
        f = t.params.centeredSlides,
        m = wt(t)
      if (f) {
        let c = o[0] / 2 - t.params.slidesOffsetBefore || 0
        l.style.transform = `translateX(calc(50% - ${c}px))`
      }
      for (let c = 0; c < a.length; c += 1) {
        let d = a[c],
          g = d.progress,
          T = Math.min(Math.max(d.progress, -u.limitProgress), u.limitProgress),
          p = T
        f ||
          (p = Math.min(
            Math.max(d.originalProgress, -u.limitProgress),
            u.limitProgress,
          ))
        let v = d.swiperSlideOffset,
          y = [t.params.cssMode ? -v - t.translate : -v, 0, 0],
          x = [0, 0, 0],
          L = !1
        t.isHorizontal() || ((y[1] = y[0]), (y[0] = 0))
        let M = {
          translate: [0, 0, 0],
          rotate: [0, 0, 0],
          scale: 1,
          opacity: 1,
        }
        ;(T < 0 ? ((M = u.next), (L = !0)) : T > 0 && ((M = u.prev), (L = !0)),
          y.forEach((P, H) => {
            y[H] = `calc(${P}px + (${s(M.translate[H])} * ${Math.abs(T * h)}))`
          }),
          x.forEach((P, H) => {
            let $ = M.rotate[H] * Math.abs(T * h)
            x[H] = $
          }),
          (d.style.zIndex = -Math.abs(Math.round(g)) + a.length))
        let R = y.join(', '),
          w = `rotateX(${m(x[0])}deg) rotateY(${m(x[1])}deg) rotateZ(${m(x[2])}deg)`,
          B =
            p < 0
              ? `scale(${1 + (1 - M.scale) * p * h})`
              : `scale(${1 - (1 - M.scale) * p * h})`,
          k = p < 0 ? 1 + (1 - M.opacity) * p * h : 1 - (1 - M.opacity) * p * h,
          E = `translate3d(${R}) ${w} ${B}`
        if ((L && M.shadow) || !L) {
          let P = d.querySelector('.swiper-slide-shadow')
          if ((!P && M.shadow && (P = it('creative', d)), P)) {
            let H = u.shadowPerProgress ? T * (1 / u.limitProgress) : T
            P.style.opacity = Math.min(Math.max(Math.abs(H), 0), 1)
          }
        }
        let C = st(u, d)
        ;((C.style.transform = E),
          (C.style.opacity = k),
          M.origin && (C.style.transformOrigin = M.origin))
      }
    },
    setTransition: (a) => {
      let l = t.slides.map((o) => Re(o))
      ;(l.forEach((o) => {
        ;((o.style.transitionDuration = `${a}ms`),
          o.querySelectorAll('.swiper-slide-shadow').forEach((u) => {
            u.style.transitionDuration = `${a}ms`
          }))
      }),
        Mt({ swiper: t, duration: a, transformElements: l, allSlides: !0 }))
    },
    perspective: () => t.params.creativeEffect.perspective,
    overwriteParams: () => ({
      watchSlidesProgress: !0,
      virtualTranslate: !t.params.cssMode,
    }),
  })
}
var Io = J(() => {
  is()
  Bt()
  mr()
  ss()
  re()
})
function Po({ swiper: t, extendParams: r, on: e }) {
  ;(r({
    cardsEffect: {
      slideShadows: !0,
      rotate: !0,
      perSlideRotate: 2,
      perSlideOffset: 8,
    },
  }),
    je({
      effect: 'cards',
      swiper: t,
      on: e,
      setTranslate: () => {
        let { slides: n, activeIndex: a, rtlTranslate: l } = t,
          o = t.params.cardsEffect,
          { startTranslate: u, isTouched: h } = t.touchEventsData,
          f = l ? -t.translate : t.translate
        for (let m = 0; m < n.length; m += 1) {
          let c = n[m],
            d = c.progress,
            g = Math.min(Math.max(d, -4), 4),
            T = c.swiperSlideOffset
          ;(t.params.centeredSlides &&
            !t.params.cssMode &&
            (t.wrapperEl.style.transform = `translateX(${t.minTranslate()}px)`),
            t.params.centeredSlides &&
              t.params.cssMode &&
              (T -= n[0].swiperSlideOffset))
          let p = t.params.cssMode ? -T - t.translate : -T,
            v = 0,
            y = -100 * Math.abs(g),
            x = 1,
            L = -o.perSlideRotate * g,
            M = o.perSlideOffset - Math.abs(g) * 0.75,
            R = t.virtual && t.params.virtual.enabled ? t.virtual.from + m : m,
            w =
              (R === a || R === a - 1) &&
              g > 0 &&
              g < 1 &&
              (h || t.params.cssMode) &&
              f < u,
            B =
              (R === a || R === a + 1) &&
              g < 0 &&
              g > -1 &&
              (h || t.params.cssMode) &&
              f > u
          if (w || B) {
            let P = (1 - Math.abs((Math.abs(g) - 0.5) / 0.5)) ** 0.5
            ;((L += -28 * g * P),
              (x += -0.5 * P),
              (M += 96 * P),
              (v = `${(o.rotate || t.isHorizontal() ? -25 : 0) * P * Math.abs(g)}%`))
          }
          if (
            (g < 0
              ? (p = `calc(${p}px ${l ? '-' : '+'} (${M * Math.abs(g)}%))`)
              : g > 0
                ? (p = `calc(${p}px ${l ? '-' : '+'} (-${M * Math.abs(g)}%))`)
                : (p = `${p}px`),
            !t.isHorizontal())
          ) {
            let P = v
            ;((v = p), (p = P))
          }
          let k = g < 0 ? `${1 + (1 - x) * g}` : `${1 - (1 - x) * g}`,
            E = `
        translate3d(${p}, ${v}, ${y}px)
        rotateZ(${o.rotate ? (l ? -L : L) : 0}deg)
        scale(${k})
      `
          if (o.slideShadows) {
            let P = c.querySelector('.swiper-slide-shadow')
            ;(P || (P = it('cards', c)),
              P &&
                (P.style.opacity = Math.min(
                  Math.max((Math.abs(g) - 0.5) / 0.5, 0),
                  1,
                )))
          }
          c.style.zIndex = -Math.abs(Math.round(d)) + n.length
          let C = st(o, c)
          C.style.transform = E
        }
      },
      setTransition: (n) => {
        let a = t.slides.map((l) => Re(l))
        ;(a.forEach((l) => {
          ;((l.style.transitionDuration = `${n}ms`),
            l.querySelectorAll('.swiper-slide-shadow').forEach((o) => {
              o.style.transitionDuration = `${n}ms`
            }))
        }),
          Mt({ swiper: t, duration: n, transformElements: a }))
      },
      perspective: () => !0,
      overwriteParams: () => ({
        _loopSwapReset: !1,
        watchSlidesProgress: !0,
        loopAdditionalSlides: t.params.cardsEffect.rotate ? 3 : 2,
        centeredSlides: !0,
        virtualTranslate: !t.params.cssMode,
      }),
    }))
}
var ko = J(() => {
  is()
  Bt()
  mr()
  ss()
  re()
})
var Xs = {}
Vn(Xs, {
  A11y: () => so,
  Autoplay: () => co,
  Controller: () => to,
  EffectCards: () => Po,
  EffectCoverflow: () => Lo,
  EffectCreative: () => Ao,
  EffectCube: () => Eo,
  EffectFade: () => To,
  EffectFlip: () => wo,
  FreeMode: () => mo,
  Grid: () => go,
  HashNavigation: () => oo,
  History: () => no,
  Keyboard: () => qa,
  Manipulation: () => yo,
  Mousewheel: () => ja,
  Navigation: () => hr,
  Pagination: () => Ys,
  Parallax: () => Qa,
  Scrollbar: () => Ks,
  Thumbs: () => fo,
  Virtual: () => Na,
  Zoom: () => Za,
})
var pr = J(() => {
  za()
  Ua()
  Wa()
  Ya()
  Ka()
  Xa()
  Ja()
  eo()
  ro()
  io()
  ao()
  lo()
  uo()
  ho()
  po()
  vo()
  bo()
  So()
  xo()
  Mo()
  Co()
  Io()
  ko()
})
var ds = Tl((Pp, Vo) => {
  'use strict'
  var Cu = function (r) {
    return Au(r) && !Iu(r)
  }
  function Au(t) {
    return !!t && typeof t == 'object'
  }
  function Iu(t) {
    var r = Object.prototype.toString.call(t)
    return r === '[object RegExp]' || r === '[object Date]' || Ou(t)
  }
  var Pu = typeof Symbol == 'function' && Symbol.for,
    ku = Pu ? Symbol.for('react.element') : 60103
  function Ou(t) {
    return t.$$typeof === ku
  }
  function Ru(t) {
    return Array.isArray(t) ? [] : {}
  }
  function cs(t, r) {
    return r.clone !== !1 && r.isMergeableObject(t) ? yr(Ru(t), t, r) : t
  }
  function Hu(t, r, e) {
    return t.concat(r).map(function (s) {
      return cs(s, e)
    })
  }
  function Du(t, r) {
    if (!r.customMerge) return yr
    var e = r.customMerge(t)
    return typeof e == 'function' ? e : yr
  }
  function Bu(t) {
    return Object.getOwnPropertySymbols
      ? Object.getOwnPropertySymbols(t).filter(function (r) {
          return Object.propertyIsEnumerable.call(t, r)
        })
      : []
  }
  function Bo(t) {
    return Object.keys(t).concat(Bu(t))
  }
  function Fo(t, r) {
    try {
      return r in t
    } catch {
      return !1
    }
  }
  function Fu(t, r) {
    return (
      Fo(t, r) &&
      !(
        Object.hasOwnProperty.call(t, r) &&
        Object.propertyIsEnumerable.call(t, r)
      )
    )
  }
  function Vu(t, r, e) {
    var s = {}
    return (
      e.isMergeableObject(t) &&
        Bo(t).forEach(function (i) {
          s[i] = cs(t[i], e)
        }),
      Bo(r).forEach(function (i) {
        Fu(t, i) ||
          (Fo(t, i) && e.isMergeableObject(r[i])
            ? (s[i] = Du(i, e)(t[i], r[i], e))
            : (s[i] = cs(r[i], e)))
      }),
      s
    )
  }
  function yr(t, r, e) {
    ;((e = e || {}),
      (e.arrayMerge = e.arrayMerge || Hu),
      (e.isMergeableObject = e.isMergeableObject || Cu),
      (e.cloneUnlessOtherwiseSpecified = cs))
    var s = Array.isArray(r),
      i = Array.isArray(t),
      n = s === i
    return n ? (s ? e.arrayMerge(t, r, e) : Vu(t, r, e)) : cs(r, e)
  }
  yr.all = function (r, e) {
    if (!Array.isArray(r)) throw new Error('first argument should be an array')
    return r.reduce(function (s, i) {
      return yr(s, i, e)
    }, {})
  }
  var _u = yr
  Vo.exports = _u
})
var yi = class {
  constructor(r, e, s) {
    ;((this.eventTarget = r),
      (this.eventName = e),
      (this.eventOptions = s),
      (this.unorderedBindings = new Set()))
  }
  connect() {
    this.eventTarget.addEventListener(this.eventName, this, this.eventOptions)
  }
  disconnect() {
    this.eventTarget.removeEventListener(
      this.eventName,
      this,
      this.eventOptions,
    )
  }
  bindingConnected(r) {
    this.unorderedBindings.add(r)
  }
  bindingDisconnected(r) {
    this.unorderedBindings.delete(r)
  }
  handleEvent(r) {
    let e = xl(r)
    for (let s of this.bindings) {
      if (e.immediatePropagationStopped) break
      s.handleEvent(e)
    }
  }
  hasBindings() {
    return this.unorderedBindings.size > 0
  }
  get bindings() {
    return Array.from(this.unorderedBindings).sort((r, e) => {
      let s = r.index,
        i = e.index
      return s < i ? -1 : s > i ? 1 : 0
    })
  }
}
function xl(t) {
  if ('immediatePropagationStopped' in t) return t
  {
    let { stopImmediatePropagation: r } = t
    return Object.assign(t, {
      immediatePropagationStopped: !1,
      stopImmediatePropagation() {
        ;((this.immediatePropagationStopped = !0), r.call(this))
      },
    })
  }
}
var bi = class {
    constructor(r) {
      ;((this.application = r),
        (this.eventListenerMaps = new Map()),
        (this.started = !1))
    }
    start() {
      this.started ||
        ((this.started = !0), this.eventListeners.forEach((r) => r.connect()))
    }
    stop() {
      this.started &&
        ((this.started = !1),
        this.eventListeners.forEach((r) => r.disconnect()))
    }
    get eventListeners() {
      return Array.from(this.eventListenerMaps.values()).reduce(
        (r, e) => r.concat(Array.from(e.values())),
        [],
      )
    }
    bindingConnected(r) {
      this.fetchEventListenerForBinding(r).bindingConnected(r)
    }
    bindingDisconnected(r, e = !1) {
      ;(this.fetchEventListenerForBinding(r).bindingDisconnected(r),
        e && this.clearEventListenersForBinding(r))
    }
    handleError(r, e, s = {}) {
      this.application.handleError(r, `Error ${e}`, s)
    }
    clearEventListenersForBinding(r) {
      let e = this.fetchEventListenerForBinding(r)
      e.hasBindings() || (e.disconnect(), this.removeMappedEventListenerFor(r))
    }
    removeMappedEventListenerFor(r) {
      let { eventTarget: e, eventName: s, eventOptions: i } = r,
        n = this.fetchEventListenerMapForEventTarget(e),
        a = this.cacheKey(s, i)
      ;(n.delete(a), n.size == 0 && this.eventListenerMaps.delete(e))
    }
    fetchEventListenerForBinding(r) {
      let { eventTarget: e, eventName: s, eventOptions: i } = r
      return this.fetchEventListener(e, s, i)
    }
    fetchEventListener(r, e, s) {
      let i = this.fetchEventListenerMapForEventTarget(r),
        n = this.cacheKey(e, s),
        a = i.get(n)
      return (a || ((a = this.createEventListener(r, e, s)), i.set(n, a)), a)
    }
    createEventListener(r, e, s) {
      let i = new yi(r, e, s)
      return (this.started && i.connect(), i)
    }
    fetchEventListenerMapForEventTarget(r) {
      let e = this.eventListenerMaps.get(r)
      return (e || ((e = new Map()), this.eventListenerMaps.set(r, e)), e)
    }
    cacheKey(r, e) {
      let s = [r]
      return (
        Object.keys(e)
          .sort()
          .forEach((i) => {
            s.push(`${e[i] ? '' : '!'}${i}`)
          }),
        s.join(':')
      )
    }
  },
  wl = {
    stop({ event: t, value: r }) {
      return (r && t.stopPropagation(), !0)
    },
    prevent({ event: t, value: r }) {
      return (r && t.preventDefault(), !0)
    },
    self({ event: t, value: r, element: e }) {
      return r ? e === t.target : !0
    },
  },
  Ml =
    /^(?:(?:([^.]+?)\+)?(.+?)(?:\.(.+?))?(?:@(window|document))?->)?(.+?)(?:#([^:]+?))(?::(.+))?$/
function Ll(t) {
  let e = t.trim().match(Ml) || [],
    s = e[2],
    i = e[3]
  return (
    i &&
      !['keydown', 'keyup', 'keypress'].includes(s) &&
      ((s += `.${i}`), (i = '')),
    {
      eventTarget: Cl(e[4]),
      eventName: s,
      eventOptions: e[7] ? Al(e[7]) : {},
      identifier: e[5],
      methodName: e[6],
      keyFilter: e[1] || i,
    }
  )
}
function Cl(t) {
  if (t == 'window') return window
  if (t == 'document') return document
}
function Al(t) {
  return t
    .split(':')
    .reduce(
      (r, e) => Object.assign(r, { [e.replace(/^!/, '')]: !/^!/.test(e) }),
      {},
    )
}
function Il(t) {
  if (t == window) return 'window'
  if (t == document) return 'document'
}
function Ni(t) {
  return t.replace(/(?:[_-])([a-z0-9])/g, (r, e) => e.toUpperCase())
}
function Ti(t) {
  return Ni(t.replace(/--/g, '-').replace(/__/g, '_'))
}
function jr(t) {
  return t.charAt(0).toUpperCase() + t.slice(1)
}
function Kn(t) {
  return t.replace(/([A-Z])/g, (r, e) => `-${e.toLowerCase()}`)
}
function Pl(t) {
  return t.match(/[^\s]+/g) || []
}
function $n(t) {
  return t != null
}
function Si(t, r) {
  return Object.prototype.hasOwnProperty.call(t, r)
}
var Nn = ['meta', 'ctrl', 'alt', 'shift'],
  Ei = class {
    constructor(r, e, s, i) {
      ;((this.element = r),
        (this.index = e),
        (this.eventTarget = s.eventTarget || r),
        (this.eventName = s.eventName || kl(r) || Hs('missing event name')),
        (this.eventOptions = s.eventOptions || {}),
        (this.identifier = s.identifier || Hs('missing identifier')),
        (this.methodName = s.methodName || Hs('missing method name')),
        (this.keyFilter = s.keyFilter || ''),
        (this.schema = i))
    }
    static forToken(r, e) {
      return new this(r.element, r.index, Ll(r.content), e)
    }
    toString() {
      let r = this.keyFilter ? `.${this.keyFilter}` : '',
        e = this.eventTargetName ? `@${this.eventTargetName}` : ''
      return `${this.eventName}${r}${e}->${this.identifier}#${this.methodName}`
    }
    shouldIgnoreKeyboardEvent(r) {
      if (!this.keyFilter) return !1
      let e = this.keyFilter.split('+')
      if (this.keyFilterDissatisfied(r, e)) return !0
      let s = e.filter((i) => !Nn.includes(i))[0]
      return s
        ? (Si(this.keyMappings, s) ||
            Hs(`contains unknown key filter: ${this.keyFilter}`),
          this.keyMappings[s].toLowerCase() !== r.key.toLowerCase())
        : !1
    }
    shouldIgnoreMouseEvent(r) {
      if (!this.keyFilter) return !1
      let e = [this.keyFilter]
      return !!this.keyFilterDissatisfied(r, e)
    }
    get params() {
      let r = {},
        e = new RegExp(`^data-${this.identifier}-(.+)-param$`, 'i')
      for (let { name: s, value: i } of Array.from(this.element.attributes)) {
        let n = s.match(e),
          a = n && n[1]
        a && (r[Ni(a)] = Ol(i))
      }
      return r
    }
    get eventTargetName() {
      return Il(this.eventTarget)
    }
    get keyMappings() {
      return this.schema.keyMappings
    }
    keyFilterDissatisfied(r, e) {
      let [s, i, n, a] = Nn.map((l) => e.includes(l))
      return (
        r.metaKey !== s || r.ctrlKey !== i || r.altKey !== n || r.shiftKey !== a
      )
    }
  },
  zn = {
    a: () => 'click',
    button: () => 'click',
    form: () => 'submit',
    details: () => 'toggle',
    input: (t) => (t.getAttribute('type') == 'submit' ? 'click' : 'input'),
    select: () => 'change',
    textarea: () => 'input',
  }
function kl(t) {
  let r = t.tagName.toLowerCase()
  if (r in zn) return zn[r](t)
}
function Hs(t) {
  throw new Error(t)
}
function Ol(t) {
  try {
    return JSON.parse(t)
  } catch {
    return t
  }
}
var xi = class {
    constructor(r, e) {
      ;((this.context = r), (this.action = e))
    }
    get index() {
      return this.action.index
    }
    get eventTarget() {
      return this.action.eventTarget
    }
    get eventOptions() {
      return this.action.eventOptions
    }
    get identifier() {
      return this.context.identifier
    }
    handleEvent(r) {
      let e = this.prepareActionEvent(r)
      this.willBeInvokedByEvent(r) &&
        this.applyEventModifiers(e) &&
        this.invokeWithEvent(e)
    }
    get eventName() {
      return this.action.eventName
    }
    get method() {
      let r = this.controller[this.methodName]
      if (typeof r == 'function') return r
      throw new Error(
        `Action "${this.action}" references undefined method "${this.methodName}"`,
      )
    }
    applyEventModifiers(r) {
      let { element: e } = this.action,
        { actionDescriptorFilters: s } = this.context.application,
        { controller: i } = this.context,
        n = !0
      for (let [a, l] of Object.entries(this.eventOptions))
        if (a in s) {
          let o = s[a]
          n = n && o({ name: a, value: l, event: r, element: e, controller: i })
        } else continue
      return n
    }
    prepareActionEvent(r) {
      return Object.assign(r, { params: this.action.params })
    }
    invokeWithEvent(r) {
      let { target: e, currentTarget: s } = r
      try {
        ;(this.method.call(this.controller, r),
          this.context.logDebugActivity(this.methodName, {
            event: r,
            target: e,
            currentTarget: s,
            action: this.methodName,
          }))
      } catch (i) {
        let { identifier: n, controller: a, element: l, index: o } = this,
          u = { identifier: n, controller: a, element: l, index: o, event: r }
        this.context.handleError(i, `invoking action "${this.action}"`, u)
      }
    }
    willBeInvokedByEvent(r) {
      let e = r.target
      return (r instanceof KeyboardEvent &&
        this.action.shouldIgnoreKeyboardEvent(r)) ||
        (r instanceof MouseEvent && this.action.shouldIgnoreMouseEvent(r))
        ? !1
        : this.element === e
          ? !0
          : e instanceof Element && this.element.contains(e)
            ? this.scope.containsElement(e)
            : this.scope.containsElement(this.action.element)
    }
    get controller() {
      return this.context.controller
    }
    get methodName() {
      return this.action.methodName
    }
    get element() {
      return this.scope.element
    }
    get scope() {
      return this.context.scope
    }
  },
  Ds = class {
    constructor(r, e) {
      ;((this.mutationObserverInit = {
        attributes: !0,
        childList: !0,
        subtree: !0,
      }),
        (this.element = r),
        (this.started = !1),
        (this.delegate = e),
        (this.elements = new Set()),
        (this.mutationObserver = new MutationObserver((s) =>
          this.processMutations(s),
        )))
    }
    start() {
      this.started ||
        ((this.started = !0),
        this.mutationObserver.observe(this.element, this.mutationObserverInit),
        this.refresh())
    }
    pause(r) {
      ;(this.started &&
        (this.mutationObserver.disconnect(), (this.started = !1)),
        r(),
        this.started ||
          (this.mutationObserver.observe(
            this.element,
            this.mutationObserverInit,
          ),
          (this.started = !0)))
    }
    stop() {
      this.started &&
        (this.mutationObserver.takeRecords(),
        this.mutationObserver.disconnect(),
        (this.started = !1))
    }
    refresh() {
      if (this.started) {
        let r = new Set(this.matchElementsInTree())
        for (let e of Array.from(this.elements))
          r.has(e) || this.removeElement(e)
        for (let e of Array.from(r)) this.addElement(e)
      }
    }
    processMutations(r) {
      if (this.started) for (let e of r) this.processMutation(e)
    }
    processMutation(r) {
      r.type == 'attributes'
        ? this.processAttributeChange(r.target, r.attributeName)
        : r.type == 'childList' &&
          (this.processRemovedNodes(r.removedNodes),
          this.processAddedNodes(r.addedNodes))
    }
    processAttributeChange(r, e) {
      this.elements.has(r)
        ? this.delegate.elementAttributeChanged && this.matchElement(r)
          ? this.delegate.elementAttributeChanged(r, e)
          : this.removeElement(r)
        : this.matchElement(r) && this.addElement(r)
    }
    processRemovedNodes(r) {
      for (let e of Array.from(r)) {
        let s = this.elementFromNode(e)
        s && this.processTree(s, this.removeElement)
      }
    }
    processAddedNodes(r) {
      for (let e of Array.from(r)) {
        let s = this.elementFromNode(e)
        s && this.elementIsActive(s) && this.processTree(s, this.addElement)
      }
    }
    matchElement(r) {
      return this.delegate.matchElement(r)
    }
    matchElementsInTree(r = this.element) {
      return this.delegate.matchElementsInTree(r)
    }
    processTree(r, e) {
      for (let s of this.matchElementsInTree(r)) e.call(this, s)
    }
    elementFromNode(r) {
      if (r.nodeType == Node.ELEMENT_NODE) return r
    }
    elementIsActive(r) {
      return r.isConnected != this.element.isConnected
        ? !1
        : this.element.contains(r)
    }
    addElement(r) {
      this.elements.has(r) ||
        (this.elementIsActive(r) &&
          (this.elements.add(r),
          this.delegate.elementMatched && this.delegate.elementMatched(r)))
    }
    removeElement(r) {
      this.elements.has(r) &&
        (this.elements.delete(r),
        this.delegate.elementUnmatched && this.delegate.elementUnmatched(r))
    }
  },
  Bs = class {
    constructor(r, e, s) {
      ;((this.attributeName = e),
        (this.delegate = s),
        (this.elementObserver = new Ds(r, this)))
    }
    get element() {
      return this.elementObserver.element
    }
    get selector() {
      return `[${this.attributeName}]`
    }
    start() {
      this.elementObserver.start()
    }
    pause(r) {
      this.elementObserver.pause(r)
    }
    stop() {
      this.elementObserver.stop()
    }
    refresh() {
      this.elementObserver.refresh()
    }
    get started() {
      return this.elementObserver.started
    }
    matchElement(r) {
      return r.hasAttribute(this.attributeName)
    }
    matchElementsInTree(r) {
      let e = this.matchElement(r) ? [r] : [],
        s = Array.from(r.querySelectorAll(this.selector))
      return e.concat(s)
    }
    elementMatched(r) {
      this.delegate.elementMatchedAttribute &&
        this.delegate.elementMatchedAttribute(r, this.attributeName)
    }
    elementUnmatched(r) {
      this.delegate.elementUnmatchedAttribute &&
        this.delegate.elementUnmatchedAttribute(r, this.attributeName)
    }
    elementAttributeChanged(r, e) {
      this.delegate.elementAttributeValueChanged &&
        this.attributeName == e &&
        this.delegate.elementAttributeValueChanged(r, e)
    }
  }
function Rl(t, r, e) {
  Xn(t, r).add(e)
}
function Hl(t, r, e) {
  ;(Xn(t, r).delete(e), Dl(t, r))
}
function Xn(t, r) {
  let e = t.get(r)
  return (e || ((e = new Set()), t.set(r, e)), e)
}
function Dl(t, r) {
  let e = t.get(r)
  e != null && e.size == 0 && t.delete(r)
}
var mt = class {
  constructor() {
    this.valuesByKey = new Map()
  }
  get keys() {
    return Array.from(this.valuesByKey.keys())
  }
  get values() {
    return Array.from(this.valuesByKey.values()).reduce(
      (e, s) => e.concat(Array.from(s)),
      [],
    )
  }
  get size() {
    return Array.from(this.valuesByKey.values()).reduce((e, s) => e + s.size, 0)
  }
  add(r, e) {
    Rl(this.valuesByKey, r, e)
  }
  delete(r, e) {
    Hl(this.valuesByKey, r, e)
  }
  has(r, e) {
    let s = this.valuesByKey.get(r)
    return s != null && s.has(e)
  }
  hasKey(r) {
    return this.valuesByKey.has(r)
  }
  hasValue(r) {
    return Array.from(this.valuesByKey.values()).some((s) => s.has(r))
  }
  getValuesForKey(r) {
    let e = this.valuesByKey.get(r)
    return e ? Array.from(e) : []
  }
  getKeysForValue(r) {
    return Array.from(this.valuesByKey)
      .filter(([e, s]) => s.has(r))
      .map(([e, s]) => e)
  }
}
var wi = class {
    constructor(r, e, s, i) {
      ;((this._selector = e),
        (this.details = i),
        (this.elementObserver = new Ds(r, this)),
        (this.delegate = s),
        (this.matchesByElement = new mt()))
    }
    get started() {
      return this.elementObserver.started
    }
    get selector() {
      return this._selector
    }
    set selector(r) {
      ;((this._selector = r), this.refresh())
    }
    start() {
      this.elementObserver.start()
    }
    pause(r) {
      this.elementObserver.pause(r)
    }
    stop() {
      this.elementObserver.stop()
    }
    refresh() {
      this.elementObserver.refresh()
    }
    get element() {
      return this.elementObserver.element
    }
    matchElement(r) {
      let { selector: e } = this
      if (e) {
        let s = r.matches(e)
        return this.delegate.selectorMatchElement
          ? s && this.delegate.selectorMatchElement(r, this.details)
          : s
      } else return !1
    }
    matchElementsInTree(r) {
      let { selector: e } = this
      if (e) {
        let s = this.matchElement(r) ? [r] : [],
          i = Array.from(r.querySelectorAll(e)).filter((n) =>
            this.matchElement(n),
          )
        return s.concat(i)
      } else return []
    }
    elementMatched(r) {
      let { selector: e } = this
      e && this.selectorMatched(r, e)
    }
    elementUnmatched(r) {
      let e = this.matchesByElement.getKeysForValue(r)
      for (let s of e) this.selectorUnmatched(r, s)
    }
    elementAttributeChanged(r, e) {
      let { selector: s } = this
      if (s) {
        let i = this.matchElement(r),
          n = this.matchesByElement.has(s, r)
        i && !n
          ? this.selectorMatched(r, s)
          : !i && n && this.selectorUnmatched(r, s)
      }
    }
    selectorMatched(r, e) {
      ;(this.delegate.selectorMatched(r, e, this.details),
        this.matchesByElement.add(e, r))
    }
    selectorUnmatched(r, e) {
      ;(this.delegate.selectorUnmatched(r, e, this.details),
        this.matchesByElement.delete(e, r))
    }
  },
  Mi = class {
    constructor(r, e) {
      ;((this.element = r),
        (this.delegate = e),
        (this.started = !1),
        (this.stringMap = new Map()),
        (this.mutationObserver = new MutationObserver((s) =>
          this.processMutations(s),
        )))
    }
    start() {
      this.started ||
        ((this.started = !0),
        this.mutationObserver.observe(this.element, {
          attributes: !0,
          attributeOldValue: !0,
        }),
        this.refresh())
    }
    stop() {
      this.started &&
        (this.mutationObserver.takeRecords(),
        this.mutationObserver.disconnect(),
        (this.started = !1))
    }
    refresh() {
      if (this.started)
        for (let r of this.knownAttributeNames) this.refreshAttribute(r, null)
    }
    processMutations(r) {
      if (this.started) for (let e of r) this.processMutation(e)
    }
    processMutation(r) {
      let e = r.attributeName
      e && this.refreshAttribute(e, r.oldValue)
    }
    refreshAttribute(r, e) {
      let s = this.delegate.getStringMapKeyForAttribute(r)
      if (s != null) {
        this.stringMap.has(r) || this.stringMapKeyAdded(s, r)
        let i = this.element.getAttribute(r)
        if (
          (this.stringMap.get(r) != i && this.stringMapValueChanged(i, s, e),
          i == null)
        ) {
          let n = this.stringMap.get(r)
          ;(this.stringMap.delete(r), n && this.stringMapKeyRemoved(s, r, n))
        } else this.stringMap.set(r, i)
      }
    }
    stringMapKeyAdded(r, e) {
      this.delegate.stringMapKeyAdded && this.delegate.stringMapKeyAdded(r, e)
    }
    stringMapValueChanged(r, e, s) {
      this.delegate.stringMapValueChanged &&
        this.delegate.stringMapValueChanged(r, e, s)
    }
    stringMapKeyRemoved(r, e, s) {
      this.delegate.stringMapKeyRemoved &&
        this.delegate.stringMapKeyRemoved(r, e, s)
    }
    get knownAttributeNames() {
      return Array.from(
        new Set(this.currentAttributeNames.concat(this.recordedAttributeNames)),
      )
    }
    get currentAttributeNames() {
      return Array.from(this.element.attributes).map((r) => r.name)
    }
    get recordedAttributeNames() {
      return Array.from(this.stringMap.keys())
    }
  },
  Fs = class {
    constructor(r, e, s) {
      ;((this.attributeObserver = new Bs(r, e, this)),
        (this.delegate = s),
        (this.tokensByElement = new mt()))
    }
    get started() {
      return this.attributeObserver.started
    }
    start() {
      this.attributeObserver.start()
    }
    pause(r) {
      this.attributeObserver.pause(r)
    }
    stop() {
      this.attributeObserver.stop()
    }
    refresh() {
      this.attributeObserver.refresh()
    }
    get element() {
      return this.attributeObserver.element
    }
    get attributeName() {
      return this.attributeObserver.attributeName
    }
    elementMatchedAttribute(r) {
      this.tokensMatched(this.readTokensForElement(r))
    }
    elementAttributeValueChanged(r) {
      let [e, s] = this.refreshTokensForElement(r)
      ;(this.tokensUnmatched(e), this.tokensMatched(s))
    }
    elementUnmatchedAttribute(r) {
      this.tokensUnmatched(this.tokensByElement.getValuesForKey(r))
    }
    tokensMatched(r) {
      r.forEach((e) => this.tokenMatched(e))
    }
    tokensUnmatched(r) {
      r.forEach((e) => this.tokenUnmatched(e))
    }
    tokenMatched(r) {
      ;(this.delegate.tokenMatched(r), this.tokensByElement.add(r.element, r))
    }
    tokenUnmatched(r) {
      ;(this.delegate.tokenUnmatched(r),
        this.tokensByElement.delete(r.element, r))
    }
    refreshTokensForElement(r) {
      let e = this.tokensByElement.getValuesForKey(r),
        s = this.readTokensForElement(r),
        i = Fl(e, s).findIndex(([n, a]) => !Vl(n, a))
      return i == -1 ? [[], []] : [e.slice(i), s.slice(i)]
    }
    readTokensForElement(r) {
      let e = this.attributeName,
        s = r.getAttribute(e) || ''
      return Bl(s, r, e)
    }
  }
function Bl(t, r, e) {
  return t
    .trim()
    .split(/\s+/)
    .filter((s) => s.length)
    .map((s, i) => ({ element: r, attributeName: e, content: s, index: i }))
}
function Fl(t, r) {
  let e = Math.max(t.length, r.length)
  return Array.from({ length: e }, (s, i) => [t[i], r[i]])
}
function Vl(t, r) {
  return t && r && t.index == r.index && t.content == r.content
}
var Vs = class {
    constructor(r, e, s) {
      ;((this.tokenListObserver = new Fs(r, e, this)),
        (this.delegate = s),
        (this.parseResultsByToken = new WeakMap()),
        (this.valuesByTokenByElement = new WeakMap()))
    }
    get started() {
      return this.tokenListObserver.started
    }
    start() {
      this.tokenListObserver.start()
    }
    stop() {
      this.tokenListObserver.stop()
    }
    refresh() {
      this.tokenListObserver.refresh()
    }
    get element() {
      return this.tokenListObserver.element
    }
    get attributeName() {
      return this.tokenListObserver.attributeName
    }
    tokenMatched(r) {
      let { element: e } = r,
        { value: s } = this.fetchParseResultForToken(r)
      s &&
        (this.fetchValuesByTokenForElement(e).set(r, s),
        this.delegate.elementMatchedValue(e, s))
    }
    tokenUnmatched(r) {
      let { element: e } = r,
        { value: s } = this.fetchParseResultForToken(r)
      s &&
        (this.fetchValuesByTokenForElement(e).delete(r),
        this.delegate.elementUnmatchedValue(e, s))
    }
    fetchParseResultForToken(r) {
      let e = this.parseResultsByToken.get(r)
      return (
        e || ((e = this.parseToken(r)), this.parseResultsByToken.set(r, e)),
        e
      )
    }
    fetchValuesByTokenForElement(r) {
      let e = this.valuesByTokenByElement.get(r)
      return (e || ((e = new Map()), this.valuesByTokenByElement.set(r, e)), e)
    }
    parseToken(r) {
      try {
        return { value: this.delegate.parseValueForToken(r) }
      } catch (e) {
        return { error: e }
      }
    }
  },
  Li = class {
    constructor(r, e) {
      ;((this.context = r),
        (this.delegate = e),
        (this.bindingsByAction = new Map()))
    }
    start() {
      this.valueListObserver ||
        ((this.valueListObserver = new Vs(
          this.element,
          this.actionAttribute,
          this,
        )),
        this.valueListObserver.start())
    }
    stop() {
      this.valueListObserver &&
        (this.valueListObserver.stop(),
        delete this.valueListObserver,
        this.disconnectAllActions())
    }
    get element() {
      return this.context.element
    }
    get identifier() {
      return this.context.identifier
    }
    get actionAttribute() {
      return this.schema.actionAttribute
    }
    get schema() {
      return this.context.schema
    }
    get bindings() {
      return Array.from(this.bindingsByAction.values())
    }
    connectAction(r) {
      let e = new xi(this.context, r)
      ;(this.bindingsByAction.set(r, e), this.delegate.bindingConnected(e))
    }
    disconnectAction(r) {
      let e = this.bindingsByAction.get(r)
      e &&
        (this.bindingsByAction.delete(r), this.delegate.bindingDisconnected(e))
    }
    disconnectAllActions() {
      ;(this.bindings.forEach((r) => this.delegate.bindingDisconnected(r, !0)),
        this.bindingsByAction.clear())
    }
    parseValueForToken(r) {
      let e = Ei.forToken(r, this.schema)
      if (e.identifier == this.identifier) return e
    }
    elementMatchedValue(r, e) {
      this.connectAction(e)
    }
    elementUnmatchedValue(r, e) {
      this.disconnectAction(e)
    }
  },
  Ci = class {
    constructor(r, e) {
      ;((this.context = r),
        (this.receiver = e),
        (this.stringMapObserver = new Mi(this.element, this)),
        (this.valueDescriptorMap = this.controller.valueDescriptorMap))
    }
    start() {
      ;(this.stringMapObserver.start(),
        this.invokeChangedCallbacksForDefaultValues())
    }
    stop() {
      this.stringMapObserver.stop()
    }
    get element() {
      return this.context.element
    }
    get controller() {
      return this.context.controller
    }
    getStringMapKeyForAttribute(r) {
      if (r in this.valueDescriptorMap) return this.valueDescriptorMap[r].name
    }
    stringMapKeyAdded(r, e) {
      let s = this.valueDescriptorMap[e]
      this.hasValue(r) ||
        this.invokeChangedCallback(
          r,
          s.writer(this.receiver[r]),
          s.writer(s.defaultValue),
        )
    }
    stringMapValueChanged(r, e, s) {
      let i = this.valueDescriptorNameMap[e]
      r !== null &&
        (s === null && (s = i.writer(i.defaultValue)),
        this.invokeChangedCallback(e, r, s))
    }
    stringMapKeyRemoved(r, e, s) {
      let i = this.valueDescriptorNameMap[r]
      this.hasValue(r)
        ? this.invokeChangedCallback(r, i.writer(this.receiver[r]), s)
        : this.invokeChangedCallback(r, i.writer(i.defaultValue), s)
    }
    invokeChangedCallbacksForDefaultValues() {
      for (let { key: r, name: e, defaultValue: s, writer: i } of this
        .valueDescriptors)
        s != null &&
          !this.controller.data.has(r) &&
          this.invokeChangedCallback(e, i(s), void 0)
    }
    invokeChangedCallback(r, e, s) {
      let i = `${r}Changed`,
        n = this.receiver[i]
      if (typeof n == 'function') {
        let a = this.valueDescriptorNameMap[r]
        try {
          let l = a.reader(e),
            o = s
          ;(s && (o = a.reader(s)), n.call(this.receiver, l, o))
        } catch (l) {
          throw (
            l instanceof TypeError &&
              (l.message = `Stimulus Value "${this.context.identifier}.${a.name}" - ${l.message}`),
            l
          )
        }
      }
    }
    get valueDescriptors() {
      let { valueDescriptorMap: r } = this
      return Object.keys(r).map((e) => r[e])
    }
    get valueDescriptorNameMap() {
      let r = {}
      return (
        Object.keys(this.valueDescriptorMap).forEach((e) => {
          let s = this.valueDescriptorMap[e]
          r[s.name] = s
        }),
        r
      )
    }
    hasValue(r) {
      let e = this.valueDescriptorNameMap[r],
        s = `has${jr(e.name)}`
      return this.receiver[s]
    }
  },
  Ai = class {
    constructor(r, e) {
      ;((this.context = r),
        (this.delegate = e),
        (this.targetsByName = new mt()))
    }
    start() {
      this.tokenListObserver ||
        ((this.tokenListObserver = new Fs(
          this.element,
          this.attributeName,
          this,
        )),
        this.tokenListObserver.start())
    }
    stop() {
      this.tokenListObserver &&
        (this.disconnectAllTargets(),
        this.tokenListObserver.stop(),
        delete this.tokenListObserver)
    }
    tokenMatched({ element: r, content: e }) {
      this.scope.containsElement(r) && this.connectTarget(r, e)
    }
    tokenUnmatched({ element: r, content: e }) {
      this.disconnectTarget(r, e)
    }
    connectTarget(r, e) {
      var s
      this.targetsByName.has(e, r) ||
        (this.targetsByName.add(e, r),
        (s = this.tokenListObserver) === null ||
          s === void 0 ||
          s.pause(() => this.delegate.targetConnected(r, e)))
    }
    disconnectTarget(r, e) {
      var s
      this.targetsByName.has(e, r) &&
        (this.targetsByName.delete(e, r),
        (s = this.tokenListObserver) === null ||
          s === void 0 ||
          s.pause(() => this.delegate.targetDisconnected(r, e)))
    }
    disconnectAllTargets() {
      for (let r of this.targetsByName.keys)
        for (let e of this.targetsByName.getValuesForKey(r))
          this.disconnectTarget(e, r)
    }
    get attributeName() {
      return `data-${this.context.identifier}-target`
    }
    get element() {
      return this.context.element
    }
    get scope() {
      return this.context.scope
    }
  }
function Wr(t, r) {
  let e = Qn(t)
  return Array.from(
    e.reduce((s, i) => ($l(i, r).forEach((n) => s.add(n)), s), new Set()),
  )
}
function _l(t, r) {
  return Qn(t).reduce((s, i) => (s.push(...Nl(i, r)), s), [])
}
function Qn(t) {
  let r = []
  for (; t; ) (r.push(t), (t = Object.getPrototypeOf(t)))
  return r.reverse()
}
function $l(t, r) {
  let e = t[r]
  return Array.isArray(e) ? e : []
}
function Nl(t, r) {
  let e = t[r]
  return e ? Object.keys(e).map((s) => [s, e[s]]) : []
}
var Ii = class {
    constructor(r, e) {
      ;((this.started = !1),
        (this.context = r),
        (this.delegate = e),
        (this.outletsByName = new mt()),
        (this.outletElementsByName = new mt()),
        (this.selectorObserverMap = new Map()),
        (this.attributeObserverMap = new Map()))
    }
    start() {
      this.started ||
        (this.outletDefinitions.forEach((r) => {
          ;(this.setupSelectorObserverForOutlet(r),
            this.setupAttributeObserverForOutlet(r))
        }),
        (this.started = !0),
        this.dependentContexts.forEach((r) => r.refresh()))
    }
    refresh() {
      ;(this.selectorObserverMap.forEach((r) => r.refresh()),
        this.attributeObserverMap.forEach((r) => r.refresh()))
    }
    stop() {
      this.started &&
        ((this.started = !1),
        this.disconnectAllOutlets(),
        this.stopSelectorObservers(),
        this.stopAttributeObservers())
    }
    stopSelectorObservers() {
      this.selectorObserverMap.size > 0 &&
        (this.selectorObserverMap.forEach((r) => r.stop()),
        this.selectorObserverMap.clear())
    }
    stopAttributeObservers() {
      this.attributeObserverMap.size > 0 &&
        (this.attributeObserverMap.forEach((r) => r.stop()),
        this.attributeObserverMap.clear())
    }
    selectorMatched(r, e, { outletName: s }) {
      let i = this.getOutlet(r, s)
      i && this.connectOutlet(i, r, s)
    }
    selectorUnmatched(r, e, { outletName: s }) {
      let i = this.getOutletFromMap(r, s)
      i && this.disconnectOutlet(i, r, s)
    }
    selectorMatchElement(r, { outletName: e }) {
      let s = this.selector(e),
        i = this.hasOutlet(r, e),
        n = r.matches(`[${this.schema.controllerAttribute}~=${e}]`)
      return s ? i && n && r.matches(s) : !1
    }
    elementMatchedAttribute(r, e) {
      let s = this.getOutletNameFromOutletAttributeName(e)
      s && this.updateSelectorObserverForOutlet(s)
    }
    elementAttributeValueChanged(r, e) {
      let s = this.getOutletNameFromOutletAttributeName(e)
      s && this.updateSelectorObserverForOutlet(s)
    }
    elementUnmatchedAttribute(r, e) {
      let s = this.getOutletNameFromOutletAttributeName(e)
      s && this.updateSelectorObserverForOutlet(s)
    }
    connectOutlet(r, e, s) {
      var i
      this.outletElementsByName.has(s, e) ||
        (this.outletsByName.add(s, r),
        this.outletElementsByName.add(s, e),
        (i = this.selectorObserverMap.get(s)) === null ||
          i === void 0 ||
          i.pause(() => this.delegate.outletConnected(r, e, s)))
    }
    disconnectOutlet(r, e, s) {
      var i
      this.outletElementsByName.has(s, e) &&
        (this.outletsByName.delete(s, r),
        this.outletElementsByName.delete(s, e),
        (i = this.selectorObserverMap.get(s)) === null ||
          i === void 0 ||
          i.pause(() => this.delegate.outletDisconnected(r, e, s)))
    }
    disconnectAllOutlets() {
      for (let r of this.outletElementsByName.keys)
        for (let e of this.outletElementsByName.getValuesForKey(r))
          for (let s of this.outletsByName.getValuesForKey(r))
            this.disconnectOutlet(s, e, r)
    }
    updateSelectorObserverForOutlet(r) {
      let e = this.selectorObserverMap.get(r)
      e && (e.selector = this.selector(r))
    }
    setupSelectorObserverForOutlet(r) {
      let e = this.selector(r),
        s = new wi(document.body, e, this, { outletName: r })
      ;(this.selectorObserverMap.set(r, s), s.start())
    }
    setupAttributeObserverForOutlet(r) {
      let e = this.attributeNameForOutletName(r),
        s = new Bs(this.scope.element, e, this)
      ;(this.attributeObserverMap.set(r, s), s.start())
    }
    selector(r) {
      return this.scope.outlets.getSelectorForOutletName(r)
    }
    attributeNameForOutletName(r) {
      return this.scope.schema.outletAttributeForScope(this.identifier, r)
    }
    getOutletNameFromOutletAttributeName(r) {
      return this.outletDefinitions.find(
        (e) => this.attributeNameForOutletName(e) === r,
      )
    }
    get outletDependencies() {
      let r = new mt()
      return (
        this.router.modules.forEach((e) => {
          let s = e.definition.controllerConstructor
          Wr(s, 'outlets').forEach((n) => r.add(n, e.identifier))
        }),
        r
      )
    }
    get outletDefinitions() {
      return this.outletDependencies.getKeysForValue(this.identifier)
    }
    get dependentControllerIdentifiers() {
      return this.outletDependencies.getValuesForKey(this.identifier)
    }
    get dependentContexts() {
      let r = this.dependentControllerIdentifiers
      return this.router.contexts.filter((e) => r.includes(e.identifier))
    }
    hasOutlet(r, e) {
      return !!this.getOutlet(r, e) || !!this.getOutletFromMap(r, e)
    }
    getOutlet(r, e) {
      return this.application.getControllerForElementAndIdentifier(r, e)
    }
    getOutletFromMap(r, e) {
      return this.outletsByName.getValuesForKey(e).find((s) => s.element === r)
    }
    get scope() {
      return this.context.scope
    }
    get schema() {
      return this.context.schema
    }
    get identifier() {
      return this.context.identifier
    }
    get application() {
      return this.context.application
    }
    get router() {
      return this.application.router
    }
  },
  Pi = class {
    constructor(r, e) {
      ;((this.logDebugActivity = (s, i = {}) => {
        let { identifier: n, controller: a, element: l } = this
        ;((i = Object.assign({ identifier: n, controller: a, element: l }, i)),
          this.application.logDebugActivity(this.identifier, s, i))
      }),
        (this.module = r),
        (this.scope = e),
        (this.controller = new r.controllerConstructor(this)),
        (this.bindingObserver = new Li(this, this.dispatcher)),
        (this.valueObserver = new Ci(this, this.controller)),
        (this.targetObserver = new Ai(this, this)),
        (this.outletObserver = new Ii(this, this)))
      try {
        ;(this.controller.initialize(), this.logDebugActivity('initialize'))
      } catch (s) {
        this.handleError(s, 'initializing controller')
      }
    }
    connect() {
      ;(this.bindingObserver.start(),
        this.valueObserver.start(),
        this.targetObserver.start(),
        this.outletObserver.start())
      try {
        ;(this.controller.connect(), this.logDebugActivity('connect'))
      } catch (r) {
        this.handleError(r, 'connecting controller')
      }
    }
    refresh() {
      this.outletObserver.refresh()
    }
    disconnect() {
      try {
        ;(this.controller.disconnect(), this.logDebugActivity('disconnect'))
      } catch (r) {
        this.handleError(r, 'disconnecting controller')
      }
      ;(this.outletObserver.stop(),
        this.targetObserver.stop(),
        this.valueObserver.stop(),
        this.bindingObserver.stop())
    }
    get application() {
      return this.module.application
    }
    get identifier() {
      return this.module.identifier
    }
    get schema() {
      return this.application.schema
    }
    get dispatcher() {
      return this.application.dispatcher
    }
    get element() {
      return this.scope.element
    }
    get parentElement() {
      return this.element.parentElement
    }
    handleError(r, e, s = {}) {
      let { identifier: i, controller: n, element: a } = this
      ;((s = Object.assign({ identifier: i, controller: n, element: a }, s)),
        this.application.handleError(r, `Error ${e}`, s))
    }
    targetConnected(r, e) {
      this.invokeControllerMethod(`${e}TargetConnected`, r)
    }
    targetDisconnected(r, e) {
      this.invokeControllerMethod(`${e}TargetDisconnected`, r)
    }
    outletConnected(r, e, s) {
      this.invokeControllerMethod(`${Ti(s)}OutletConnected`, r, e)
    }
    outletDisconnected(r, e, s) {
      this.invokeControllerMethod(`${Ti(s)}OutletDisconnected`, r, e)
    }
    invokeControllerMethod(r, ...e) {
      let s = this.controller
      typeof s[r] == 'function' && s[r](...e)
    }
  }
function zl(t) {
  return ql(t, Ul(t))
}
function ql(t, r) {
  let e = Yl(t),
    s = jl(t.prototype, r)
  return (Object.defineProperties(e.prototype, s), e)
}
function Ul(t) {
  return Wr(t, 'blessings').reduce((e, s) => {
    let i = s(t)
    for (let n in i) {
      let a = e[n] || {}
      e[n] = Object.assign(a, i[n])
    }
    return e
  }, {})
}
function jl(t, r) {
  return Gl(r).reduce((e, s) => {
    let i = Wl(t, r, s)
    return (i && Object.assign(e, { [s]: i }), e)
  }, {})
}
function Wl(t, r, e) {
  let s = Object.getOwnPropertyDescriptor(t, e)
  if (!(s && 'value' in s)) {
    let n = Object.getOwnPropertyDescriptor(r, e).value
    return (s && ((n.get = s.get || n.get), (n.set = s.set || n.set)), n)
  }
}
var Gl =
    typeof Object.getOwnPropertySymbols == 'function'
      ? (t) => [
          ...Object.getOwnPropertyNames(t),
          ...Object.getOwnPropertySymbols(t),
        ]
      : Object.getOwnPropertyNames,
  Yl = (() => {
    function t(e) {
      function s() {
        return Reflect.construct(e, arguments, new.target)
      }
      return (
        (s.prototype = Object.create(e.prototype, {
          constructor: { value: s },
        })),
        Reflect.setPrototypeOf(s, e),
        s
      )
    }
    function r() {
      let s = t(function () {
        this.a.call(this)
      })
      return ((s.prototype.a = function () {}), new s())
    }
    try {
      return (r(), t)
    } catch {
      return (s) => class extends s {}
    }
  })()
function Kl(t) {
  return {
    identifier: t.identifier,
    controllerConstructor: zl(t.controllerConstructor),
  }
}
var ki = class {
    constructor(r, e) {
      ;((this.application = r),
        (this.definition = Kl(e)),
        (this.contextsByScope = new WeakMap()),
        (this.connectedContexts = new Set()))
    }
    get identifier() {
      return this.definition.identifier
    }
    get controllerConstructor() {
      return this.definition.controllerConstructor
    }
    get contexts() {
      return Array.from(this.connectedContexts)
    }
    connectContextForScope(r) {
      let e = this.fetchContextForScope(r)
      ;(this.connectedContexts.add(e), e.connect())
    }
    disconnectContextForScope(r) {
      let e = this.contextsByScope.get(r)
      e && (this.connectedContexts.delete(e), e.disconnect())
    }
    fetchContextForScope(r) {
      let e = this.contextsByScope.get(r)
      return (e || ((e = new Pi(this, r)), this.contextsByScope.set(r, e)), e)
    }
  },
  Oi = class {
    constructor(r) {
      this.scope = r
    }
    has(r) {
      return this.data.has(this.getDataKey(r))
    }
    get(r) {
      return this.getAll(r)[0]
    }
    getAll(r) {
      let e = this.data.get(this.getDataKey(r)) || ''
      return Pl(e)
    }
    getAttributeName(r) {
      return this.data.getAttributeNameForKey(this.getDataKey(r))
    }
    getDataKey(r) {
      return `${r}-class`
    }
    get data() {
      return this.scope.data
    }
  },
  Ri = class {
    constructor(r) {
      this.scope = r
    }
    get element() {
      return this.scope.element
    }
    get identifier() {
      return this.scope.identifier
    }
    get(r) {
      let e = this.getAttributeNameForKey(r)
      return this.element.getAttribute(e)
    }
    set(r, e) {
      let s = this.getAttributeNameForKey(r)
      return (this.element.setAttribute(s, e), this.get(r))
    }
    has(r) {
      let e = this.getAttributeNameForKey(r)
      return this.element.hasAttribute(e)
    }
    delete(r) {
      if (this.has(r)) {
        let e = this.getAttributeNameForKey(r)
        return (this.element.removeAttribute(e), !0)
      } else return !1
    }
    getAttributeNameForKey(r) {
      return `data-${this.identifier}-${Kn(r)}`
    }
  },
  Hi = class {
    constructor(r) {
      ;((this.warnedKeysByObject = new WeakMap()), (this.logger = r))
    }
    warn(r, e, s) {
      let i = this.warnedKeysByObject.get(r)
      ;(i || ((i = new Set()), this.warnedKeysByObject.set(r, i)),
        i.has(e) || (i.add(e), this.logger.warn(s, r)))
    }
  }
function Di(t, r) {
  return `[${t}~="${r}"]`
}
var Bi = class {
    constructor(r) {
      this.scope = r
    }
    get element() {
      return this.scope.element
    }
    get identifier() {
      return this.scope.identifier
    }
    get schema() {
      return this.scope.schema
    }
    has(r) {
      return this.find(r) != null
    }
    find(...r) {
      return r.reduce(
        (e, s) => e || this.findTarget(s) || this.findLegacyTarget(s),
        void 0,
      )
    }
    findAll(...r) {
      return r.reduce(
        (e, s) => [
          ...e,
          ...this.findAllTargets(s),
          ...this.findAllLegacyTargets(s),
        ],
        [],
      )
    }
    findTarget(r) {
      let e = this.getSelectorForTargetName(r)
      return this.scope.findElement(e)
    }
    findAllTargets(r) {
      let e = this.getSelectorForTargetName(r)
      return this.scope.findAllElements(e)
    }
    getSelectorForTargetName(r) {
      let e = this.schema.targetAttributeForScope(this.identifier)
      return Di(e, r)
    }
    findLegacyTarget(r) {
      let e = this.getLegacySelectorForTargetName(r)
      return this.deprecate(this.scope.findElement(e), r)
    }
    findAllLegacyTargets(r) {
      let e = this.getLegacySelectorForTargetName(r)
      return this.scope.findAllElements(e).map((s) => this.deprecate(s, r))
    }
    getLegacySelectorForTargetName(r) {
      let e = `${this.identifier}.${r}`
      return Di(this.schema.targetAttribute, e)
    }
    deprecate(r, e) {
      if (r) {
        let { identifier: s } = this,
          i = this.schema.targetAttribute,
          n = this.schema.targetAttributeForScope(s)
        this.guide.warn(
          r,
          `target:${e}`,
          `Please replace ${i}="${s}.${e}" with ${n}="${e}". The ${i} attribute is deprecated and will be removed in a future version of Stimulus.`,
        )
      }
      return r
    }
    get guide() {
      return this.scope.guide
    }
  },
  Fi = class {
    constructor(r, e) {
      ;((this.scope = r), (this.controllerElement = e))
    }
    get element() {
      return this.scope.element
    }
    get identifier() {
      return this.scope.identifier
    }
    get schema() {
      return this.scope.schema
    }
    has(r) {
      return this.find(r) != null
    }
    find(...r) {
      return r.reduce((e, s) => e || this.findOutlet(s), void 0)
    }
    findAll(...r) {
      return r.reduce((e, s) => [...e, ...this.findAllOutlets(s)], [])
    }
    getSelectorForOutletName(r) {
      let e = this.schema.outletAttributeForScope(this.identifier, r)
      return this.controllerElement.getAttribute(e)
    }
    findOutlet(r) {
      let e = this.getSelectorForOutletName(r)
      if (e) return this.findElement(e, r)
    }
    findAllOutlets(r) {
      let e = this.getSelectorForOutletName(r)
      return e ? this.findAllElements(e, r) : []
    }
    findElement(r, e) {
      return this.scope
        .queryElements(r)
        .filter((i) => this.matchesElement(i, r, e))[0]
    }
    findAllElements(r, e) {
      return this.scope
        .queryElements(r)
        .filter((i) => this.matchesElement(i, r, e))
    }
    matchesElement(r, e, s) {
      let i = r.getAttribute(this.scope.schema.controllerAttribute) || ''
      return r.matches(e) && i.split(' ').includes(s)
    }
  },
  Vi = class t {
    constructor(r, e, s, i) {
      ;((this.targets = new Bi(this)),
        (this.classes = new Oi(this)),
        (this.data = new Ri(this)),
        (this.containsElement = (n) =>
          n.closest(this.controllerSelector) === this.element),
        (this.schema = r),
        (this.element = e),
        (this.identifier = s),
        (this.guide = new Hi(i)),
        (this.outlets = new Fi(this.documentScope, e)))
    }
    findElement(r) {
      return this.element.matches(r)
        ? this.element
        : this.queryElements(r).find(this.containsElement)
    }
    findAllElements(r) {
      return [
        ...(this.element.matches(r) ? [this.element] : []),
        ...this.queryElements(r).filter(this.containsElement),
      ]
    }
    queryElements(r) {
      return Array.from(this.element.querySelectorAll(r))
    }
    get controllerSelector() {
      return Di(this.schema.controllerAttribute, this.identifier)
    }
    get isDocumentScope() {
      return this.element === document.documentElement
    }
    get documentScope() {
      return this.isDocumentScope
        ? this
        : new t(
            this.schema,
            document.documentElement,
            this.identifier,
            this.guide.logger,
          )
    }
  },
  _i = class {
    constructor(r, e, s) {
      ;((this.element = r),
        (this.schema = e),
        (this.delegate = s),
        (this.valueListObserver = new Vs(
          this.element,
          this.controllerAttribute,
          this,
        )),
        (this.scopesByIdentifierByElement = new WeakMap()),
        (this.scopeReferenceCounts = new WeakMap()))
    }
    start() {
      this.valueListObserver.start()
    }
    stop() {
      this.valueListObserver.stop()
    }
    get controllerAttribute() {
      return this.schema.controllerAttribute
    }
    parseValueForToken(r) {
      let { element: e, content: s } = r
      return this.parseValueForElementAndIdentifier(e, s)
    }
    parseValueForElementAndIdentifier(r, e) {
      let s = this.fetchScopesByIdentifierForElement(r),
        i = s.get(e)
      return (
        i ||
          ((i = this.delegate.createScopeForElementAndIdentifier(r, e)),
          s.set(e, i)),
        i
      )
    }
    elementMatchedValue(r, e) {
      let s = (this.scopeReferenceCounts.get(e) || 0) + 1
      ;(this.scopeReferenceCounts.set(e, s),
        s == 1 && this.delegate.scopeConnected(e))
    }
    elementUnmatchedValue(r, e) {
      let s = this.scopeReferenceCounts.get(e)
      s &&
        (this.scopeReferenceCounts.set(e, s - 1),
        s == 1 && this.delegate.scopeDisconnected(e))
    }
    fetchScopesByIdentifierForElement(r) {
      let e = this.scopesByIdentifierByElement.get(r)
      return (
        e || ((e = new Map()), this.scopesByIdentifierByElement.set(r, e)),
        e
      )
    }
  },
  $i = class {
    constructor(r) {
      ;((this.application = r),
        (this.scopeObserver = new _i(this.element, this.schema, this)),
        (this.scopesByIdentifier = new mt()),
        (this.modulesByIdentifier = new Map()))
    }
    get element() {
      return this.application.element
    }
    get schema() {
      return this.application.schema
    }
    get logger() {
      return this.application.logger
    }
    get controllerAttribute() {
      return this.schema.controllerAttribute
    }
    get modules() {
      return Array.from(this.modulesByIdentifier.values())
    }
    get contexts() {
      return this.modules.reduce((r, e) => r.concat(e.contexts), [])
    }
    start() {
      this.scopeObserver.start()
    }
    stop() {
      this.scopeObserver.stop()
    }
    loadDefinition(r) {
      this.unloadIdentifier(r.identifier)
      let e = new ki(this.application, r)
      this.connectModule(e)
      let s = r.controllerConstructor.afterLoad
      s && s.call(r.controllerConstructor, r.identifier, this.application)
    }
    unloadIdentifier(r) {
      let e = this.modulesByIdentifier.get(r)
      e && this.disconnectModule(e)
    }
    getContextForElementAndIdentifier(r, e) {
      let s = this.modulesByIdentifier.get(e)
      if (s) return s.contexts.find((i) => i.element == r)
    }
    proposeToConnectScopeForElementAndIdentifier(r, e) {
      let s = this.scopeObserver.parseValueForElementAndIdentifier(r, e)
      s
        ? this.scopeObserver.elementMatchedValue(s.element, s)
        : console.error(
            `Couldn't find or create scope for identifier: "${e}" and element:`,
            r,
          )
    }
    handleError(r, e, s) {
      this.application.handleError(r, e, s)
    }
    createScopeForElementAndIdentifier(r, e) {
      return new Vi(this.schema, r, e, this.logger)
    }
    scopeConnected(r) {
      this.scopesByIdentifier.add(r.identifier, r)
      let e = this.modulesByIdentifier.get(r.identifier)
      e && e.connectContextForScope(r)
    }
    scopeDisconnected(r) {
      this.scopesByIdentifier.delete(r.identifier, r)
      let e = this.modulesByIdentifier.get(r.identifier)
      e && e.disconnectContextForScope(r)
    }
    connectModule(r) {
      ;(this.modulesByIdentifier.set(r.identifier, r),
        this.scopesByIdentifier
          .getValuesForKey(r.identifier)
          .forEach((s) => r.connectContextForScope(s)))
    }
    disconnectModule(r) {
      ;(this.modulesByIdentifier.delete(r.identifier),
        this.scopesByIdentifier
          .getValuesForKey(r.identifier)
          .forEach((s) => r.disconnectContextForScope(s)))
    }
  },
  Xl = {
    controllerAttribute: 'data-controller',
    actionAttribute: 'data-action',
    targetAttribute: 'data-target',
    targetAttributeForScope: (t) => `data-${t}-target`,
    outletAttributeForScope: (t, r) => `data-${t}-${r}-outlet`,
    keyMappings: Object.assign(
      Object.assign(
        {
          enter: 'Enter',
          tab: 'Tab',
          esc: 'Escape',
          space: ' ',
          up: 'ArrowUp',
          down: 'ArrowDown',
          left: 'ArrowLeft',
          right: 'ArrowRight',
          home: 'Home',
          end: 'End',
          page_up: 'PageUp',
          page_down: 'PageDown',
        },
        qn('abcdefghijklmnopqrstuvwxyz'.split('').map((t) => [t, t])),
      ),
      qn('0123456789'.split('').map((t) => [t, t])),
    ),
  }
function qn(t) {
  return t.reduce(
    (r, [e, s]) => Object.assign(Object.assign({}, r), { [e]: s }),
    {},
  )
}
var _s = class {
  constructor(r = document.documentElement, e = Xl) {
    ;((this.logger = console),
      (this.debug = !1),
      (this.logDebugActivity = (s, i, n = {}) => {
        this.debug && this.logFormattedMessage(s, i, n)
      }),
      (this.element = r),
      (this.schema = e),
      (this.dispatcher = new bi(this)),
      (this.router = new $i(this)),
      (this.actionDescriptorFilters = Object.assign({}, wl)))
  }
  static start(r, e) {
    let s = new this(r, e)
    return (s.start(), s)
  }
  async start() {
    ;(await Ql(),
      this.logDebugActivity('application', 'starting'),
      this.dispatcher.start(),
      this.router.start(),
      this.logDebugActivity('application', 'start'))
  }
  stop() {
    ;(this.logDebugActivity('application', 'stopping'),
      this.dispatcher.stop(),
      this.router.stop(),
      this.logDebugActivity('application', 'stop'))
  }
  register(r, e) {
    this.load({ identifier: r, controllerConstructor: e })
  }
  registerActionOption(r, e) {
    this.actionDescriptorFilters[r] = e
  }
  load(r, ...e) {
    ;(Array.isArray(r) ? r : [r, ...e]).forEach((i) => {
      i.controllerConstructor.shouldLoad && this.router.loadDefinition(i)
    })
  }
  unload(r, ...e) {
    ;(Array.isArray(r) ? r : [r, ...e]).forEach((i) =>
      this.router.unloadIdentifier(i),
    )
  }
  get controllers() {
    return this.router.contexts.map((r) => r.controller)
  }
  getControllerForElementAndIdentifier(r, e) {
    let s = this.router.getContextForElementAndIdentifier(r, e)
    return s ? s.controller : null
  }
  handleError(r, e, s) {
    var i
    ;(this.logger.error(
      `%s

%o

%o`,
      e,
      r,
      s,
    ),
      (i = window.onerror) === null ||
        i === void 0 ||
        i.call(window, e, '', 0, 0, r))
  }
  logFormattedMessage(r, e, s = {}) {
    ;((s = Object.assign({ application: this }, s)),
      this.logger.groupCollapsed(`${r} #${e}`),
      this.logger.log('details:', Object.assign({}, s)),
      this.logger.groupEnd())
  }
}
function Ql() {
  return new Promise((t) => {
    document.readyState == 'loading'
      ? document.addEventListener('DOMContentLoaded', () => t())
      : t()
  })
}
function Jl(t) {
  return Wr(t, 'classes').reduce((e, s) => Object.assign(e, Zl(s)), {})
}
function Zl(t) {
  return {
    [`${t}Class`]: {
      get() {
        let { classes: r } = this
        if (r.has(t)) return r.get(t)
        {
          let e = r.getAttributeName(t)
          throw new Error(`Missing attribute "${e}"`)
        }
      },
    },
    [`${t}Classes`]: {
      get() {
        return this.classes.getAll(t)
      },
    },
    [`has${jr(t)}Class`]: {
      get() {
        return this.classes.has(t)
      },
    },
  }
}
function ec(t) {
  return Wr(t, 'outlets').reduce((e, s) => Object.assign(e, tc(s)), {})
}
function Un(t, r, e) {
  return t.application.getControllerForElementAndIdentifier(r, e)
}
function jn(t, r, e) {
  let s = Un(t, r, e)
  if (
    s ||
    (t.application.router.proposeToConnectScopeForElementAndIdentifier(r, e),
    (s = Un(t, r, e)),
    s)
  )
    return s
}
function tc(t) {
  let r = Ti(t)
  return {
    [`${r}Outlet`]: {
      get() {
        let e = this.outlets.find(t),
          s = this.outlets.getSelectorForOutletName(t)
        if (e) {
          let i = jn(this, e, t)
          if (i) return i
          throw new Error(
            `The provided outlet element is missing an outlet controller "${t}" instance for host controller "${this.identifier}"`,
          )
        }
        throw new Error(
          `Missing outlet element "${t}" for host controller "${this.identifier}". Stimulus couldn't find a matching outlet element using selector "${s}".`,
        )
      },
    },
    [`${r}Outlets`]: {
      get() {
        let e = this.outlets.findAll(t)
        return e.length > 0
          ? e
              .map((s) => {
                let i = jn(this, s, t)
                if (i) return i
                console.warn(
                  `The provided outlet element is missing an outlet controller "${t}" instance for host controller "${this.identifier}"`,
                  s,
                )
              })
              .filter((s) => s)
          : []
      },
    },
    [`${r}OutletElement`]: {
      get() {
        let e = this.outlets.find(t),
          s = this.outlets.getSelectorForOutletName(t)
        if (e) return e
        throw new Error(
          `Missing outlet element "${t}" for host controller "${this.identifier}". Stimulus couldn't find a matching outlet element using selector "${s}".`,
        )
      },
    },
    [`${r}OutletElements`]: {
      get() {
        return this.outlets.findAll(t)
      },
    },
    [`has${jr(r)}Outlet`]: {
      get() {
        return this.outlets.has(t)
      },
    },
  }
}
function rc(t) {
  return Wr(t, 'targets').reduce((e, s) => Object.assign(e, sc(s)), {})
}
function sc(t) {
  return {
    [`${t}Target`]: {
      get() {
        let r = this.targets.find(t)
        if (r) return r
        throw new Error(
          `Missing target element "${t}" for "${this.identifier}" controller`,
        )
      },
    },
    [`${t}Targets`]: {
      get() {
        return this.targets.findAll(t)
      },
    },
    [`has${jr(t)}Target`]: {
      get() {
        return this.targets.has(t)
      },
    },
  }
}
function ic(t) {
  let r = _l(t, 'values'),
    e = {
      valueDescriptorMap: {
        get() {
          return r.reduce((s, i) => {
            let n = Jn(i, this.identifier),
              a = this.data.getAttributeNameForKey(n.key)
            return Object.assign(s, { [a]: n })
          }, {})
        },
      },
    }
  return r.reduce((s, i) => Object.assign(s, nc(i)), e)
}
function nc(t, r) {
  let e = Jn(t, r),
    { key: s, name: i, reader: n, writer: a } = e
  return {
    [i]: {
      get() {
        let l = this.data.get(s)
        return l !== null ? n(l) : e.defaultValue
      },
      set(l) {
        l === void 0 ? this.data.delete(s) : this.data.set(s, a(l))
      },
    },
    [`has${jr(i)}`]: {
      get() {
        return this.data.has(s) || e.hasCustomDefaultValue
      },
    },
  }
}
function Jn([t, r], e) {
  return cc({ controller: e, token: t, typeDefinition: r })
}
function $s(t) {
  switch (t) {
    case Array:
      return 'array'
    case Boolean:
      return 'boolean'
    case Number:
      return 'number'
    case Object:
      return 'object'
    case String:
      return 'string'
  }
}
function Ur(t) {
  switch (typeof t) {
    case 'boolean':
      return 'boolean'
    case 'number':
      return 'number'
    case 'string':
      return 'string'
  }
  if (Array.isArray(t)) return 'array'
  if (Object.prototype.toString.call(t) === '[object Object]') return 'object'
}
function ac(t) {
  let { controller: r, token: e, typeObject: s } = t,
    i = $n(s.type),
    n = $n(s.default),
    a = i && n,
    l = i && !n,
    o = !i && n,
    u = $s(s.type),
    h = Ur(t.typeObject.default)
  if (l) return u
  if (o) return h
  if (u !== h) {
    let f = r ? `${r}.${e}` : e
    throw new Error(
      `The specified default value for the Stimulus Value "${f}" must match the defined type "${u}". The provided default value of "${s.default}" is of type "${h}".`,
    )
  }
  if (a) return u
}
function oc(t) {
  let { controller: r, token: e, typeDefinition: s } = t,
    n = ac({ controller: r, token: e, typeObject: s }),
    a = Ur(s),
    l = $s(s),
    o = n || a || l
  if (o) return o
  let u = r ? `${r}.${s}` : e
  throw new Error(`Unknown value type "${u}" for "${e}" value`)
}
function lc(t) {
  let r = $s(t)
  if (r) return Wn[r]
  let e = Si(t, 'default'),
    s = Si(t, 'type'),
    i = t
  if (e) return i.default
  if (s) {
    let { type: n } = i,
      a = $s(n)
    if (a) return Wn[a]
  }
  return t
}
function cc(t) {
  let { token: r, typeDefinition: e } = t,
    s = `${Kn(r)}-value`,
    i = oc(t)
  return {
    type: i,
    key: s,
    name: Ni(s),
    get defaultValue() {
      return lc(e)
    },
    get hasCustomDefaultValue() {
      return Ur(e) !== void 0
    },
    reader: dc[i],
    writer: Gn[i] || Gn.default,
  }
}
var Wn = {
    get array() {
      return []
    },
    boolean: !1,
    number: 0,
    get object() {
      return {}
    },
    string: '',
  },
  dc = {
    array(t) {
      let r = JSON.parse(t)
      if (!Array.isArray(r))
        throw new TypeError(
          `expected value of type "array" but instead got value "${t}" of type "${Ur(r)}"`,
        )
      return r
    },
    boolean(t) {
      return !(t == '0' || String(t).toLowerCase() == 'false')
    },
    number(t) {
      return Number(t.replace(/_/g, ''))
    },
    object(t) {
      let r = JSON.parse(t)
      if (r === null || typeof r != 'object' || Array.isArray(r))
        throw new TypeError(
          `expected value of type "object" but instead got value "${t}" of type "${Ur(r)}"`,
        )
      return r
    },
    string(t) {
      return t
    },
  },
  Gn = { default: uc, array: Yn, object: Yn }
function Yn(t) {
  return JSON.stringify(t)
}
function uc(t) {
  return `${t}`
}
var _ = class {
  constructor(r) {
    this.context = r
  }
  static get shouldLoad() {
    return !0
  }
  static afterLoad(r, e) {}
  get application() {
    return this.context.application
  }
  get scope() {
    return this.context.scope
  }
  get element() {
    return this.scope.element
  }
  get identifier() {
    return this.scope.identifier
  }
  get targets() {
    return this.scope.targets
  }
  get outlets() {
    return this.scope.outlets
  }
  get classes() {
    return this.scope.classes
  }
  get data() {
    return this.scope.data
  }
  initialize() {}
  connect() {}
  disconnect() {}
  dispatch(
    r,
    {
      target: e = this.element,
      detail: s = {},
      prefix: i = this.identifier,
      bubbles: n = !0,
      cancelable: a = !0,
    } = {},
  ) {
    let l = i ? `${i}:${r}` : r,
      o = new CustomEvent(l, { detail: s, bubbles: n, cancelable: a })
    return (e.dispatchEvent(o), o)
  }
}
_.blessings = [Jl, rc, ic, ec]
_.targets = []
_.outlets = []
_.values = {}
var pt = class {
  static getFiltersFromUrl(r) {
    let e = {}
    r.forEach((n, a) => {
      if (a.startsWith('filter.')) {
        let l = a.replace('filter.', '')
        e[l] || (e[l] = [])
      }
    })
    let s = Array.from(r.keys()).filter((n) => n.startsWith('filter.'))
    return (
      [...new Set(s)].forEach((n) => {
        let a = n.replace('filter.', '')
        e[a] = r.getAll(n)
      }),
      e
    )
  }
  static convertToSearchspringFilters(r) {
    let e = []
    return (
      Object.entries(r).forEach(([s, i]) => {
        i.forEach((n) => {
          e.push({ type: 'value', field: s, value: n })
        })
      }),
      e
    )
  }
  static getMerchandisingSegmentsFromUrl(r) {
    let e = 'merch.segment/'
    return r
      .getAll('tag')
      .filter((s) => s.startsWith(e))
      .map((s) => s.slice(e.length))
      .filter(Boolean)
  }
  static getUrlForToggle(r, e) {
    let s = new URL(window.location.href),
      i = `filter.${r}`,
      n = s.searchParams.getAll(i)
    s.searchParams.delete(i)
    let a = [...n]
    return (
      a.includes(e) ? (a = a.filter((l) => l !== e)) : a.push(e),
      a.forEach((l) => s.searchParams.append(i, l)),
      s.searchParams.delete('page'),
      s.toString()
    )
  }
}
var fc = new Set(['GET', 'HEAD', 'OPTIONS']),
  hc = { NONE: 0, SHORT: 10 * 1e3, DEFAULT: 60 * 1e3, LONG: 3600 * 1e3 },
  Ns = new Map()
function Zn(t, r) {
  if (r.cacheKey) return r.cacheKey
  let e = (r.method ?? 'GET').toUpperCase(),
    s =
      r.body != null
        ? typeof r.body == 'string'
          ? r.body
          : JSON.stringify(r.body)
        : ''
  return `${e}:${t}:${s}`
}
function mc() {
  let t = Date.now()
  for (let [r, e] of Ns.entries()) e.expires <= t && Ns.delete(r)
}
var ea = !1
function pc() {
  ea || ((ea = !0), setInterval(mc, 300 * 1e3))
}
async function ir(t, r = {}) {
  pc()
  let { strategy: e = 'DEFAULT', cacheKey: s, ...i } = r,
    n = (i.method ?? 'GET').toUpperCase(),
    a = Date.now(),
    l = e !== 'NONE' && (fc.has(n) || s != null)
  if (l) {
    let f = Zn(t, r),
      m = Ns.get(f)
    if (m && m.expires > a)
      return new Response(m.body, {
        status: m.status,
        statusText: m.statusText,
        headers: new Headers(m.headers),
      })
  }
  let o = await fetch(t, i)
  if (!l || !o.ok) return o
  let u = await o.text(),
    h = Zn(t, r)
  return (
    Ns.set(h, {
      expires: a + hc[e],
      body: u,
      status: o.status,
      statusText: o.statusText,
      headers: Array.from(o.headers.entries()),
    }),
    new Response(u, {
      status: o.status,
      statusText: o.statusText,
      headers: o.headers,
    })
  )
}
var gc = /^(?:[a-z][a-z\d+.-]*:)?\/\//i
function vc(t) {
  let r = t && t.length > 0 ? t : '/',
    e = r.startsWith('/') ? r : `/${r}`
  return e.endsWith('/') ? e : `${e}/`
}
function yc(t) {
  return t.replace(/^\/+/, '')
}
function de(t) {
  if (gc.test(t)) return t
  let r = vc(window.Shopify?.routes?.root)
  return t
    ? t.startsWith('?') || t.startsWith('#')
      ? `${r}${t}`
      : `${r}${yc(t)}`
    : r
}
var ra = 'product-card-ssr'
var Yr = [500, 1500]
function ta(t, r) {
  return new Promise((e) => {
    if (r?.aborted) return e()
    let s = setTimeout(e, t)
    r?.addEventListener(
      'abort',
      () => {
        ;(clearTimeout(s), e())
      },
      { once: !0 },
    )
  })
}
function bc(t) {
  return t instanceof DOMException && t.name === 'AbortError'
}
function tt(t) {
  let r = t.match(/\/products\/([^/?#]+)/)
  return r ? r[1] : null
}
function Tc(t) {
  return de(`/products/${encodeURIComponent(t)}?sections=${ra}`)
}
async function Rt(t, r, e = Yr.length + 1) {
  let s = Tc(t)
  for (let i = 0; i < e; i++) {
    if (r?.aborted) return null
    try {
      let n = await ir(s, { strategy: 'LONG', signal: r })
      if (n.status >= 400 && n.status < 500) return null
      if (!n.ok) {
        if (i < e - 1 && i < Yr.length) {
          await ta(Yr[i], r)
          continue
        }
        return null
      }
      return (await n.json())[ra] ?? null
    } catch (n) {
      if (bc(n)) return null
      if (i < e - 1 && i < Yr.length) {
        await ta(Yr[i], r)
        continue
      }
      return null
    }
  }
  return null
}
var Pe = class {
  static productCardSkeleton(r) {
    return `<div class="product-card-placeholder animate-pulse" data-handle="${r}" data-is-skeleton="true">
      <div class="w-full aspect-2/3 bg-gray-100 rounded"></div>
      <div class="mt-4 space-y-2">
        <div class="h-3 bg-gray-100 rounded w-1/3"></div>
        <div class="h-4 bg-gray-100 rounded w-2/3"></div>
        <div class="h-3 bg-gray-100 rounded w-1/4"></div>
      </div>
    </div>`
  }
  static productCard(r) {
    let e = r.imageUrl
      ? `<div class="collection-product__image-wrapper">
          <img src="${r.imageUrl}" width="400" height="400" class="collection-product__image" loading="lazy" alt="${r.name}" />
        </div>`
      : ''
    return `
        <div class="collection-product">
          <a href="${r.url}" class="collection-product__link">
            ${e}
            <div class="collection-product__content">
              <p class="collection-product__title">${r.name}</p>
              <p class="collection-product__price">$${r.price}</p>
            </div>
          </a>
        </div>
      `
  }
  static carouselSlide(r, e, s) {
    return `<div class="swiper-slide" role="group" aria-label="${e + 1} / ${s}">${r}</div>`
  }
  static checkmarkIcon() {
    return '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 14 14" fill="none" height="14" width="14" class="transition-opacity shrink-0 opacity-100" aria-hidden="true"><title>Check</title><use href="#icon-checkmark-filled"></use></svg>'
  }
  static chevronDownIcon() {
    return `<svg
              class="w-4 h-4 transform transition-transform duration-200"
              data-collapsible-target="icon"
              viewBox="0 0 20 20"
              fill="none"
              aria-hidden="true"
            >
              <use href="#icon-chevron-down"></use>
            </svg>`
  }
  static facetPill(r) {
    let e = r.isActive
      ? 'text-xs font-medium text-white bg-black border border-gray-300 rounded-full min-w-8 h-8 flex items-center justify-center text-center'
      : 'text-xs font-medium border border-transparent hover:border-gray-300 transition-all duration-200 rounded-full min-w-8 h-8 flex items-center justify-center text-center'
    return `
          <a href="${r.url}"
            class="${e}"
            data-action="click->${r.controllerName}#handleFilterClick"
            aria-label="Filter by ${r.value}"
          >
            ${r.value.replace(' Plus', '')}
          </a>
        `
  }
  static pillFilterGrid(r) {
    return `<div class="grid grid-cols-6 gap-1">${r}</div>`
  }
  static facetListItem(r) {
    let e = r.isActive ? 'text-primary font-medium' : 'text-primary/70',
      s = r.isActive ? this.checkmarkIcon() : ''
    return `
           <li class="ss-facet-item py-2.5 md:py-0 mb-2 md:mb-2.5">
             <a href="${r.url}"
                class="ss-facet-link flex items-center gap-2 hover:underline underline-offset-1 text-body-light transition-colors ${e}"
                data-action="click->${r.controllerName}#handleFilterClick"
             >
             <span class="ss-facet-label capitalize">${r.label}</span>
             ${s}
             </a>
           </li>
         `
  }
  static facetCollapsible(r) {
    let e = r.contentTag ?? 'div',
      s = r.contentClass ?? ''
    return `
          <div class="ss-facet-group mb-6" data-controller="collapsible" data-field="${r.field}">
             <button
               type="button"
               class="ss-facet-title font-bold mb-2 capitalize w-full text-left flex items-center justify-between py-2 text-lg hover:text-primary/50 transition-colors cursor-pointer"
               data-action="click->collapsible#toggle"
               data-collapsible-target="collapsibleTrigger"
               aria-expanded="false"
             >
               <span>${r.label}</span>
               ${this.chevronDownIcon()}
             </button>
             <${e} class="${s} hidden" data-collapsible-target="collapsibleContent">
               ${r.content}
             </${e}>
          </div>
        `
  }
  static sortOption(r) {
    return `<option value="${`${r.field}:${r.direction}`}" ${r.isActive ? 'selected' : ''}>${r.label}</option>`
  }
}
var nr = { ANALYTICS: 'C0002', PREFERENCES: 'C0003', MARKETING: 'C0004' }
function ar(t) {
  let r = window.OnetrustActiveGroups
  return r
    ? r
        .split(',')
        .map((e) => e.trim())
        .includes(t)
    : !1
}
function sa(t, r) {
  if (ar(nr.ANALYTICS))
    try {
      window.posthog?.capture(t, r)
    } catch (e) {
      console.warn('[PostHog] Failed to capture event', t, e)
    }
}
var Sc = 5,
  Ec = 3,
  Ee = class {
    static applyCardImageLoadingStrategy(r, e) {
      let s = r.querySelectorAll('.swiper-slide img')
      if (s.length > 0) {
        s.forEach((n, a) => {
          let l = e && a === 0
          ;(n.setAttribute('loading', l ? 'eager' : 'lazy'),
            n.setAttribute('decoding', 'async'),
            l
              ? n.setAttribute('fetchpriority', 'high')
              : n.removeAttribute('fetchpriority'))
        })
        return
      }
      let i = r.querySelector('img')
      i &&
        (i.setAttribute('loading', e ? 'eager' : 'lazy'),
        i.setAttribute('decoding', 'async'),
        e
          ? i.setAttribute('fetchpriority', 'high')
          : i.removeAttribute('fetchpriority'))
    }
    static renderProductSkeletons(r, e = []) {
      if (!r || r.length === 0) return '<p>No products found.</p>'
      let s = r.map((o) => {
        let u = o.mappings?.core || o,
          h = tt(u.url) ?? ''
        return Pe.productCardSkeleton(h)
      })
      if (!e?.length) return s.join('')
      let i = new Map()
      for (let o of e) {
        let u = o.value?.trim()
        if (!u) continue
        let h = o.config?.position?.index ?? 0
        ;(i.has(h) || i.set(h, []), i.get(h).push(u))
      }
      if (i.size === 0) return s.join('')
      let n = Array.from(i.keys()).sort((o, u) => o - u),
        a = [],
        l = 0
      for (let o of n) {
        for (; l < o && l < s.length; ) (a.push(s[l]), l++)
        a.push(...i.get(o))
      }
      for (; l < s.length; ) (a.push(s[l]), l++)
      return a.join('')
    }
    static async hydrateProductCards(r, e, s, i = 0, n) {
      if (!e || e.length === 0) return
      let a = new Map()
      for (let f of e) {
        let m = f.mappings?.core || f,
          c = tt(m.url)
        c && !a.has(c) && a.set(c, f)
      }
      let l = Array.from(a.keys()).map((f, m) => ({
        handle: f,
        index: m,
        attempts: 0,
      }))
      if (l.length === 0) return
      let o = [...l],
        u = async () => {
          for (; o.length > 0; ) {
            if (s?.aborted) return
            let f = o.shift()
            if (!f) return
            let m = await Rt(f.handle, s, 1)
            if (s?.aborted) return
            if (m) {
              this.swapCard(r, f, m, i, a, n)
              continue
            }
            if (((f.attempts += 1), f.attempts < Ec)) {
              o.unshift(f)
              continue
            }
            sa('plp_product_card_hydration_failed', {
              handle: f.handle,
              position: f.index,
              attempts: f.attempts,
              module: n?.module,
              tag: n?.tag,
            })
          }
        },
        h = Math.min(Sc, l.length)
      await Promise.all(Array.from({ length: h }, () => u()))
    }
    static swapCard(r, e, s, i, n, a) {
      let l = r.querySelector(
        `[data-handle="${e.handle}"][data-is-skeleton="true"]`,
      )
      if (!l) return
      let o = document.createElement('div')
      o.innerHTML = s
      let u = o.firstElementChild
      if (u) {
        if ((this.applyCardImageLoadingStrategy(u, e.index < i), a)) {
          let h = n.get(e.handle)
          h && this.applyTrackingAttributes(u, h, a)
        }
        l.replaceWith(u)
      }
    }
    static applyTrackingAttributes(r, e, s) {
      let i = e.mappings?.core || e,
        n = i.uid != null ? String(i.uid) : ''
      if (!n) return
      let a = r.getAttribute('data-controller') ?? '',
        l = new Set(a.split(/\s+/).filter(Boolean))
      ;(l.add('product-card-tracking'),
        r.setAttribute('data-controller', Array.from(l).join(' ')))
      let o = r.getAttribute('data-action') ?? '',
        u = new Set(o.split(/\s+/).filter(Boolean))
      ;(u.add('click->product-card-tracking#onClick'),
        r.setAttribute('data-action', Array.from(u).join(' ')),
        r.setAttribute('data-product-card-tracking-module-value', s.module),
        r.setAttribute(
          'data-product-card-tracking-response-id-value',
          s.responseId,
        ),
        s.tag && r.setAttribute('data-product-card-tracking-tag-value', s.tag),
        r.setAttribute('data-product-card-tracking-parent-id-value', n),
        r.setAttribute('data-product-card-tracking-uid-value', n),
        i.sku &&
          r.setAttribute('data-product-card-tracking-sku-value', String(i.sku)),
        typeof i.price == 'number' &&
          r.setAttribute(
            'data-product-card-tracking-price-value',
            String(i.price),
          ))
    }
    static renderProducts(r) {
      return !r || r.length === 0
        ? '<p>No products found.</p>'
        : r
            .map((e) => {
              let s = e.mappings?.core || e,
                i = typeof s.price == 'number' ? s.price.toFixed(2) : s.price
              return Pe.productCard({
                url: s.url,
                name: s.name,
                price: String(i),
                imageUrl: s.imageUrl || void 0,
              })
            })
            .join('')
    }
    static renderPillFilterGrid(r, e, s) {
      if (!r.values) return ''
      let i = r.values
        .map((n) => {
          let a = pt.getUrlForToggle(r.field, n.value),
            l = e.includes(n.value)
          return Pe.facetPill({
            url: a,
            value: n.value,
            isActive: l,
            controllerName: s,
          })
        })
        .join('')
      return Pe.pillFilterGrid(i)
    }
    static renderFacets(r, e, s = 'collection') {
      if (!r || r.length === 0) return ''
      let i = new URL(window.location.href).searchParams,
        n = ['ss_size_jean', 'ss_size_apparel', 'ss_size'],
        a = {}
      return (
        i.forEach((l, o) => {
          if (o.startsWith('filter.')) {
            let u = o.replace('filter.', '')
            ;(a[u] || (a[u] = []), a[u].push(l))
          }
        }),
        r
          .map((l) => {
            if (!l.values || l.values.length === 0) return ''
            let o = a[l.field] || [],
              u = e?.[l.field]?.label || l.field,
              h = o.length > 0 ? `${u} (${o.length})` : (u ?? '')
            if (n.includes(l.field)) {
              let m = this.renderPillFilterGrid(l, o, s)
              return Pe.facetCollapsible({
                field: l.field,
                label: h,
                content: m,
                contentClass: 'ss-facet-grid',
              })
            }
            let f = l.values
              .map((m) => {
                let c = pt.getUrlForToggle(l.field, m.value),
                  d = o.includes(m.value)
                return Pe.facetListItem({
                  url: c,
                  label: m.label,
                  isActive: d,
                  controllerName: s,
                })
              })
              .join('')
            return Pe.facetCollapsible({
              field: l.field,
              label: h,
              content: f,
              contentTag: 'ul',
              contentClass: 'ss-facet-list',
            })
          })
          .join('')
      )
    }
    static renderSortingOptions(r, e, s) {
      return (
        (r = r.filter((i) => i.label !== 'Best Match')),
        !r || r.length === 0
          ? ''
          : r
              .map((i) => {
                let n = i.field === e && i.direction === s
                return Pe.sortOption({
                  field: i.field,
                  direction: i.direction,
                  label: i.label,
                  isActive: n,
                })
              })
              .join('')
      )
    }
  }
function ue(t) {
  return t
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;')
    .replace(/'/g, '&#39;')
}
var {
    entries: ga,
    setPrototypeOf: ia,
    isFrozen: xc,
    getPrototypeOf: wc,
    getOwnPropertyDescriptor: Mc,
  } = Object,
  { freeze: Me, seal: ze, create: lr } = Object,
  { apply: Gi, construct: Yi } = typeof Reflect < 'u' && Reflect
Me ||
  (Me = function (r) {
    return r
  })
ze ||
  (ze = function (r) {
    return r
  })
Gi ||
  (Gi = function (r, e) {
    for (
      var s = arguments.length, i = new Array(s > 2 ? s - 2 : 0), n = 2;
      n < s;
      n++
    )
      i[n - 2] = arguments[n]
    return r.apply(e, i)
  })
Yi ||
  (Yi = function (r) {
    for (
      var e = arguments.length, s = new Array(e > 1 ? e - 1 : 0), i = 1;
      i < e;
      i++
    )
      s[i - 1] = arguments[i]
    return new r(...s)
  })
var Kr = fe(Array.prototype.forEach),
  Lc = fe(Array.prototype.lastIndexOf),
  na = fe(Array.prototype.pop),
  Xr = fe(Array.prototype.push),
  Cc = fe(Array.prototype.splice),
  we = Array.isArray,
  Zr = fe(String.prototype.toLowerCase),
  zi = fe(String.prototype.toString),
  aa = fe(String.prototype.match),
  or = fe(String.prototype.replace),
  oa = fe(String.prototype.indexOf),
  Ac = fe(String.prototype.trim),
  Ic = fe(Number.prototype.toString),
  Pc = fe(Boolean.prototype.toString),
  la = typeof BigInt > 'u' ? null : fe(BigInt.prototype.toString),
  ca = typeof Symbol > 'u' ? null : fe(Symbol.prototype.toString),
  le = fe(Object.prototype.hasOwnProperty),
  Qr = fe(Object.prototype.toString),
  Te = fe(RegExp.prototype.test),
  zs = kc(TypeError)
function fe(t) {
  return function (r) {
    r instanceof RegExp && (r.lastIndex = 0)
    for (
      var e = arguments.length, s = new Array(e > 1 ? e - 1 : 0), i = 1;
      i < e;
      i++
    )
      s[i - 1] = arguments[i]
    return Gi(t, r, s)
  }
}
function kc(t) {
  return function () {
    for (var r = arguments.length, e = new Array(r), s = 0; s < r; s++)
      e[s] = arguments[s]
    return Yi(t, e)
  }
}
function K(t, r) {
  let e = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : Zr
  if ((ia && ia(t, null), !we(r))) return t
  let s = r.length
  for (; s--; ) {
    let i = r[s]
    if (typeof i == 'string') {
      let n = e(i)
      n !== i && (xc(r) || (r[s] = n), (i = n))
    }
    t[i] = !0
  }
  return t
}
function Oc(t) {
  for (let r = 0; r < t.length; r++) le(t, r) || (t[r] = null)
  return t
}
function ke(t) {
  let r = lr(null)
  for (let [e, s] of ga(t))
    le(t, e) &&
      (we(s)
        ? (r[e] = Oc(s))
        : s && typeof s == 'object' && s.constructor === Object
          ? (r[e] = ke(s))
          : (r[e] = s))
  return r
}
function Rc(t) {
  switch (typeof t) {
    case 'string':
      return t
    case 'number':
      return Ic(t)
    case 'boolean':
      return Pc(t)
    case 'bigint':
      return la ? la(t) : '0'
    case 'symbol':
      return ca ? ca(t) : 'Symbol()'
    case 'undefined':
      return Qr(t)
    case 'function':
    case 'object': {
      if (t === null) return Qr(t)
      let r = t,
        e = cr(r, 'toString')
      if (typeof e == 'function') {
        let s = e(r)
        return typeof s == 'string' ? s : Qr(s)
      }
      return Qr(t)
    }
    default:
      return Qr(t)
  }
}
function cr(t, r) {
  for (; t !== null; ) {
    let s = Mc(t, r)
    if (s) {
      if (s.get) return fe(s.get)
      if (typeof s.value == 'function') return fe(s.value)
    }
    t = wc(t)
  }
  function e() {
    return null
  }
  return e
}
function Hc(t) {
  try {
    return (Te(t, ''), !0)
  } catch {
    return !1
  }
}
var da = Me([
    'a',
    'abbr',
    'acronym',
    'address',
    'area',
    'article',
    'aside',
    'audio',
    'b',
    'bdi',
    'bdo',
    'big',
    'blink',
    'blockquote',
    'body',
    'br',
    'button',
    'canvas',
    'caption',
    'center',
    'cite',
    'code',
    'col',
    'colgroup',
    'content',
    'data',
    'datalist',
    'dd',
    'decorator',
    'del',
    'details',
    'dfn',
    'dialog',
    'dir',
    'div',
    'dl',
    'dt',
    'element',
    'em',
    'fieldset',
    'figcaption',
    'figure',
    'font',
    'footer',
    'form',
    'h1',
    'h2',
    'h3',
    'h4',
    'h5',
    'h6',
    'head',
    'header',
    'hgroup',
    'hr',
    'html',
    'i',
    'img',
    'input',
    'ins',
    'kbd',
    'label',
    'legend',
    'li',
    'main',
    'map',
    'mark',
    'marquee',
    'menu',
    'menuitem',
    'meter',
    'nav',
    'nobr',
    'ol',
    'optgroup',
    'option',
    'output',
    'p',
    'picture',
    'pre',
    'progress',
    'q',
    'rp',
    'rt',
    'ruby',
    's',
    'samp',
    'search',
    'section',
    'select',
    'shadow',
    'slot',
    'small',
    'source',
    'spacer',
    'span',
    'strike',
    'strong',
    'style',
    'sub',
    'summary',
    'sup',
    'table',
    'tbody',
    'td',
    'template',
    'textarea',
    'tfoot',
    'th',
    'thead',
    'time',
    'tr',
    'track',
    'tt',
    'u',
    'ul',
    'var',
    'video',
    'wbr',
  ]),
  qi = Me([
    'svg',
    'a',
    'altglyph',
    'altglyphdef',
    'altglyphitem',
    'animatecolor',
    'animatemotion',
    'animatetransform',
    'circle',
    'clippath',
    'defs',
    'desc',
    'ellipse',
    'enterkeyhint',
    'exportparts',
    'filter',
    'font',
    'g',
    'glyph',
    'glyphref',
    'hkern',
    'image',
    'inputmode',
    'line',
    'lineargradient',
    'marker',
    'mask',
    'metadata',
    'mpath',
    'part',
    'path',
    'pattern',
    'polygon',
    'polyline',
    'radialgradient',
    'rect',
    'stop',
    'style',
    'switch',
    'symbol',
    'text',
    'textpath',
    'title',
    'tref',
    'tspan',
    'view',
    'vkern',
  ]),
  Ui = Me([
    'feBlend',
    'feColorMatrix',
    'feComponentTransfer',
    'feComposite',
    'feConvolveMatrix',
    'feDiffuseLighting',
    'feDisplacementMap',
    'feDistantLight',
    'feDropShadow',
    'feFlood',
    'feFuncA',
    'feFuncB',
    'feFuncG',
    'feFuncR',
    'feGaussianBlur',
    'feImage',
    'feMerge',
    'feMergeNode',
    'feMorphology',
    'feOffset',
    'fePointLight',
    'feSpecularLighting',
    'feSpotLight',
    'feTile',
    'feTurbulence',
  ]),
  Dc = Me([
    'animate',
    'color-profile',
    'cursor',
    'discard',
    'font-face',
    'font-face-format',
    'font-face-name',
    'font-face-src',
    'font-face-uri',
    'foreignobject',
    'hatch',
    'hatchpath',
    'mesh',
    'meshgradient',
    'meshpatch',
    'meshrow',
    'missing-glyph',
    'script',
    'set',
    'solidcolor',
    'unknown',
    'use',
  ]),
  ji = Me([
    'math',
    'menclose',
    'merror',
    'mfenced',
    'mfrac',
    'mglyph',
    'mi',
    'mlabeledtr',
    'mmultiscripts',
    'mn',
    'mo',
    'mover',
    'mpadded',
    'mphantom',
    'mroot',
    'mrow',
    'ms',
    'mspace',
    'msqrt',
    'mstyle',
    'msub',
    'msup',
    'msubsup',
    'mtable',
    'mtd',
    'mtext',
    'mtr',
    'munder',
    'munderover',
    'mprescripts',
  ]),
  Bc = Me([
    'maction',
    'maligngroup',
    'malignmark',
    'mlongdiv',
    'mscarries',
    'mscarry',
    'msgroup',
    'mstack',
    'msline',
    'msrow',
    'semantics',
    'annotation',
    'annotation-xml',
    'mprescripts',
    'none',
  ]),
  ua = Me(['#text']),
  fa = Me([
    'accept',
    'action',
    'align',
    'alt',
    'autocapitalize',
    'autocomplete',
    'autopictureinpicture',
    'autoplay',
    'background',
    'bgcolor',
    'border',
    'capture',
    'cellpadding',
    'cellspacing',
    'checked',
    'cite',
    'class',
    'clear',
    'color',
    'cols',
    'colspan',
    'controls',
    'controlslist',
    'coords',
    'crossorigin',
    'datetime',
    'decoding',
    'default',
    'dir',
    'disabled',
    'disablepictureinpicture',
    'disableremoteplayback',
    'download',
    'draggable',
    'enctype',
    'enterkeyhint',
    'exportparts',
    'face',
    'for',
    'headers',
    'height',
    'hidden',
    'high',
    'href',
    'hreflang',
    'id',
    'inert',
    'inputmode',
    'integrity',
    'ismap',
    'kind',
    'label',
    'lang',
    'list',
    'loading',
    'loop',
    'low',
    'max',
    'maxlength',
    'media',
    'method',
    'min',
    'minlength',
    'multiple',
    'muted',
    'name',
    'nonce',
    'noshade',
    'novalidate',
    'nowrap',
    'open',
    'optimum',
    'part',
    'pattern',
    'placeholder',
    'playsinline',
    'popover',
    'popovertarget',
    'popovertargetaction',
    'poster',
    'preload',
    'pubdate',
    'radiogroup',
    'readonly',
    'rel',
    'required',
    'rev',
    'reversed',
    'role',
    'rows',
    'rowspan',
    'spellcheck',
    'scope',
    'selected',
    'shape',
    'size',
    'sizes',
    'slot',
    'span',
    'srclang',
    'start',
    'src',
    'srcset',
    'step',
    'style',
    'summary',
    'tabindex',
    'title',
    'translate',
    'type',
    'usemap',
    'valign',
    'value',
    'width',
    'wrap',
    'xmlns',
  ]),
  Wi = Me([
    'accent-height',
    'accumulate',
    'additive',
    'alignment-baseline',
    'amplitude',
    'ascent',
    'attributename',
    'attributetype',
    'azimuth',
    'basefrequency',
    'baseline-shift',
    'begin',
    'bias',
    'by',
    'class',
    'clip',
    'clippathunits',
    'clip-path',
    'clip-rule',
    'color',
    'color-interpolation',
    'color-interpolation-filters',
    'color-profile',
    'color-rendering',
    'cx',
    'cy',
    'd',
    'dx',
    'dy',
    'diffuseconstant',
    'direction',
    'display',
    'divisor',
    'dur',
    'edgemode',
    'elevation',
    'end',
    'exponent',
    'fill',
    'fill-opacity',
    'fill-rule',
    'filter',
    'filterunits',
    'flood-color',
    'flood-opacity',
    'font-family',
    'font-size',
    'font-size-adjust',
    'font-stretch',
    'font-style',
    'font-variant',
    'font-weight',
    'fx',
    'fy',
    'g1',
    'g2',
    'glyph-name',
    'glyphref',
    'gradientunits',
    'gradienttransform',
    'height',
    'href',
    'id',
    'image-rendering',
    'in',
    'in2',
    'intercept',
    'k',
    'k1',
    'k2',
    'k3',
    'k4',
    'kerning',
    'keypoints',
    'keysplines',
    'keytimes',
    'lang',
    'lengthadjust',
    'letter-spacing',
    'kernelmatrix',
    'kernelunitlength',
    'lighting-color',
    'local',
    'marker-end',
    'marker-mid',
    'marker-start',
    'markerheight',
    'markerunits',
    'markerwidth',
    'maskcontentunits',
    'maskunits',
    'max',
    'mask',
    'mask-type',
    'media',
    'method',
    'mode',
    'min',
    'name',
    'numoctaves',
    'offset',
    'operator',
    'opacity',
    'order',
    'orient',
    'orientation',
    'origin',
    'overflow',
    'paint-order',
    'path',
    'pathlength',
    'patterncontentunits',
    'patterntransform',
    'patternunits',
    'points',
    'preservealpha',
    'preserveaspectratio',
    'primitiveunits',
    'r',
    'rx',
    'ry',
    'radius',
    'refx',
    'refy',
    'repeatcount',
    'repeatdur',
    'restart',
    'result',
    'rotate',
    'scale',
    'seed',
    'shape-rendering',
    'slope',
    'specularconstant',
    'specularexponent',
    'spreadmethod',
    'startoffset',
    'stddeviation',
    'stitchtiles',
    'stop-color',
    'stop-opacity',
    'stroke-dasharray',
    'stroke-dashoffset',
    'stroke-linecap',
    'stroke-linejoin',
    'stroke-miterlimit',
    'stroke-opacity',
    'stroke',
    'stroke-width',
    'style',
    'surfacescale',
    'systemlanguage',
    'tabindex',
    'tablevalues',
    'targetx',
    'targety',
    'transform',
    'transform-origin',
    'text-anchor',
    'text-decoration',
    'text-rendering',
    'textlength',
    'type',
    'u1',
    'u2',
    'unicode',
    'values',
    'viewbox',
    'visibility',
    'version',
    'vert-adv-y',
    'vert-origin-x',
    'vert-origin-y',
    'width',
    'word-spacing',
    'wrap',
    'writing-mode',
    'xchannelselector',
    'ychannelselector',
    'x',
    'x1',
    'x2',
    'xmlns',
    'y',
    'y1',
    'y2',
    'z',
    'zoomandpan',
  ]),
  ha = Me([
    'accent',
    'accentunder',
    'align',
    'bevelled',
    'close',
    'columnalign',
    'columnlines',
    'columnspacing',
    'columnspan',
    'denomalign',
    'depth',
    'dir',
    'display',
    'displaystyle',
    'encoding',
    'fence',
    'frame',
    'height',
    'href',
    'id',
    'largeop',
    'length',
    'linethickness',
    'lquote',
    'lspace',
    'mathbackground',
    'mathcolor',
    'mathsize',
    'mathvariant',
    'maxsize',
    'minsize',
    'movablelimits',
    'notation',
    'numalign',
    'open',
    'rowalign',
    'rowlines',
    'rowspacing',
    'rowspan',
    'rspace',
    'rquote',
    'scriptlevel',
    'scriptminsize',
    'scriptsizemultiplier',
    'selection',
    'separator',
    'separators',
    'stretchy',
    'subscriptshift',
    'supscriptshift',
    'symmetric',
    'voffset',
    'width',
    'xmlns',
  ]),
  qs = Me(['xlink:href', 'xml:id', 'xlink:title', 'xml:space', 'xmlns:xlink']),
  Fc = ze(/\{\{[\w\W]*|[\w\W]*\}\}/gm),
  Vc = ze(/<%[\w\W]*|[\w\W]*%>/gm),
  _c = ze(/\$\{[\w\W]*/gm),
  $c = ze(/^data-[\-\w.\u00B7-\uFFFF]+$/),
  Nc = ze(/^aria-[\-\w]+$/),
  va = ze(
    /^(?:(?:(?:f|ht)tps?|mailto|tel|callto|sms|cid|xmpp|matrix):|[^a-z]|[a-z+.\-]+(?:[^a-z+.\-:]|$))/i,
  ),
  zc = ze(/^(?:\w+script|data):/i),
  qc = ze(/[\u0000-\u0020\u00A0\u1680\u180E\u2000-\u2029\u205F\u3000]/g),
  ya = ze(/^html$/i),
  Uc = ze(/^[a-z][.\w]*(-[.\w]+)+$/i),
  ma = Object.freeze({
    __proto__: null,
    ARIA_ATTR: Nc,
    ATTR_WHITESPACE: qc,
    CUSTOM_ELEMENT: Uc,
    DATA_ATTR: $c,
    DOCTYPE_NAME: ya,
    ERB_EXPR: Vc,
    IS_ALLOWED_URI: va,
    IS_SCRIPT_OR_DATA: zc,
    MUSTACHE_EXPR: Fc,
    TMPLIT_EXPR: _c,
  }),
  Jr = {
    element: 1,
    text: 3,
    progressingInstruction: 7,
    comment: 8,
    document: 9,
  },
  jc = function () {
    return typeof window > 'u' ? null : window
  },
  Wc = function (r, e) {
    if (typeof r != 'object' || typeof r.createPolicy != 'function') return null
    let s = null,
      i = 'data-tt-policy-suffix'
    e && e.hasAttribute(i) && (s = e.getAttribute(i))
    let n = 'dompurify' + (s ? '#' + s : '')
    try {
      return r.createPolicy(n, {
        createHTML(a) {
          return a
        },
        createScriptURL(a) {
          return a
        },
      })
    } catch {
      return (
        console.warn('TrustedTypes policy ' + n + ' could not be created.'),
        null
      )
    }
  },
  pa = function () {
    return {
      afterSanitizeAttributes: [],
      afterSanitizeElements: [],
      afterSanitizeShadowDOM: [],
      beforeSanitizeAttributes: [],
      beforeSanitizeElements: [],
      beforeSanitizeShadowDOM: [],
      uponSanitizeAttribute: [],
      uponSanitizeElement: [],
      uponSanitizeShadowNode: [],
    }
  }
function ba() {
  let t = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : jc(),
    r = (j) => ba(j)
  if (
    ((r.version = '3.4.1'),
    (r.removed = []),
    !t || !t.document || t.document.nodeType !== Jr.document || !t.Element)
  )
    return ((r.isSupported = !1), r)
  let { document: e } = t,
    s = e,
    i = s.currentScript,
    {
      DocumentFragment: n,
      HTMLTemplateElement: a,
      Node: l,
      Element: o,
      NodeFilter: u,
      NamedNodeMap: h = t.NamedNodeMap || t.MozNamedAttrMap,
      HTMLFormElement: f,
      DOMParser: m,
      trustedTypes: c,
    } = t,
    d = o.prototype,
    g = cr(d, 'cloneNode'),
    T = cr(d, 'remove'),
    p = cr(d, 'nextSibling'),
    v = cr(d, 'childNodes'),
    y = cr(d, 'parentNode')
  if (typeof a == 'function') {
    let j = e.createElement('template')
    j.content && j.content.ownerDocument && (e = j.content.ownerDocument)
  }
  let x,
    L = '',
    {
      implementation: M,
      createNodeIterator: R,
      createDocumentFragment: w,
      getElementsByTagName: B,
    } = e,
    { importNode: k } = s,
    E = pa()
  r.isSupported =
    typeof ga == 'function' &&
    typeof y == 'function' &&
    M &&
    M.createHTMLDocument !== void 0
  let {
      MUSTACHE_EXPR: C,
      ERB_EXPR: P,
      TMPLIT_EXPR: H,
      DATA_ATTR: $,
      ARIA_ATTR: I,
      IS_SCRIPT_OR_DATA: A,
      ATTR_WHITESPACE: O,
      CUSTOM_ELEMENT: q,
    } = ma,
    { IS_ALLOWED_URI: G } = ma,
    Q = null,
    Ae = K({}, [...da, ...qi, ...Ui, ...ji, ...ua]),
    Z = null,
    F = K({}, [...fa, ...Wi, ...ha, ...qs]),
    V = Object.seal(
      lr(null, {
        tagNameCheck: {
          writable: !0,
          configurable: !1,
          enumerable: !0,
          value: null,
        },
        attributeNameCheck: {
          writable: !0,
          configurable: !1,
          enumerable: !0,
          value: null,
        },
        allowCustomizedBuiltInElements: {
          writable: !0,
          configurable: !1,
          enumerable: !0,
          value: !1,
        },
      }),
    ),
    z = null,
    N = null,
    W = Object.seal(
      lr(null, {
        tagCheck: {
          writable: !0,
          configurable: !1,
          enumerable: !0,
          value: null,
        },
        attributeCheck: {
          writable: !0,
          configurable: !1,
          enumerable: !0,
          value: null,
        },
      }),
    ),
    pe = !0,
    _e = !0,
    $e = !1,
    Ge = !0,
    se = !1,
    be = !0,
    He = !1,
    St = !1,
    Ze = !1,
    De = !1,
    ct = !1,
    dt = !1,
    Zt = !0,
    er = !1,
    tr = 'user-content-',
    kt = !0,
    ut = !1,
    Be = {},
    Fe = null,
    ft = K({}, [
      'annotation-xml',
      'audio',
      'colgroup',
      'desc',
      'foreignobject',
      'head',
      'iframe',
      'math',
      'mi',
      'mn',
      'mo',
      'ms',
      'mtext',
      'noembed',
      'noframes',
      'noscript',
      'plaintext',
      'script',
      'style',
      'svg',
      'template',
      'thead',
      'title',
      'video',
      'xmp',
    ]),
    En = null,
    xn = K({}, ['audio', 'video', 'img', 'source', 'image', 'track']),
    ci = null,
    wn = K({}, [
      'alt',
      'class',
      'for',
      'id',
      'label',
      'name',
      'pattern',
      'placeholder',
      'role',
      'summary',
      'title',
      'value',
      'style',
      'xmlns',
    ]),
    Ps = 'http://www.w3.org/1998/Math/MathML',
    ks = 'http://www.w3.org/2000/svg',
    et = 'http://www.w3.org/1999/xhtml',
    rr = et,
    di = !1,
    ui = null,
    ol = K({}, [Ps, ks, et], zi),
    fi = K({}, ['mi', 'mo', 'mn', 'ms', 'mtext']),
    hi = K({}, ['annotation-xml']),
    ll = K({}, ['title', 'style', 'font', 'a', 'script']),
    qr = null,
    cl = ['application/xhtml+xml', 'text/html'],
    dl = 'text/html',
    ge = null,
    sr = null,
    ul = e.createElement('form'),
    Mn = function (S) {
      return S instanceof RegExp || S instanceof Function
    },
    mi = function () {
      let S =
        arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}
      if (sr && sr === S) return
      ;((!S || typeof S != 'object') && (S = {}),
        (S = ke(S)),
        (qr =
          cl.indexOf(S.PARSER_MEDIA_TYPE) === -1 ? dl : S.PARSER_MEDIA_TYPE),
        (ge = qr === 'application/xhtml+xml' ? zi : Zr),
        (Q =
          le(S, 'ALLOWED_TAGS') && we(S.ALLOWED_TAGS)
            ? K({}, S.ALLOWED_TAGS, ge)
            : Ae),
        (Z =
          le(S, 'ALLOWED_ATTR') && we(S.ALLOWED_ATTR)
            ? K({}, S.ALLOWED_ATTR, ge)
            : F),
        (ui =
          le(S, 'ALLOWED_NAMESPACES') && we(S.ALLOWED_NAMESPACES)
            ? K({}, S.ALLOWED_NAMESPACES, zi)
            : ol),
        (ci =
          le(S, 'ADD_URI_SAFE_ATTR') && we(S.ADD_URI_SAFE_ATTR)
            ? K(ke(wn), S.ADD_URI_SAFE_ATTR, ge)
            : wn),
        (En =
          le(S, 'ADD_DATA_URI_TAGS') && we(S.ADD_DATA_URI_TAGS)
            ? K(ke(xn), S.ADD_DATA_URI_TAGS, ge)
            : xn),
        (Fe =
          le(S, 'FORBID_CONTENTS') && we(S.FORBID_CONTENTS)
            ? K({}, S.FORBID_CONTENTS, ge)
            : ft),
        (z =
          le(S, 'FORBID_TAGS') && we(S.FORBID_TAGS)
            ? K({}, S.FORBID_TAGS, ge)
            : ke({})),
        (N =
          le(S, 'FORBID_ATTR') && we(S.FORBID_ATTR)
            ? K({}, S.FORBID_ATTR, ge)
            : ke({})),
        (Be = le(S, 'USE_PROFILES')
          ? S.USE_PROFILES && typeof S.USE_PROFILES == 'object'
            ? ke(S.USE_PROFILES)
            : S.USE_PROFILES
          : !1),
        (pe = S.ALLOW_ARIA_ATTR !== !1),
        (_e = S.ALLOW_DATA_ATTR !== !1),
        ($e = S.ALLOW_UNKNOWN_PROTOCOLS || !1),
        (Ge = S.ALLOW_SELF_CLOSE_IN_ATTR !== !1),
        (se = S.SAFE_FOR_TEMPLATES || !1),
        (be = S.SAFE_FOR_XML !== !1),
        (He = S.WHOLE_DOCUMENT || !1),
        (De = S.RETURN_DOM || !1),
        (ct = S.RETURN_DOM_FRAGMENT || !1),
        (dt = S.RETURN_TRUSTED_TYPE || !1),
        (Ze = S.FORCE_BODY || !1),
        (Zt = S.SANITIZE_DOM !== !1),
        (er = S.SANITIZE_NAMED_PROPS || !1),
        (kt = S.KEEP_CONTENT !== !1),
        (ut = S.IN_PLACE || !1),
        (G = Hc(S.ALLOWED_URI_REGEXP) ? S.ALLOWED_URI_REGEXP : va),
        (rr = typeof S.NAMESPACE == 'string' ? S.NAMESPACE : et),
        (fi =
          le(S, 'MATHML_TEXT_INTEGRATION_POINTS') &&
          S.MATHML_TEXT_INTEGRATION_POINTS &&
          typeof S.MATHML_TEXT_INTEGRATION_POINTS == 'object'
            ? ke(S.MATHML_TEXT_INTEGRATION_POINTS)
            : K({}, ['mi', 'mo', 'mn', 'ms', 'mtext'])),
        (hi =
          le(S, 'HTML_INTEGRATION_POINTS') &&
          S.HTML_INTEGRATION_POINTS &&
          typeof S.HTML_INTEGRATION_POINTS == 'object'
            ? ke(S.HTML_INTEGRATION_POINTS)
            : K({}, ['annotation-xml'])))
      let D =
        le(S, 'CUSTOM_ELEMENT_HANDLING') &&
        S.CUSTOM_ELEMENT_HANDLING &&
        typeof S.CUSTOM_ELEMENT_HANDLING == 'object'
          ? ke(S.CUSTOM_ELEMENT_HANDLING)
          : lr(null)
      if (
        ((V = lr(null)),
        le(D, 'tagNameCheck') &&
          Mn(D.tagNameCheck) &&
          (V.tagNameCheck = D.tagNameCheck),
        le(D, 'attributeNameCheck') &&
          Mn(D.attributeNameCheck) &&
          (V.attributeNameCheck = D.attributeNameCheck),
        le(D, 'allowCustomizedBuiltInElements') &&
          typeof D.allowCustomizedBuiltInElements == 'boolean' &&
          (V.allowCustomizedBuiltInElements = D.allowCustomizedBuiltInElements),
        se && (_e = !1),
        ct && (De = !0),
        Be &&
          ((Q = K({}, ua)),
          (Z = lr(null)),
          Be.html === !0 && (K(Q, da), K(Z, fa)),
          Be.svg === !0 && (K(Q, qi), K(Z, Wi), K(Z, qs)),
          Be.svgFilters === !0 && (K(Q, Ui), K(Z, Wi), K(Z, qs)),
          Be.mathMl === !0 && (K(Q, ji), K(Z, ha), K(Z, qs))),
        (W.tagCheck = null),
        (W.attributeCheck = null),
        le(S, 'ADD_TAGS') &&
          (typeof S.ADD_TAGS == 'function'
            ? (W.tagCheck = S.ADD_TAGS)
            : we(S.ADD_TAGS) &&
              (Q === Ae && (Q = ke(Q)), K(Q, S.ADD_TAGS, ge))),
        le(S, 'ADD_ATTR') &&
          (typeof S.ADD_ATTR == 'function'
            ? (W.attributeCheck = S.ADD_ATTR)
            : we(S.ADD_ATTR) && (Z === F && (Z = ke(Z)), K(Z, S.ADD_ATTR, ge))),
        le(S, 'ADD_URI_SAFE_ATTR') &&
          we(S.ADD_URI_SAFE_ATTR) &&
          K(ci, S.ADD_URI_SAFE_ATTR, ge),
        le(S, 'FORBID_CONTENTS') &&
          we(S.FORBID_CONTENTS) &&
          (Fe === ft && (Fe = ke(Fe)), K(Fe, S.FORBID_CONTENTS, ge)),
        le(S, 'ADD_FORBID_CONTENTS') &&
          we(S.ADD_FORBID_CONTENTS) &&
          (Fe === ft && (Fe = ke(Fe)), K(Fe, S.ADD_FORBID_CONTENTS, ge)),
        kt && (Q['#text'] = !0),
        He && K(Q, ['html', 'head', 'body']),
        Q.table && (K(Q, ['tbody']), delete z.tbody),
        S.TRUSTED_TYPES_POLICY)
      ) {
        if (typeof S.TRUSTED_TYPES_POLICY.createHTML != 'function')
          throw zs(
            'TRUSTED_TYPES_POLICY configuration option must provide a "createHTML" hook.',
          )
        if (typeof S.TRUSTED_TYPES_POLICY.createScriptURL != 'function')
          throw zs(
            'TRUSTED_TYPES_POLICY configuration option must provide a "createScriptURL" hook.',
          )
        ;((x = S.TRUSTED_TYPES_POLICY), (L = x.createHTML('')))
      } else
        (x === void 0 && (x = Wc(c, i)),
          x !== null && typeof L == 'string' && (L = x.createHTML('')))
      ;(Me && Me(S), (sr = S))
    },
    Ln = K({}, [...qi, ...Ui, ...Dc]),
    Cn = K({}, [...ji, ...Bc]),
    fl = function (S) {
      let D = y(S)
      ;(!D || !D.tagName) && (D = { namespaceURI: rr, tagName: 'template' })
      let U = Zr(S.tagName),
        ie = Zr(D.tagName)
      return ui[S.namespaceURI]
        ? S.namespaceURI === ks
          ? D.namespaceURI === et
            ? U === 'svg'
            : D.namespaceURI === Ps
              ? U === 'svg' && (ie === 'annotation-xml' || fi[ie])
              : !!Ln[U]
          : S.namespaceURI === Ps
            ? D.namespaceURI === et
              ? U === 'math'
              : D.namespaceURI === ks
                ? U === 'math' && hi[ie]
                : !!Cn[U]
            : S.namespaceURI === et
              ? (D.namespaceURI === ks && !hi[ie]) ||
                (D.namespaceURI === Ps && !fi[ie])
                ? !1
                : !Cn[U] && (ll[U] || !Ln[U])
              : !!(qr === 'application/xhtml+xml' && ui[S.namespaceURI])
        : !1
    },
    Ye = function (S) {
      Xr(r.removed, { element: S })
      try {
        y(S).removeChild(S)
      } catch {
        T(S)
      }
    },
    Ot = function (S, D) {
      try {
        Xr(r.removed, { attribute: D.getAttributeNode(S), from: D })
      } catch {
        Xr(r.removed, { attribute: null, from: D })
      }
      if ((D.removeAttribute(S), S === 'is'))
        if (De || ct)
          try {
            Ye(D)
          } catch {}
        else
          try {
            D.setAttribute(S, '')
          } catch {}
    },
    An = function (S) {
      let D = null,
        U = null
      if (Ze) S = '<remove></remove>' + S
      else {
        let ce = aa(S, /^[\r\n\t ]+/)
        U = ce && ce[0]
      }
      qr === 'application/xhtml+xml' &&
        rr === et &&
        (S =
          '<html xmlns="http://www.w3.org/1999/xhtml"><head></head><body>' +
          S +
          '</body></html>')
      let ie = x ? x.createHTML(S) : S
      if (rr === et)
        try {
          D = new m().parseFromString(ie, qr)
        } catch {}
      if (!D || !D.documentElement) {
        D = M.createDocument(rr, 'template', null)
        try {
          D.documentElement.innerHTML = di ? L : ie
        } catch {}
      }
      let Se = D.body || D.documentElement
      return (
        S &&
          U &&
          Se.insertBefore(e.createTextNode(U), Se.childNodes[0] || null),
        rr === et
          ? B.call(D, He ? 'html' : 'body')[0]
          : He
            ? D.documentElement
            : Se
      )
    },
    In = function (S) {
      return R.call(
        S.ownerDocument || S,
        S,
        u.SHOW_ELEMENT |
          u.SHOW_COMMENT |
          u.SHOW_TEXT |
          u.SHOW_PROCESSING_INSTRUCTION |
          u.SHOW_CDATA_SECTION,
        null,
      )
    },
    pi = function (S) {
      return (
        S instanceof f &&
        (typeof S.nodeName != 'string' ||
          typeof S.textContent != 'string' ||
          typeof S.removeChild != 'function' ||
          !(S.attributes instanceof h) ||
          typeof S.removeAttribute != 'function' ||
          typeof S.setAttribute != 'function' ||
          typeof S.namespaceURI != 'string' ||
          typeof S.insertBefore != 'function' ||
          typeof S.hasChildNodes != 'function')
      )
    },
    gi = function (S) {
      return typeof l == 'function' && S instanceof l
    }
  function ht(j, S, D) {
    Kr(j, (U) => {
      U.call(r, S, D, sr)
    })
  }
  let Pn = function (S) {
      let D = null
      if ((ht(E.beforeSanitizeElements, S, null), pi(S))) return (Ye(S), !0)
      let U = ge(S.nodeName)
      if (
        (ht(E.uponSanitizeElement, S, { tagName: U, allowedTags: Q }),
        (be &&
          S.hasChildNodes() &&
          !gi(S.firstElementChild) &&
          Te(/<[/\w!]/g, S.innerHTML) &&
          Te(/<[/\w!]/g, S.textContent)) ||
          (be &&
            S.namespaceURI === et &&
            U === 'style' &&
            gi(S.firstElementChild)) ||
          S.nodeType === Jr.progressingInstruction ||
          (be && S.nodeType === Jr.comment && Te(/<[/\w]/g, S.data)))
      )
        return (Ye(S), !0)
      if (
        z[U] ||
        (!(W.tagCheck instanceof Function && W.tagCheck(U)) && !Q[U])
      ) {
        if (
          !z[U] &&
          On(U) &&
          ((V.tagNameCheck instanceof RegExp && Te(V.tagNameCheck, U)) ||
            (V.tagNameCheck instanceof Function && V.tagNameCheck(U)))
        )
          return !1
        if (kt && !Fe[U]) {
          let ie = y(S) || S.parentNode,
            Se = v(S) || S.childNodes
          if (Se && ie) {
            let ce = Se.length
            for (let Ie = ce - 1; Ie >= 0; --Ie) {
              let Ne = g(Se[Ie], !0)
              ie.insertBefore(Ne, p(S))
            }
          }
        }
        return (Ye(S), !0)
      }
      return (S instanceof o && !fl(S)) ||
        ((U === 'noscript' || U === 'noembed' || U === 'noframes') &&
          Te(/<\/no(script|embed|frames)/i, S.innerHTML))
        ? (Ye(S), !0)
        : (se &&
            S.nodeType === Jr.text &&
            ((D = S.textContent),
            Kr([C, P, H], (ie) => {
              D = or(D, ie, ' ')
            }),
            S.textContent !== D &&
              (Xr(r.removed, { element: S.cloneNode() }), (S.textContent = D))),
          ht(E.afterSanitizeElements, S, null),
          !1)
    },
    kn = function (S, D, U) {
      if (N[D] || (Zt && (D === 'id' || D === 'name') && (U in e || U in ul)))
        return !1
      if (!(_e && !N[D] && Te($, D))) {
        if (!(pe && Te(I, D))) {
          if (
            !(W.attributeCheck instanceof Function && W.attributeCheck(D, S))
          ) {
            if (!Z[D] || N[D]) {
              if (
                !(
                  (On(S) &&
                    ((V.tagNameCheck instanceof RegExp &&
                      Te(V.tagNameCheck, S)) ||
                      (V.tagNameCheck instanceof Function &&
                        V.tagNameCheck(S))) &&
                    ((V.attributeNameCheck instanceof RegExp &&
                      Te(V.attributeNameCheck, D)) ||
                      (V.attributeNameCheck instanceof Function &&
                        V.attributeNameCheck(D, S)))) ||
                  (D === 'is' &&
                    V.allowCustomizedBuiltInElements &&
                    ((V.tagNameCheck instanceof RegExp &&
                      Te(V.tagNameCheck, U)) ||
                      (V.tagNameCheck instanceof Function &&
                        V.tagNameCheck(U))))
                )
              )
                return !1
            } else if (!ci[D]) {
              if (!Te(G, or(U, O, ''))) {
                if (
                  !(
                    (D === 'src' || D === 'xlink:href' || D === 'href') &&
                    S !== 'script' &&
                    oa(U, 'data:') === 0 &&
                    En[S]
                  )
                ) {
                  if (!($e && !Te(A, or(U, O, '')))) {
                    if (U) return !1
                  }
                }
              }
            }
          }
        }
      }
      return !0
    },
    hl = K({}, [
      'annotation-xml',
      'color-profile',
      'font-face',
      'font-face-format',
      'font-face-name',
      'font-face-src',
      'font-face-uri',
      'missing-glyph',
    ]),
    On = function (S) {
      return !hl[Zr(S)] && Te(q, S)
    },
    Rn = function (S) {
      ht(E.beforeSanitizeAttributes, S, null)
      let { attributes: D } = S
      if (!D || pi(S)) return
      let U = {
          attrName: '',
          attrValue: '',
          keepAttr: !0,
          allowedAttributes: Z,
          forceKeepAttr: void 0,
        },
        ie = D.length
      for (; ie--; ) {
        let Se = D[ie],
          { name: ce, namespaceURI: Ie, value: Ne } = Se,
          Ke = ge(ce),
          vi = Ne,
          ve = ce === 'value' ? vi : Ac(vi)
        if (
          ((U.attrName = Ke),
          (U.attrValue = ve),
          (U.keepAttr = !0),
          (U.forceKeepAttr = void 0),
          ht(E.uponSanitizeAttribute, S, U),
          (ve = U.attrValue),
          er &&
            (Ke === 'id' || Ke === 'name') &&
            oa(ve, tr) !== 0 &&
            (Ot(ce, S), (ve = tr + ve)),
          be &&
            Te(
              /((--!?|])>)|<\/(style|script|title|xmp|textarea|noscript|iframe|noembed|noframes)/i,
              ve,
            ))
        ) {
          Ot(ce, S)
          continue
        }
        if (Ke === 'attributename' && aa(ve, 'href')) {
          Ot(ce, S)
          continue
        }
        if (U.forceKeepAttr) continue
        if (!U.keepAttr) {
          Ot(ce, S)
          continue
        }
        if (!Ge && Te(/\/>/i, ve)) {
          Ot(ce, S)
          continue
        }
        se &&
          Kr([C, P, H], (Bn) => {
            ve = or(ve, Bn, ' ')
          })
        let Dn = ge(S.nodeName)
        if (!kn(Dn, Ke, ve)) {
          Ot(ce, S)
          continue
        }
        if (
          x &&
          typeof c == 'object' &&
          typeof c.getAttributeType == 'function' &&
          !Ie
        )
          switch (c.getAttributeType(Dn, Ke)) {
            case 'TrustedHTML': {
              ve = x.createHTML(ve)
              break
            }
            case 'TrustedScriptURL': {
              ve = x.createScriptURL(ve)
              break
            }
          }
        if (ve !== vi)
          try {
            ;(Ie ? S.setAttributeNS(Ie, ce, ve) : S.setAttribute(ce, ve),
              pi(S) ? Ye(S) : na(r.removed))
          } catch {
            Ot(ce, S)
          }
      }
      ht(E.afterSanitizeAttributes, S, null)
    },
    Hn = function (S) {
      let D = null,
        U = In(S)
      for (ht(E.beforeSanitizeShadowDOM, S, null); (D = U.nextNode()); )
        (ht(E.uponSanitizeShadowNode, D, null),
          Pn(D),
          Rn(D),
          D.content instanceof n && Hn(D.content))
      ht(E.afterSanitizeShadowDOM, S, null)
    }
  return (
    (r.sanitize = function (j) {
      let S =
          arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {},
        D = null,
        U = null,
        ie = null,
        Se = null
      if (
        ((di = !j),
        di && (j = '<!-->'),
        typeof j != 'string' && !gi(j) && ((j = Rc(j)), typeof j != 'string'))
      )
        throw zs('dirty is not a string, aborting')
      if (!r.isSupported) return j
      if (
        (St || mi(S), (r.removed = []), typeof j == 'string' && (ut = !1), ut)
      ) {
        let Ne = j.nodeName
        if (typeof Ne == 'string') {
          let Ke = ge(Ne)
          if (!Q[Ke] || z[Ke])
            throw zs('root node is forbidden and cannot be sanitized in-place')
        }
      } else if (j instanceof l)
        ((D = An('<!---->')),
          (U = D.ownerDocument.importNode(j, !0)),
          (U.nodeType === Jr.element && U.nodeName === 'BODY') ||
          U.nodeName === 'HTML'
            ? (D = U)
            : D.appendChild(U))
      else {
        if (!De && !se && !He && j.indexOf('<') === -1)
          return x && dt ? x.createHTML(j) : j
        if (((D = An(j)), !D)) return De ? null : dt ? L : ''
      }
      D && Ze && Ye(D.firstChild)
      let ce = In(ut ? j : D)
      for (; (ie = ce.nextNode()); )
        (Pn(ie), Rn(ie), ie.content instanceof n && Hn(ie.content))
      if (ut) return j
      if (De) {
        if (se) {
          D.normalize()
          let Ne = D.innerHTML
          ;(Kr([C, P, H], (Ke) => {
            Ne = or(Ne, Ke, ' ')
          }),
            (D.innerHTML = Ne))
        }
        if (ct)
          for (Se = w.call(D.ownerDocument); D.firstChild; )
            Se.appendChild(D.firstChild)
        else Se = D
        return (
          (Z.shadowroot || Z.shadowrootmode) && (Se = k.call(s, Se, !0)),
          Se
        )
      }
      let Ie = He ? D.outerHTML : D.innerHTML
      return (
        He &&
          Q['!doctype'] &&
          D.ownerDocument &&
          D.ownerDocument.doctype &&
          D.ownerDocument.doctype.name &&
          Te(ya, D.ownerDocument.doctype.name) &&
          (Ie =
            '<!DOCTYPE ' +
            D.ownerDocument.doctype.name +
            `>
` +
            Ie),
        se &&
          Kr([C, P, H], (Ne) => {
            Ie = or(Ie, Ne, ' ')
          }),
        x && dt ? x.createHTML(Ie) : Ie
      )
    }),
    (r.setConfig = function () {
      let j =
        arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}
      ;(mi(j), (St = !0))
    }),
    (r.clearConfig = function () {
      ;((sr = null), (St = !1))
    }),
    (r.isValidAttribute = function (j, S, D) {
      sr || mi({})
      let U = ge(j),
        ie = ge(S)
      return kn(U, ie, D)
    }),
    (r.addHook = function (j, S) {
      typeof S == 'function' && Xr(E[j], S)
    }),
    (r.removeHook = function (j, S) {
      if (S !== void 0) {
        let D = Lc(E[j], S)
        return D === -1 ? void 0 : Cc(E[j], D, 1)[0]
      }
      return na(E[j])
    }),
    (r.removeHooks = function (j) {
      E[j] = []
    }),
    (r.removeAllHooks = function () {
      E = pa()
    }),
    r
  )
}
var Ta = ba()
var Gc = [
    'a',
    'b',
    'br',
    'div',
    'em',
    'h1',
    'h2',
    'h3',
    'h4',
    'img',
    'li',
    'ol',
    'p',
    'span',
    'strong',
    'ul',
  ],
  Yc = ['alt', 'class', 'height', 'href', 'rel', 'src', 'target', 'width']
function Ki(t) {
  return Ta.sanitize(t, {
    ALLOWED_TAGS: Gc,
    ALLOWED_ATTR: Yc,
    ALLOW_DATA_ATTR: !1,
    FORBID_CONTENTS: ['script', 'style', 'iframe', 'form', 'object', 'embed'],
    ALLOWED_URI_REGEXP:
      /^(?:(?:https?|mailto):|[^a-z]|[a-z+.-]+(?:[^a-z+.-:]|$))/i,
    ADD_ATTR: ['target'],
  })
}
var Kc = '(min-width: 1194px) 25vw, (min-width: 834px) 33vw, 50vw',
  Xc = [300, 500, 700, 900, 1100]
function xa(t, r, e) {
  let s = t.mappings?.core ?? t,
    i = typeof s.name == 'string' ? s.name : '',
    n = typeof s.url == 'string' ? s.url : '#',
    a = typeof s.imageUrl == 'string' ? s.imageUrl : '',
    l = Sa(s.price),
    o = Sa(s.msrp),
    u = e.sizes || Kc,
    h = i.split('|')[0]?.trim().toLowerCase() ?? i,
    f = Jc({ imageUrl: a, alt: i, isAboveFold: e.isAboveFold, sizes: u }),
    m = Qc(l, o)
  return `<div data-handle="${ue(r)}" data-is-skeleton="true" data-minimal-card="true">
  <article class="flex flex-col group">
    <div class="relative w-full overflow-hidden aspect-2/3">
      <a href="${ue(n)}" tabindex="-1" aria-hidden="true" aria-label="${ue(i)}" class="relative z-10 block w-full h-full overflow-hidden">
        ${f}
      </a>
    </div>
    <div class="mt-5 flex flex-col">
      <div class="mb-3 h-4.25 flex gap-2.5 items-center pl-1.25" aria-hidden="true">
        <span class="block w-2.5 h-2.5 bg-gray-200"></span>
        <span class="block w-2.5 h-2.5 bg-gray-200"></span>
        <span class="block w-2.5 h-2.5 bg-gray-200"></span>
        <span class="block w-2.5 h-2.5 bg-gray-200"></span>
        <span class="block w-2.5 h-2.5 bg-gray-200"></span>
      </div>
      <a href="${ue(n)}" class="flex flex-col text-primary" aria-label="${ue(i)}">
        <div class="mb-1.25 min-h-4.5 flex items-center" aria-hidden="true">
          <span class="block h-3 w-12 product-card-skeleton"></span>
        </div>
        <h3 class="text-body whitespace-pre-wrap overflow-hidden line-clamp-3 max-w-fit capitalize">${ue(h)}</h3>
        <div class="mt-1">${m}</div>
      </a>
    </div>
  </article>
</div>`
}
function Sa(t) {
  if (typeof t == 'number' && Number.isFinite(t)) return t
  if (typeof t == 'string') {
    let r = Number.parseFloat(t)
    return Number.isFinite(r) ? r : null
  }
  return null
}
function Xi(t) {
  return `$${t.toFixed(2)}`
}
function Qc(t, r) {
  return t === null
    ? ''
    : r !== null && r > t
      ? `<span class="text-body"><span class="text-error font-medium">${Xi(t)}</span> <span class="line-through text-muted ml-1">${Xi(r)}</span></span>`
      : `<span class="text-body">${Xi(t)}</span>`
}
function Jc(t) {
  if (!t.imageUrl) return '<div class="w-full h-full bg-gray-100"></div>'
  let { src: r, srcset: e } = Zc(t.imageUrl),
    s = t.isAboveFold ? 'eager' : 'lazy',
    i = t.isAboveFold ? ' fetchpriority="high"' : ''
  return `<img
    src="${ue(r)}"
    srcset="${ue(e)}"
    sizes="${ue(t.sizes)}"
    alt="${ue(t.alt)}"
    loading="${s}"
    decoding="async"${i}
    class="w-full h-full object-cover"
  >`
}
function Zc(t) {
  let r = t.split('?')[0],
    e = Xc.map((s) => `${Ea(r, s)} ${s}w`).join(', ')
  return { src: Ea(r, 700), srcset: e }
}
function Ea(t, r) {
  return `${t}?width=${r}&format=webp`
}
var ed = 3500,
  Ht = class {
    constructor() {
      b(this, 'currentAbortController', null)
      b(this, 'renderedColumns', null)
      b(this, 'lastRenderState', null)
      b(this, 'boundOnResize', null)
      b(this, 'hasRenderedOnce', !1)
    }
    disconnect() {
      ;(this.currentAbortController?.abort(),
        (this.currentAbortController = null),
        this.boundOnResize &&
          (window.removeEventListener('resize', this.boundOnResize),
          (this.boundOnResize = null)))
    }
    render(r, e, s = [], i = [], n) {
      let a = this.isAppendRender(e)
      if (
        ((this.lastRenderState = {
          productsTarget: r,
          products: e,
          inlineBanners: s,
          metafieldBanners: i,
          tracking: n,
        }),
        (this.renderedColumns = this.getColumnsPerRow(r)),
        a)
      ) {
        ;(this.renderRows(r, e, s, i),
          this.bindResizeListener(),
          this.currentAbortController ||
            (this.currentAbortController = new AbortController()),
          this.kickLazyHydration(r, e, n))
        return
      }
      if (!this.hasRenderedOnce) {
        ;((this.hasRenderedOnce = !0),
          this.preloadLcpImage(e),
          this.runWithViewTransition(() => {
            this.renderRows(r, e, s, i)
          }),
          this.bindResizeListener(),
          this.currentAbortController?.abort(),
          (this.currentAbortController = new AbortController()),
          this.kickLazyHydration(r, e, n))
        return
      }
      this.renderWithFullCards(r, e, s, i)
    }
    kickLazyHydration(r, e, s) {
      this.currentAbortController &&
        Ee.hydrateProductCards(
          r,
          e,
          this.currentAbortController.signal,
          (this.renderedColumns ?? 0) * 2,
          s,
        ).catch((i) => {
          ;(i instanceof DOMException && i.name === 'AbortError') ||
            console.error(
              '[CollectionController] Failed to hydrate product cards',
              i,
            )
        })
    }
    runWithViewTransition(r) {
      let e = document
      typeof e.startViewTransition == 'function'
        ? e.startViewTransition(r)
        : r()
    }
    renderWithFullCards(r, e, s, i) {
      ;(this.currentAbortController?.abort(),
        (this.currentAbortController = new AbortController()))
      let n = this.currentAbortController.signal
      if (
        (this.runWithViewTransition(() => {
          this.renderRows(r, e, s, i, void 0, !0)
        }),
        this.bindResizeListener(),
        e.length === 0)
      )
        return
      let a = e.map((f) => {
          let m = f.mappings?.core ?? f
          return tt(m.url)
        }),
        l = []
      if (
        (a.forEach((f, m) => {
          f !== null && l.push({ index: m, handle: f, promise: Rt(f, n) })
        }),
        l.length === 0)
      )
        return
      let o = !1,
        u = Promise.all(l.map((f) => f.promise)).then(() => 'done'),
        h = new Promise((f) => {
          let m = setTimeout(() => {
            ;((o = !0), f('timeout'))
          }, ed)
          n.addEventListener('abort', () => clearTimeout(m), { once: !0 })
        })
      Promise.race([u, h])
        .then((f) => {
          n.aborted ||
            (f === 'done'
              ? this.atomicSwapCards(r, e, s, i, l)
              : this.progressiveSwapCards(r, n, l))
        })
        .catch((f) => {
          n.aborted ||
            console.error(
              '[CollectionController] Failed to render product cards',
              f,
            )
        })
    }
    async atomicSwapCards(r, e, s, i, n) {
      let a = await Promise.all(
          n.map(async (o) => ({
            index: o.index,
            handle: o.handle,
            html: await o.promise,
          })),
        ),
        l = new Map()
      ;(a.forEach(({ index: o, html: u }) => {
        u && l.set(o, u)
      }),
        this.preloadLcpImage(e),
        this.runWithViewTransition(() => {
          this.renderRows(r, e, s, i, l)
        }),
        this.bindResizeListener(),
        l.size < n.length &&
          this.kickLazyHydration(r, e, this.lastRenderState?.tracking))
    }
    progressiveSwapCards(r, e, s) {
      s.forEach((i) => {
        i.promise
          .then((n) => {
            if (e.aborted || !n) return
            let a = r.querySelector(
              `[data-handle="${i.handle}"][data-is-skeleton="true"]`,
            )
            if (!a) return
            let l = document.createElement('div')
            l.innerHTML = n
            let o = l.firstElementChild
            o && a.replaceWith(o)
          })
          .catch(() => {})
      })
    }
    isAppendRender(r) {
      let e = this.lastRenderState?.products
      if (!e || e.length === 0 || r.length <= e.length) return !1
      for (let s = 0; s < e.length; s++) if (e[s] !== r[s]) return !1
      return !0
    }
    preloadLcpImage(r) {
      let e = r[0]?.mappings?.core,
        s = typeof e?.imageUrl == 'string' ? e.imageUrl : ''
      if (!s) return
      let i = s.split('?')[0],
        a = [300, 500, 700, 900, 1100]
          .map((f) => `${i}?width=${f}&format=webp ${f}w`)
          .join(', '),
        l = `${i}?width=700&format=webp`,
        o = '(min-width: 1194px) 25vw, (min-width: 834px) 33vw, 50vw',
        u = 'lcp-image-preload',
        h = document.getElementById(u)
      ;(h ||
        ((h = document.createElement('link')),
        (h.id = u),
        (h.rel = 'preload'),
        (h.as = 'image'),
        h.setAttribute('fetchpriority', 'high'),
        document.head.appendChild(h)),
        (h.href = l),
        h.setAttribute('imagesrcset', a),
        h.setAttribute('imagesizes', o))
    }
    bindResizeListener() {
      this.boundOnResize ||
        ((this.boundOnResize = this.handleResize.bind(this)),
        window.addEventListener('resize', this.boundOnResize))
    }
    handleResize() {
      !this.lastRenderState ||
        this.getColumnsPerRow(this.lastRenderState.productsTarget) ===
          this.renderedColumns ||
        this.render(
          this.lastRenderState.productsTarget,
          this.lastRenderState.products,
          this.lastRenderState.inlineBanners,
          this.lastRenderState.metafieldBanners,
          this.lastRenderState.tracking,
        )
    }
    renderRows(r, e, s, i, n, a = !1) {
      let l = this.getColumnsPerRow(r),
        o = document.createDocumentFragment(),
        u = this.groupInlineBannersByRow(s, l),
        h = this.groupMetafieldBannersByRow(i, l)
      if (e.length === 0) {
        r.innerHTML = '<p>No products found.</p>'
        return
      }
      let f = l * 2,
        m = this.computeTotalRows(e.length, u, l),
        c = 0
      for (let d = 0; d < m; d++) {
        ;(h.get(d) ?? []).forEach(({ item: L, imageUrls: M }) => {
          o.appendChild(this.buildMetafieldBanner(L, M))
        })
        let T = u.get(d) ?? [],
          p = new Map(T.map((L) => [L.col, L.html])),
          v = Math.max(1, l - T.length),
          y = c,
          x = e.slice(y, y + v)
        ;((c += v),
          o.appendChild(this.buildProductRow(x, r.className, p, l, y, f, n, a)))
      }
      ;(u.forEach((d, g) => {
        g < m ||
          d.forEach(({ html: T }) => {
            let p = document.createElement('div')
            p.innerHTML = Ki(T)
            let v = o.lastElementChild
            v && v.appendChild(p)
          })
      }),
        r.replaceChildren(o))
    }
    groupInlineBannersByRow(r, e) {
      let s = new Map()
      return (
        r.forEach((i) => {
          let n = i.value?.trim()
          if (!n) return
          let a = i.config?.position?.index ?? 0,
            l = this.getBannerRow(a, e),
            o = a % e,
            u = s.get(l) ?? []
          ;(u.push({ col: o, html: n }), s.set(l, u))
        }),
        s
      )
    }
    groupMetafieldBannersByRow(r, e) {
      let s = new Map()
      return (
        r.forEach((i) => {
          let n = this.selectMetafieldBannerImages(i, e)
          if (!(n.length > 0 || !!(i.title || i.description))) return
          let l = s.get(i.row) ?? []
          ;(l.push({ item: i, imageUrls: n }), s.set(i.row, l))
        }),
        s
      )
    }
    buildProductRow(
      r,
      e,
      s = new Map(),
      i = r.length,
      n = 0,
      a = 0,
      l,
      o = !1,
    ) {
      let u = document.createElement('div')
      if (
        ((u.className = `${e} w-full`),
        (u.style.gridColumn = '1 / -1'),
        s.size === 0)
      )
        return (
          (u.innerHTML = r
            .map((f, m) => {
              let c = n + m
              return this.buildProductCellHtml(f, c, a, l, o)
            })
            .join('')),
          u
        )
      let h = 0
      for (let f = 0; f < i; f++)
        if (s.has(f)) {
          let m = document.createElement('div')
          ;((m.innerHTML = Ki(s.get(f))), u.appendChild(m))
        } else if (h < r.length) {
          let m = r[h],
            c = n + h,
            d = document.createElement('div')
          ;((d.innerHTML = this.buildProductCellHtml(m, c, a, l, o)),
            u.appendChild(d),
            h++)
        }
      return u
    }
    buildProductCellHtml(r, e, s, i, n = !1) {
      let a = this.getProductHandle(r),
        l = i?.get(e)
      return (
        l ||
        (n
          ? `<div data-handle="${a}" data-is-skeleton="true" class="product-card-skeleton aspect-2/3 w-full"></div>`
          : e < s
            ? xa(r, a, {
                isAboveFold: !0,
                sizes:
                  '(min-width: 1194px) 25vw, (min-width: 834px) 33vw, 50vw',
              })
            : `<div data-handle="${a}" data-is-skeleton="true" class="product-card-skeleton aspect-2/3 w-full"></div>`)
      )
    }
    buildFullWidthHtmlBlock(r) {
      let e = document.createElement('div')
      return (
        (e.className = 'w-full'),
        (e.style.gridColumn = '1 / -1'),
        (e.innerHTML = r),
        e
      )
    }
    buildMetafieldBanner(r, e) {
      let s = e.length > 0,
        i = r.title?.trim() ?? '',
        n = r.description?.trim() ?? '',
        a = i.length > 0 || n.length > 0,
        l = r.textJustify ?? 'left',
        o =
          l === 'center'
            ? 'text-center'
            : l === 'right'
              ? 'text-right'
              : 'text-left',
        u = [
          i
            ? `<h2 class="text-xl md:text-2xl font-semibold leading-tight ${o}">${ue(i)}</h2>`
            : '',
          n
            ? `<p class="mt-2 text-body font-medium leading-relaxed ${o}">${ue(n)}</p>`
            : '',
        ]
          .filter(Boolean)
          .join('')
      if (!s)
        return this.buildFullWidthHtmlBlock(
          `<div class="w-full bg-surface md:px-8 pb-12 text-primary">${u}</div>`,
        )
      let h = a
        ? `<div
          class="absolute inset-0 flex flex-col justify-end p-8 text-surface"
          style="background: linear-gradient(to top, rgba(0,0,0,0.6) 0%, transparent 100%)"
        >${u}</div>`
        : ''
      if (e.length > 1) {
        let f = e
          .map(
            (c, d) => `<div
            class="swiper-slide"
            role="group"
            aria-label="${d + 1} / ${e.length}"
          >
            <img src="${ue(c)}" alt="${ue(i)}" class="w-full h-auto block">
          </div>`,
          )
          .join('')
        return this.buildFullWidthHtmlBlock(`<div
          class="relative my-8 md:my-12 overflow-hidden -mx-gutter"
        >
          <div data-controller="collection-banner-swiper" class="w-full">
            <div class="swiper w-full">
              <div class="swiper-wrapper">${f}</div>
            </div>
            <button
          type="button"
          class="absolute bottom-4 right-4 z-20 text-surface transition-opacity hover:opacity-80 focus-visible:outline-none"
          data-action="click->collection-banner-swiper#toggleAutoplay"
          data-collection-banner-swiper-target="toggleButton"
          aria-label="Pause autoplay"
        >
          <span data-collection-banner-swiper-target="playIcon" class="hidden" aria-hidden="true">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 24 24"
              fill="none"
              class="w-4 h-4"
              aria-hidden="true"
            >
              <use href="#icon-play"></use>
            </svg>
          </span>
          <span data-collection-banner-swiper-target="pauseIcon" aria-hidden="true">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 24 24"
              fill="none"
              class="w-4 h-4"
              aria-hidden="true"
            >
              <use href="#icon-pause"></use>
            </svg>
          </span>
        </button>
          </div>
          ${h}
        </div>`)
      }
      return this.buildFullWidthHtmlBlock(`<div
        class="relative my-8 md:my-12 overflow-hidden -mx-gutter"
      >
        <img src="${ue(e[0])}" alt="${ue(i)}" class="w-full h-auto block">
        ${h}
      </div>`)
    }
    getColumnsPerRow(r) {
      let e = window.getComputedStyle(r).gridTemplateColumns
      if (!e || e === 'none') return 1
      let s = e
        .trim()
        .split(/\s+(?![^()]*\))/)
        .filter(Boolean)
      return s.length > 0 ? s.length : 1
    }
    computeTotalRows(r, e, s) {
      let i = r,
        n = 0
      for (; i > 0; ) {
        let a = e.get(n)?.length ?? 0,
          l = Math.max(1, s - a)
        ;((i -= l), n++)
      }
      return n
    }
    getBannerRow(r, e) {
      return Math.floor(r / e)
    }
    getProductHandle(r) {
      return (
        (r.mappings?.core || r).url?.match(/\/products\/([^/?#]+)/)?.[1] ?? ''
      )
    }
    selectMetafieldBannerImages(r, e) {
      let s = this.normaliseBannerImages(r.images),
        i = this.normaliseBannerImages(r.mobileImages)
      return e === 5 ? (s.length > 0 ? s : i) : i.length > 0 ? i : s
    }
    normaliseBannerImages(r) {
      return !r || r.length === 0 ? [] : r.map((e) => e.trim()).filter(Boolean)
    }
  }
ur()
pr()
var Qe = { xs: 390, sm: 834, md: 1194, lg: 1440, xl: 1920 }
function Oo(t) {
  return {
    slidesPerView: 2.5,
    spaceBetween: 2,
    loop: !1,
    resizeObserver: !0,
    observer: !0,
    breakpoints: {
      [Qe.xs]: { slidesPerView: 2.5 },
      [Qe.sm]: { slidesPerView: 3.5 },
      [Qe.md]: { slidesPerView: 8 },
      [Qe.lg]: { slidesPerView: 9 },
      [Qe.xl]: { slidesPerView: 9 },
    },
    on: {
      afterInit(r) {
        t > -1 && r.slideTo(t, 0)
      },
    },
  }
}
function Qs(t, r) {
  return r
    ? `
    <div class="relative overflow-x-hidden left-1/2 right-1/2 w-screen -ml-[50vw] -mr-[50vw] lg:left-auto lg:right-auto lg:w-auto lg:ml-0 lg:mr-0">
      <div class="relative flex flex-col gap-4 mt-4 mb-4 md:gap-5 -mx-gutter md:my-9 lg:mx-0">
        <div
          id="quick-links-slider"
          class="swiper swiper-quick-links-carousel max-w-full md:!px-gutter !pr-gutter !mx-0 lg:!px-0 lg:!pr-0"
        >
          <div class="swiper-wrapper">
            ${t.map((s) => `<div class="swiper-slide">${s}</div>`).join('')}
          </div>
        </div>
      </div>
    </div>
  `
    : `
    <div class="overflow-x-hidden">
      <div class="quickLink flex flex-wrap items-center gap-[15px] py-[25px] sm:py-[10px] -mx-gutter px-gutter"
          role="group"
          aria-label="Collection quick links">
        ${t.join('')}
      </div>
    </div>
  `
}
var bu =
    'text-button capitalize p-[10px] h-[28px] flex-shrink-0 flex items-center cursor-pointer border border-primary bg-transparent text-primary transition-colors duration-200 hover:bg-accent hover:border-accent hover:text-surface',
  Tu =
    'text-button capitalize p-[10px] h-[28px] flex-shrink-0 flex items-center cursor-pointer border border-primary bg-accent border-accent text-surface',
  ns = ({
    label: t,
    filterValue: r,
    isActive: e,
    href: s,
    image: i,
    pillClass: n = bu,
    activePillClass: a = Tu,
  }) => {
    if (i) {
      let u = `
      <div class="relative w-full aspect-[200/300] overflow-hidden block group">
        <div class="absolute top-0 left-0 w-full h-full outline outline-2 outline-offset-[-2px] z-[1]"
          style="outline-color: ${e ? 'var(--color-accent)' : 'transparent'};"></div>
        <img src="${i}" alt="" class="w-full h-full object-cover" />
      </div>
      ${t ? `<span class="text-body py-2.5 max-md:pl-[10px] m-auto">${t}</span>` : ''}
    `
      return s
        ? `<a href="${s}" class="flex flex-col gap-[5px] w-full p-0">${u}</a>`
        : `<button type="button" class="flex flex-col gap-[10px] w-full p-0 cursor-pointer"
           data-action="click->collection#handleQuickLinkClick"
           data-filter-value="${r ?? ''}"
           aria-pressed="${e ?? !1}"
           aria-label="Filter by ${t}">${u}</button>`
    }
    let l = e ? a : n
    return s
      ? `<a href="${s}" class="${l}" aria-label="Filter by ${t}">${t}</a>`
      : `<button type="button" class="${l} cursor-pointer"
         data-action="click->collection#handleQuickLinkClick"
         data-filter-value="${r ?? ''}"
         aria-pressed="${e ?? !1}"
         aria-label="Filter by ${t}">${t}</button>`
  }
qe.use([hr])
var as = class {
  constructor() {
    b(this, 'swiperInstance', null)
  }
  destroy() {
    ;(this.swiperInstance?.destroy(!0, !0), (this.swiperInstance = null))
  }
  render({
    quickLinksTarget: r,
    facets: e,
    quickLinkItems: s,
    quicklinkFormat: i,
    facetField: n,
    getActiveFilterValues: a,
    parseFilterEntries: l,
  }) {
    if (s.length > 0 && i === 'visual') {
      let o = s.map((u) => this.buildMetaPill(u, !0, a, l))
      ;((r.hidden = !1), (r.innerHTML = Qs(o, !0)))
    } else if (s.length > 0) {
      let o = s.map((u) => this.buildMetaPill(u, !1, a, l))
      ;((r.hidden = !1), (r.innerHTML = Qs(o, !1)))
    } else this.renderQuickLinksFromFacets(r, e, n, a)
    this.initSwiper(r)
  }
  initSwiper(r) {
    this.swiperInstance?.destroy(!0, !0)
    let e = r.querySelector('.swiper')
    if (!e) return
    let s = Array.from(r.querySelectorAll('.swiper-slide')).findIndex((i) =>
      i.querySelector('[aria-pressed="true"]'),
    )
    this.swiperInstance = new qe(e, Oo(s))
  }
  renderQuickLinksFromFacets(r, e, s, i) {
    let n = e.find((o) => o.field === s)
    if (!n) {
      ;((r.innerHTML = ''), (r.hidden = !0))
      return
    }
    let a = i(),
      l =
        n.values
          ?.filter(
            (o) =>
              o.value?.toLowerCase() !== 'all' &&
              o.label?.toLowerCase() !== 'all',
          )
          .map((o) =>
            ns({
              label: o.label ?? '',
              filterValue: o.value,
              isActive: a.includes(o.value ?? ''),
            }),
          ) || []
    if (l.length === 0) {
      ;((r.innerHTML = ''), (r.hidden = !0))
      return
    }
    ;((r.hidden = !1), (r.innerHTML = Qs(l, !1)))
  }
  buildMetaPill(r, e, s, i) {
    if (r.type === 'link')
      return ns({ label: r.label, href: r.url, image: e ? r.image : void 0 })
    if (!r.filters?.trim()) {
      let l = [...new URLSearchParams(window.location.search).keys()].some(
        (o) => o.startsWith('filter.'),
      )
      return ns({ label: r.label, filterValue: '', isActive: !l })
    }
    let a = i(r.filters).some(({ key: l, value: o }) => s(l).includes(o))
    return ns({
      label: r.label,
      filterValue: r.filters.trim(),
      isActive: a,
      image: e ? r.image : void 0,
    })
  }
}
var os = class {
  constructor() {
    b(this, 'currentPage', 1)
    b(this, 'totalPages', 0)
  }
  getCurrentPage() {
    return this.currentPage
  }
  getTotalPages() {
    return this.totalPages
  }
  hasMorePages() {
    return this.currentPage < this.totalPages
  }
  incrementPage() {
    this.currentPage += 1
  }
  reset() {
    ;((this.currentPage = 1), (this.totalPages = 0))
  }
  updateFromResponse(r) {
    r.pagination && (this.totalPages = r.pagination.totalPages || 0)
  }
  updateVisibility(r) {
    let e = this.hasMorePages(),
      s = r.querySelector('[data-action*="handleLoadMore"]')
    s &&
      (e
        ? (s.removeAttribute('hidden'), (r.style.display = ''))
        : (s.setAttribute('hidden', ''), (r.style.display = 'none')))
  }
}
function ls() {
  return typeof crypto < 'u' && crypto.randomUUID
    ? crypto.randomUUID()
    : 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (t) {
        var r = (Math.random() * 16) | 0,
          e = t == 'x' ? r : (r & 3) | 8
        return e.toString(16)
      })
}
function gr(t) {
  if (typeof document > 'u') return
  let e = `; ${document.cookie}`.split(`; ${t}=`)
  if (e.length === 2) return e.pop()?.split(';').shift()
}
var Ro = 'ssUserId',
  Ho = '_isuid',
  Js = 'ssSessionId',
  Do = 3600 * 24 * 365,
  Zs = null
function ln(t, r, e) {
  if (typeof document > 'u') return
  let s = [`${t}=${r}`, 'path=/', 'SameSite=Lax']
  ;(e !== void 0 && s.push(`max-age=${e}`), (document.cookie = s.join('; ')))
}
function Su() {
  let r = gr(Ro) || gr(Ho) || ls()
  return (ln(Ro, r, Do), ln(Ho, r, Do), r)
}
function Eu() {
  if (typeof window > 'u') return ls()
  let t = null
  try {
    t = window.sessionStorage.getItem(Js)
  } catch {}
  if (!t) {
    t = gr(Js) || ls()
    try {
      window.sessionStorage.setItem(Js, t)
    } catch {}
  }
  return (ln(Js, t), t)
}
function vr() {
  return Zs || ((Zs = { userId: Su(), sessionId: Eu(), pageLoadId: ls() }), Zs)
}
var xu = 'https://analytics.searchspring.net/beacon/v2',
  wu = 'good-american/liquid/1.0.0',
  ei
function Mu() {
  return (
    ei !== void 0 ||
      (ei =
        document
          .querySelector('meta[name="searchspring-site-id"]')
          ?.getAttribute('content') || null),
    ei
  )
}
function Lu() {
  let t = vr()
  return {
    timestamp: new Date().toISOString(),
    pageUrl: window.location.href,
    userId: t.userId,
    sessionId: t.sessionId,
    pageLoadId: t.pageLoadId,
    initiator: wu,
  }
}
async function nt(t) {
  if (!ar(nr.ANALYTICS)) return
  let r = Mu()
  if (!r) {
    console.warn('[searchspring-beacon] siteId is not configured')
    return
  }
  let e = `${xu}/${r}/${t.module}/${t.event}`,
    s = JSON.stringify({ context: Lu(), data: t.data })
  try {
    if (typeof navigator < 'u' && typeof navigator.sendBeacon == 'function') {
      let i = new Blob([s], { type: 'text/plain' })
      if (navigator.sendBeacon(e, i)) return
    }
    await fetch(e, {
      method: 'POST',
      headers: { 'Content-Type': 'text/plain' },
      body: s,
      keepalive: !0,
    })
  } catch (i) {
    console.warn('[searchspring-beacon] failed to send', t.event, i)
  }
}
async function Lt(t) {
  t.responseId &&
    (await nt({
      module: t.module,
      event: 'render',
      data:
        t.module === 'recommendations'
          ? { tag: t.tag ?? '', responseId: t.responseId }
          : { responseId: t.responseId },
    }))
}
var ye
;(function (t) {
  ;((t.production = 'production'), (t.development = 'development'))
})(ye || (ye = {}))
var cn = Rs(ds())
var _o = (t) => {
  let r = 1,
    e = 0,
    s
  for (; t >= 0; ) ((s = r), (r = r + e), (e = s), t--)
  return e
}
var $o = Rs(ds()),
  us = 'ss-networkcache',
  $u = { enabled: !0, ttl: 3e5, maxSize: 1e3, purgeable: !0 },
  ti = class {
    constructor(r) {
      ;((this.memoryCache = {}),
        (this.config = (0, $o.default)($u, r || {})),
        this.load(),
        this.config?.entries &&
          Object.keys(this.config.entries).map((e) => {
            this.config.entries &&
              this.config.entries[e] &&
              this.set(e, this.config.entries[e])
          }))
    }
    load() {
      if (typeof window < 'u' && window?.sessionStorage) {
        let r = window.sessionStorage.getItem(us),
          e = { ...(r && JSON.parse(r)) }
        this.memoryCache = e || {}
      }
      this.purgeExpired()
    }
    get(r) {
      if (this.config.enabled) {
        this.load()
        try {
          let e = []
          if (
            (typeof window < 'u' &&
              window.performance?.getEntriesByType('navigation')?.[0]?.type ===
                'back_forward' &&
              (e = ['lastViewed', 'cart']),
            Object.keys(this.memoryCache).length && r)
          ) {
            let s = r
            if (e.length && r.startsWith('/api/search/search.json'))
              try {
                let i = r.split('{')[0],
                  n = '{' + r.split('{')[1],
                  a = JSON.parse(n),
                  l = Object.keys(this.memoryCache).find((o) => {
                    try {
                      if (o.split('{')[0] == i) {
                        let h = '{' + o.split('{')[1],
                          f = JSON.parse(h),
                          m = Array.from(
                            new Set([...Object.keys(a), ...Object.keys(f)]),
                          )
                        for (let c of m)
                          if (
                            !e.includes(c) &&
                            JSON.stringify(a[c]) !== JSON.stringify(f[c])
                          )
                            return !1
                        return !0
                      } else return !1
                    } catch {
                      return !1
                    }
                  })
                l && (s = l)
              } catch {}
            if (this.memoryCache[s])
              if (Date.now() >= this.memoryCache[s].expires) {
                let i = { ...this.memoryCache }
                ;(delete i[s],
                  window.sessionStorage.setItem(us, JSON.stringify(i)))
              } else return this.memoryCache[s].value
          }
        } catch (e) {
          console.warn('something went wrong getting from cache', e)
        }
      }
    }
    purgeExpired() {
      Object.keys(this.memoryCache).forEach((r) => {
        Date.now() > this.memoryCache[r].expires && delete this.memoryCache[r]
      })
      try {
        if (typeof window < 'u' && window?.sessionStorage) {
          let r = JSON.stringify(this.memoryCache)
          window.sessionStorage.setItem(us, r)
        }
      } catch {
        console.warn('failed to store network cache')
      }
    }
    set(r, e) {
      if (this.config.enabled) {
        this.load()
        try {
          let s = {
              value: e,
              expires: Date.now() + this.config.ttl,
              purgeable: this.config.purgeable,
            },
            i =
              new Blob([JSON.stringify(this.memoryCache)], {
                endings: 'native',
              }).size / 1024
          for (; i > this.config.maxSize; ) {
            let n = Object.keys(this.memoryCache)
              .filter((a) => this.memoryCache[a].purgeable)
              .sort(
                (a, l) =>
                  this.memoryCache[a].expires - this.memoryCache[l].expires,
              )[0]
            if (!n) break
            ;(delete this.memoryCache[n],
              (i =
                new Blob([JSON.stringify(this.memoryCache)], {
                  endings: 'native',
                }).size / 1024))
          }
          ;((this.memoryCache[r] = s),
            typeof window < 'u' &&
              window?.sessionStorage &&
              window.sessionStorage.setItem(
                us,
                JSON.stringify(this.memoryCache),
              ))
        } catch {
          console.warn('something went wrong setting to cache')
        }
      }
    }
    clear() {
      try {
        ;((this.memoryCache = {}),
          typeof window < 'u' &&
            window?.sessionStorage &&
            window.sessionStorage.setItem(us, ''))
      } catch {
        console.warn('something went wrong clearing cache')
      }
    }
  }
var Nu = (t) => typeof Blob < 'u' && t instanceof Blob,
  at = class {
    constructor(r) {
      ;((this.configuration = r),
        (this.retryDelay = 1e3),
        (this.retryCount = 0),
        (this.cache = new ti(this.configuration.cache)))
    }
    get mode() {
      return this.configuration.mode
    }
    async request(r, e) {
      let { url: s, init: i } = this.createFetchParams(r)
      if (e) {
        let l =
          this.cache.get(`${r.path}/${e}`) || this.cache.get(`${r.path}/*`)
        if (l) return ((this.retryCount = 0), (this.retryDelay = 1e3), l)
      }
      let n, a
      try {
        if (
          ((n = await this.fetchApi(s, i)),
          (a = await n?.json()),
          n.status >= 200 && n.status < 300)
        )
          return (
            (this.retryCount = 0),
            (this.retryDelay = 1e3),
            e && this.cache.set(`${r.path}/${e}`, a),
            a
          )
        throw n.status == 429
          ? this.retryCount < this.configuration.maxRetry
            ? (await new Promise((l) => setTimeout(l, this.retryDelay)),
              (this.retryDelay = _o(this.retryCount) * 1e3),
              this.retryCount++,
              new Error('Rate limited.'))
            : new Error('Retry rate limit exceeded.')
          : n.status == 404 && a?.message == 'Profile is currently paused'
            ? new Error(`${a.message}: ${r.query?.tag}`)
            : new Error('Unexpected Response Status.')
      } catch (l) {
        if (l.message == 'Rate limited.') return await this.request(r, e)
        throw {
          err: l,
          fetchDetails: {
            status: n?.status,
            message: n?.statusText || 'FAILED',
            url: s,
            ...i,
          },
        }
      }
    }
    createFetchParams(r) {
      let e = r?.body?.siteId || r?.query?.siteId
      if (!e) throw new Error('Request failed. Missing "siteId" parameter.')
      let s = `https://${e}.a${r.subDomain ? `.${r.subDomain}` : ''}.searchspring.io`,
        n = `${(this.configuration.origin || s).replace(/\/$/, '')}/${r.path.replace(/^\//, '')}`,
        a = (0, cn.default)(r.query || {}, this.configuration.globals)
      Object.keys(a).length !== 0 &&
        (n += '?' + this.configuration.queryParamsStringify(a))
      let l =
          (typeof FormData < 'u' && r.body instanceof FormData) ||
          r.body instanceof URLSearchParams ||
          Nu(r.body)
            ? r.body
            : JSON.stringify(
                r.body
                  ? (0, cn.default)(r.body, this.configuration.globals)
                  : r.body,
              ),
        o = { ...this.configuration.headers, ...r.headers },
        u = { method: r.method, headers: o, body: l }
      return { url: n, init: u }
    }
    async fetchApi(r, e) {
      return await this.configuration.fetchApi(r, e)
    }
  },
  We = class {
    constructor(r = {}) {
      ;((this.config = r),
        r.maxRetry || (this.config.maxRetry = 8),
        (this.config.cache = this.config.cache || {}),
        (this.config.mode = this.config.mode || ye.production),
        this.config.mode == ye.development && (this.config.cache.enabled = !1))
    }
    get cache() {
      return this.config?.cache || {}
    }
    get maxRetry() {
      return this.config.maxRetry || 8
    }
    get origin() {
      return this.config.origin || ''
    }
    get fetchApi() {
      return (
        this.config.fetchApi ||
        (typeof window < 'u' ? window.fetch?.bind(window) : fetch)
      )
    }
    get queryParamsStringify() {
      return this.config.queryParamsStringify || No
    }
    get headers() {
      return this.config.headers || {}
    }
    set headers(r) {
      this.config.headers = r
    }
    get globals() {
      return this.config.globals || {}
    }
    set globals(r) {
      this.config.globals = r
    }
    get mode() {
      return this.config.mode
    }
  }
function No(t, r = '') {
  return Object.keys(t)
    .map((e) => {
      let s = r + (r.length ? `[${e}]` : e),
        i = t[e]
      if (i instanceof Array) {
        let n = i
          .map((a) => encodeURIComponent(String(a)))
          .join(`&${encodeURIComponent(s)}=`)
        return `${encodeURIComponent(s)}=${n}`
      }
      return i instanceof Date
        ? `${encodeURIComponent(s)}=${encodeURIComponent(i.toISOString())}`
        : i instanceof Object
          ? No(i, s)
          : `${encodeURIComponent(s)}=${encodeURIComponent(String(i))}`
    })
    .filter((e) => e.length > 0)
    .join('&')
}
function zo(...t) {
  let r = {}
  return (
    t.reverse().forEach((e) => {
      Object.keys(e).forEach((s) => {
        let i = e[s] instanceof Array ? e[s] : [e[s]]
        r[s] = (r[s] || []).concat(i)
      })
    }),
    r
  )
}
var fs = 'beacon'
function ae(t) {
  let r = zo(
    ae.sorts(t),
    ae.search(t),
    ae.filters(t),
    ae.merchandising(t),
    ae.pagination(t),
    ae.siteId(t),
    ae.facets(t),
    ae.tracking(t),
    ae.personalization(t),
  )
  return ((r[fs] = !0), r)
}
ae.sorts = (t = {}) =>
  (t.sorts || []).reduce(
    (r, e) =>
      !e.field ||
      !e.direction ||
      (e.direction != 'asc' && e.direction != 'desc')
        ? r
        : {
            ...r,
            ['sort.' + e.field]: (r[e.field] || []).concat([e.direction]),
          },
    {},
  )
ae.search = (t = {}) => {
  let r = t.search || {},
    e = {}
  return (
    r.query && r.query.string && (e.q = r.query.string),
    r.subQuery && (e.rq = r.subQuery.trim()),
    r.originalQuery && (e.originalQuery = r.originalQuery.trim()),
    r.fallbackQuery && (e.fallbackQuery = r.fallbackQuery.trim()),
    r.redirectResponse && (e.redirectResponse = r.redirectResponse),
    r.source && (e.source = r.source),
    r.input && (e.input = r.input),
    e
  )
}
ae.filters = (t = {}) =>
  (t.filters || []).reduce((r, e) => {
    let s = e.background ? 'bgfilter' : 'filter'
    if (e.type == 'value') {
      let i = s + '.' + e.field
      return { ...r, [i]: (r[i] || []).concat([e.value]) }
    } else if (e.type == 'range') {
      let i = s + '.' + e.field + '.low',
        n = s + '.' + e.field + '.high',
        a = e?.value?.low ?? '*',
        l = e?.value?.high ?? '*'
      return {
        ...r,
        [i]: (r[i] || []).concat([a]),
        [n]: (r[n] || []).concat([l]),
      }
    }
    return r
  }, {})
ae.merchandising = (t = {}) => {
  let r = t.merchandising || {},
    e = r.disabled ? { disableMerchandising: !0 } : {}
  return (
    r.landingPage && (e['landing-page'] = r.landingPage),
    r.segments instanceof Array &&
      r.segments.length &&
      (e.tag = r.segments.map((s) => `merch.segment/${s}`)),
    typeof r.intellisuggest == 'boolean' &&
      (e.intellisuggest = r.intellisuggest),
    r.disableInlineBanners && (e.disableInlineBanners = r.disableInlineBanners),
    e
  )
}
ae.pagination = (t = {}) => {
  let r = t.pagination || {},
    e = {}
  return (
    r.page && (e.page = r.page),
    (r.pageSize || r.pageSize === 0) && (e.resultsPerPage = r.pageSize),
    e
  )
}
ae.siteId = (t = {}) => (t.siteId ? { siteId: t.siteId } : {})
ae.facets = (t = {}) => {
  let r = t.facets || {},
    e = {}
  if (r.include && r.include.length && r.exclude && r.exclude.length)
    throw 'cannot use facet include and exclude at the same time'
  return (
    r.include?.length && (e.includedFacets = r.include),
    r.exclude?.length && (e.excludedFacets = r.exclude),
    r.autoDrillDown === !1 && (e.disableFacetDrillDown = !0),
    e
  )
}
ae.tracking = (t = {}) => {
  let r = t.tracking || {},
    e = {}
  return (
    r.userId && (e.userId = r.userId),
    r.domain && (e.domain = r.domain),
    r.sessionId && (e.sessionId = r.sessionId),
    r.pageLoadId && (e.pageLoadId = r.pageLoadId),
    e
  )
}
ae.personalization = (t = {}) => {
  let r = t.personalization || {},
    e = {}
  return (
    r.disabled && (e.skipPersonalization = r.disabled),
    r.cart && (e.cart = r.cart),
    r.lastViewed && (e.lastViewed = r.lastViewed),
    r.shopper && (e.shopper = r.shopper),
    e
  )
}
function dn(t) {
  return t
    .replace(/&gt;/g, '>')
    .replace(/&lt;/g, '<')
    .replace(/&#0?39;/g, "'")
    .replace(/&quot;/g, '"')
    .replace(/&amp;/g, '&')
}
var qo = [
    'uid',
    'sku',
    'name',
    'url',
    'addToCartUrl',
    'price',
    'msrp',
    'imageUrl',
    'secureImageUrl',
    'thumbnailImageUrl',
    'secureThumbnailImageUrl',
    'rating',
    'ratingCount',
    'description',
    'stockMessage',
    'brand',
    'popularity',
    'caption',
  ],
  fn = class {
    constructor(r) {
      Object.assign(this, r)
    }
  }
function oe(t, r) {
  return {
    ...oe.pagination(t),
    ...oe.results(t),
    ...oe.filters(t),
    ...oe.facets(t, r),
    ...oe.sorting(t),
    ...oe.merchandising(t),
    ...oe.search(t, r),
    ...oe.tracking(t),
  }
}
oe.pagination = (t) => {
  let r = t?.pagination
  return {
    pagination: {
      totalResults: r?.totalResults,
      page: r?.currentPage,
      pageSize: r?.perPage,
      totalPages: r?.totalPages,
    },
  }
}
oe.results = (t) => ({
  results: (t?.results || []).map((e) => oe.result(e, t)),
})
oe.result = (t, r) => {
  let e = qo.reduce(
    (n, a) => (typeof t[a] < 'u' ? { ...n, [a]: un(t[a] || '') } : n),
    {},
  )
  ;(e.price && (e.price = +e.price), e.msrp && (e.msrp = +e.msrp))
  let s = Object.keys(t)
      .filter((n) => qo.indexOf(n) == -1)
      .filter(
        (n) =>
          !(
            n == 'badges' &&
            Array.isArray(t[n]) &&
            typeof t[n]?.[0] == 'object'
          ),
      )
      .reduce((n, a) => ({ ...n, [a]: un(t[a] || '') }), {}),
    i =
      t?.children?.map((n) => ({
        attributes: {
          ...Object.keys(n).reduce((a, l) => ({ ...a, [l]: un(n[l]) }), {}),
        },
      })) || []
  return new fn({
    id: t.uid,
    responseId: r.responseId,
    mappings: { core: e },
    attributes: s,
    badges:
      Array.isArray(t.badges) && typeof t.badges[0] == 'object' ? t.badges : [],
    children: i,
  })
}
oe.filters = (t) => ({
  filters: (t?.filterSummary || []).map((e) => {
    let s = e.value,
      i = 'value'
    return (
      typeof e.value == 'object' &&
        e &&
        e.value &&
        e.value.rangeHigh &&
        e.value.rangeLow &&
        ((i = 'range'),
        (s = { low: +e.value.rangeLow, high: +e.value.rangeHigh })),
      { type: i, field: e.field, label: e.filterValue, value: s }
    )
  }),
})
oe.facets = (t, r = {}) => {
  let e = r.filters || [],
    s = t?.facets || [],
    i = r?.facets?.limit,
    n = r?.facets?.valueLimit,
    a = s.map((l) => {
      let o = { field: l.field, type: 'value', filtered: !!l.facet_active }
      if (l.step)
        (l.range &&
          (o = {
            ...o,
            type: 'range',
            step: l.step,
            range: {
              low: l.range[0] == '*' ? void 0 : +l.range[0],
              high: l.range[1] == '*' ? void 0 : +l.range[1],
            },
          }),
          l.active &&
            typeof l.active != 'boolean' &&
            l.active.length > 1 &&
            (o.active = {
              low: l.active[0] == '*' ? void 0 : +l.active[0],
              high: l.active[1] == '*' ? void 0 : +l.active[1],
            }))
      else if (l.values instanceof Array)
        if (l.type == 'hierarchy') {
          ;((o.type = 'value'),
            (o.values = (l.values || []).map((f) => ({
              filtered: !!f.active,
              value: f.value,
              label: f.label,
              count: f.count,
            }))))
          let u = e.find((f) => f.field == l.field),
            h = []
          if (u && !u.background) {
            let f = u.value?.split(l.hierarchyDelimiter || '>')
            if (f)
              for (let m = f.length - 1; m >= 0; m--) {
                let c = f.slice(0, m + 1),
                  d = c.join(l.hierarchyDelimiter)
                h.unshift({
                  value: d,
                  filtered: d == u.value,
                  label: c[c.length - 1],
                })
              }
            h.unshift({ value: null, filtered: !1, label: 'View All' })
          }
          o.values = h.concat(o.values)
        } else
          l.values[0].type == 'value'
            ? ((o.type = 'value'),
              (o.values = l.values.map((u) => ({
                filtered: u.active,
                value: u.value,
                label: u.label,
                count: u.count,
              }))))
            : l.values[0].type == 'range' &&
              ((o.type = 'range-buckets'),
              (o.values = l.values.map((u) => ({
                filtered: u.active,
                low: u.low == '*' ? null : u.low ? +u.low : null,
                high: u.high == '*' ? null : u.high ? +u.high : null,
                label: u.label,
                count: u.count,
              }))))
      return o
    })
  return (
    i && (a = a.slice(0, i)),
    n && (a = a.map((l) => (l.values && (l.values = l.values.slice(0, n)), l))),
    { facets: a }
  )
}
oe.sorting = (t) => ({
  sorting: (t?.sorting?.options || [])
    .filter((s) => s.active)
    .map((s) => ({ field: s.field, direction: s.direction })),
})
oe.merchandising = (t) => {
  let r = t?.merchandising
  return (
    r?.content &&
      Array.isArray(r.content) &&
      !r.content.length &&
      (r.content = {}),
    {
      merchandising: {
        redirect: r?.redirect || '',
        content: r?.content || {},
        campaigns: r?.triggeredCampaigns || [],
        personalized: r?.personalized,
        experiments: r?.experiments || [],
      },
    }
  )
}
oe.search = (t, r) => {
  let e = {
    search: {
      query: r?.search?.query?.string,
      didYouMean: t?.didYouMean?.query,
      matchType: t?.query?.matchType,
    },
  }
  return (
    t?.query?.corrected && t?.query.original
      ? ((e.search.query = t?.query?.corrected),
        (e.search.originalQuery = t?.query?.original))
      : r?.search?.originalQuery &&
        (e.search.originalQuery = r?.search?.originalQuery),
    e
  )
}
oe.tracking = (t) => ({ tracking: { responseId: t.responseId } })
function un(t) {
  return Array.isArray(t)
    ? t.map((r) => (typeof r == 'string' ? dn(String(r)) : r))
    : dn(String(t))
}
function ot(t) {
  return {
    ...ot.query(t),
    ...ot.correctedQuery(t),
    ...ot.suggested(t),
    ...ot.alternatives(t),
  }
}
ot.query = (t) => (t?.query ? { query: t.query } : {})
ot.correctedQuery = (t) =>
  typeof t != 'object' || !t['corrected-query']
    ? {}
    : { correctedQuery: t['corrected-query'] }
ot.suggested = (t) =>
  typeof t != 'object' || !t.suggested || typeof t.suggested != 'object'
    ? {}
    : {
        suggested: {
          text: t.suggested?.text,
          type: t.suggested?.type,
          source: t.suggested?.source,
        },
      }
ot.alternatives = (t) => ({
  alternatives: (t?.alternatives || []).map((e) => ({ text: e.text })),
})
var hn = (t) => {
  if (!t) return
  let r = []
  return (
    t.map((e) => {
      if (e.type == 'value') {
        let s = r.findIndex((i) => i.field == e.field)
        if (s > -1) r[s].values.push(e.value)
        else {
          let i = { field: e.field, type: '=', values: [e.value] }
          r.push(i)
        }
      } else if (e.type == 'range') {
        if (typeof e.value.low == 'number') {
          let s = { field: e.field, type: '>=', values: [e.value.low] },
            i = r.findIndex((n) => n.field == e.field && n.type == '>=')
          i > -1 ? (r[i] = s) : r.push(s)
        }
        if (typeof e.value.high == 'number') {
          let s = { field: e.field, type: '<=', values: [e.value.high] },
            i = r.findIndex((n) => n.field == e.field && n.type == '<=')
          i > -1 ? (r[i] = s) : r.push(s)
        }
      }
    }),
    r
  )
}
var ri = class extends at {
  async getEndpoint(r, e = '/api/search/search.json') {
    r.resultsFormat = 'native'
    let s = {},
      i = { ...r }
    return (
      delete i[fs],
      delete i.pageLoadId,
      delete i.domain,
      delete i.input,
      await this.request(
        { path: e, method: 'GET', headers: s, query: r },
        JSON.stringify(i),
      )
    )
  }
  async postMeta(r) {
    let e = {}
    return (
      (e['Content-Type'] = 'application/json'),
      await this.request(
        { path: '/api/meta/meta.json', method: 'POST', headers: e, body: r },
        JSON.stringify(r),
      )
    )
  }
  async getMeta(r) {
    let e = {}
    return await this.request(
      { path: '/api/meta/meta.json', method: 'GET', headers: e, query: r },
      JSON.stringify(r),
    )
  }
  async getSearch(r) {
    return (
      (r.ajaxCatalog = 'Snap'),
      this.getEndpoint(r, '/api/search/search.json')
    )
  }
  async getCategory(r) {
    return (
      (r.ajaxCatalog = 'Snap'),
      this.getEndpoint(r, '/api/search/category.json')
    )
  }
  async getAutocomplete(r) {
    return (
      (r.ajaxCatalog = 'Snap'),
      this.getEndpoint(r, '/api/search/autocomplete.json')
    )
  }
  async getFinder(r) {
    return (
      (r.ajaxCatalog = 'Snap'),
      this.getEndpoint(r, '/api/search/finder.json')
    )
  }
}
var mn = Rs(ds())
var br = 'test',
  Ft = class extends at {
    constructor(r, e) {
      super(r)
      let s = (0, mn.default)(
        {
          mode: this.configuration.mode,
          origin: this.configuration.origin,
          cache: this.configuration.cache,
          fetchApi: this.configuration.fetchApi,
        },
        e?.legacy || {},
      )
      r.mode == ye.development && (s.headers = { ...s.headers })
      let i = (0, mn.default)(
          {
            mode: this.configuration.mode,
            origin: this.configuration.origin,
            cache: this.configuration.cache,
            fetchApi: this.configuration.fetchApi,
          },
          e?.suggest || {},
        ),
        n = new We(s),
        a = new We(i)
      this.requesters = { legacy: new ri(n), suggest: new Tr(a) }
    }
    async getMeta(r) {
      let e = r
      return this.requesters.legacy.getMeta(e)
    }
    async getSearch(r) {
      let e = ae(r)
      this.configuration.mode == ye.development && (e[br] = !0)
      let s = await this.requesters.legacy.getSearch(e)
      return oe(s, r)
    }
    async getCategory(r) {
      let e = ae(r)
      this.configuration.mode == ye.development && (e[br] = !0)
      let s = await this.requesters.legacy.getCategory(e)
      return oe(s, r)
    }
    async getFinder(r) {
      let e = ae(r)
      this.configuration.mode == ye.development && (e[br] = !0)
      let s = await this.requesters.legacy.getFinder(e)
      return oe(s, r)
    }
    async getAutocomplete(r) {
      let e = ae(r),
        s = {
          siteId: e.siteId,
          language: 'en',
          query: e.q,
          suggestionCount: (r.suggestions || {}).count || 5,
        }
      ;((r.search || {}).query || {}).spellCorrection ||
        (s.disableSpellCorrect = !0)
      let i = await this.requesters.suggest.getSuggest(s),
        n = ot(i),
        a = (n.suggested || {}).text || n.correctedQuery || n.query
      this.requesters.suggest.configuration?.globals
        ?.integratedSpellCorrection &&
        (a = (n.suggested || {}).text || n.query || n.correctedQuery)
      let l = { ...e, redirectResponse: 'full', q: a }
      ;(this.configuration.mode == ye.development && (l[br] = !0),
        r.search?.query?.string && (r.search.query.string = a))
      let o = await this.requesters.legacy.getAutocomplete(l)
      return { ...oe(o, r), autocomplete: n }
    }
  }
var gn = class {
    constructor() {
      this.promise = new Promise((r, e) => {
        ;((this.reject = e), (this.resolve = r))
      })
    }
  },
  zu = 150,
  si = class extends at {
    constructor(r) {
      ;(super(r), (this.batches = {}))
    }
    async getProfile(r) {
      let e = {}
      return await this.request(
        {
          path: '/api/personalized-recommendations/profile.json',
          method: 'GET',
          headers: e,
          query: r,
        },
        JSON.stringify(r),
      )
    }
    async batchRecommendations(r) {
      let e = r.batchId || 1,
        s = r.batched
          ? `${r.profile?.siteId || r.siteId}:${e}`
          : `${Math.random()}:${e}`,
        i = (this.batches[s] = this.batches[s] || {
          timeout: null,
          request: { profiles: [] },
          entries: [],
        }),
        n = new gn()
      i.entries.push({ request: r, deferred: n })
      let a = typeof window < 'u' ? window.clearTimeout : clearTimeout,
        l = typeof window < 'u' ? window.setTimeout : setTimeout
      return (
        a && a(i.timeout),
        (i.timeout = l(async () => {
          ;(delete this.batches[s],
            i.entries.sort(qu),
            i.entries.map((o) => {
              if (
                (o.request.product &&
                  (Array.isArray(o.request.products) &&
                  o.request.products.indexOf(o.request.product) == -1
                    ? (o.request.products = o.request.products.concat(
                        o.request.product,
                      ))
                    : (o.request.products = [o.request.product])),
                o.request.profile)
              ) {
                let {
                    tag: y,
                    profile: {
                      categories: x,
                      brands: L,
                      blockedItems: M,
                      limit: R,
                      query: w,
                      filters: B,
                      dedupe: k,
                    },
                  } = o.request,
                  E = {
                    tag: y,
                    ...pn({
                      categories: x,
                      brands: L,
                      blockedItems: M,
                      limit: R,
                      searchTerm: w,
                      filters: hn(B),
                      dedupe: k,
                    }),
                  }
                i.request.profiles?.push(E)
              } else {
                let {
                    tag: y,
                    categories: x,
                    brands: L,
                    limit: M,
                    query: R,
                    dedupe: w,
                  } = o.request,
                  B = {
                    tag: y,
                    ...pn({
                      categories: x,
                      brands: L,
                      limit: M,
                      searchTerm: R,
                      dedupe: w,
                    }),
                  }
                i.request.profiles?.push(B)
              }
              let {
                  products: u,
                  blockedItems: h,
                  filters: f,
                  test: m,
                  cart: c,
                  lastViewed: d,
                  shopper: g,
                } = o.request,
                T = Array.from(
                  new Set((i.request.products || []).concat(u || [])),
                ),
                p = Array.from(
                  new Set((i.request.blockedItems || []).concat(h || [])),
                ),
                v = Array.from(
                  new Set(
                    (i.request.filters || [])
                      .concat(hn(f) || [])
                      .map((y) => JSON.stringify(y)),
                  ),
                ).map((y) => JSON.parse(y))
              ;((i.request = {
                ...i.request,
                ...pn({
                  siteId: o.request.profile?.siteId || o.request.siteId,
                  products: T.length ? T : void 0,
                  blockedItems: p.length ? p : void 0,
                  filters: v.length ? v : void 0,
                  test: m,
                  cart: c,
                  lastViewed: d,
                  shopper: g,
                }),
                [fs]: !0,
              }),
                this.configuration.mode == ye.development &&
                  (i.request[br] = !0))
            }))
          try {
            this.configuration.mode == ye.development && (i.request.test = !0)
            let o = await this.postRecommendations(i.request)
            i.entries?.forEach((u, h) => {
              u.deferred.resolve([o[h]])
            })
          } catch (o) {
            i.entries?.forEach((u) => {
              u.deferred.reject(o)
            })
          }
        }, zu)),
        n.promise
      )
    }
    async postRecommendations(r) {
      let e = {}
      return (
        (e['Content-Type'] = 'text/plain'),
        await this.request(
          {
            path: '/v1/recommend',
            method: 'POST',
            headers: e,
            body: r,
            subDomain: 'p13n',
          },
          JSON.stringify(r),
        )
      )
    }
  }
function qu(t, r) {
  let e = t.request,
    s = r.request,
    i = e.order || e.profile?.order,
    n = s.order || s.profile?.order
  return i == null && n == null
    ? 0
    : i == null && n != null
      ? 1
      : (n == null && i != null) || i < n
        ? -1
        : i > n
          ? 1
          : 0
}
function pn(t) {
  let r = {}
  return (
    Object.keys(t).map((e) => {
      t[e] !== void 0 && (r[e] = t[e])
    }),
    r
  )
}
var Tr = class extends at {
  async getSuggest(r) {
    let e = {}
    return await this.request(
      { path: '/api/suggest/query', method: 'GET', headers: e, query: r },
      JSON.stringify(r),
    )
  }
  async postSuggest(r) {
    let e = {}
    return (
      (e['Content-Type'] = 'application/json'),
      await this.request(
        { path: '/api/suggest/query', method: 'POST', headers: e, body: r },
        JSON.stringify(r),
      )
    )
  }
  async getTrending(r) {
    let e = {}
    return await this.request(
      { path: '/api/suggest/trending', method: 'GET', headers: e, query: r },
      JSON.stringify(r),
    )
  }
  async postTrending(r) {
    let e = {}
    return (
      (e['Content-Type'] = 'application/json'),
      await this.request(
        { path: '/api/suggest/trending', method: 'POST', headers: e, body: r },
        JSON.stringify(r),
      )
    )
  }
}
var Ct = Rs(ds()),
  Uu = {
    mode: ye.production,
    meta: { cache: { purgeable: !1 } },
    search: {},
    autocomplete: {},
    recommend: {},
    finder: {},
    suggest: {},
  },
  ii = class {
    constructor(r, e = {}) {
      if (((this.mode = ye.production), !r?.siteId))
        throw 'no siteId specified!'
      ;((this.globals = r),
        (this.config = (0, Ct.default)(Uu, e)),
        Object.values(ye).includes(this.config.mode) &&
          (this.mode = this.config.mode),
        (this.requesters = {
          autocomplete: new Ft(
            new We({
              fetchApi: this.config.fetchApi,
              mode: this.mode,
              origin: this.config.autocomplete?.origin,
              headers: this.config.autocomplete?.headers,
              cache: this.config.autocomplete?.cache,
              globals: this.config.autocomplete?.globals,
            }),
            this.config.autocomplete?.requesters,
          ),
          meta: new Ft(
            new We({
              fetchApi: this.config.fetchApi,
              mode: this.mode,
              origin: this.config.meta?.origin,
              headers: this.config.meta?.headers,
              cache: this.config.meta?.cache,
              globals: this.config.meta?.globals,
            }),
          ),
          recommend: new si(
            new We({
              fetchApi: this.config.fetchApi,
              mode: this.mode,
              origin: this.config.recommend?.origin,
              headers: this.config.recommend?.headers,
              cache: this.config.recommend?.cache,
              globals: this.config.recommend?.globals,
            }),
          ),
          search: new Ft(
            new We({
              fetchApi: this.config.fetchApi,
              mode: this.mode,
              origin: this.config.search?.origin,
              headers: this.config.search?.headers,
              cache: this.config.search?.cache,
              globals: this.config.search?.globals,
            }),
          ),
          finder: new Ft(
            new We({
              fetchApi: this.config.fetchApi,
              mode: this.mode,
              origin: this.config.finder?.origin,
              headers: this.config.finder?.headers,
              cache: this.config.finder?.cache,
              globals: this.config.finder?.globals,
            }),
          ),
          suggest: new Tr(
            new We({
              fetchApi: this.config.fetchApi,
              mode: this.mode,
              origin: this.config.suggest?.origin,
              headers: this.config.suggest?.headers,
              cache: this.config.suggest?.cache,
              globals: this.config.suggest?.globals,
            }),
          ),
        }))
    }
    async meta(r) {
      let e = { siteId: this.globals.siteId }
      return (
        (r = (0, Ct.default)(e, r || {})),
        this.requesters.meta.getMeta(r)
      )
    }
    async autocomplete(r = {}) {
      if (!r.search?.query?.string) throw 'query string parameter is required'
      return (
        (r = (0, Ct.default)(this.globals, r)),
        Promise.all([
          this.meta({ siteId: r.siteId || '' }),
          this.requesters.autocomplete.getAutocomplete(r),
        ])
      )
    }
    async search(r = {}) {
      return (
        (r = (0, Ct.default)(this.globals, r)),
        Promise.all([
          this.meta({ siteId: r.siteId || '' }),
          this.requesters.search.getSearch(r),
        ])
      )
    }
    async category(r = {}) {
      return (
        (r = (0, Ct.default)(this.globals, r)),
        Promise.all([
          this.meta({ siteId: r.siteId || '' }),
          this.requesters.search.getCategory(r),
        ])
      )
    }
    async finder(r = {}) {
      return (
        (r = (0, Ct.default)(this.globals, r)),
        Promise.all([
          this.meta({ siteId: r.siteId || '' }),
          this.requesters.finder.getFinder(r),
        ])
      )
    }
    async trending(r) {
      return (
        (r = (0, Ct.default)({ siteId: this.globals.siteId }, r || {})),
        this.requesters.suggest.getTrending(r)
      )
    }
    async recommend(r) {
      let { tag: e, ...s } = r
      if (!e) throw 'tag parameter is required'
      let i = { tag: e, siteId: r.siteId || this.globals.siteId }
      s.branch && ((i.branch = s.branch), delete s.branch)
      let n = { tag: e, ...s, siteId: r.siteId || this.globals.siteId },
        [a, l, o] = await Promise.all([
          this.meta(r.siteId ? { siteId: r.siteId } : void 0),
          this.requesters.recommend.getProfile(i),
          this.requesters.recommend.batchRecommendations(n),
        ])
      return {
        ...l,
        meta: a,
        results: o[0] && o[0].results,
        responseId: o[0] ? o[0].responseId : '',
      }
    }
  }
var vn = null,
  Je = class extends _ {
    get client() {
      if (!vn) {
        let r = document
          .querySelector('meta[name="searchspring-site-id"]')
          ?.getAttribute('content')
        if (!r) throw new Error('SearchSpring site ID is not configured.')
        vn = new ii({ siteId: r })
      }
      return vn
    }
    async getRecommendations(r, e, s) {
      let { products: i } = await this.getRecommendationsWithMeta(r, e, s)
      return i
    }
    async getRecommendationsWithMeta(r, e, s) {
      let i = { tag: r, limit: e, products: s ? [s] : [], batched: !0 },
        n = await this.client.recommend(i),
        a = Array.isArray(n) ? n[0] : n
      if (!a?.results || a.results.length === 0)
        return { products: [], responseId: '', tag: r }
      let l = a.responseId ?? '',
        o = a.profile?.tag ?? r
      return { products: a.results, responseId: l, tag: o }
    }
    updateResultsCountTargets(r, e) {
      if (!r || r.length === 0) return
      let s = typeof e == 'number' ? `(${e})` : ''
      r.forEach((i) => {
        i.textContent = s
      })
    }
    injectHtmlIntoTarget(r, e) {
      if (!e || e.trim().length === 0) return
      let s = document.createElement('div')
      s.innerHTML = e
      let i = s.firstElementChild?.innerHTML ?? e
      return (
        r.classList.add('content-updating'),
        r.classList.remove('content-ready'),
        requestAnimationFrame(() => {
          ;((r.innerHTML = i),
            requestAnimationFrame(() => {
              ;(r.classList.remove('content-updating'),
                r.classList.add('content-ready'))
            }))
        }),
        r.innerHTML
      )
    }
  }
function ju(t) {
  try {
    return decodeURIComponent(t)
  } catch {
    return t
  }
}
function yn(t) {
  let r = t.replace(/\+/g, ' ')
  return ju(r).trim()
}
var bn = 'SORT',
  Sr = class {
    constructor(r) {
      b(this, 'callbacks')
      this.callbacks = r
    }
    updateSortParams(r, e) {
      let s = new URLSearchParams(window.location.search)
      ;(s.set('sort.field', r), s.set('sort.direction', e), s.delete('page'))
      let i = decodeURIComponent(s.toString())
      ;(window.history.pushState({}, '', `${window.location.pathname}?${i}`),
        this.callbacks.onSortChange())
    }
    handleSortClick(r) {
      r.preventDefault()
      let e = r.currentTarget,
        s = e.dataset.sortField ?? '',
        i = e.dataset.sortDirection ?? ''
      !s || !i || this.updateSortParams(s, i)
    }
    handleSortChange(r) {
      let s = r.currentTarget.value
      if (!s) return
      let [i, n] = s.split(':')
      !i || !n || this.updateSortParams(i, n)
    }
    getCurrentSortParams() {
      let r = new URLSearchParams(window.location.search)
      return {
        field: r.get('sort.field') ?? void 0,
        direction: r.get('sort.direction') ?? void 0,
      }
    }
    getSortLabel(r = []) {
      let { field: e, direction: s } = this.getCurrentSortParams()
      if (!e || !s) return bn
      let i = r.find((n) => n.field === e && n.direction === s)
      return i && i.label ? `${bn} ${i.label.toUpperCase()}` : bn
    }
    updateSortLabel(r, e) {
      let s = this.getSortLabel(e)
      if ('labelTarget' in r) {
        let i = r.labelTarget
        i && (i.textContent = s)
      }
    }
  }
var Er = class {
  constructor(r = {}) {
    b(this, 'callbacks')
    b(this, 'filtersButtonElement', null)
    this.callbacks = r
  }
  setFiltersButton(r) {
    ;((this.filtersButtonElement = r), this.updateFiltersButtonText())
  }
  updateFiltersButtonText() {
    if (!this.filtersButtonElement) return
    let r = this.countActiveFilters(),
      e = 'All Filters',
      s = r > 0 ? `${e} (${r})` : e
    this.filtersButtonElement.textContent = s
  }
  countActiveFilters() {
    let r = new URL(window.location.href).searchParams,
      e = 0
    return (
      r.forEach((s, i) => {
        i.startsWith('filter.') && e++
      }),
      e
    )
  }
  onFiltersChanged() {
    ;(this.updateFiltersButtonText(), this.callbacks.onFilterChange?.())
  }
  clearAllFilters() {
    let r = new URL(window.location.href)
    for (let s of [...r.searchParams.keys()])
      s.startsWith('filter.') && r.searchParams.delete(s)
    r.searchParams.delete('page')
    let e =
      r.searchParams.size > 0
        ? `${r.pathname}?${r.searchParams.toString()}`
        : r.pathname
    ;(window.history.pushState({}, '', e), this.onFiltersChanged())
  }
}
function Uo(t, r) {
  let e = null,
    s = (...i) => {
      ;(e !== null && clearTimeout(e),
        (e = setTimeout(() => {
          ;((e = null), t(...i))
        }, r)))
    }
  return (
    (s.cancel = () => {
      e !== null && (clearTimeout(e), (e = null))
    }),
    s
  )
}
var Wu = 200,
  Vt = class extends Je {
    constructor() {
      super(...arguments)
      b(this, 'pageLoadId')
      b(this, 'userId')
      b(this, 'sessionId')
      b(this, 'allProducts', [])
      b(this, 'productsController', new Ht())
      b(this, 'quickLinksController', new as())
      b(this, 'paginationController', new os())
      b(
        this,
        'sortHandler',
        new Sr({ onSortChange: () => this.handleSortUpdate() }),
      )
      b(this, 'filterHandler', new Er())
      b(this, 'boundOnPopState')
      b(this, 'fallbackHandle', null)
      b(this, 'searchSequence', 0)
      b(
        this,
        'debouncedPerformSearch',
        Uo(() => this.performSearch(), Wu),
      )
    }
    connect() {
      let e = vr()
      ;((this.pageLoadId = e.pageLoadId),
        (this.userId = e.userId),
        (this.sessionId = e.sessionId),
        (this.boundOnPopState = this.onPopState.bind(this)),
        this.hasFiltersButtonTarget &&
          this.filterHandler.setFiltersButton(this.filtersButtonTarget),
        this.performSearch(),
        window.addEventListener('popstate', this.boundOnPopState))
    }
    disconnect() {
      ;(this.searchSequence++,
        this.debouncedPerformSearch.cancel(),
        this.productsController.disconnect(),
        this.quickLinksController.destroy(),
        window.removeEventListener('popstate', this.boundOnPopState))
    }
    onPopState() {
      ;(this.paginationController.reset(),
        (this.allProducts = []),
        this.performSearch(),
        this.filterHandler.onFiltersChanged())
    }
    async performSearch() {
      let e = this.fallbackHandle ?? this.handleValue,
        s = this.fallbackHandle !== null
      if (!e) {
        console.error('[CollectionController] No collection handle provided')
        return
      }
      let i = window.location.pathname.split('/'),
        n = i.indexOf('collections'),
        a = []
      if (n > -1 && i.length > n + 2) {
        let d = i[n + 2]
        d && (a = d.split('+').map((g) => g.trim().replace(/-|\s/g, '')))
      }
      let l = new URL(window.location.href).searchParams,
        o = e === 'new-arrivals',
        u = [],
        { field: h, direction: f } = this.sortHandler.getCurrentSortParams()
      if (
        (o
          ? u.push({
              type: 'value',
              field: 'ss_less_than_90_days',
              value: '1',
              background: !0,
            })
          : u.push({
              type: 'value',
              field: 'collection_handle',
              value: e,
              background: !0,
            }),
        a.forEach((d) => {
          u.push({ type: 'value', field: 'ss_tags', value: d, background: !0 })
        }),
        !s)
      ) {
        let d = pt.getFiltersFromUrl(l),
          g = pt.convertToSearchspringFilters(d)
        u.push(...g)
      }
      let m = pt.getMerchandisingSegmentsFromUrl(l),
        c = {
          search: { query: { string: l.get('q') || '' } },
          filters: u,
          pagination: {
            pageSize: this.productsPerPageValue,
            page: this.paginationController.getCurrentPage(),
          },
          ...(h && f ? { sorts: [{ field: h, direction: f }] } : {}),
          ...(m.length > 0 ? { merchandising: { segments: m } } : {}),
          tracking: {
            userId: this.userId,
            sessionId: this.sessionId,
            pageLoadId: this.pageLoadId,
          },
        }
      try {
        let d = ++this.searchSequence,
          [g, T] = await this.client.search(c)
        if (d !== this.searchSequence) return
        if (!T) {
          this.updateResultsCount(void 0)
          return
        }
        if (T.merchandising?.redirect) {
          window.location.href = T.merchandising.redirect
          return
        }
        this.render(g, T)
      } catch (d) {
        ;(console.error('Searchspring Error:', d),
          this.updateResultsCount(void 0),
          (this.productsTarget.innerHTML = '<p>Error loading products.</p>'))
      }
    }
    render(e, s) {
      let i = s.results || [],
        { field: n, direction: a } = this.sortHandler.getCurrentSortParams()
      if (
        (this.paginationController.updateFromResponse(s),
        this.paginationController.getCurrentPage() === 1
          ? (this.allProducts = i)
          : (this.allProducts = [...this.allProducts, ...i]),
        this.handleValue === 'fit-finder-results' &&
          this.allProducts.length === 0)
      ) {
        ;((this.fallbackHandle = 'best-sellers'),
          (this.allProducts = []),
          this.paginationController.reset(),
          this.hasDescriptionTarget &&
            (this.descriptionTarget.innerHTML = `
        <p>Sorry, no results were found. Shop our best sellers!</p>
        ${this.collectionDescriptionValue}
        `),
          this.performSearch())
        return
      }
      let l = s.tracking?.responseId ?? '',
        o = l ? { module: 'category', responseId: l } : void 0
      if (this.hasProductsTarget) {
        let u = s.merchandising?.content?.inline ?? []
        this.productsController.render(
          this.productsTarget,
          this.allProducts,
          u,
          this.inlineBannersValue,
          o,
        )
      }
      if (
        (l && i.length > 0 && Lt({ module: 'category', responseId: l }),
        this.hasPaginationTarget &&
          this.paginationController.updateVisibility(this.paginationTarget),
        this.updateResultsCount(s.pagination?.totalResults),
        this.hasFiltersTarget && e.facets)
      ) {
        let u = new Map()
        ;(this.filtersTarget
          .querySelectorAll('[data-controller*="collapsible"]')
          .forEach((h) => {
            let f = h.querySelector(
                '[data-collapsible-target="collapsibleTrigger"]',
              ),
              m = h.dataset.field
            m && u.set(m, f.getAttribute('aria-expanded') === 'true')
          }),
          (this.filtersTarget.innerHTML = Ee.renderFacets(
            s.facets || [],
            e.facets,
            'collection',
          )),
          this.filtersTarget
            .querySelectorAll('[data-controller*="collapsible"]')
            .forEach((h) => {
              let f = h.querySelector(
                  '[data-collapsible-target="collapsibleTrigger"]',
                ),
                m = h.querySelector(
                  '[data-collapsible-target="collapsibleContent"]',
                ),
                c = h.querySelector('[data-collapsible-target="icon"]'),
                d = h.dataset.field
              d &&
                u.get(d) &&
                (f.setAttribute('aria-expanded', 'true'),
                m.classList.remove('hidden'),
                c && (c.style.transform = 'rotate(180deg)'))
            }))
      }
      if (this.hasSortingTarget) {
        let u = e.sortOptions ?? []
        this.updateSortingOptions(u, n, a)
      }
      this.hasQuickLinksTarget &&
        this.quickLinksController.render({
          quickLinksTarget: this.quickLinksTarget,
          facets: s.facets || [],
          quickLinkItems: this.safeQuickLinkItems,
          quicklinkFormat: this.quicklinkFormatValue,
          facetField: this.facetFieldValue,
          getActiveFilterValues: this.getActiveFilterValues.bind(this),
          parseFilterEntries: this.parseFilterEntries.bind(this),
        })
    }
    updateSortingOptions(e, s, i) {
      let n = this.sortingTarget.querySelector('select[name="ss-sort"]')
      if (!n) {
        console.warn(
          '[CollectionController] No select element found in sortingTarget',
        )
        return
      }
      let a = Ee.renderSortingOptions(e, s, i)
      n.innerHTML = a
      let l = n.closest('[data-controller*="select"]')
      if (l) {
        let o = this.application?.getControllerForElementAndIdentifier(
          l,
          'select',
        )
        o &&
          ('buildCustomOptions' in o && o.buildCustomOptions(),
          'syncFromNative' in o && o.syncFromNative(),
          this.sortHandler.updateSortLabel(o, e))
      }
    }
    handleFilterClick(e) {
      e.preventDefault()
      let s = e.currentTarget
      ;(window.history.pushState({}, '', s.href),
        this.debouncedPerformSearch(),
        this.filterHandler.onFiltersChanged(),
        this.scrollToProductCardsOnMobile())
    }
    handleQuickLinkClick(e) {
      e.preventDefault()
      let i = e.currentTarget.dataset.filterValue ?? '',
        n = `filter.${this.facetFieldValue}`,
        a = new URLSearchParams(window.location.search)
      ;(i
        ? i.includes('=')
          ? this.applyMetaFilterParams(a, i)
          : this.applyFacetFilterParams(a, i, n)
        : this.clearAllFilterParams(a),
        a.delete('page'))
      let l = decodeURIComponent(a.toString()),
        o = l ? `${window.location.pathname}?${l}` : window.location.pathname
      ;(window.history.pushState({}, '', o),
        this.paginationController.reset(),
        (this.allProducts = []),
        this.performSearch(),
        this.filterHandler.onFiltersChanged(),
        this.scrollToProductCardsOnMobile())
    }
    toggleSortDropdown() {
      if (!this.hasSortMenuTarget) return
      let s = this.sortMenuTarget.classList.toggle('hidden')
      this.sortingTarget
        .querySelector('[data-action*="toggleSortDropdown"]')
        ?.setAttribute('aria-expanded', String(!s))
    }
    handleSortClick(e) {
      this.sortHandler.handleSortClick(e)
    }
    handleSortChange(e) {
      this.sortHandler.handleSortChange(e)
    }
    handleSortUpdate() {
      ;(this.paginationController.reset(),
        (this.allProducts = []),
        this.performSearch())
    }
    handleLoadMore(e) {
      ;(e.preventDefault(),
        this.paginationController.incrementPage(),
        this.performSearch())
    }
    clearAllFilters(e) {
      ;(e.preventDefault(),
        this.filterHandler.clearAllFilters(),
        this.paginationController.reset(),
        (this.allProducts = []),
        this.performSearch(),
        this.scrollToProductCardsOnMobile())
    }
    updateResultsCount(e) {
      this.hasResultsCountTarget &&
        this.updateResultsCountTargets(this.resultsCountTargets, e)
    }
    clearAllFilterParams(e) {
      Array.from(e.keys())
        .filter((s) => s.startsWith('filter.'))
        .forEach((s) => e.delete(s))
    }
    applyMetaFilterParams(e, s) {
      let i = this.parseFilterEntries(s)
      i.some(({ key: a, value: l }) =>
        this.getActiveFilterValues(a).includes(l),
      )
        ? i.forEach(({ key: a, value: l }) => {
            let o = e.getAll(a).filter((u) => u !== l)
            ;(e.delete(a), o.forEach((u) => e.append(a, u)))
          })
        : i.forEach(({ key: a, value: l }) => {
            e.getAll(a).includes(l) || e.append(a, l)
          })
    }
    applyFacetFilterParams(e, s, i) {
      let n = this.getActiveFilterValues(),
        a = s.split(',').map((o) => yn(o))
      if (a.every((o) => n.includes(o))) {
        let o = n.filter((u) => !a.includes(u))
        ;(e.delete(i), o.forEach((u) => e.append(i, u)))
      } else
        a.forEach((o) => {
          n.includes(o) || e.append(i, o)
        })
    }
    getActiveFilterValues(e) {
      let s = e ?? `filter.${this.facetFieldValue}`
      return new URLSearchParams(window.location.search).getAll(s)
    }
    parseFilterEntries(e) {
      return e
        .split('&')
        .map((s) => s.trim())
        .filter(Boolean)
        .flatMap((s) => {
          let i = s.indexOf('=')
          if (i === -1)
            return (
              console.warn(
                `[CollectionController] Malformed filter entry (missing "="): "${s}"`,
              ),
              []
            )
          let n = s.substring(0, i).trim(),
            a = yn(s.substring(i + 1))
          return n
            ? [{ key: n, value: a }]
            : (console.warn(
                `[CollectionController] Malformed filter entry (empty key): "${s}"`,
              ),
              [])
        })
    }
    get safeQuickLinkItems() {
      return Array.isArray(this.quicklinkItemsValue)
        ? this.quicklinkItemsValue
        : []
    }
    scrollToProductCardsOnMobile(e = '[data-product-cards]') {
      if (window.innerWidth >= Qe.md) return
      let s = document.querySelector(e)
      s && s.scrollIntoView({ behavior: 'smooth', block: 'start' })
    }
  }
;(b(Vt, 'targets', [
  'products',
  'filters',
  'quickLinks',
  'sorting',
  'sortMenu',
  'pagination',
  'filtersButton',
  'resultsCount',
  'description',
]),
  b(Vt, 'values', {
    handle: String,
    productsPerPage: { type: Number, default: 60 },
    facetField: { type: String, default: 'ss_tags_category' },
    quicklinkFormat: { type: String, default: 'text' },
    quicklinkItems: { type: Array, default: [] },
    inlineBanners: { type: Array, default: [] },
    collectionDescription: { type: String, default: '' },
  }))
var hs = class hs extends _ {
  constructor() {
    super(...arguments)
    b(this, 'swiper', null)
    b(this, 'isAutoplayPaused', !1)
    b(this, 'intersectionObserver', null)
    b(this, 'initPromise', null)
  }
  connect() {
    if (typeof IntersectionObserver > 'u') {
      this.ensureSwiper()
      return
    }
    ;((this.intersectionObserver = new IntersectionObserver(
      (e) => {
        for (let s of e)
          if (s.isIntersecting) {
            ;(this.ensureSwiper(), this.disconnectObserver())
            break
          }
      },
      { rootMargin: '300px' },
    )),
      this.intersectionObserver.observe(this.element))
  }
  disconnect() {
    ;(this.disconnectObserver(),
      this.swiper?.destroy(!0, !0),
      (this.swiper = null),
      (this.initPromise = null))
  }
  async toggleAutoplay(e) {
    ;(e.preventDefault(),
      e.stopPropagation(),
      await this.ensureSwiper(),
      this.swiper &&
        (this.isAutoplayPaused
          ? (this.swiper.autoplay.start(), (this.isAutoplayPaused = !1))
          : (this.swiper.autoplay.stop(), (this.isAutoplayPaused = !0)),
        this.updateAutoplayIconState()))
  }
  ensureSwiper() {
    return this.swiper
      ? Promise.resolve()
      : this.initPromise
        ? this.initPromise
        : ((this.initPromise = this.initialiseSwiper().catch((e) => {
            throw ((this.initPromise = null), e)
          })),
          this.initPromise)
  }
  async initialiseSwiper() {
    let [{ default: e }, { Autoplay: s, A11y: i }] = await Promise.all([
      Promise.resolve().then(() => (ur(), js)),
      Promise.resolve().then(() => (pr(), Xs)),
    ])
    if (!this.element.isConnected || this.swiper) return
    let n = this.element.querySelector('.swiper')
    n instanceof HTMLElement &&
      ((this.swiper = new e(n, {
        modules: [s, i],
        slidesPerView: 1,
        loop: !0,
        speed: 700,
        autoHeight: !0,
        autoplay: { delay: hs.AUTOPLAY_DELAY_MS, disableOnInteraction: !1 },
      })),
      this.updateAutoplayIconState())
  }
  disconnectObserver() {
    ;(this.intersectionObserver?.disconnect(),
      (this.intersectionObserver = null))
  }
  updateAutoplayIconState() {
    if (
      !(!this.hasPlayIconTarget || !this.hasPauseIconTarget) &&
      (this.playIconTarget.classList.toggle('hidden', !this.isAutoplayPaused),
      this.pauseIconTarget.classList.toggle('hidden', this.isAutoplayPaused),
      this.hasToggleButtonTarget)
    ) {
      let e = this.isAutoplayPaused ? 'Continue autoplay' : 'Pause autoplay'
      this.toggleButtonTarget.setAttribute('aria-label', e)
    }
  }
}
;(b(hs, 'targets', ['toggleButton', 'playIcon', 'pauseIcon']),
  b(hs, 'AUTOPLAY_DELAY_MS', 3e3))
var ms = hs
var _t = class extends _ {
  connect() {
    if (!this.hasUtmSlugValue) return
    let r = this.utmSlugValue.trim().toLowerCase()
    if (r.length === 0) return
    let e = this.readCampaignCookieValue(),
      s = e !== void 0 && this.valueMatchesSlug(e, r)
    this.hasBadgeTarget
      ? (this.badgeTarget.classList.toggle('hidden', !s),
        this.hasFallbackTarget &&
          this.fallbackTarget.classList.toggle('hidden', s),
        this.element.classList.remove('invisible'))
      : this.element.classList.toggle('invisible', !s)
  }
  readCampaignCookieValue() {
    let r = gr('utm_campaign')
    if (r !== void 0 && r.trim().length > 0)
      try {
        return decodeURIComponent(r).toLowerCase()
      } catch {
        console.warn(
          `[PromoMessageController] Failed to decode cookie value: ${r}`,
        )
      }
  }
  valueMatchesSlug(r, e) {
    return r === e
      ? !0
      : r
          .split(/[|,\s]+/)
          .map((i) => i.trim())
          .filter((i) => i.length > 0)
          .includes(e)
  }
}
;(b(_t, 'values', { utmSlug: String }), b(_t, 'targets', ['badge', 'fallback']))
var me,
  jo,
  ps,
  xr,
  gs,
  $t = class extends _ {
    constructor() {
      super(...arguments)
      _n(this, me)
      b(this, 'currentIndex', 0)
      b(this, 'timer', null)
      b(this, 'prefersReduced', !1)
      b(this, 'isPaused', !1)
      b(this, 'pauseIcon', null)
      b(this, 'playIcon', null)
    }
    connect() {
      ;((this.currentIndex = 0),
        (this.timer = null),
        (this.prefersReduced = window.matchMedia(
          '(prefers-reduced-motion: reduce)',
        ).matches),
        (this.isPaused = this.prefersReduced),
        (this.pauseIcon = this.element.querySelector(
          '[data-promo-banner-icon="pause"]',
        )),
        (this.playIcon = this.element.querySelector(
          '[data-promo-banner-icon="play"]',
        )),
        this.isPaused
          ? xe(this, me, gs).call(this, !0)
          : (xe(this, me, gs).call(this, !1), xe(this, me, ps).call(this)))
    }
    disconnect() {
      xe(this, me, xr).call(this)
    }
    togglePause() {
      ;((this.isPaused = !this.isPaused),
        this.isPaused
          ? (xe(this, me, xr).call(this), xe(this, me, gs).call(this, !0))
          : (xe(this, me, gs).call(this, !1), xe(this, me, ps).call(this)))
    }
    hoverPause() {
      xe(this, me, xr).call(this)
    }
    hoverResume() {
      this.isPaused || xe(this, me, ps).call(this)
    }
    focusPause() {
      xe(this, me, xr).call(this)
    }
    focusResume() {
      this.isPaused || xe(this, me, ps).call(this)
    }
  }
;((me = new WeakSet()),
  (jo = function (e) {
    let s = this.promoMessageSlideTargets.length
    s !== 0 &&
      ((this.currentIndex = ((e % s) + s) % s),
      this.promoMessageSlideTargets.forEach((i, n) => {
        let a = n === this.currentIndex
        ;(i.classList.toggle('relative', a),
          i.classList.toggle('opacity-100', a),
          i.classList.toggle('translate-y-0', a),
          i.classList.toggle('pointer-events-auto', a),
          i.classList.toggle('visible', a),
          i.classList.toggle('absolute', !a),
          i.classList.toggle('inset-0', !a),
          i.classList.toggle('opacity-0', !a),
          i.classList.toggle('translate-y-2', !a),
          i.classList.toggle('pointer-events-none', !a),
          i.classList.toggle('invisible', !a),
          i.setAttribute('aria-hidden', a ? 'false' : 'true'))
      }))
  }),
  (ps = function () {
    this.isPaused ||
      this.promoMessageSlideTargets.length <= 1 ||
      (xe(this, me, xr).call(this),
      (this.timer = setInterval(
        () => xe(this, me, jo).call(this, this.currentIndex + 1),
        this.intervalValue,
      )))
  }),
  (xr = function () {
    this.timer && (clearInterval(this.timer), (this.timer = null))
  }),
  (gs = function (e) {
    this.hasPausePlayBtnTarget &&
      (this.pausePlayBtnTarget.setAttribute(
        'aria-label',
        e ? this.playLabelValue : this.pauseLabelValue,
      ),
      this.pausePlayBtnTarget.setAttribute('aria-pressed', String(e)),
      this.pauseIcon &&
        ((this.pauseIcon.style.display = e ? 'none' : ''),
        this.pauseIcon.classList.toggle('hidden', e)),
      this.playIcon &&
        ((this.playIcon.style.display = e ? '' : 'none'),
        this.playIcon.classList.toggle('hidden', !e)))
  }),
  b($t, 'targets', ['promoMessageTrack', 'promoMessageSlide', 'pausePlayBtn']),
  b($t, 'values', {
    interval: { type: Number, default: 5e3 },
    pauseLabel: { type: String, default: 'Pause rotating messages' },
    playLabel: { type: String, default: 'Play rotating messages' },
  }))
function wr(t) {
  let r = document.body,
    e = Number(r.dataset.scrollLockCount ?? '0'),
    s = t ? e + 1 : Math.max(0, e - 1)
  if (s === 0) {
    ;(delete r.dataset.scrollLockCount, r.classList.remove('drawer-open'))
    return
  }
  ;((r.dataset.scrollLockCount = String(s)), r.classList.add('drawer-open'))
}
var Nt = class extends _ {
  constructor() {
    super(...arguments)
    b(this, 'previouslyFocused', null)
    b(this, 'activePanel', null)
    b(this, 'activeBackdrop', null)
    b(this, 'activeTrigger', null)
    b(
      this,
      'focusableSelectors',
      [
        'a[href]',
        'button:not([disabled])',
        'input:not([disabled])',
        'select:not([disabled])',
        'textarea:not([disabled])',
        '[tabindex]:not([tabindex="-1"])',
      ].join(', '),
    )
    b(this, 'onKeydown', (e) => {
      this.activePanel?.hasAttribute('data-open') &&
        (e.key === 'Escape' && (e.stopPropagation(), this.close()),
        e.key === 'Tab' && this.handleTab(e))
    })
  }
  connect() {
    ;(document.addEventListener('keydown', this.onKeydown),
      this.checkAutoOpen())
  }
  disconnect() {
    ;(document.removeEventListener('keydown', this.onKeydown),
      this.restoreScroll())
  }
  open(e) {
    let s = this.resolvePanel(e)
    if (!s) return
    ;((this.activePanel = s), (this.activeBackdrop = this.resolveBackdrop(s)))
    let i = e?.currentTarget instanceof HTMLElement ? e.currentTarget : null
    this.activeTrigger =
      i ?? (this.hasTriggerTarget ? this.triggerTarget : null)
    let n = document.activeElement
    ;((this.previouslyFocused = n instanceof HTMLElement ? n : null),
      s.removeAttribute('hidden'),
      requestAnimationFrame(() => {
        requestAnimationFrame(() => {
          ;(s.setAttribute('data-open', ''),
            this.activeBackdrop?.setAttribute('data-open', ''),
            this.focusFirst())
        })
      }),
      this.lockScroll(),
      this.activeTrigger &&
        this.activeTrigger.setAttribute('aria-expanded', 'true'),
      this.dispatch('opened'))
  }
  close() {
    let e = this.activePanel
    e &&
      (e.removeAttribute('data-open'),
      this.activeBackdrop?.removeAttribute('data-open'),
      this.activeTrigger &&
        this.activeTrigger.setAttribute('aria-expanded', 'false'),
      this.previouslyFocused?.focus(),
      (this.previouslyFocused = null),
      this.restoreScroll(),
      e.addEventListener(
        'transitionend',
        () => {
          e.hasAttribute('data-open') || e.setAttribute('hidden', '')
        },
        { once: !0 },
      ),
      (this.activePanel = null),
      (this.activeBackdrop = null),
      (this.activeTrigger = null),
      this.dispatch('closed'))
  }
  focusFirst() {
    this.getFocusableElements()[0]?.focus()
  }
  handleTab(e) {
    let s = this.getFocusableElements()
    if (s.length === 0) return
    let i = s[0],
      n = s[s.length - 1]
    e.shiftKey
      ? document.activeElement === i && (e.preventDefault(), n.focus())
      : document.activeElement === n && (e.preventDefault(), i.focus())
  }
  getFocusableElements() {
    return this.activePanel
      ? Array.from(
          this.activePanel.querySelectorAll(this.focusableSelectors),
        ).filter((e) => !e.closest('[hidden]'))
      : []
  }
  resolvePanel(e) {
    let s = e?.currentTarget
    if (s instanceof HTMLElement) {
      let i = s.getAttribute('aria-controls')
      if (i) return document.getElementById(i)
    }
    return this.hasPanelTarget ? this.panelTarget : null
  }
  resolveBackdrop(e) {
    let s = e.previousElementSibling
    return s instanceof HTMLElement &&
      s.getAttribute('data-drawer-target') === 'backdrop'
      ? s
      : this.hasBackdropTarget
        ? this.backdropTarget
        : null
  }
  lockScroll() {
    wr(!0)
  }
  restoreScroll() {
    wr(!1)
  }
  checkAutoOpen() {
    if (!this.autoOpenParamValue) return
    let e = new URLSearchParams(window.location.search)
    if (e.get(this.autoOpenParamValue) !== 'open') return
    ;(this.open(), e.delete(this.autoOpenParamValue))
    let s =
      e.toString().length > 0
        ? `${window.location.pathname}?${e.toString()}`
        : window.location.pathname
    window.history.replaceState({}, '', s)
  }
}
;(b(Nt, 'targets', ['panel', 'backdrop', 'trigger']),
  b(Nt, 'values', { autoOpenParam: { type: String, default: '' } }))
var Mr = class extends _ {
  constructor() {
    super(...arguments)
    b(this, 'hideTimeout', null)
    b(this, 'onDrawerOpened', (e) => {
      if (e.target !== this.element) {
        this.setParentHeaderVisible(!1)
        return
      }
      this.setParentHeaderVisible(!0)
    })
    b(this, 'onDrawerClosed', (e) => {
      if (e.target !== this.element) {
        this.setParentHeaderVisible(!0)
        return
      }
      this.resetMobileMenu()
    })
  }
  connect() {
    ;(this.element.addEventListener('drawer:opened', this.onDrawerOpened),
      this.element.addEventListener('drawer:closed', this.onDrawerClosed))
  }
  disconnect() {
    ;(this.element.removeEventListener('drawer:opened', this.onDrawerOpened),
      this.element.removeEventListener('drawer:closed', this.onDrawerClosed))
  }
  openSubmenu(e) {
    let i = e.currentTarget.getAttribute('data-panel')
    if (!i) return
    let n = document.getElementById(i),
      a = this.element.querySelector('[data-mobile-menu-main]')
    n &&
      (a && !a.hasAttribute('hidden')
        ? (a.classList.add(
            'transition-[opacity,transform]',
            'duration-300',
            'ease-in-out',
          ),
          a.classList.add('opacity-0', '-translate-x-4'),
          a.classList.remove('opacity-100', 'translate-x-0'),
          a.addEventListener(
            'transitionend',
            () => {
              ;(a.setAttribute('hidden', ''),
                a.classList.remove(
                  'transition-[opacity,transform]',
                  'duration-300',
                  'ease-in-out',
                ),
                this.showBackButton(),
                n.removeAttribute('hidden'),
                n.classList.remove('opacity-100', 'translate-x-0'),
                n.classList.add('opacity-0', 'translate-x-4'),
                n.offsetHeight,
                n.classList.add(
                  'transition-[opacity,transform]',
                  'duration-300',
                  'ease-in-out',
                ),
                n.classList.add('opacity-100', 'translate-x-0'),
                n.classList.remove('opacity-0', 'translate-x-4'),
                n.addEventListener(
                  'transitionend',
                  () => {
                    ;(n.classList.remove(
                      'transition-[opacity,transform]',
                      'duration-300',
                      'ease-in-out',
                    ),
                      this.element
                        .querySelector('.mobile-menu-back-button')
                        ?.focus())
                  },
                  { once: !0 },
                ))
            },
            { once: !0 },
          ))
        : (this.showBackButton(),
          n.removeAttribute('hidden'),
          n.classList.remove('opacity-100', 'translate-x-0'),
          n.classList.add('opacity-0', 'translate-x-4'),
          n.offsetHeight,
          n.classList.add(
            'transition-[opacity,transform]',
            'duration-300',
            'ease-in-out',
            'opacity-100',
            'translate-x-0',
          ),
          n.classList.remove('opacity-0', 'translate-x-4')))
  }
  closeSubmenu() {
    let e = this.panelTargets.find(
        (i) =>
          !i.hasAttribute('hidden') && i.classList.contains('translate-x-0'),
      ),
      s = this.element.querySelector('[data-mobile-menu-main]')
    e &&
      (this.hideBackButton(),
      e.classList.add(
        'transition-[opacity,transform]',
        'duration-300',
        'ease-in-out',
      ),
      e.classList.add('opacity-0', 'translate-x-4'),
      e.classList.remove('opacity-100', 'translate-x-0'),
      e.addEventListener(
        'transitionend',
        () => {
          ;(e.setAttribute('hidden', ''),
            e.classList.remove(
              'transition-[opacity,transform]',
              'duration-300',
              'ease-in-out',
              'opacity-0',
              'translate-x-4',
            ),
            s &&
              (s.removeAttribute('hidden'),
              s.classList.remove('opacity-100', 'translate-x-0'),
              s.classList.add('opacity-0', '-translate-x-4'),
              s.offsetHeight,
              s.classList.add(
                'transition-[opacity,transform]',
                'duration-300',
                'ease-in-out',
              ),
              s.classList.add('opacity-100', 'translate-x-0'),
              s.classList.remove('opacity-0', '-translate-x-4'),
              s.addEventListener(
                'transitionend',
                () => {
                  s.classList.remove(
                    'transition-[opacity,transform]',
                    'duration-300',
                    'ease-in-out',
                  )
                },
                { once: !0 },
              )))
        },
        { once: !0 },
      ))
  }
  closeAllDrawers() {
    this.application
      .getControllerForElementAndIdentifier(this.element, 'drawer')
      ?.close()
  }
  resetMobileMenu() {
    ;(this.hideTimeout &&
      (clearTimeout(this.hideTimeout), (this.hideTimeout = null)),
      this.panelTargets.forEach((s) => {
        ;(s.setAttribute('hidden', ''),
          s.classList.remove(
            'opacity-100',
            'translate-x-0',
            'opacity-0',
            'translate-x-4',
            'transition-[opacity,transform]',
            'duration-300',
            'ease-in-out',
          ))
      }))
    let e = this.element.querySelector('[data-mobile-menu-main]')
    ;(e &&
      (e.removeAttribute('hidden'),
      e.classList.remove(
        'opacity-0',
        '-translate-x-4',
        'transition-[opacity,transform]',
        'duration-300',
        'ease-in-out',
      ),
      e.classList.add('opacity-100', 'translate-x-0')),
      this.hideBackButton(),
      this.setParentHeaderVisible(!0))
  }
  setParentHeaderVisible(e) {
    this.hasHeaderTarget &&
      (this.headerTarget.classList.toggle('hidden', !e),
      e &&
        this.headerTarget.classList.remove('opacity-0', 'pointer-events-none'))
  }
  showBackButton() {
    let e = this.element.querySelector('.mobile-menu-back-button')
    e && e.classList.remove('hidden')
  }
  hideBackButton() {
    let e = this.element.querySelector('.mobile-menu-back-button')
    e && e.classList.add('hidden')
  }
}
b(Mr, 'targets', ['panel', 'header'])
async function Wo(t) {
  !t.responseId ||
    !t.redirect ||
    (await nt({
      module: 'autocomplete',
      event: 'redirect',
      data: { responseId: t.responseId, redirect: t.redirect },
    }))
}
var Lr = class extends Je {
  constructor() {
    super(...arguments)
    b(this, 'debounceTimer', null)
    b(this, 'DEBOUNCE_MS', 300)
    b(this, 'trendingQueries', [])
    b(this, 'lastResponseId', '')
  }
  connect() {
    ;(super.connect(), this.fetchTrending())
  }
  onInput() {
    if (
      (this.debounceTimer && clearTimeout(this.debounceTimer),
      !this.inputTarget.value.trim())
    ) {
      ;(this.clearResults(), this.showTrending())
      return
    }
    ;(this.showViewAll(),
      (this.debounceTimer = setTimeout(
        () => this.fetchAutocomplete(),
        this.DEBOUNCE_MS,
      )))
  }
  async fetchTrending() {
    try {
      let e = await this.client.trending({ limit: 3 })
      ;((this.trendingQueries = (e.trending?.queries ?? [])
        .map((s) => s.searchQuery ?? '')
        .filter(Boolean)),
        this.showTrending())
    } catch {
      this.trendingQueries = []
    }
  }
  showTrending() {
    !this.hasSuggestionsTarget ||
      this.trendingQueries.length === 0 ||
      this.renderSuggestionList('Top Suggestions', this.trendingQueries)
  }
  async search(e) {
    ;(e.preventDefault(),
      this.debounceTimer && clearTimeout(this.debounceTimer))
    let s = this.inputTarget.value.trim()
    if (!s) return
    let n = e.target.closest('form')?.action ?? de('/search')
    window.location.href = `${n}?q=${encodeURIComponent(s)}`
  }
  async fetchAutocomplete() {
    let e = this.inputTarget.value.trim()
    if (!e) {
      this.clearResults()
      return
    }
    try {
      let [, s] = await this.client.autocomplete({
        suggestions: { count: 10 },
        search: { query: { string: e, spellCorrection: !0 } },
      })
      this.lastResponseId = s.tracking?.responseId ?? ''
      let i = s.merchandising?.redirect
      if (i) {
        ;(Wo({ responseId: this.lastResponseId, redirect: i }),
          (window.location.href = i))
        return
      }
      ;(this.renderSuggestions(s),
        this.renderResults(s),
        this.lastResponseId &&
          Lt({ module: 'autocomplete', responseId: this.lastResponseId }))
    } catch {
      ;(this.clearResults(),
        this.hasSuggestionsTarget && (this.suggestionsTarget.innerHTML = ''))
    }
  }
  renderSuggestions(e) {
    if (!this.hasSuggestionsTarget) return
    let s = e.autocomplete ?? {},
      n = (
        s.suggested?.text
          ? [s.suggested, ...(s.alternatives ?? [])]
          : (s.alternatives ?? [])
      )
        .map((a) => a.text ?? '')
        .filter(Boolean)
        .slice(0, 3)
    n.length !== 0 && this.renderSuggestionList('Search Suggestions', n)
  }
  renderSuggestionList(e, s) {
    this.suggestionsTarget.innerHTML = ''
    let i = document.createElement('p')
    ;((i.className = 'text-body text-primary/50 mb-3'), (i.textContent = e))
    let n = document.createElement('ul')
    n.className = 'search-suggestions'
    for (let a of s) {
      let l = document.createElement('li')
      l.className = 'mb-2 last:mb-0'
      let o = document.createElement('button')
      ;((o.type = 'button'),
        (o.className = 'btn btn-ghost uppercase'),
        (o.dataset.action = 'click->search-drawer#selectSuggestion'),
        (o.dataset.query = a),
        (o.textContent = a),
        l.appendChild(o),
        n.appendChild(l))
    }
    ;(this.suggestionsTarget.appendChild(i),
      this.suggestionsTarget.appendChild(n))
  }
  renderResults(e) {
    if (!this.hasResultsTarget) return
    let i = (e.results ?? []).filter((l) => l.id !== void 0)
    if (i.length === 0) {
      ;((this.resultsTarget.innerHTML = '<p>No results found.</p>'),
        this.hasResultsWrapperTarget && (this.resultsWrapperTarget.hidden = !1),
        this.showRecommendations())
      return
    }
    let n = i.slice(0, 3)
    ;((this.resultsTarget.innerHTML = Ee.renderProductSkeletons(n)),
      this.hasResultsWrapperTarget && (this.resultsWrapperTarget.hidden = !1),
      this.hideRecommendations())
    let a = this.lastResponseId
      ? { module: 'autocomplete', responseId: this.lastResponseId }
      : void 0
    Ee.hydrateProductCards(this.resultsTarget, n, void 0, void 0, a)
  }
  selectSuggestion(e) {
    e.preventDefault()
    let i = e.currentTarget.dataset.query ?? ''
    ;(this.hideSuggestions(),
      (this.inputTarget.value = i),
      this.inputTarget.form?.requestSubmit())
  }
  clearResults() {
    ;(this.hasResultsTarget && (this.resultsTarget.innerHTML = ''),
      this.hasResultsWrapperTarget && (this.resultsWrapperTarget.hidden = !0),
      this.hasSuggestionsTarget && this.hideSuggestions(),
      this.hideViewAll(),
      this.showRecommendations())
  }
  hideSuggestions() {
    this.hasSuggestionsTarget && (this.suggestionsTarget.innerHTML = '')
  }
  showViewAll() {
    if (!this.hasViewAllLinkTarget) return
    let e = this.inputTarget.value.trim()
    if (!e) {
      this.hideViewAll()
      return
    }
    let s = this.inputTarget.form?.action ?? de('/search')
    ;((this.viewAllLinkTarget.href = `${s}?q=${encodeURIComponent(e)}`),
      this.viewAllLinkTarget.removeAttribute('aria-disabled'),
      this.viewAllLinkTarget.removeAttribute('tabindex'),
      this.viewAllLinkTarget.classList.remove(
        'pointer-events-none',
        'opacity-50',
      ))
  }
  hideViewAll() {
    this.hasViewAllLinkTarget &&
      (this.viewAllLinkTarget.setAttribute('aria-disabled', 'true'),
      this.viewAllLinkTarget.setAttribute('tabindex', '-1'),
      this.viewAllLinkTarget.classList.add('pointer-events-none', 'opacity-50'))
  }
  showRecommendations() {
    this.hasRecommendationsTarget && (this.recommendationsTarget.hidden = !1)
  }
  hideRecommendations() {
    this.hasRecommendationsTarget && (this.recommendationsTarget.hidden = !0)
  }
}
b(Lr, 'targets', [
  'input',
  'results',
  'resultsWrapper',
  'suggestions',
  'viewAllLink',
  'recommendations',
])
function Go(t) {
  let r = new URL(t ?? window.location.href, window.location.origin)
    .searchParams
  return {
    size: r.get('size'),
    inseam: r.get('inseam'),
    amount: r.get('amount'),
  }
}
function ni(t, r) {
  let e = new URL(t, window.location.origin)
  return (
    e.searchParams.delete('size'),
    e.searchParams.delete('inseam'),
    r.size && e.searchParams.set('size', r.size),
    r.inseam && e.searchParams.set('inseam', r.inseam),
    e.toString()
  )
}
function Tn(t, r, e) {
  let s = t.querySelector(`[data-variant-type="${r}"][aria-checked="true"]`)
  if (!s) return null
  let i = s.dataset[e]?.trim()
  return i || s.textContent?.trim() || null
}
function Yo(t, r, e, s) {
  let i = t.querySelectorAll(`a[data-variant-type="${r}"]`)
  for (let n of Array.from(i))
    if ((n.dataset[e]?.trim() || n.textContent?.trim()) === s) return n
  return null
}
async function ai(t, r, e = {}) {
  let i = []
  for (let a = 0; a < r.length; a += 5) i.push(r.slice(a, a + 5))
  let n = await Promise.all(
    i.map(async (a) => {
      let l = new URL(t, window.location.origin)
      for (let u of e.stripParams ?? []) l.searchParams.delete(u)
      l.searchParams.set('sections', a.join(','))
      let o = await ir(l.toString(), {
        strategy: e.cacheStrategy ?? 'LONG',
        signal: e.signal,
      })
      if (!o.ok)
        throw new Error(
          `Failed to load Shopify sections: ${o.status} ${o.statusText} for ${l.toString()} with sections ${a.join(', ')}`,
        )
      return o.json()
    }),
  )
  return Object.assign({}, ...n)
}
var bt = class extends _ {
  injectHtmlIntoTarget(r, e, s = null) {
    if (!e || e.trim().length === 0) {
      ;((r.innerHTML = ''), s && s())
      return
    }
    let i = document.createElement('div')
    i.innerHTML = e
    let n = i.firstElementChild?.innerHTML ?? e
    ;(r.classList.add('content-updating'),
      r.classList.remove('content-ready'),
      requestAnimationFrame(() => {
        ;((r.innerHTML = n),
          r.offsetHeight,
          r.classList.remove('content-updating'),
          r.classList.add('content-ready'),
          s && Promise.resolve(s()).catch(console.error))
      }))
  }
}
var Tt = class Tt extends bt {
  constructor() {
    super(...arguments)
    b(this, 'currentAbortController', null)
    b(this, 'onPopState', async (e) => {
      let s = window.location.href
      this.updateProduct(s, !1)
    })
    b(this, 'onSizeChange', (e) => {
      let s = e.target
      if (!(s instanceof HTMLSelectElement) || !/options\[/i.test(s.name))
        return
      let i = s.value
      if (!i) return
      let n = s.name.match(/options\[(.+)\]/i)?.[1]?.trim(),
        a = n && n.toLowerCase() !== 'size' ? n.toLowerCase() : 'size',
        l = new URL(window.location.href)
      ;(l.searchParams.set(a, i),
        window.history.replaceState({}, '', l.toString()))
    })
  }
  connect() {
    this.quickAddValue ||
      (window.addEventListener('popstate', this.onPopState),
      document.addEventListener('change', this.onSizeChange),
      requestAnimationFrame(() => {
        this.applySelectionFromUrl()
      }))
  }
  disconnect() {
    this.quickAddValue ||
      (window.removeEventListener('popstate', this.onPopState),
      document.removeEventListener('change', this.onSizeChange))
  }
  async onArtificialVariantChange(e) {
    e.preventDefault()
    let s = e.currentTarget,
      i = ''
    if (s instanceof HTMLAnchorElement) i = s.href
    else if (s instanceof HTMLSelectElement) i = s.value
    else return
    let n = this.getCurrentSizeSelection(),
      a = this.getCurrentInseamSelection(),
      o = new URL(i, window.location.origin).pathname,
      u = {}
    s instanceof HTMLAnchorElement && s.dataset.variantType === 'inseam'
      ? n && (u.size = n)
      : s instanceof HTMLAnchorElement
        ? (n && (u.size = n), a && (u.inseam = a))
        : s instanceof HTMLSelectElement &&
          s.name === 'inseam' &&
          n &&
          (u.size = n)
    let h = ni(o, u)
    this.updateProduct(h)
  }
  resetAbortController() {
    return (
      this.currentAbortController?.abort(),
      (this.currentAbortController = new AbortController()),
      this.currentAbortController.signal
    )
  }
  get activeSectionKeys() {
    return this.quickAddValue ? Tt.QUICK_ADD_SECTION_KEYS : Tt.SECTION_KEYS
  }
  async fetchSections(e, s) {
    return ai(e, Object.values(this.activeSectionKeys), {
      signal: s,
      stripParams: ['size', 'inseam'],
      cacheStrategy: 'LONG',
    })
  }
  handleUpdateError(e, s) {
    ;(e instanceof DOMException && e.name === 'AbortError') ||
      (console.error('[Product Controller] Error updating product:', e),
      this.quickAddValue || (window.location.href = s))
  }
  async updateProduct(e, s = !0) {
    let i = this.resetAbortController()
    try {
      s && !this.quickAddValue && window.history.pushState({}, '', e)
      let n = await this.fetchSections(e, i)
      if (i.aborted) return
      let {
          SWATCHES: a,
          INSEAMS: l,
          GALLERY: o,
          INFO: u,
          VARIANTS: h,
          CUSTOMERS_SAY: f,
          BNPL: m,
          DESCRIPTION: c,
          STYLE_WITH: d,
        } = this.activeSectionKeys,
        g = [a, l, o, u, h, f, m]
      ;(c && g.push(c), d && g.push(d))
      let T = g.map((k) => n[k] ?? null),
        [p, v, y, x, L, M, R, w = null, B = null] = T
      ;(await this.replaceSection(p, v, y, x, L, M, R, w, B),
        this.quickAddValue && this.rebindQuickAddSizeGuideTrigger(),
        this.applySelectionFromUrl(),
        (this.urlValue = e))
    } catch (n) {
      this.handleUpdateError(n, e)
    }
  }
  async replaceSection(e, s, i, n, a, l, o, u, h) {
    let f = (c, d, g) =>
        new Promise((T) => {
          this.injectHtmlIntoTarget(c, d, () => {
            ;(g?.(), T())
          })
        }),
      m = this.getStyleWithContainer()
    await Promise.all([
      f(this.artificialVariantsInseamContainerTarget, s),
      f(this.productGalleryContainerTarget, i),
      f(this.productInfoContainerTarget, n),
      f(this.productVariantsContainerTarget, a),
      f(this.artificialVariantsSwatchesContainerTarget, e),
      f(this.productCustomersSayContainerTarget, l),
      f(this.productBnplContainerTarget, o),
      ...(this.hasProductDescriptionContainerTarget
        ? [f(this.productDescriptionContainerTarget, u)]
        : []),
      ...(m ? [f(m, h)] : []),
    ])
  }
  getStyleWithContainer() {
    return this.quickAddValue
      ? null
      : document.querySelector('[data-product-style-with-container]')
  }
  rebindQuickAddSizeGuideTrigger() {
    let e = this.element.querySelector(
      '[id^="quick-add-size-guide-"][data-drawer-target="panel"]',
    )
    if (!e) return
    let s = this.productVariantsContainerTarget.querySelector(
      '[data-drawer-target="trigger"][aria-controls]',
    )
    s && s.setAttribute('aria-controls', e.id)
  }
  getCurrentSizeSelection() {
    return (
      this.productVariantsContainerTarget.querySelector(
        'select[name*="options[Size]"], select[name*="options[size]"]',
      )?.value || null
    )
  }
  getCurrentInseamSelection() {
    let e = Tn(
      this.artificialVariantsInseamContainerTarget,
      'inseam',
      'inseamLabel',
    )
    if (e) return e
    let s = this.artificialVariantsInseamContainerTarget.querySelector(
      'select[name="inseam"]',
    )
    return (s && s.selectedOptions[0]?.text?.trim()) || null
  }
  applySelectionFromUrl() {
    let e = Go()
    ;(e.inseam && this.applyInseamFromUrl(e.inseam, e.size)) ||
      (e.size && this.applySizeFromUrl(e.size),
      e.amount && this.applyAmountFromUrl(e.amount))
  }
  applyInseamFromUrl(e, s) {
    let i = this.artificialVariantsInseamContainerTarget,
      n = Tn(i, 'inseam', 'inseamLabel')
    if (n !== null) {
      if (n === e) return !1
      let o = Yo(i, 'inseam', 'inseamLabel', e)
      if (!o) return !1
      let u = {}
      s && (u.size = s)
      let h = ni(new URL(o.href, window.location.origin).pathname, u)
      return (this.updateProduct(h), !0)
    }
    let a = i.querySelector('select[name="inseam"]')
    if (!a) return !1
    let l = a.selectedOptions[0]
    if (l && l.text.trim() === e) return !1
    for (let o of Array.from(a.options))
      if (o.text.trim() === e) {
        let u = {}
        s && (u.size = s)
        let h = ni(o.value, u)
        return (this.updateProduct(h), !0)
      }
    return !1
  }
  applySizeFromUrl(e) {
    let s = this.productVariantsContainerTarget.querySelector(
      'select[name*="options[Size]"], select[name*="options[size]"]',
    )
    s && this.applyValueToVariantSelect(s, e)
  }
  applyAmountFromUrl(e) {
    let s = this.productVariantsContainerTarget.querySelector(
      'select[name*="options[Amount]"], select[name*="options[amount]"]',
    )
    s && this.applyValueToVariantSelect(s, e)
  }
  applyValueToVariantSelect(e, s) {
    Array.from(e.options).find((n) => n.value === s) &&
      ((e.value = s),
      e.dispatchEvent(new Event('change', { bubbles: !0 })),
      this.syncVariantPickerController(e, s))
  }
  syncVariantPickerController(e, s) {
    let i = e.closest(
      '[data-controller="variant-picker"], [data-controller="select"]',
    )
    if (!i) return
    let n = i.matches('[data-controller="variant-picker"]')
        ? 'variant-picker'
        : 'select',
      a = this.application.getControllerForElementAndIdentifier(i, n)
    a && Tt.isSyncableController(a) && a.syncFromNative(s)
  }
  static isSyncableController(e) {
    return (
      typeof e == 'object' &&
      e !== null &&
      'syncFromNative' in e &&
      typeof e.syncFromNative == 'function'
    )
  }
}
;(b(Tt, 'SECTION_KEYS', {
  SWATCHES: 'product-ssr-swatches',
  INSEAMS: 'product-ssr-inseams',
  GALLERY: 'product-ssr-gallery',
  INFO: 'product-ssr-info',
  VARIANTS: 'product-ssr-variants',
  CUSTOMERS_SAY: 'product-ssr-customers-say',
  BNPL: 'product-ssr-bnpl',
  DESCRIPTION: 'product-ssr-description',
  STYLE_WITH: 'product-ssr-style-with',
}),
  b(Tt, 'QUICK_ADD_SECTION_KEYS', {
    SWATCHES: 'product-ssr-swatches',
    INSEAMS: 'product-ssr-inseams',
    GALLERY: 'quick-add-ssr-gallery',
    INFO: 'product-ssr-info',
    VARIANTS: 'product-ssr-variants',
    CUSTOMERS_SAY: 'product-ssr-customers-say',
    BNPL: 'product-ssr-bnpl',
  }),
  b(Tt, 'values', {
    url: String,
    familyTags: Array,
    quickAdd: { type: Boolean, default: !1 },
  }),
  b(Tt, 'targets', [
    'sisterVariantLink',
    'artificialVariantsSwatchesContainer',
    'artificialVariantsInseamContainer',
    'productGalleryContainer',
    'productInfoContainer',
    'productVariantsContainer',
    'productCustomersSayContainer',
    'productBnplContainer',
    'productDescriptionContainer',
  ]))
var vs = Tt
var zt = class extends _ {
  constructor() {
    super(...arguments)
    b(this, 'swiper', null)
    b(this, 'initPromise', null)
    b(this, 'intersectionObserver', null)
  }
  connect() {
    if (typeof IntersectionObserver > 'u') {
      this.ensureSwiper()
      return
    }
    ;((this.intersectionObserver = new IntersectionObserver(
      (e) => {
        for (let s of e)
          if (s.isIntersecting) {
            ;(this.ensureSwiper(), this.disconnectObserver())
            break
          }
      },
      { rootMargin: '200px' },
    )),
      this.intersectionObserver.observe(this.element))
  }
  disconnect() {
    ;(this.disconnectObserver(),
      this.swiper?.destroy(!0, !0),
      (this.swiper = null),
      (this.initPromise = null))
  }
  async onMouseEnter() {
    ;(await this.ensureSwiper(),
      this.swiper && this.swiper.realIndex === 0 && this.swiper.slideNext(0))
  }
  onMouseLeave() {
    this.swiper && this.swiper.slideToLoop(0, 0)
  }
  async onPrevClick(e) {
    ;(e.preventDefault(),
      e.stopPropagation(),
      await this.ensureSwiper(),
      this.swiper?.slidePrev())
  }
  async onNextClick(e) {
    ;(e.preventDefault(),
      e.stopPropagation(),
      await this.ensureSwiper(),
      this.swiper?.slideNext())
  }
  ensureSwiper() {
    return this.swiper
      ? Promise.resolve()
      : this.initPromise
        ? this.initPromise
        : ((this.initPromise = this.initialiseSwiper().catch((e) => {
            throw ((this.initPromise = null), e)
          })),
          this.initPromise)
  }
  async initialiseSwiper() {
    let [{ default: e }, { A11y: s, Pagination: i }] = await Promise.all([
      Promise.resolve().then(() => (ur(), js)),
      Promise.resolve().then(() => (pr(), Xs)),
    ])
    if (!this.element.isConnected || this.swiper) return
    let n = this.element,
      a = n.closest('[data-card-swiper-disable-touch]') !== null,
      l = [s],
      o = this.slidesPerViewValue > 0,
      u = {
        loop: !o,
        threshold: 8,
        allowTouchMove: !a,
        simulateTouch: !a,
        preventClicks: !0,
        preventClicksPropagation: !0,
      }
    if (
      (o && ((u.slidesPerView = this.slidesPerViewValue), (u.spaceBetween = 0)),
      this.paginationValue)
    ) {
      l.push(i)
      let h =
        n.querySelector('.swiper-pagination') ??
        n.parentElement?.querySelector('.swiper-pagination') ??
        null
      u.pagination = { el: h, clickable: !0 }
    }
    ;((u.modules = l), (this.swiper = new e(n, u)))
  }
  disconnectObserver() {
    ;(this.intersectionObserver?.disconnect(),
      (this.intersectionObserver = null))
  }
}
;(b(zt, 'targets', ['prevBtn', 'nextBtn']),
  b(zt, 'values', {
    pagination: { type: Boolean, default: !1 },
    slidesPerView: { type: Number, default: 0 },
  }))
var ys = 6,
  Cr = class extends _ {
    constructor() {
      super(...arguments)
      b(this, 'abortController', null)
      b(this, 'prefetchedHandles', new Set())
      b(this, 'swatchOrder', null)
    }
    connect() {
      ;(this.restoreOrInitSwatchOrder(), this.applySwatchVisibility())
    }
    restoreOrInitSwatchOrder() {
      let e = this.element.getAttribute('data-swatch-order')
      if (e)
        try {
          this.swatchOrder = JSON.parse(e)
          return
        } catch {
          this.element.removeAttribute('data-swatch-order')
        }
      if (!this.hasSwatchContainerTarget) return
      let s = this.getSwatchButtons(this.swatchContainerTarget)
      if (s.length <= ys) return
      let i = s.map((a) => this.getSwatchUrl(a)),
        n = s.findIndex((a) => this.isActiveSwatch(a))
      if (n > 0) {
        let [a] = i.splice(n, 1)
        i.unshift(a)
      }
      ;((this.swatchOrder = i),
        this.element.setAttribute('data-swatch-order', JSON.stringify(i)),
        this.reorderSwatchDom(this.swatchContainerTarget, i))
    }
    applySwatchVisibility() {
      if (!this.hasSwatchContainerTarget) return
      let e = this.getSwatchButtons(this.swatchContainerTarget)
      if (e.length <= ys) return
      let s = this.hasOverflowCountTarget ? this.overflowCountTarget : null
      this.applyVisibilityToButtons(e, s)
    }
    applySwatchOrderToNewCard(e) {
      if (!this.swatchOrder) return
      let s = e.querySelector(
        '[data-product-card-swatch-target="swatchContainer"]',
      )
      if (!s) return
      ;(e.setAttribute('data-swatch-order', JSON.stringify(this.swatchOrder)),
        this.reorderSwatchDom(s, this.swatchOrder))
      let i = this.getSwatchButtons(s)
      if (i.length <= ys) return
      let n = s.querySelector(
        '[data-product-card-swatch-target="overflowCount"]',
      )
      this.applyVisibilityToButtons(i, n)
    }
    reorderSwatchDom(e, s) {
      let i = this.getSwatchButtons(e),
        n = new Map(),
        a = []
      for (let u of i) {
        let h = this.getSwatchUrl(u)
        h ? n.set(h, u) : a.push(u)
      }
      let l = e.querySelector(
          '[data-product-card-swatch-target="overflowCount"]',
        ),
        o = document.createDocumentFragment()
      for (let u of s) {
        let h = n.get(u)
        h && (o.appendChild(h), n.delete(u))
      }
      for (let u of n.values()) o.appendChild(u)
      for (let u of a) o.appendChild(u)
      ;(l && o.appendChild(l), e.replaceChildren(o))
    }
    getSwatchButtons(e) {
      return Array.from(
        e.querySelectorAll('[data-product-card-swatch-url-param]'),
      )
    }
    getSwatchUrl(e) {
      return e.dataset.productCardSwatchUrlParam ?? ''
    }
    markSwatchActive(e) {
      if (!(!e || !this.hasSwatchContainerTarget))
        for (let s of this.getSwatchButtons(this.swatchContainerTarget)) {
          let i = s === e
          ;(s.classList.toggle('ring-black', i),
            s.classList.toggle('ring-transparent', !i),
            s.setAttribute('aria-pressed', String(i)),
            i ? (s.dataset.active = 'true') : delete s.dataset.active)
        }
    }
    getActiveSwatch() {
      if (!this.hasSwatchContainerTarget) return null
      for (let e of this.getSwatchButtons(this.swatchContainerTarget))
        if (this.isActiveSwatch(e)) return e
      return null
    }
    isActiveSwatch(e) {
      return e.dataset.active === 'true'
    }
    applyVisibilityToButtons(e, s) {
      let i = e.length - ys
      ;(e.forEach((n, a) => {
        n.classList.toggle('hidden', a >= ys)
      }),
        s && ((s.textContent = `+${i}`), s.classList.remove('hidden')))
    }
    prefetch(e) {
      let i = e.currentTarget?.dataset.productCardSwatchUrlParam
      if (!i) return
      let n = tt(i)
      !n ||
        this.prefetchedHandles.has(n) ||
        (this.prefetchedHandles.add(n), Rt(n))
    }
    async swap(e) {
      ;(e.preventDefault(), e.stopPropagation())
      let s = e.currentTarget,
        i = s?.dataset.productCardSwatchUrlParam
      if (!i) return
      let n = tt(i)
      if (!n) return
      let a = this.getActiveSwatch()
      ;(this.markSwatchActive(s),
        this.abortController?.abort(),
        (this.abortController = new AbortController()))
      let { signal: l } = this.abortController,
        o = await Rt(n, l)
      if (l.aborted) return
      if (!o) {
        this.markSwatchActive(a)
        return
      }
      let u = o.replace(/loading="lazy"/g, 'loading="eager"'),
        h = document.createElement('template')
      h.innerHTML = u.trim()
      let f =
        h.content.querySelector('[data-controller~="product-card-swatch"]') ??
        h.content.firstElementChild
      if (!f) {
        this.markSwatchActive(a)
        return
      }
      ;(this.applySwatchOrderToNewCard(f),
        await this.waitForFirstImage(f, l),
        !l.aborted && this.element.replaceWith(f))
    }
    disconnect() {
      ;(this.abortController?.abort(), (this.abortController = null))
    }
    waitForFirstImage(e, s) {
      let i = e.querySelector('img')
      if (!i) return Promise.resolve()
      let n = new Image(),
        a = i.getAttribute('srcset'),
        l = i.getAttribute('sizes'),
        o = i.getAttribute('src')
      if (
        (a && (n.srcset = a), l && (n.sizes = l), o && (n.src = o), n.complete)
      )
        return Promise.resolve()
      let u = [
        new Promise((h) => {
          let f = () => {
            ;((n.srcset = ''), (n.src = ''), h())
          }
          ;(n.addEventListener('load', f, { once: !0 }),
            n.addEventListener('error', f, { once: !0 }))
        }),
        new Promise((h) => setTimeout(h, 3e3)),
      ]
      return (
        s &&
          u.push(
            new Promise((h) => {
              if (s.aborted) return h()
              s.addEventListener('abort', () => h(), { once: !0 })
            }),
          ),
        Promise.race(u)
      )
    }
  }
b(Cr, 'targets', ['swatchContainer', 'overflowCount'])
async function Ko() {
  let t = await fetch(de('/cart.js'), {
    headers: { Accept: 'application/json' },
  })
  if (!t.ok) throw new Error(`Failed to fetch cart: ${t.status}`)
  return t.json()
}
async function Sn(t) {
  let r = await fetch(de('/cart/add.js'), {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
    body: JSON.stringify({ id: t.id, quantity: t.quantity ?? 1 }),
  })
  if (!r.ok) throw new Error(`Failed to add to cart: ${r.status}`)
}
async function Xo(t) {
  return (await Sn(t), Ko())
}
var Gu = 'https://a.klaviyo.com/client/back-in-stock-subscriptions/',
  Yu = '2024-06-15'
function Qo(t, r, e) {
  let s = {
    data: {
      type: 'back-in-stock-subscription',
      attributes: {
        channels: ['EMAIL'],
        profile: { data: { type: 'profile', attributes: { email: t } } },
      },
      relationships: {
        variant: {
          data: { type: 'catalog-variant', id: `$shopify:::$default:::${r}` },
        },
      },
    },
  }
  return fetch(`${Gu}?company_id=${encodeURIComponent(e)}`, {
    method: 'POST',
    headers: {
      revision: Yu,
      'Content-Type': 'application/json',
      Accept: 'application/json',
    },
    body: JSON.stringify(s),
  })
}
function Jo(t) {
  return t.map((r) => ({
    ProductID: String(r.product_id),
    VariantID: String(r.variant_id),
    SKU: r.sku,
    Title: r.title,
    VariantTitle: r.variant_title,
    Quantity: r.quantity,
    ItemPrice: r.final_price / 100,
    TotalAmount: (r.final_price / 100) * r.quantity,
    URL: r.handle,
    ImageURL: r.featured_image?.url || r.image || '',
    Categories: [r.product_type].filter(Boolean),
  }))
}
function oi(t, r, e, s) {
  try {
    if (typeof window > 'u' || !ar(nr.ANALYTICS)) return
    let i = (window.klaviyo = window.klaviyo ?? [])
    r &&
      i.push([
        'identify',
        { $email: r, $first_name: e ?? '', $last_name: s ?? '' },
      ])
    let n = Jo(t)
    i.push(['track', 'Updated Cart', { Items: n }])
  } catch (i) {
    console.warn('[klaviyo-cart-snapshot] failed to send', i)
  }
}
function Ar(t) {
  document.dispatchEvent(
    new CustomEvent('toast:show', {
      detail: {
        message: t.message,
        variant: t.variant ?? 'info',
        duration: t.duration ?? 4e3,
        position: t.position ?? 'top-right',
        dedupe: t.dedupe ?? !0,
      },
    }),
  )
}
async function Zo(t) {
  t.responseId &&
    (await nt({
      module: t.module,
      event: 'addtocart',
      data: {
        ...(t.tag ? { tag: t.tag } : {}),
        responseId: t.responseId,
        results: [t.added],
      },
    }))
}
var bs = class bs extends _ {
  constructor() {
    super(...arguments)
    b(this, 'adding', !1)
    b(this, 'currentVariantId', '')
    b(this, 'klaviyoHandler', null)
    b(this, 'onVariantChange', (e) => {
      let s = e.target
      if (!(s instanceof HTMLSelectElement) || !/options\[/i.test(s.name))
        return
      let i = this.productScope
      if (i && !i.contains(s)) return
      let n = s.selectedOptions[0]
      if (!n) return
      if (!n.value) {
        this.resetCta()
        return
      }
      let a = n.dataset.soldOut === 'true',
        l = n.value
      this.toggleCta(a, l)
      let o = n.dataset.variantId
      if (o) {
        this.currentVariantId = o
        let u = this.findForm()
        if (u) {
          let h = u.querySelector('input[name="id"]')
          h && (h.value = o)
        }
      }
    })
  }
  connect() {
    document.addEventListener('change', this.onVariantChange)
  }
  disconnect() {
    ;(document.removeEventListener('change', this.onVariantChange),
      this.klaviyoHandler &&
        (window.removeEventListener('klaviyoForms', this.klaviyoHandler),
        (this.klaviyoHandler = null)))
  }
  addToCart(e) {
    let s = this.findVisibleSizeSelect()
    if (s && !s.value) {
      ;(e.preventDefault(),
        Ar({ message: bs.selectionPromptMessage(s), variant: 'info' }),
        this.scrollToSizeSelector())
      return
    }
    ;(e.preventDefault(), this.handleAddToCart())
  }
  scrollToSizeSelector() {
    let s = (this.productScope ?? document).querySelector(
      '[data-controller~="variant-picker"], .product-option-selector',
    )
    s && s.scrollIntoView({ behavior: 'smooth', block: 'center' })
  }
  notifyMe() {
    if (
      !(
        !this.klaviyoCompanyIdValue ||
        !this.klaviyoBisFormIdValue ||
        !window.klaviyo
      )
    ) {
      if (
        (this.klaviyoHandler &&
          window.removeEventListener('klaviyoForms', this.klaviyoHandler),
        !this.currentVariantId)
      ) {
        let s = this.findForm()?.querySelector('input[name="id"]')
        s?.value && (this.currentVariantId = s.value)
      }
      ;((this.klaviyoHandler = (e) => {
        let s = e
        if (s.detail.type !== 'stepSubmit') return
        this.klaviyoHandler &&
          (window.removeEventListener('klaviyoForms', this.klaviyoHandler),
          (this.klaviyoHandler = null))
        let i = s.detail.metaData.$email
        !i ||
          !this.currentVariantId ||
          Qo(i, this.currentVariantId, this.klaviyoCompanyIdValue)
      }),
        window.addEventListener('klaviyoForms', this.klaviyoHandler),
        'openForm' in window.klaviyo &&
          window.klaviyo.openForm(this.klaviyoBisFormIdValue))
    }
  }
  async handleAddToCart() {
    if (this.adding) return
    let e = this.findForm()
    if (!e) return
    let s = e.querySelector('input[name="id"]')
    if (!s?.value) return
    let i = parseInt(s.value, 10)
    if (!isNaN(i)) {
      ;((this.adding = !0), this.disableButton())
      try {
        let n = await Xo({ id: i })
        try {
          this.fireAddToCartBeacon(n.items, i)
        } catch (a) {
          console.warn('[product-cta] beacon failed:', a)
        }
        ;(oi(n.items), document.dispatchEvent(new CustomEvent('cart:refresh')))
      } catch (n) {
        ;(console.error('[product-cta] Failed to add to cart:', n),
          Ar({
            message: 'Unable to add item to bag. Please try again.',
            variant: 'error',
          }))
      } finally {
        ;((this.adding = !1), this.enableButton())
      }
    }
  }
  fireAddToCartBeacon(e, s) {
    if (!this.beaconModuleValue || !this.beaconResponseIdValue) return
    let i = e.find((l) => l.variant_id === s)
    if (!i) return
    let n = String(i.product_id),
      a = {
        parentId: n,
        uid: n,
        qty: 1,
        price: i.price / 100,
        ...(i.sku ? { sku: i.sku } : {}),
      }
    Zo({
      module: this.beaconModuleValue,
      added: a,
      responseId: this.beaconResponseIdValue,
      tag: this.beaconTagValue || void 0,
    })
  }
  disableButton() {
    if (!this.hasAddToCartButtonTarget) return
    let e = this.addToCartButtonTarget.querySelector('button')
    e && (e.setAttribute('disabled', ''), e.classList.add('cursor-wait'))
  }
  enableButton() {
    if (!this.hasAddToCartButtonTarget) return
    let e = this.addToCartButtonTarget.querySelector('button')
    e && (e.removeAttribute('disabled'), e.classList.remove('cursor-wait'))
  }
  toggleCta(e, s) {
    if (!this.hasAddToCartButtonTarget || !this.hasNotifyMeButtonTarget) return
    let i = this.addToCartButtonTarget.querySelector('button')
    ;(i &&
      (i.classList.remove(
        'group',
        'hover:!bg-secondary',
        'hover:!text-surface',
      ),
      (i.textContent = 'Add to bag')),
      e
        ? (this.addToCartButtonTarget.classList.add('hidden'),
          this.notifyMeButtonTarget.classList.remove('hidden'),
          this.showOosMessage(s ?? ''))
        : (this.addToCartButtonTarget.classList.remove('hidden'),
          this.notifyMeButtonTarget.classList.add('hidden'),
          this.hideOosMessage()))
  }
  resetCta() {
    ;((this.currentVariantId = ''),
      this.hasAddToCartButtonTarget &&
        this.hasNotifyMeButtonTarget &&
        (this.addToCartButtonTarget.classList.remove('hidden'),
        this.notifyMeButtonTarget.classList.add('hidden')),
      this.hideOosMessage())
    let s = this.findForm()?.querySelector('input[name="id"]')
    s && (s.value = '')
  }
  showOosMessage(e) {
    !this.hasOosMessageTarget ||
      !this.oosMessageTemplateValue ||
      ((this.oosMessageTarget.textContent =
        this.oosMessageTemplateValue.replace('__SIZE__', e)),
      this.oosMessageTarget.classList.remove('hidden'))
  }
  hideOosMessage() {
    this.hasOosMessageTarget &&
      ((this.oosMessageTarget.textContent = ''),
      this.oosMessageTarget.classList.add('hidden'))
  }
  findForm() {
    return (
      this.element.closest('form') ??
      document.querySelector('form[action*="/cart/add"]')
    )
  }
  findVisibleSizeSelect() {
    let s = (this.productScope ?? document).querySelectorAll(
      'select[name*="options["], select[aria-label="Size"]',
    )
    for (let i of Array.from(s)) {
      let n = i.closest(
        '[data-controller="variant-picker"], [data-controller="select"]',
      )
      if ((n && n.offsetParent !== null) || (!n && i.offsetParent !== null))
        return i
    }
    return null
  }
  static selectionPromptMessage(e) {
    let s =
      e.name
        .match(/options\[(.+)\]/i)?.[1]
        ?.trim()
        .toLowerCase() ?? 'size'
    return `Please select ${/^[aeiou]/.test(s) ? 'an' : 'a'} ${s}`
  }
  get productScope() {
    return (
      this.element.closest(
        '[data-controller="product"], [data-controller^="product "], [data-controller$=" product"], [data-controller*=" product "]',
      ) ?? this.element.closest('form')
    )
  }
}
;(b(bs, 'targets', ['addToCartButton', 'notifyMeButton', 'oosMessage']),
  b(bs, 'values', {
    klaviyoCompanyId: String,
    klaviyoBisFormId: String,
    oosMessageTemplate: { type: String, default: '' },
    beaconModule: { type: String, default: '' },
    beaconResponseId: { type: String, default: '' },
    beaconTag: { type: String, default: '' },
  }))
var Ts = bs
ur()
pr()
var Ku = { MD: 1194 },
  Ir = class extends _ {
    connect() {
      ;(this.initSwiper(),
        (this.currentImageIndex = 0),
        (this.lastFocusedElement = null))
    }
    disconnect() {
      this.swiper && this.swiper.destroy()
    }
    initSwiper() {
      let r = this.swiperTarget.querySelectorAll('.swiper-slide').length
      this.swiper = new qe(this.swiperTarget, {
        modules: [hr, Ys, Ks],
        spaceBetween: 0,
        slidesPerView: r >= 2 ? 1.2 : 1,
        observer: !0,
        observeParents: !0,
        pagination: { el: '.swiper-pagination', clickable: !0 },
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev',
        },
        scrollbar: { el: '.swiper-scrollbar', draggable: !0, hide: !0 },
        breakpoints: {
          [Ku.MD]: {
            slidesPerView: r >= 2 ? 2 : 1,
            spaceBetween: 0,
            slidesPerGroup: r >= 2 ? 2 : 1,
          },
        },
        on: {
          init: (e) => {
            e.el.querySelector('.swiper-wrapper')?.removeAttribute('aria-live')
          },
        },
      })
    }
    openModal(r) {
      if (!this.hasDialogTarget || this.dialogTarget.open) return
      let s = r.currentTarget.dataset.index,
        i = this.swiper ? this.swiper.realIndex : 0,
        n = s !== void 0 && s !== '' ? parseInt(s, 10) : i
      ;((this.lastFocusedElement = document.activeElement),
        (this.currentImageIndex = n),
        this.dialogTarget.showModal(),
        document.body.classList.add('drawer-open'),
        requestAnimationFrame(() => {
          let a = this.modalImageTargets[n]
          ;(a && a.scrollIntoView({ behavior: 'auto', block: 'start' }),
            this.hasModalScrollTarget && this.modalScrollTarget.focus())
        }),
        this._highlightThumbnail(n),
        this._announceImage(n))
    }
    closeModal() {
      !this.hasDialogTarget ||
        !this.dialogTarget.open ||
        this.dialogTarget.close()
    }
    handleBackdropClick(r) {
      r.target === this.dialogTarget && this.closeModal()
    }
    dialogClosed() {
      ;(document.body.classList.remove('drawer-open'),
        this.lastFocusedElement &&
          (this.lastFocusedElement.focus(), (this.lastFocusedElement = null)))
    }
    handleKeydown(r) {
      if (this.dialogTarget?.open)
        switch (r.key) {
          case 'ArrowRight':
          case 'ArrowDown':
            ;(r.preventDefault(),
              this._scrollToImage(
                (this.currentImageIndex + 1) % this.modalImageTargets.length,
              ))
            break
          case 'ArrowLeft':
          case 'ArrowUp':
            r.preventDefault()
            let e = this.currentImageIndex - 1,
              s = e < 0 ? this.modalImageTargets.length - 1 : e
            this._scrollToImage(s)
            break
          case 'Home':
            ;(r.preventDefault(), this._scrollToImage(0))
            break
          case 'End':
            ;(r.preventDefault(),
              this._scrollToImage(this.modalImageTargets.length - 1))
            break
        }
    }
    scrollToImage(r) {
      let e = r.currentTarget,
        s = parseInt(e.dataset.index || '0', 10)
      this._scrollToImage(s)
    }
    _scrollToImage(r) {
      let e = this.modalImageTargets[r]
      e &&
        (e.scrollIntoView({ behavior: 'auto', block: 'start' }),
        (this.currentImageIndex = r),
        this._highlightThumbnail(r),
        this._announceImage(r))
    }
    _announceImage(r) {
      if (!this.hasAnnouncementTarget) return
      let e = this.modalImageTargets.length,
        i =
          this.modalImageTargets[r]?.querySelector('img')?.alt ||
          `Image ${r + 1}`
      this.announcementTarget.textContent = `${i}. Image ${r + 1} of ${e}.`
    }
    _highlightThumbnail(r) {
      for (let [e, s] of this.thumbnailTargets.entries())
        e === r
          ? (s.classList.remove('ring-transparent'),
            s.classList.add('ring-primary'))
          : (s.classList.remove('ring-primary'),
            s.classList.add('ring-transparent'))
    }
  }
b(Ir, 'targets', [
  'swiper',
  'dialog',
  'modalImage',
  'modalScroll',
  'thumbnail',
  'announcement',
])
var Pr = class extends _ {
  toggle() {
    this.contentTarget.getAttribute('data-expanded') === 'true'
      ? this.collapse()
      : this.expand()
  }
  expand() {
    let r = this.contentTarget.scrollHeight
    ;((this.contentTarget.style.height = `${this.contentTarget.offsetHeight}px`),
      this.contentTarget.offsetHeight,
      this.contentTarget.classList.remove('h-30', 'md:h-34'),
      this.contentTarget.classList.add('h-auto'),
      this.contentTarget.classList.remove('mask-fade-bottom'),
      (this.contentTarget.style.height = `${r}px`),
      this.contentTarget.addEventListener(
        'transitionend',
        () => {
          ;((this.contentTarget.style.height = ''),
            this.contentTarget.classList.remove('overflow-hidden'))
        },
        { once: !0 },
      ),
      this.contentTarget.setAttribute('data-expanded', 'true'),
      (this.buttonTarget.textContent = 'Less'))
  }
  collapse() {
    ;(this.contentTarget.classList.add('overflow-hidden'),
      this.contentTarget.classList.remove('h-auto'),
      this.contentTarget.classList.add('mask-fade-bottom'),
      (this.contentTarget.style.height = `${this.contentTarget.offsetHeight}px`),
      this.contentTarget.offsetHeight,
      this.contentTarget.classList.add('h-30', 'md:h-34'),
      (this.contentTarget.style.height = ''),
      this.contentTarget.setAttribute('data-expanded', 'false'),
      (this.buttonTarget.textContent = 'More'))
  }
}
b(Pr, 'targets', ['content', 'button'])
var kr = class extends _ {
  constructor() {
    super(...arguments)
    b(this, 'closeTimer', null)
    b(this, 'onMouseEnter', (e) => {
      this.clearCloseTimer()
      let s = e.currentTarget
      ;(this.closeAll(s), this.open(s))
    })
    b(this, 'onMouseLeave', (e) => {
      let s = e.currentTarget
      this.closeTimer = setTimeout(() => {
        this.close(s)
      }, 100)
    })
    b(this, 'onTriggerKeydown', (e) => {
      let s = e.currentTarget,
        i = s.closest('[data-main-menu-target="item"]')
      if (!i) return
      let n = i.hasAttribute('data-open')
      switch (e.key) {
        case 'Enter':
        case ' ': {
          ;(e.preventDefault(),
            n
              ? this.close(i)
              : (this.closeAll(),
                this.open(i),
                s.setAttribute('data-keyboard-open', ''),
                this.getSubmenu(i)?.querySelector('a')?.focus()))
          break
        }
        case 'Escape': {
          n && (e.stopPropagation(), this.close(i), s.focus())
          break
        }
        case 'ArrowDown': {
          n ||
            (e.preventDefault(),
            this.closeAll(),
            this.open(i),
            s.setAttribute('data-keyboard-open', ''),
            this.getSubmenu(i)?.querySelector('a')?.focus())
          break
        }
      }
    })
    b(this, 'onDocumentKeydown', (e) => {
      e.key === 'Escape' && this.closeAll()
    })
  }
  connect() {
    ;(this.itemTargets.forEach((e) => {
      ;(e.addEventListener('mouseenter', this.onMouseEnter),
        e.addEventListener('mouseleave', this.onMouseLeave))
    }),
      this.triggerTargets.forEach((e) => {
        e.addEventListener('keydown', this.onTriggerKeydown)
      }),
      document.addEventListener('keydown', this.onDocumentKeydown))
  }
  disconnect() {
    ;(this.itemTargets.forEach((e) => {
      ;(e.removeEventListener('mouseenter', this.onMouseEnter),
        e.removeEventListener('mouseleave', this.onMouseLeave))
    }),
      this.triggerTargets.forEach((e) => {
        e.removeEventListener('keydown', this.onTriggerKeydown)
      }),
      document.removeEventListener('keydown', this.onDocumentKeydown),
      this.clearCloseTimer())
  }
  open(e) {
    ;(e.setAttribute('data-open', ''),
      this.getTrigger(e)?.setAttribute('aria-expanded', 'true'),
      this.syncNavState())
  }
  close(e) {
    e.removeAttribute('data-open')
    let s = this.getTrigger(e)
    ;(s?.setAttribute('aria-expanded', 'false'),
      s?.removeAttribute('data-keyboard-open'),
      this.syncNavState())
  }
  closeAll(e) {
    ;(this.itemTargets.forEach((s) => {
      s !== e && this.close(s)
    }),
      this.syncNavState())
  }
  syncNavState() {
    this.itemTargets.some((s) => s.hasAttribute('data-open'))
      ? this.element.setAttribute('data-has-open', '')
      : this.element.removeAttribute('data-has-open')
  }
  getTrigger(e) {
    return e.querySelector('[data-main-menu-target="trigger"]')
  }
  getSubmenu(e) {
    return e.querySelector('[data-main-menu-target="submenu"]')
  }
  clearCloseTimer() {
    this.closeTimer !== null &&
      (clearTimeout(this.closeTimer), (this.closeTimer = null))
  }
}
b(kr, 'targets', ['trigger', 'submenu', 'item'])
var qt = class extends _ {
  constructor() {
    super(...arguments)
    b(this, 'onKeydown', (e) => {
      if (this.triggerTarget.disabled) return
      let s = e,
        { key: i } = s,
        n = Array.from(this.listTarget.children)
      if (!this.isOpen && ['Enter', ' ', 'ArrowDown', 'ArrowUp'].includes(i)) {
        ;(e.preventDefault(), this.open())
        return
      }
      if (this.isOpen) {
        if (i === 'Escape') {
          ;(s.preventDefault(), this.close())
          return
        }
        let a = document.activeElement,
          l = n.indexOf(a)
        if (i === 'ArrowDown') {
          s.preventDefault()
          let o = (l + 1) % n.length
          n[o]?.focus()
        } else if (i === 'ArrowUp') {
          s.preventDefault()
          let o = (l - 1 + n.length) % n.length
          n[o]?.focus()
        } else
          i === 'Enter' || i === ' '
            ? (s.preventDefault(), l >= 0 && this.selectOption(n[l]))
            : i === 'Tab' && this.close(!1)
      }
    })
    b(this, 'onClickOutside', (e) => {
      this.element.contains(e.target) || this.close(!1)
    })
  }
  connect() {
    ;(this.buildCustomOptions(),
      this.updateTriggerLabel(),
      document.addEventListener('click', this.onClickOutside),
      this.element.addEventListener('keydown', this.onKeydown))
  }
  disconnect() {
    ;(document.removeEventListener('click', this.onClickOutside),
      this.element.removeEventListener('keydown', this.onKeydown))
  }
  toggle() {
    this.isOpen ? this.close() : this.open()
  }
  open() {
    if (this.triggerTarget.disabled) return
    ;(this.triggerTarget.setAttribute('aria-expanded', 'true'),
      this.dropdownTarget.classList.remove('hidden'),
      this.element.classList.add(...this.openClasses))
    let e = this.listTarget.querySelector('[aria-selected="true"]'),
      s = this.listTarget.firstElementChild
    requestAnimationFrame(() => {
      e ? e.focus({ preventScroll: !0 }) : s && s.focus({ preventScroll: !0 })
    })
  }
  close(e = !0) {
    this.isOpen &&
      (this.triggerTarget.setAttribute('aria-expanded', 'false'),
      this.dropdownTarget.classList.add('hidden'),
      this.element.classList.remove(...this.openClasses),
      e && this.triggerTarget.focus({ preventScroll: !0 }))
  }
  select(e) {
    let s = e.currentTarget
    this.selectOption(s)
  }
  syncFromNative(e) {
    let s = e ?? this.nativeTarget.value
    ;(e !== void 0 && (this.nativeTarget.value = s),
      this.updateSelectionState(s),
      this.updateTriggerLabelForValue(s))
  }
  selectOption(e) {
    let s = e.dataset.value
    e.dataset.disabled !== 'true' &&
      ((this.nativeTarget.value = s || ''),
      this.nativeTarget.dispatchEvent(new Event('change', { bubbles: !0 })),
      this.updateSelectionState(s || ''),
      this.close(),
      this.updateTriggerLabel())
  }
  updateSelectionState(e) {
    Array.from(this.listTarget.children).forEach((i) => {
      let n = i.dataset.value === e
      ;(i.setAttribute('aria-selected', n ? 'true' : 'false'),
        n ? i.classList.add('bg-gray-100') : i.classList.remove('bg-gray-100'))
    })
  }
  get isOpen() {
    return this.triggerTarget.getAttribute('aria-expanded') === 'true'
  }
  get shouldSkipLabelUpdate() {
    return this.nativeTarget.dataset.selectSkipLabelUpdate === 'true'
  }
  updateTriggerLabel() {
    if (this.shouldSkipLabelUpdate) return
    let e = this.nativeTarget.selectedOptions[0]
    e && (this.labelTarget.textContent = e.text.trim())
  }
  updateTriggerLabelForValue(e) {
    if (this.shouldSkipLabelUpdate) return
    let s = Array.from(this.nativeTarget.options).find((i) => i.value === e)
    s && (this.labelTarget.textContent = s.text.trim())
  }
  buildCustomOptions() {
    ;((this.listTarget.innerHTML = ''),
      Array.from(this.nativeTarget.options).forEach((e) => {
        if (e.disabled && e.value === '') return
        let s = document.createElement('li')
        ;((s.role = 'option'),
          (s.tabIndex = -1),
          (s.className =
            'flex items-center justify-between px-2.5 py-2.5 cursor-pointer hover:bg-gray-50 transition-colors focus:bg-gray-100 focus:outline-none'),
          (s.dataset.value = e.value),
          (s.dataset.action = 'click->select#select'))
        let i = this.nativeTarget.value === e.value
        ;(s.setAttribute('aria-selected', i ? 'true' : 'false'),
          i && s.classList.add('bg-gray-100'))
        let n = document.createElement('span')
        if (
          ((n.className = 'text-body font-medium'),
          (n.textContent = e.text.trim()),
          s.appendChild(n),
          e.disabled)
        )
          ((s.dataset.disabled = 'true'),
            s.classList.add('cursor-not-allowed'),
            s.setAttribute('aria-disabled', 'true'),
            n.classList.add('text-muted'))
        else if (e.dataset.soldOut === 'true') {
          ;((s.dataset.soldOut = 'true'), n.classList.add('text-muted'))
          let a = e.dataset.soldOutText || 'Waitlist',
            l = document.createElement('span')
          ;((l.className = 'text-muted text-body'),
            (l.textContent = a),
            s.appendChild(l))
        } else if (e.dataset.lowStockText) {
          let a = document.createElement('span')
          ;((a.className = 'text-body'),
            (a.textContent = e.dataset.lowStockText),
            s.appendChild(a))
        }
        this.listTarget.appendChild(s)
      }))
  }
}
;(b(qt, 'targets', ['native', 'trigger', 'label', 'dropdown', 'list']),
  b(qt, 'classes', ['open', 'selected']))
var Ut = class extends _ {
  connect() {
    this.hasNativeTarget && this.nativeTarget.value && this.syncFromNative()
  }
  selectSize(r) {
    let s = r.currentTarget.dataset.value
    s &&
      ((this.nativeTarget.value = s),
      this.nativeTarget.dispatchEvent(new Event('change', { bubbles: !0 })))
  }
  onNativeChange() {
    let r = this.nativeTarget.value
    r &&
      (this.updateButtonStates(r),
      this.updateSizeLabel(this.getDisplayText(r)),
      this.updateIndicatorFor(r))
  }
  syncFromNative(r) {
    let e = r ?? this.nativeTarget.value
    ;(r !== void 0 && (this.nativeTarget.value = e),
      this.updateButtonStates(e),
      this.updateSizeLabel(this.getDisplayText(e)),
      this.updateIndicatorFor(e))
  }
  updateButtonStates(r) {
    for (let e of this.sizeButtonTargets)
      e.dataset.value === r
        ? (e.setAttribute('aria-checked', 'true'),
          e.classList.add('border-primary', 'text-body'),
          e.classList.remove('border-transparent', 'text-body-light'))
        : (e.setAttribute('aria-checked', 'false'),
          e.classList.remove('border-primary', 'text-body'),
          e.classList.add('border-transparent', 'text-body-light'))
  }
  updateSizeLabel(r) {
    this.hasSizeLabelTarget && (this.sizeLabelTarget.textContent = r)
  }
  getDisplayText(r) {
    let e = this.sizeButtonTargets.find((i) => i.dataset.value === r)
    if (e) return e.dataset.displayText ?? e.dataset.value ?? r
    let s = this.findOption(r)
    return s?.dataset.displayText ?? s?.value ?? r
  }
  findOption(r) {
    return this.hasNativeTarget
      ? (Array.from(this.nativeTarget.options).find((s) => s.value === r) ??
          null)
      : null
  }
  updateIndicatorFor(r) {
    if (!this.hasIndicatorTarget) return
    let e = this.getVariantMetadata(r)
    if (!e) {
      ;(this.indicatorTarget.replaceChildren(),
        this.indicatorTarget.classList.add('invisible'))
      return
    }
    if (e.soldOut) {
      this.renderIndicator('waitlist', this.waitlistLabelValue)
      return
    }
    if (e.inventoryQty > 0 && e.inventoryQty <= this.lowStockThresholdValue) {
      let s = this.lowStockTemplateValue.replace(
        '__COUNT__',
        String(e.inventoryQty),
      )
      this.renderIndicator('lowStock', s)
      return
    }
    ;(this.indicatorTarget.replaceChildren(),
      this.indicatorTarget.classList.add('invisible'))
  }
  getVariantMetadata(r) {
    let e = this.sizeButtonTargets.find((i) => i.dataset.value === r)
    if (e)
      return {
        soldOut: e.dataset.soldOut === 'true',
        inventoryQty: parseInt(e.dataset.inventoryQuantity ?? '0', 10),
      }
    let s = this.findOption(r)
    return s
      ? {
          soldOut: s.dataset.soldOut === 'true',
          inventoryQty: parseInt(s.dataset.inventoryQuantity ?? '0', 10),
        }
      : null
  }
  renderIndicator(r, e) {
    let s = null
    if (
      (r === 'lowStock' && this.hasLowStockTemplateTarget
        ? (s = this.lowStockTemplateTarget)
        : r === 'waitlist' &&
          this.hasWaitlistTemplateTarget &&
          (s = this.waitlistTemplateTarget),
      !s)
    ) {
      ;(this.indicatorTarget.replaceChildren(),
        this.indicatorTarget.classList.add('invisible'))
      return
    }
    let i = s.content.cloneNode(!0),
      n = i.firstElementChild
    if (n) {
      let a = n.querySelector('[data-indicator-dot]')
      ;(n.replaceChildren(),
        a && n.appendChild(a),
        n.appendChild(document.createTextNode(e)))
    }
    ;(this.indicatorTarget.replaceChildren(i),
      this.indicatorTarget.classList.remove('invisible'))
  }
}
;(b(Ut, 'targets', [
  'native',
  'sizeButton',
  'sizeLabel',
  'indicator',
  'lowStockTemplate',
  'waitlistTemplate',
]),
  b(Ut, 'values', {
    lowStockThreshold: { type: Number, default: 5 },
    lowStockTemplate: { type: String, default: 'Only __COUNT__ left' },
    waitlistLabel: { type: String, default: 'Waitlist' },
  }))
var Xu = '(min-width: 768px)',
  el = ['fixed', 'bottom-0', 'left-0', 'right-0', 'z-60'],
  tl = ['h-12', 'items-center'],
  Qu = 300,
  Or = class extends _ {
    constructor() {
      super(...arguments)
      b(this, 'sentinel', null)
      b(this, 'mediaQuery', null)
      b(this, 'mediaListener', null)
      b(this, 'elementHeight', 0)
      b(this, 'portaled', !1)
      b(this, 'rafId', 0)
      b(this, 'cachedCta', null)
      b(this, 'openDrawers', 0)
      b(this, 'onScroll', () => {
        this.rafId ||
          (this.rafId = requestAnimationFrame(() => {
            ;((this.rafId = 0), this.evaluate())
          }))
      })
      b(this, 'onDrawerOpened', () => {
        ;((this.openDrawers += 1), this.applyDrawerVisibility())
      })
      b(this, 'onDrawerClosed', () => {
        ;((this.openDrawers = Math.max(0, this.openDrawers - 1)),
          this.applyDrawerVisibility())
      })
    }
    connect() {
      ;((this.mediaQuery = window.matchMedia(Xu)),
        (this.mediaListener = (e) => {
          e.matches ? this.disable() : this.enable()
        }),
        this.mediaQuery.addEventListener('change', this.mediaListener),
        document.addEventListener('drawer:opened', this.onDrawerOpened),
        document.addEventListener('drawer:closed', this.onDrawerClosed),
        this.mediaQuery.matches || this.enable())
    }
    disconnect() {
      ;(this.disable(),
        this.mediaQuery &&
          this.mediaListener &&
          this.mediaQuery.removeEventListener('change', this.mediaListener),
        (this.mediaQuery = null),
        (this.mediaListener = null),
        document.removeEventListener('drawer:opened', this.onDrawerOpened),
        document.removeEventListener('drawer:closed', this.onDrawerClosed))
    }
    enable() {
      if (this.sentinel) return
      let e = this.element.parentElement
      e &&
        ((this.sentinel = document.createElement('div')),
        this.sentinel.setAttribute('aria-hidden', 'true'),
        e.insertBefore(this.sentinel, this.element),
        window.addEventListener('scroll', this.onScroll, { passive: !0 }),
        window.addEventListener('resize', this.onScroll, { passive: !0 }),
        this.evaluate())
    }
    disable() {
      ;(window.removeEventListener('scroll', this.onScroll),
        window.removeEventListener('resize', this.onScroll),
        this.rafId && (cancelAnimationFrame(this.rafId), (this.rafId = 0)),
        this.makeInline(),
        this.sentinel?.remove(),
        (this.sentinel = null))
    }
    evaluate() {
      if (!this.sentinel) return
      let e = this.sentinel.getBoundingClientRect().top
      !this.portaled && e < -Qu
        ? this.makeFloating()
        : this.portaled && e >= 0 && this.makeInline()
    }
    get cta() {
      if (this.cachedCta) return this.cachedCta
      if (this.hasCtaTarget)
        return ((this.cachedCta = this.ctaTarget), this.cachedCta)
      let e = this.element.firstElementChild
      return (
        (this.cachedCta = e instanceof HTMLElement ? e : null),
        this.cachedCta
      )
    }
    makeFloating() {
      let e = this.cta
      !e ||
        !this.sentinel ||
        (this.elementHeight || (this.elementHeight = e.offsetHeight),
        (this.sentinel.style.height = `${this.elementHeight}px`),
        e.classList.add(...el),
        !this.portaled &&
          e.parentElement !== document.body &&
          (document.body.appendChild(e), (this.portaled = !0)),
        e
          .querySelectorAll('[data-sticky-mobile-cta-wishlist]')
          .forEach((s) => s.classList.add('hidden')),
        e
          .querySelectorAll('[data-sticky-mobile-cta-oos]')
          .forEach((s) => s.classList.add('hidden')),
        this.getFloatingButtons(e).forEach((s) => s.classList.add(...tl)))
    }
    makeInline() {
      let e = this.cta
      e &&
        (this.portaled && (this.element.appendChild(e), (this.portaled = !1)),
        this.sentinel && (this.sentinel.style.height = ''),
        e.classList.remove(...el),
        (this.elementHeight = 0),
        e
          .querySelectorAll('[data-sticky-mobile-cta-wishlist]')
          .forEach((s) => s.classList.remove('hidden')),
        e.querySelectorAll('[data-sticky-mobile-cta-oos]').forEach((s) => {
          s.textContent?.trim() && s.classList.remove('hidden')
        }),
        this.getFloatingButtons(e).forEach((s) => s.classList.remove(...tl)))
    }
    getFloatingButtons(e) {
      return Array.from(
        e.querySelectorAll(
          'button:not([data-sticky-mobile-cta-wishlist]), a:not([data-sticky-mobile-cta-wishlist])',
        ),
      )
    }
    applyDrawerVisibility() {
      if (this.mediaQuery?.matches) return
      let e = this.cta
      e &&
        (this.openDrawers > 0
          ? e.classList.add('hidden')
          : e.classList.remove('hidden'))
    }
  }
b(Or, 'targets', ['cta'])
var Rr = class extends Je {
  constructor() {
    super(...arguments)
    b(this, 'productsController', new Ht())
    b(
      this,
      'sortHandler',
      new Sr({ onSortChange: () => this.handleSortUpdate() }),
    )
    b(this, 'filterHandler', new Er())
  }
  connect() {
    ;(super.connect(),
      this.hasFiltersButtonTarget &&
        this.filterHandler.setFiltersButton(this.filtersButtonTarget))
    let s = new URLSearchParams(window.location.search).get('q')
    s && this.performSearch(s)
  }
  disconnect() {
    this.productsController.disconnect()
  }
  async performSearch(e) {
    if (!this.hasResultsTarget) {
      console.warn('[SearchPage] no resultsTarget found')
      return
    }
    try {
      let { field: s, direction: i } = this.sortHandler.getCurrentSortParams(),
        n = new URLSearchParams(window.location.search),
        a = []
      n.forEach((T, p) => {
        if (p.startsWith('filter.')) {
          let v = p.replace('filter.', '')
          a.push({ type: 'value', field: v, value: T })
        }
      })
      let l = vr(),
        o = {
          search: { query: { string: e } },
          filters: a,
          pagination: { pageSize: 60, page: 1 },
          ...(s && i ? { sorts: [{ field: s, direction: i }] } : {}),
          tracking: {
            userId: l.userId,
            sessionId: l.sessionId,
            pageLoadId: l.pageLoadId,
          },
        },
        [u, h] = await this.client.search(o)
      if (!h) {
        ;(this.updateResultsCount(void 0),
          this.hideToolbar(),
          this.showRecommendations(),
          (this.resultsTarget.innerHTML = this.noResultsMessage(e)))
        return
      }
      let f = h?.merchandising?.redirect
      if (f) {
        window.location.assign(f)
        return
      }
      let m = h.pagination?.totalResults ?? 0,
        c = h.results || []
      if (m === 0 || c.length === 0) {
        ;(this.hideToolbar(),
          this.showRecommendations(),
          (this.resultsTarget.innerHTML = this.noResultsMessage(e)))
        return
      }
      ;(this.showToolbar(),
        this.hideRecommendations(),
        this.updateResultsCount(m))
      let d = h.tracking?.responseId ?? '',
        g = d ? { module: 'search', responseId: d } : void 0
      if (
        (this.productsController.render(this.resultsTarget, c, [], [], g),
        d && Lt({ module: 'search', responseId: d }),
        this.hasSortingTarget && u.sortOptions)
      ) {
        let T = new URLSearchParams(window.location.search),
          p = T.get('sort.field') ?? void 0,
          v = T.get('sort.direction') ?? void 0,
          y = u.sortOptions ?? []
        this.updateSortingOptions(y, p, v)
      }
      if (this.hasFiltersTarget && u.facets) {
        let T = new Map()
        ;(this.filtersTarget
          .querySelectorAll('[data-controller*="collapsible"]')
          .forEach((p) => {
            let v = p.querySelector(
                '[data-collapsible-target="collapsibleTrigger"]',
              ),
              y = p.dataset.field
            y && T.set(y, v.getAttribute('aria-expanded') === 'true')
          }),
          (this.filtersTarget.innerHTML = Ee.renderFacets(
            h.facets || [],
            u.facets,
            'search-page',
          )),
          this.filtersTarget
            .querySelectorAll('[data-controller*="collapsible"]')
            .forEach((p) => {
              let v = p.querySelector(
                  '[data-collapsible-target="collapsibleTrigger"]',
                ),
                y = p.querySelector(
                  '[data-collapsible-target="collapsibleContent"]',
                ),
                x = p.querySelector('[data-collapsible-target="icon"]'),
                L = p.dataset.field
              L &&
                T.get(L) &&
                (v.setAttribute('aria-expanded', 'true'),
                y.classList.remove('hidden'),
                x && (x.style.transform = 'rotate(180deg)'))
            }))
      }
    } catch (s) {
      ;(console.error('[SearchPage] Search error:', s),
        this.updateResultsCount(void 0),
        this.hideToolbar(),
        this.showRecommendations(),
        (this.resultsTarget.innerHTML = this.noResultsMessage(e)))
    }
  }
  updateSortingOptions(e, s, i) {
    let n = this.sortingTarget.querySelector('select[name="ss-sort"]')
    if (!n) {
      console.warn(
        '[SearchPageController] No select element found in sortingTarget',
      )
      return
    }
    let a = Ee.renderSortingOptions(e, s, i)
    n.innerHTML = a
    let l = n.closest('[data-controller*="select"]')
    if (l) {
      let o = this.application?.getControllerForElementAndIdentifier(
        l,
        'select',
      )
      o &&
        ('buildCustomOptions' in o && o.buildCustomOptions(),
        'syncFromNative' in o && o.syncFromNative(),
        this.sortHandler.updateSortLabel(o, e))
    }
  }
  handleSortClick(e) {
    this.sortHandler.handleSortClick(e)
  }
  handleSortChange(e) {
    this.sortHandler.handleSortChange(e)
  }
  handleFilterClick(e) {
    e.preventDefault()
    let s = e.currentTarget
    window.history.pushState({}, '', s.href)
    let n = new URLSearchParams(window.location.search).get('q')
    ;(n && this.performSearch(n), this.filterHandler.onFiltersChanged())
  }
  clearAllFilters(e) {
    ;(e.preventDefault(), this.filterHandler.clearAllFilters())
    let i = new URLSearchParams(window.location.search).get('q')
    i ? this.performSearch(i) : this.updateResultsCount(void 0)
  }
  noResultsMessage(e) {
    return `<p class="max-w-prose whitespace-pre-wrap text-body-light">We couldn't find any results for "<span class="text-body">${ue(e)}</span>"</p>`
  }
  showToolbar() {
    this.hasSortingTarget && this.sortingTarget.removeAttribute('hidden')
  }
  hideToolbar() {
    this.hasSortingTarget && this.sortingTarget.setAttribute('hidden', '')
  }
  getRecommendationSections() {
    return Array.from(
      document.querySelectorAll(
        '[data-controller~="searchspring-recommendations"]',
      ),
    )
      .map((e) => e.closest('section'))
      .filter((e) => e !== null)
  }
  showRecommendations() {
    for (let e of this.getRecommendationSections()) e.removeAttribute('hidden')
  }
  hideRecommendations() {
    for (let e of this.getRecommendationSections()) e.setAttribute('hidden', '')
  }
  updateResultsCount(e) {
    this.hasResultsCountTarget &&
      this.updateResultsCountTargets(this.resultsCountTargets, e)
  }
  handleSortUpdate() {
    let s = new URLSearchParams(window.location.search).get('q')
    s && this.performSearch(s)
  }
}
b(Rr, 'targets', [
  'results',
  'sorting',
  'sortMenu',
  'filters',
  'filtersButton',
  'resultsCount',
])
var Hr = class extends _ {
  connect() {
    window.self === window.top &&
      this.hasUrlValue &&
      this.urlValue.trim() !== '' &&
      window.location.replace(de(this.urlValue))
  }
}
b(Hr, 'values', { url: String })
var jt = class extends _ {
  constructor() {
    super(...arguments)
    b(this, 'showThreshold', 0)
    b(this, 'isVisible', !1)
    b(this, 'calculateThreshold', () => {
      this.showThreshold = window.innerHeight * this.thresholdValue
    })
    b(this, 'handleScroll', () => {
      let e = window.scrollY >= this.showThreshold
      e && !this.isVisible ? this.show() : !e && this.isVisible && this.hide()
    })
  }
  connect() {
    ;(this.calculateThreshold(),
      this.handleScroll(),
      window.addEventListener('scroll', this.handleScroll, { passive: !0 }),
      window.addEventListener('resize', this.calculateThreshold, {
        passive: !0,
      }))
  }
  disconnect() {
    ;(window.removeEventListener('scroll', this.handleScroll),
      window.removeEventListener('resize', this.calculateThreshold))
  }
  show() {
    this.hasButtonTarget &&
      ((this.isVisible = !0),
      this.buttonTarget.setAttribute('aria-hidden', 'false'),
      this.buttonTarget.classList.remove('opacity-0', 'pointer-events-none'),
      this.buttonTarget.classList.add('opacity-100'))
  }
  hide() {
    this.hasButtonTarget &&
      ((this.isVisible = !1),
      this.buttonTarget.classList.remove('opacity-100'),
      this.buttonTarget.classList.add('opacity-0', 'pointer-events-none'),
      this.buttonTarget.setAttribute('aria-hidden', 'true'))
  }
  scrollToTop() {
    ;(window.scrollTo({ top: 0, behavior: 'smooth' }), this.focusFirstElement())
  }
  focusFirstElement() {
    let e = document.querySelectorAll(
        'button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])',
      ),
      i = Array.from(e).filter((n) => n.getAttribute('tabindex') !== '-1')[0]
    i && i.focus()
  }
}
;(b(jt, 'targets', ['button']),
  b(jt, 'values', { threshold: { type: Number, default: 3 } }))
var At = class extends _ {
  constructor() {
    super(...arguments)
    b(this, 'hasAudio', !1)
    b(this, 'onPlay', () => this.syncPlayButton())
    b(this, 'onPause', () => this.syncPlayButton())
    b(this, 'onEnded', () => this.handleVideoEnd())
    b(this, 'onLoadedMetadata', () => this.detectAudioAndSync())
    b(this, 'onCanPlay', () => this.detectAudioAndSync())
  }
  connect() {
    if (!this.hasVideoTarget) return
    let e = this.videoTarget
    ;(e.addEventListener('play', this.onPlay),
      e.addEventListener('pause', this.onPause),
      e.addEventListener('ended', this.onEnded),
      e.addEventListener('loadedmetadata', this.onLoadedMetadata),
      e.addEventListener('canplay', this.onCanPlay),
      this.detectAudio(),
      this.syncAll())
  }
  disconnect() {
    if (!this.hasVideoTarget) return
    let e = this.videoTarget
    ;(e.removeEventListener('play', this.onPlay),
      e.removeEventListener('pause', this.onPause),
      e.removeEventListener('ended', this.onEnded),
      e.removeEventListener('loadedmetadata', this.onLoadedMetadata),
      e.removeEventListener('canplay', this.onCanPlay))
  }
  handlePlayClick(e) {
    ;(e.stopPropagation(), e.preventDefault(), this.togglePlay())
  }
  toggleVolume(e) {
    ;(e.stopPropagation(),
      e.preventDefault(),
      this.hasVideoTarget &&
        ((this.videoTarget.muted = !this.videoTarget.muted),
        this.syncVolumeButton()))
  }
  togglePlay() {
    this.hasVideoTarget &&
      (this.videoTarget.paused
        ? this.videoTarget.play()
        : this.videoTarget.pause())
  }
  handleVideoEnd() {
    !this.loopValue &&
      this.hasVideoControlsTarget &&
      this.setVisible(this.videoControlsTarget, !0)
  }
  detectAudio() {
    let e = this.videoTarget
    typeof e.mozHasAudio == 'boolean'
      ? (this.hasAudio = e.mozHasAudio)
      : typeof e.webkitAudioDecodedByteCount == 'number'
        ? (this.hasAudio = e.webkitAudioDecodedByteCount > 0)
        : e.audioTracks !== void 0 && e.audioTracks.length > 0
          ? (this.hasAudio = e.audioTracks.length > 0)
          : (this.hasAudio = !e.muted)
  }
  detectAudioAndSync() {
    ;(this.detectAudio(), this.syncAll())
  }
  syncAll() {
    ;(this.syncPlayButton(),
      this.syncVolumeButton(),
      this.syncControlsVisibility())
  }
  syncPlayButton() {
    if (!this.hasPlayButtonTarget) return
    let e = this.videoTarget.paused
    ;(this.setIconVisible(this.playButtonTarget, 'play', e),
      this.setIconVisible(this.playButtonTarget, 'pause', !e),
      this.syncControlsVisibility())
  }
  syncVolumeButton() {
    if (!this.hasVolumeButtonTarget) return
    let e = this.videoTarget.muted
    ;(this.setIconVisible(this.volumeButtonTarget, 'volume-muted', e),
      this.setIconVisible(this.volumeButtonTarget, 'volume-unmuted', !e))
  }
  syncControlsVisibility() {
    this.hasVideoControlsTarget &&
      (this.setVisible(this.playButtonTarget, this.hasPlayButtonTarget),
      this.setVisible(
        this.volumeButtonTarget,
        this.hasVolumeButtonTarget && this.hasAudio,
      ),
      this.setVisible(this.videoControlsTarget, !0))
  }
  setVisible(e, s) {
    e && e.classList.toggle(this.hiddenClass, !s)
  }
  setIconVisible(e, s, i) {
    let n = e.querySelector(`[data-video-icon="${s}"]`)
    n && n.classList.toggle(this.hiddenClass, !i)
  }
}
;(b(At, 'targets', ['video', 'playButton', 'volumeButton', 'videoControls']),
  b(At, 'classes', ['hidden']),
  b(At, 'values', {
    autoplay: { type: Boolean, default: !0 },
    loop: { type: Boolean, default: !0 },
  }))
var Ss = class extends _ {
  constructor() {
    super(...arguments)
    b(this, 'header')
    b(this, 'updateHeaderPosition', () => {
      if (!this.header) return
      let s = this.header.getBoundingClientRect().bottom
      document.documentElement.style.setProperty('--header-bottom', `${s}px`)
    })
  }
  connect() {
    ;((this.header = this.element),
      this.updateHeaderPosition(),
      window.addEventListener('scroll', this.updateHeaderPosition),
      window.addEventListener('resize', this.updateHeaderPosition))
  }
  disconnect() {
    ;(window.removeEventListener('scroll', this.updateHeaderPosition),
      window.removeEventListener('resize', this.updateHeaderPosition))
  }
}
var Wt = class extends _ {
  constructor() {
    super(...arguments)
    b(this, 'swiper', null)
    b(this, 'position', 'start')
  }
  async connect() {
    let [{ default: e }, { Navigation: s, Scrollbar: i, Mousewheel: n }] =
      await Promise.all([
        Promise.resolve().then(() => (ur(), js)),
        Promise.resolve().then(() => (pr(), Xs)),
      ])
    if (!this.element.isConnected) return
    let a = this.element.querySelector('.swiper')
    a &&
      (this.swiper = new e(a, {
        modules: [s, i, n],
        spaceBetween: this.spaceBetweenValue,
        simulateTouch: !1,
        watchSlidesProgress: !0,
        mousewheel: { forceToAxis: !0 },
        breakpoints: {
          0: { slidesPerView: this.slidesPerViewMobileValue },
          [Qe.sm]: { slidesPerView: this.slidesPerViewTabletValue },
          [Qe.md]: { slidesPerView: this.slidesPerViewDesktopValue },
        },
        scrollbar: {
          el: a.querySelector('.swiper-scrollbar'),
          draggable: !0,
          hide: !0,
        },
        navigation: {
          prevEl: this.hasPrevBtnTarget ? this.prevBtnTarget : null,
          nextEl: this.hasNextBtnTarget ? this.nextBtnTarget : null,
        },
        on: {
          init: () => {
            this.updatePosition('start')
          },
          reachBeginning: () => {
            this.updatePosition('start')
          },
          reachEnd: () => {
            this.updatePosition('end')
          },
          fromEdge: (l) => {
            !l.isBeginning && !l.isEnd && this.updatePosition('middle')
          },
        },
      }))
  }
  disconnect() {
    ;(this.swiper?.destroy(!0, !0), (this.swiper = null))
  }
  refresh() {
    this.swiper?.update()
  }
  updatePosition(e) {
    if (((this.position = e), !this.hasPrevBtnTarget || !this.hasNextBtnTarget))
      return
    let s = e !== 'start',
      i = e !== 'end'
    ;(this.toggleNavState(this.prevBtnTarget, s),
      this.toggleNavState(this.nextBtnTarget, i),
      this.prevBtnTarget.toggleAttribute('disabled', !s),
      this.nextBtnTarget.toggleAttribute('disabled', !i),
      this.prevBtnTarget.removeAttribute('aria-disabled'),
      this.nextBtnTarget.removeAttribute('aria-disabled'))
  }
  toggleNavState(e, s) {
    ;(e.classList.toggle('carousel-nav--active', s),
      e.classList.toggle('carousel-nav--inactive', !s))
    let i = e.querySelector('path')
    i &&
      (i.classList.toggle('stroke-primary', s),
      i.classList.toggle('stroke-nav-active', !s))
  }
  getPosition() {
    return this.position
  }
}
;(b(Wt, 'targets', ['prevBtn', 'nextBtn']),
  b(Wt, 'values', {
    slidesPerViewMobile: { type: Number, default: 2 },
    slidesPerViewTablet: { type: Number, default: 3 },
    slidesPerViewDesktop: { type: Number, default: 5 },
    spaceBetween: { type: Number, default: 8 },
  }))
var Dr = class extends _ {
  toggle() {
    this.collapsibleTriggerTarget.getAttribute('aria-expanded') === 'true'
      ? this.collapse()
      : this.expand()
  }
  expand() {
    ;(this.collapsibleTriggerTarget.setAttribute('aria-expanded', 'true'),
      this.collapsibleContentTarget.classList.remove('hidden'),
      (this.iconTarget.style.transform = 'rotate(180deg)'))
  }
  collapse() {
    ;(this.collapsibleTriggerTarget.setAttribute('aria-expanded', 'false'),
      this.collapsibleContentTarget.classList.add('hidden'),
      (this.iconTarget.style.transform = 'rotate(0deg)'))
  }
}
b(Dr, 'targets', ['collapsibleTrigger', 'collapsibleContent', 'icon'])
var Br = class extends _ {
  connect() {
    let r = new URLSearchParams(window.location.search)
    r.set('cart', 'open')
    let e = `${this.rootUrlValue}?${r.toString()}`
    window.location.replace(e)
  }
}
b(Br, 'values', { rootUrl: { type: String, default: '/' } })
var Es = class extends _ {
  handleChange(r) {
    r.target.closest('form')?.requestSubmit()
  }
}
var Fr = class extends _ {
  constructor() {
    super(...arguments)
    b(this, 'initialValue', '')
    b(this, 'onSelectChange', () => {
      this.updateInfoFromSelection(this.selectTarget)
    })
    b(this, 'onDrawerOpened', (e) => {
      let s = e.target instanceof HTMLElement ? e.target : null
      !s || !s.contains(this.element) || this.resetToInitial()
    })
  }
  connect() {
    ;((this.initialValue = this.selectTarget.value),
      this.selectTarget.addEventListener('change', this.onSelectChange),
      document.addEventListener('drawer:opened', this.onDrawerOpened),
      this.updateInfoFromSelection(this.selectTarget))
  }
  disconnect() {
    ;(this.selectTarget.removeEventListener('change', this.onSelectChange),
      document.removeEventListener('drawer:opened', this.onDrawerOpened))
  }
  resetToInitial() {
    ;((this.selectTarget.value = this.initialValue),
      this.syncSelectUi(this.initialValue),
      this.updateInfoFromSelection(this.selectTarget))
  }
  updateInfoFromSelection(e) {
    let s = e.options[e.selectedIndex]
    if (!s) return
    let i = s.dataset.currencyCode?.trim() ?? '',
      n = s.text.trim().match(/\(([^)]+)\)\s*$/),
      a = n ? n[1] : '',
      l = i || a
    if (l) {
      ;((this.currencyTarget.textContent = l),
        this.infoTarget.classList.remove('hidden'))
      return
    }
    ;((this.currencyTarget.textContent = ''),
      this.infoTarget.classList.add('hidden'))
  }
  syncSelectUi(e) {
    let s = this.selectTarget.closest('[data-controller~="select"]')
    if (!(s instanceof HTMLElement)) return
    this.application
      .getControllerForElementAndIdentifier(s, 'select')
      ?.syncFromNative(e)
  }
}
b(Fr, 'targets', ['select', 'info', 'currency'])
async function xs(t) {
  let r = await fetch(de('/cart/change.js'), {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
    body: JSON.stringify({ id: t.id, quantity: t.quantity }),
  })
  if (!r.ok) throw new Error(`Failed to update cart item: ${r.status}`)
  return r.json()
}
var Gt = class Gt extends bt {
  constructor() {
    super(...arguments)
    b(this, 'updating', !1)
    b(this, 'onCartRefresh', async () => {
      ;(await this.refreshAllSections(), this.openDrawer())
    })
    b(this, 'onPageShow', async (e) => {
      e.persisted &&
        ((this.updating = !1),
        this.enableButtons(),
        await this.refreshAllSections())
    })
  }
  connect() {
    ;(document.addEventListener('cart:refresh', this.onCartRefresh),
      window.addEventListener('pageshow', this.onPageShow))
  }
  disconnect() {
    ;(document.removeEventListener('cart:refresh', this.onCartRefresh),
      window.removeEventListener('pageshow', this.onPageShow))
  }
  async increment(e) {
    let s = this.findLineItem(e)
    if (!s) return
    let i = s.dataset.lineItemKey,
      n = this.getQuantity(s)
    i && (await this.mutateAndRefresh(() => xs({ id: i, quantity: n + 1 })))
  }
  async decrement(e) {
    let s = this.findLineItem(e)
    if (!s) return
    let i = s.dataset.lineItemKey,
      n = this.getQuantity(s)
    if (i) {
      if (n <= 1) {
        await this.removeItem(i)
        return
      }
      await this.mutateAndRefresh(() => xs({ id: i, quantity: n - 1 }))
    }
  }
  async remove(e) {
    e.preventDefault()
    let s = this.findLineItem(e)
    if (!s) return
    let i = s.dataset.lineItemKey
    i && (await this.removeItem(i))
  }
  async checkoutWithCoverage() {
    if (!this.updating) {
      ;((this.updating = !0), this.disableButtons())
      try {
        ;(await Sn({ id: this.getShippingProtectionVariantId() }),
          (window.location.href = de('/checkout')))
      } catch (e) {
        ;(console.error('[cart-drawer] Failed to add shipping protection:', e),
          (this.updating = !1),
          this.enableButtons())
      }
    }
  }
  checkoutWithoutCoverage() {
    window.location.href = de('/checkout')
  }
  checkout() {
    window.location.href = de('/checkout')
  }
  async mutateAndRefresh(e) {
    if (!this.updating) {
      ;((this.updating = !0), this.disableButtons())
      try {
        let s = await e()
        ;(await this.cleanupOrphanedShippingProtection(s),
          oi(s.items),
          await this.refreshAllSections())
      } catch (s) {
        console.error('[cart-drawer] Cart mutation failed:', s)
      } finally {
        ;((this.updating = !1), this.enableButtons())
      }
    }
  }
  async removeItem(e) {
    await this.mutateAndRefresh(() => xs({ id: e, quantity: 0 }))
  }
  async cleanupOrphanedShippingProtection(e) {
    if (!this.shippingProtectionHandleValue) return
    let s = this.shippingProtectionHandleValue
    if (e.items.filter((a) => a.handle !== s).length > 0) return
    let n = e.items.filter((a) => a.handle === s)
    for (let a of n) await xs({ id: a.key, quantity: 0 })
  }
  async refreshAllSections() {
    let e = Object.values(Gt.SECTION_KEYS),
      s = de(`?sections=${e.join(',')}`)
    try {
      let i = await fetch(s, { headers: { Accept: 'application/json' } })
      if (!i.ok) return
      let n = await i.json(),
        { BADGE: a, HEADER: l, ITEMS: o, FOOTER: u } = Gt.SECTION_KEYS
      ;(this.hasBadgeTarget &&
        a in n &&
        this.injectHtmlIntoTarget(this.badgeTarget, n[a] ?? ''),
        this.hasHeaderTarget &&
          l in n &&
          this.injectHtmlIntoTarget(this.headerTarget, n[l] ?? ''),
        this.hasItemsTarget &&
          o in n &&
          this.injectHtmlIntoTarget(this.itemsTarget, n[o] ?? ''),
        this.hasFooterTarget &&
          u in n &&
          this.injectHtmlIntoTarget(this.footerTarget, n[u] ?? ''),
        this.toggleRecommendations(n[o]))
    } catch (i) {
      console.error('[cart-drawer] Failed to refresh sections:', i)
    }
  }
  toggleRecommendations(e) {
    if (!this.hasRecommendationsTarget) return
    let s = !0
    ;(e
      ? (s = e.includes('data-cart-state="empty"'))
      : this.hasItemsTarget &&
        (s =
          this.itemsTarget
            .querySelector('[data-cart-state]')
            ?.getAttribute('data-cart-state') === 'empty'),
      this.recommendationsTarget
        .querySelectorAll('[data-recommendation-state]')
        .forEach((i) => {
          let n = i.dataset.recommendationState
          i.hidden = n === 'empty' ? !s : s
        }))
  }
  getShippingProtectionVariantId() {
    let e = this.element.querySelector('[data-shipping-protection-variant-id]'),
      s = parseInt(e?.dataset.shippingProtectionVariantId ?? '', 10)
    if (isNaN(s)) throw new Error('Shipping protection variant ID not found')
    return s
  }
  openDrawer() {
    let e = this.application.getControllerForElementAndIdentifier(
      this.element,
      'drawer',
    )
    e && 'open' in e && e.open()
  }
  findLineItem(e) {
    let s = e.currentTarget
    return s instanceof HTMLElement ? s.closest('[data-line-item-key]') : null
  }
  getQuantity(e) {
    let s = e.querySelector('[data-cart-drawer-target="quantity"]')
    return parseInt(s?.textContent ?? '1', 10)
  }
  disableButtons() {
    this.element.querySelectorAll('button').forEach((e) => {
      ;(e.setAttribute('disabled', ''), e.classList.add('cursor-wait'))
    })
  }
  enableButtons() {
    this.element.querySelectorAll('button').forEach((e) => {
      ;(e.removeAttribute('disabled'), e.classList.remove('cursor-wait'))
    })
  }
}
;(b(Gt, 'SECTION_KEYS', {
  BADGE: 'cart-drawer-ssr-badge',
  HEADER: 'cart-drawer-ssr-header',
  ITEMS: 'cart-drawer-ssr-items',
  FOOTER: 'cart-drawer-ssr-footer',
}),
  b(Gt, 'targets', ['badge', 'header', 'items', 'footer', 'recommendations']),
  b(Gt, 'values', { shippingProtectionHandle: { type: String, default: '' } }))
var ws = Gt
var Vr = class extends _ {
  constructor() {
    super(...arguments)
    b(this, 'onToastShow', (e) => {
      if (!(e instanceof CustomEvent)) return
      let s = e.detail
      if (!s?.message) return
      let i = s.variant ?? 'info',
        n = s.duration ?? 4e3,
        a = s.position ?? 'top-right',
        l = s.dedupe ?? !0
      ;(this.applyPosition(a), this.addToast(s.message, i, n, l))
    })
  }
  connect() {
    document.addEventListener('toast:show', this.onToastShow)
  }
  disconnect() {
    document.removeEventListener('toast:show', this.onToastShow)
  }
  applyPosition(e) {
    if (!this.hasContainerTarget) return
    let s = this.containerTarget
    switch (
      (s.classList.remove(
        'bottom-6',
        'top-24',
        'right-6',
        'left-6',
        'items-end',
        'items-start',
        'items-center',
        'md:bottom-auto',
        'md:top-24',
        'left-1/2',
        '-translate-x-1/2',
      ),
      e)
    ) {
      case 'top-left':
        s.classList.add('top-24', 'left-6', 'items-start')
        break
      case 'bottom-right':
        s.classList.add('bottom-6', 'right-6', 'items-end')
        break
      case 'bottom-left':
        s.classList.add('bottom-6', 'left-6', 'items-start')
        break
      case 'top-center':
        s.classList.add(
          'top-24',
          'left-1/2',
          '-translate-x-1/2',
          'items-center',
        )
        break
      case 'bottom-center':
        s.classList.add(
          'bottom-6',
          'left-1/2',
          '-translate-x-1/2',
          'items-center',
        )
        break
      default:
        s.classList.add('top-24', 'right-6', 'items-end')
        break
    }
  }
  addToast(e, s, i, n) {
    if (
      !this.hasContainerTarget ||
      (n &&
        this.containerTarget
          .querySelector('[role="status"]')
          ?.textContent?.trim()
          .replace(/\s+/g, ' ')
          .includes(e))
    )
      return
    let a = document.createElement('div')
    ;(a.setAttribute('role', 'status'),
      (a.className = this.buildClasses(s)),
      (a.innerHTML = this.buildContent(e)))
    let l = a.querySelector('[data-dismiss]')
    ;(l && l.addEventListener('click', () => this.removeToast(a), { once: !0 }),
      this.containerTarget.appendChild(a),
      requestAnimationFrame(() => {
        ;(a.classList.remove('translate-y-2', 'opacity-0'),
          a.classList.add('translate-y-0', 'opacity-100'))
      }),
      i > 0 && setTimeout(() => this.removeToast(a), i))
  }
  removeToast(e) {
    ;(e.classList.remove('translate-y-0', 'opacity-100'),
      e.classList.add('translate-y-2', 'opacity-0'),
      e.addEventListener('transitionend', () => e.remove(), { once: !0 }),
      setTimeout(() => e.remove(), 300))
  }
  buildClasses(e) {
    let s =
      'pointer-events-auto flex items-center gap-3 px-4 py-3 text-body shadow-lg transition-all duration-300 translate-y-2 opacity-0 max-w-sm'
    switch (e) {
      case 'error':
        return `${s} bg-destructive text-surface`
      case 'success':
        return `${s} bg-success text-surface`
      default:
        return `${s} bg-primary text-surface`
    }
  }
  buildContent(e) {
    return `
      <span class="grow">${e.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;')}</span>
      <button
        data-dismiss
        type="button"
        class="shrink-0 p-1 text-surface/70 hover:text-surface transition-colors"
        aria-label="Dismiss"
      >
        <svg width="14" height="14" viewBox="0 0 14 14" fill="none" aria-hidden="true">
          <use href="#icon-close"></use>
        </svg>
      </button>
    `
  }
}
b(Vr, 'targets', ['container'])
var Ms = class extends _ {
  togglePreferences(r) {
    r.preventDefault()
    let e = window.OneTrust
    e && e.ToggleInfoDisplay()
  }
}
var Ju = 2.54,
  lt = class lt extends _ {
    constructor() {
      super(...arguments)
      b(this, 'stickyObserver', null)
    }
    connect() {
      ;(this.applyUnit(), this.observeStickyHeaders())
    }
    disconnect() {
      ;(this.stickyObserver?.disconnect(), (this.stickyObserver = null))
    }
    switchView() {
      if (!this.hasViewSelectTarget) return
      let e =
        this.viewSelectTarget instanceof HTMLSelectElement
          ? this.viewSelectTarget
          : this.viewSelectTarget.querySelector('select')
      ;(e ? e.value : 'measurements') === 'conversions'
        ? this.showConversions()
        : this.showMeasurements()
    }
    selectCm() {
      ;((this.unitValue = 'cm'), this.applyUnit())
    }
    selectInch() {
      ;((this.unitValue = 'inch'), this.applyUnit())
    }
    observeStickyHeaders() {
      ;((this.stickyObserver = new IntersectionObserver(
        (e) => {
          e.forEach((s) => {
            let i = s.target,
              n = this.stickySentinelTargets.indexOf(i),
              a = this.stickyHeaderTargets[n]
            a &&
              (s.isIntersecting
                ? a.classList.remove(...lt.STICKY_CLASSES)
                : a.classList.add(...lt.STICKY_CLASSES))
          })
        },
        { threshold: 0 },
      )),
        this.stickySentinelTargets.forEach((e) => {
          this.stickyObserver?.observe(e)
        }))
    }
    showMeasurements() {
      ;(this.hasMeasurementsViewTarget &&
        this.measurementsViewTarget.classList.remove('hidden'),
        this.hasConversionsViewTarget &&
          this.conversionsViewTarget.classList.add('hidden'),
        this.hasUnitToggleTarget &&
          this.unitToggleTarget.classList.remove('hidden'))
    }
    showConversions() {
      ;(this.hasMeasurementsViewTarget &&
        this.measurementsViewTarget.classList.add('hidden'),
        this.hasConversionsViewTarget &&
          this.conversionsViewTarget.classList.remove('hidden'),
        this.hasUnitToggleTarget &&
          this.unitToggleTarget.classList.add('hidden'))
    }
    applyUnit() {
      let e = this.unitValue === 'cm'
      ;(this.cellTargets.forEach((s) => {
        let i = s.getAttribute('data-inches')
        if (i === null || i === '') return
        let n = lt.formatValue(i, e)
        n !== null && (s.textContent = n)
      }),
        this.updateButtonStyles(e))
    }
    static formatValue(e, s) {
      let i = e.split(/[-\u2013\u2014]/),
        n = []
      for (let a of i) {
        let l = a.trim().replace(/"/g, '')
        if (l === '') continue
        let o = parseFloat(l)
        if (Number.isNaN(o)) return null
        s ? n.push(Math.round(o * Ju).toString()) : n.push(o + '"')
      }
      return n.length === 0 ? null : n.join(' - ')
    }
    updateButtonStyles(e) {
      let s = lt.ACTIVE_CLASSES
      ;(this.hasCmButtonTarget &&
        (e
          ? (this.cmButtonTarget.classList.add(...s),
            this.cmButtonTarget.setAttribute(
              'aria-label',
              'Selected unit of measurement: CM.',
            ))
          : (this.cmButtonTarget.classList.remove(...s),
            this.cmButtonTarget.setAttribute(
              'aria-label',
              'Display by unit of measurement: CM.',
            ))),
        this.hasInchButtonTarget &&
          (e
            ? (this.inchButtonTarget.classList.remove(...s),
              this.inchButtonTarget.setAttribute(
                'aria-label',
                'Display by unit of measurement: INCH.',
              ))
            : (this.inchButtonTarget.classList.add(...s),
              this.inchButtonTarget.setAttribute(
                'aria-label',
                'Selected unit of measurement: INCH.',
              ))))
    }
  }
;(b(lt, 'targets', [
  'viewSelect',
  'unitToggle',
  'measurementsView',
  'conversionsView',
  'cmButton',
  'inchButton',
  'cell',
  'stickyHeader',
  'stickySentinel',
]),
  b(lt, 'values', { unit: { type: String, default: 'inch' } }),
  b(lt, 'ACTIVE_CLASSES', ['bg-primary', 'text-surface']),
  b(lt, 'STICKY_CLASSES', ['border-b', 'border-b-muted']))
var Ls = lt
var It = class It extends _ {
  constructor() {
    super(...arguments)
    b(this, 'loadedUrl', null)
    b(this, 'inFlight', null)
  }
  disconnect() {
    ;(this.inFlight?.abort(), (this.inFlight = null))
  }
  async load() {
    if (!this.hasContentTarget) return
    let e = this.getProductUrl()
    if (!e || this.loadedUrl === e) return
    this.inFlight?.abort()
    let s = new AbortController()
    ;((this.inFlight = s), this.loadedUrl !== e && this.renderSkeleton())
    try {
      let i = await ai(e, [this.sectionValue], {
        signal: s.signal,
        stripParams: ['size', 'inseam'],
        cacheStrategy: 'LONG',
      })
      if (s.signal.aborted) return
      let n = i[this.sectionValue]
      if (typeof n != 'string') {
        this.renderError()
        return
      }
      ;((this.contentTarget.innerHTML = n), (this.loadedUrl = e))
    } catch (i) {
      if (i instanceof DOMException && i.name === 'AbortError') return
      ;(console.warn('[SizeGuideLoader] Failed to load size guide', i),
        this.renderError())
    } finally {
      this.inFlight === s && (this.inFlight = null)
    }
  }
  getProductUrl() {
    let e = '[data-controller~="product"][data-product-url-value]'
    if (this.element.matches(e)) {
      let n = this.element.getAttribute('data-product-url-value')
      if (n) return n
    }
    let i = this.element
      .querySelector(e)
      ?.getAttribute('data-product-url-value')
    return i || window.location.pathname
  }
  renderSkeleton() {
    this.contentTarget.innerHTML = It.SKELETON_HTML
  }
  renderError() {
    this.contentTarget.innerHTML = It.ERROR_HTML
  }
}
;(b(It, 'targets', ['content']),
  b(It, 'values', {
    section: { type: String, default: 'product-ssr-size-guide' },
  }),
  b(
    It,
    'SKELETON_HTML',
    `
    <div class="px-gutter-drawer pt-12 animate-pulse" aria-busy="true" aria-live="polite">
      <div class="h-7 w-1/3 bg-nav-inactive rounded mb-6"></div>
      <div class="space-y-3">
        <div class="h-10 bg-nav-inactive rounded"></div>
        <div class="h-10 bg-nav-inactive rounded"></div>
        <div class="h-10 bg-nav-inactive rounded"></div>
        <div class="h-10 bg-nav-inactive rounded"></div>
        <div class="h-10 bg-nav-inactive rounded"></div>
      </div>
    </div>
  `,
  ),
  b(
    It,
    'ERROR_HTML',
    `
    <p class="px-gutter-drawer pt-12 text-body">Unable to load the size guide. Please try again.</p>
  `,
  ))
var Cs = It
var Pt = class extends Je {
  constructor() {
    super(...arguments)
    b(this, 'abortController', null)
  }
  async connect() {
    this.tagValue && (await this.fetchAndRender())
  }
  disconnect() {
    ;(this.abortController?.abort(), (this.abortController = null))
  }
  async fetchAndRender() {
    ;(this.abortController?.abort(),
      (this.abortController = new AbortController()))
    let { signal: e } = this.abortController
    try {
      let {
        products: s,
        responseId: i,
        tag: n,
      } = await this.getRecommendationsWithMeta(
        this.tagValue,
        this.limitValue,
        this.productIdValue || void 0,
      )
      if (e.aborted) return
      if (s.length === 0) {
        this.hide()
        return
      }
      ;(this.show(),
        this.renderProducts(s, e, i, n),
        i && Lt({ module: 'recommendations', responseId: i, tag: n }))
    } catch (s) {
      if (s instanceof DOMException && s.name === 'AbortError') return
      ;(console.error(
        '[SearchspringRecommendationsController] Failed to fetch recommendations:',
        s,
      ),
        this.hide())
    }
  }
  renderProducts(e, s, i, n) {
    if (!this.hasProductsTarget) return
    let a = i ? { module: 'recommendations', responseId: i, tag: n } : void 0,
      l = this.hasCarouselOutlet
    ;(l
      ? ((this.productsTarget.innerHTML = e
          .map((o, u) => {
            let h = tt(o.mappings?.core?.url ?? '') ?? '',
              f = Pe.productCardSkeleton(h)
            return Pe.carouselSlide(f, u, e.length)
          })
          .join('')),
        this.carouselOutlet.refresh())
      : (this.productsTarget.innerHTML = Ee.renderProductSkeletons(e)),
      Ee.hydrateProductCards(this.productsTarget, e, s, 0, a)
        .then(() => {
          l && this.hasCarouselOutlet && this.carouselOutlet.refresh()
        })
        .catch((o) => {
          ;(o instanceof DOMException && o.name === 'AbortError') ||
            (console.error(
              '[SearchspringRecommendationsController] Hydration failed:',
              o,
            ),
            this.hide())
        }))
  }
  hide() {
    this.element.classList.add('hidden')
  }
  show() {
    this.element.classList.remove('hidden')
  }
}
;(b(Pt, 'targets', ['products']),
  b(Pt, 'outlets', ['carousel']),
  b(Pt, 'values', {
    tag: { type: String, default: '' },
    limit: { type: Number, default: 12 },
    productId: { type: String, default: '' },
  }))
var Yt = class extends bt {
  constructor() {
    super(...arguments)
    b(this, 'currentStep', 1)
    b(this, 'totalSteps', 3)
    b(this, 'selectedOptions', [])
    b(this, 'stepData', {})
    b(this, 'lastSelectedOption', '')
    b(this, 'isTransitioning', !1)
    b(this, 'filterFieldByStep', {
      1: 'tags_fit',
      2: 'tags_stretch',
      3: 'tags_wash',
    })
    b(this, 'fitFilterValuesByOption', {
      skinny: ['skinny'],
      straight: ['straight'],
      baggy: ['loose', 'relaxed'],
      'bootcut/flare': ['bootcut', 'flare'],
      wideleg: ['wide leg'],
      'all fits': ['skinny', 'straight', 'loose', 'relaxed', 'wide leg'],
    })
    b(this, 'stretchFilterValuesByOption', {
      'very stretchy': ['always fits', 'power stretch', 'super stretch'],
      'some stretch': ['comfort', 'comfort stretch', 'super stretch'],
      'no stretch': ['rigid'],
      'all stretch levels': [
        'always fits',
        'power stretch',
        'super stretch',
        'comfort',
        'comfort stretch',
        'rigid',
      ],
    })
    b(this, 'washFilterValuesByOption', {
      light: ['light blue', 'white'],
      medium: ['medium light blue', 'medium blue', 'medium dark blue'],
      dark: ['dark blue', 'black', 'grey', 'medium dark blue'],
      'all washes': [
        'light blue',
        'white',
        'medium light blue',
        'medium blue',
        'medium dark blue',
        'dark blue',
        'black',
        'grey',
      ],
    })
    b(this, 'stepConfig', {
      1: {
        title: 'What fit are you looking for?',
        label: 'Fit',
        options: [
          'skinny',
          'straight',
          'baggy',
          'bootcut/flare',
          'wideleg',
          'all fits',
        ],
      },
      2: {
        title: 'What is your perfect stretch level?',
        label: 'Stretch',
        options: [
          'very stretchy',
          'some stretch',
          'no stretch',
          'all stretch levels',
        ],
      },
      3: {
        title: "What's your favorite wash?",
        label: 'Wash',
        options: ['light', 'medium', 'dark', 'all washes'],
      },
    })
  }
  connect() {
    ;(this.updateStep(),
      this.updateProgressBar(this.currentStep, this.totalSteps))
  }
  selectOption(e) {
    let s = e.currentTarget,
      i = s.dataset.option
    if (!i) return
    let n = this.checkmarkTargets.find((o) => o.dataset.option === i)
    if (!n) return
    let a = s.nextElementSibling
    s.checked
      ? (this.selectedOptions.includes(i) || this.selectedOptions.push(i),
        n.classList.remove('opacity-0'),
        n.classList.add('opacity-100'),
        (this.lastSelectedOption = i),
        this.showDescriptionForOption(i))
      : ((this.selectedOptions = this.selectedOptions.filter((o) => o !== i)),
        n.classList.add('opacity-0'),
        n.classList.remove('opacity-100'),
        a?.classList.remove('underline'),
        this.lastSelectedOption === i &&
          ((this.lastSelectedOption =
            this.selectedOptions[this.selectedOptions.length - 1] || ''),
          this.lastSelectedOption
            ? this.showDescriptionForOption(this.lastSelectedOption)
            : this.hideDescription()))
  }
  showDescription(e) {
    let i = e.currentTarget.dataset.option
    i && this.selectedOptions.length === 0 && this.showDescriptionForOption(i)
  }
  showDescriptionForOption(e) {
    let s = this.getDescriptionForOption(e)
    s &&
      ((this.descriptionTextTarget.textContent = s),
      this.descriptionPanelTarget.classList.remove('opacity-0'),
      this.descriptionPanelTarget.classList.add('opacity-100'))
  }
  getDescriptionForOption(e) {
    switch (e) {
      case 'skinny':
        return this.skinnyDescriptionValue
      case 'straight':
        return this.straightDescriptionValue
      case 'baggy':
        return this.baggyDescriptionValue
      case 'bootcut/flare':
        return this.bootcutDescriptionValue
      case 'wideleg':
        return this.widelegDescriptionValue
      case 'all fits':
        return this.allFitsDescriptionValue
      case 'very stretchy':
        return this.veryStretchyDescriptionValue
      case 'some stretch':
        return this.someStretchDescriptionValue
      case 'no stretch':
        return this.noStretchDescriptionValue
      case 'all stretch levels':
        return this.allStretchDescriptionValue
      case 'light':
        return this.lightWashDescriptionValue
      case 'medium':
        return this.mediumWashDescriptionValue
      case 'dark':
        return this.darkWashDescriptionValue
      case 'all washes':
        return this.allWashesDescriptionValue
      default:
        return null
    }
  }
  hideDescription() {
    this.selectedOptions.length === 0 &&
      (this.descriptionPanelTarget.classList.add('opacity-0'),
      this.descriptionPanelTarget.classList.remove('opacity-100'))
  }
  goToNext() {
    this.isTransitioning ||
      ((this.stepData[this.currentStep] = [...this.selectedOptions]),
      this.currentStep < this.totalSteps
        ? (this.currentStep++,
          (this.selectedOptions = this.stepData[this.currentStep] || []),
          (this.nextButtonTarget.disabled = !0),
          (this.backButtonTarget.disabled = !0),
          this.transitionToStep().finally(() => {
            ;((this.nextButtonTarget.disabled = !1),
              (this.backButtonTarget.disabled = !1))
          }))
        : this.redirectToResults())
  }
  goBack() {
    this.currentStep > 1 &&
      !this.isTransitioning &&
      ((this.stepData[this.currentStep] = [...this.selectedOptions]),
      this.currentStep--,
      (this.selectedOptions = this.stepData[this.currentStep] || []),
      (this.nextButtonTarget.disabled = !0),
      (this.backButtonTarget.disabled = !0),
      this.transitionToStep().finally(() => {
        ;((this.nextButtonTarget.disabled = !1),
          (this.backButtonTarget.disabled = !1))
      }))
  }
  updateStep() {
    let e = this.stepConfig[this.currentStep]
    ;((this.progressLabelTarget.textContent = `${this.currentStep} / ${this.totalSteps} ${e.label}`),
      (this.stepTitleTarget.textContent = e.title),
      this.updateOptionsList(e.options),
      this.currentStep > 1
        ? this.backButtonTarget.classList.remove('hidden')
        : this.backButtonTarget.classList.add('hidden'),
      this.currentStep === this.totalSteps
        ? (this.nextButtonTarget.textContent = 'See your results')
        : (this.nextButtonTarget.textContent = 'Next'),
      this.updateCheckmarks(),
      (this.lastSelectedOption = ''),
      this.selectedOptions.length > 0
        ? ((this.lastSelectedOption =
            this.selectedOptions[this.selectedOptions.length - 1]),
          this.showDescriptionForOption(this.lastSelectedOption))
        : this.hideDescription(),
      this.updateProgressBar(this.currentStep, this.totalSteps))
  }
  updateOptionsList(e) {
    ;((this.optionsListTarget.innerHTML = ''),
      e.forEach((s) => {
        let i = document.createElement('li')
        ;((i.className = 'flex items-center gap-3'),
          (i.innerHTML = `
        <div class="w-5 h-5 flex items-center justify-center">
          <span
            class="text-primary text-body w-2.5 h-2.5 transition-opacity duration-300 opacity-0 absolute left-0"
            data-fit-finder-target="checkmark"
            data-option="${s}"
          >
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 14 14" fill="none" height="14" width="14" class="w-full h-full"><title>Check</title><circle cx="7" cy="7" r="6.5" fill="#fff"></circle><path d="M4.5 7.604 6.108 9.5l3.392-4" stroke="currentColor" stroke-linecap="square" stroke-width="1.5"></path></svg>
          </span>
        </div>
        <label class="flex-1 cursor-pointer relative">
          <input
            type="checkbox"
            class="sr-only"
            data-fit-finder-target="option"
            data-option="${s}"
            data-action="change->fit-finder#selectOption mouseover->fit-finder#showDescription mouseout->fit-finder#hideDescription"
            value="${s}"
          >
          <span class="text-left text-body hover:underline transition-all duration-300 uppercase">
            ${s}
          </span>
        </label>
      `),
          this.optionsListTarget.appendChild(i))
      }))
  }
  updateCheckmarks() {
    ;(this.checkmarkTargets.forEach((e) => {
      ;(e.classList.add('opacity-0'), e.classList.remove('opacity-100'))
    }),
      this.optionTargets.forEach((e) => {
        ;((e.checked = !1), e.nextElementSibling?.classList.remove('underline'))
      }),
      this.selectedOptions.forEach((e) => {
        let s = this.optionTargets.find((n) => n.dataset.option === e),
          i = this.checkmarkTargets.find((n) => n.dataset.option === e)
        s &&
          i &&
          ((s.checked = !0),
          i.classList.remove('opacity-0'),
          i.classList.add('opacity-100'))
      }))
  }
  redirectToResults() {
    let e = new URLSearchParams(),
      s = {}
    ;(Object.entries(this.stepData).forEach(([a, l]) => {
      let o = parseInt(a),
        u = this.filterFieldByStep[o]
      u &&
        (s[u] || (s[u] = new Set()),
        l.forEach((h) => {
          this.getMappedFilterValues(o, h).forEach((m) => {
            s[u].add(m)
          })
        }))
    }),
      Object.entries(s).forEach(([a, l]) => {
        l.forEach((o) => {
          e.append(`filter.${a}`, o)
        })
      }))
    let i = de('/collections/fit-finder-results'),
      n = e.toString()
    window.location.href = n ? `${i}?${n}` : i
  }
  getMappedFilterValues(e, s) {
    return e === 1
      ? (this.fitFilterValuesByOption[s] ?? [])
      : e === 2
        ? (this.stretchFilterValuesByOption[s] ?? [])
        : e === 3
          ? (this.washFilterValuesByOption[s] ?? [])
          : [s]
  }
  updateProgressBar(e, s) {
    let i = (e / s) * 100
    if (this.progressBarTarget)
      ((this.progressBarTarget.style.transition =
        'width 600ms cubic-bezier(0.16, 1, 0.3, 1)'),
        (this.progressBarTarget.style.width = `${i}%`))
    else throw new Error('progressBarTarget is null or undefined')
  }
  async transitionToStep() {
    this.isTransitioning = !0
    let e = [
      this.stepTitleTarget,
      this.optionsListTarget,
      this.progressLabelTarget,
      this.nextButtonTarget,
      this.backButtonTarget,
      this.descriptionPanelTarget,
    ].filter(Boolean)
    try {
      ;(await this.slideOut(e), this.updateStep(), await this.slideIn(e))
    } finally {
      this.isTransitioning = !1
    }
  }
  slideOut(e) {
    return new Promise((s) => {
      ;(e.forEach((i, n) => {
        setTimeout(() => {
          ;((i.style.transition =
            'transform 350ms cubic-bezier(0.4, 0, 0.6, 1), opacity 350ms cubic-bezier(0.4, 0, 0.6, 1)'),
            (i.style.transform = 'translateY(25px)'),
            (i.style.opacity = '0'))
        }, n * 15)
      }),
        setTimeout(s, 350 + e.length * 15))
    })
  }
  slideIn(e) {
    return new Promise((s) => {
      ;(e.forEach((i) => {
        ;((i.style.transition = 'none'),
          (i.style.transform = 'translateY(-25px)'),
          (i.style.opacity = '0'))
      }),
        e[0] && e[0].offsetHeight,
        e.forEach((i, n) => {
          setTimeout(() => {
            ;((i.style.transition =
              'transform 400ms cubic-bezier(0.16, 1, 0.3, 1), opacity 400ms cubic-bezier(0.16, 1, 0.3, 1)'),
              (i.style.transform = 'translateY(0)'),
              (i.style.opacity = '1'))
          }, n * 20)
        }),
        setTimeout(
          () => {
            ;(e.forEach((i) => {
              ;((i.style.transition = ''),
                (i.style.transform = ''),
                (i.style.opacity = ''))
            }),
              s())
          },
          400 + e.length * 20,
        ))
    })
  }
}
;(b(Yt, 'values', {
  skinnyDescription: String,
  straightDescription: String,
  baggyDescription: String,
  bootcutDescription: String,
  widelegDescription: String,
  allFitsDescription: String,
  veryStretchyDescription: String,
  someStretchDescription: String,
  noStretchDescription: String,
  allStretchDescription: String,
  lightWashDescription: String,
  mediumWashDescription: String,
  darkWashDescription: String,
  allWashesDescription: String,
}),
  b(Yt, 'targets', [
    'progressBar',
    'progressLabel',
    'stepContainer',
    'stepTitle',
    'optionsList',
    'option',
    'checkmark',
    'descriptionPanel',
    'descriptionText',
    'nextButton',
    'backButton',
  ]))
var _r = class extends _ {
  openModal() {
    this.hasDialogTarget &&
      (this.dialogTarget.open ||
        (this.dialogTarget.showModal(),
        document.body.classList.add('drawer-open'),
        this.hasModalVideoTarget &&
          ((this.modalVideoTarget.currentTime = 0),
          this.modalVideoTarget.play())))
  }
  closeModal() {
    this.hasDialogTarget && this.dialogTarget.open && this.dialogTarget.close()
  }
  handleBackdropClick(r) {
    r.target === this.dialogTarget && this.closeModal()
  }
  dialogClosed() {
    ;(document.body.classList.remove('drawer-open'),
      this.hasModalVideoTarget &&
        (this.modalVideoTarget.pause(),
        (this.modalVideoTarget.currentTime = 0)))
  }
}
b(_r, 'targets', ['dialog', 'modalVideo'])
var $r = class extends _ {
  toggle(r) {
    let e = r.currentTarget,
      s = this.triggerTargets.indexOf(e)
    if (s === -1) return
    let i = this.contentTargets[s],
      n = this.iconTargets[s]
    i.classList.contains('hidden') ? this.open(e, i, n) : this.close(e, i, n)
  }
  open(r, e, s) {
    ;(e.classList.remove('hidden'),
      e.setAttribute('aria-hidden', 'false'),
      r.setAttribute('aria-expanded', 'true'),
      s.classList.add('rotate-180'))
  }
  close(r, e, s) {
    ;(e.classList.add('hidden'),
      e.setAttribute('aria-hidden', 'true'),
      r.setAttribute('aria-expanded', 'false'),
      s.classList.remove('rotate-180'))
  }
}
b($r, 'targets', ['trigger', 'content', 'icon'])
var Zu = 'https://api-cdn.yotpo.com/v1/widget',
  rl = new Map()
function ef(t, r) {
  return `${t}:${r}`
}
function tf(t) {
  if (typeof t != 'object' || t === null || !('response' in t)) return null
  let r = t.response
  if (typeof r != 'object' || r === null || !('bottomline' in r)) return null
  let e = r.bottomline
  if (typeof e != 'object' || e === null) return null
  let s = e
  return typeof s.average_score != 'number' || typeof s.total_review != 'number'
    ? null
    : {
        average_score: s.average_score,
        total_review: s.total_review,
        custom_fields_bottomline:
          typeof s.custom_fields_bottomline == 'object' &&
          s.custom_fields_bottomline !== null
            ? s.custom_fields_bottomline
            : void 0,
      }
}
async function rf(t, r) {
  let e = `${Zu}/${encodeURIComponent(t)}/products/${encodeURIComponent(r)}/reviews.json?per_page=1&page=1`
  console.debug('[yotpo] fetching', e)
  try {
    let s = await fetch(e)
    if ((console.debug('[yotpo] response status', s.status), !s.ok)) return null
    let i = await s.json(),
      n = tf(i)
    return (console.debug('[yotpo] parsed', n), n)
  } catch (s) {
    return (console.error('[yotpo] fetch error', s), null)
  }
}
function li(t, r) {
  let e = ef(t, r),
    s = rl.get(e)
  if (s) return s
  let i = rf(t, r)
  return (rl.set(e, i), i)
}
var Kt = class extends _ {
  connect() {
    this.appKeyValue && this.productIdValue && this.fetchAndRender()
  }
  scrollToReviews(r) {
    if (
      (r.preventDefault(),
      this.element.closest('[data-product-quick-add-value="true"]'))
    )
      return
    let e = document.getElementById('ProductReviews')
    e && e.scrollIntoView({ behavior: 'smooth' })
  }
  async fetchAndRender() {
    let r = await li(this.appKeyValue, this.productIdValue)
    r && this.render(r)
  }
  render(r) {
    if (!this.hasStarsTarget || !this.hasCountTarget) return
    let e = r.total_review
    if (e <= 0) {
      ;((this.starsTarget.innerHTML = this.starSvg(!0)),
        (this.countTarget.textContent = '0 Reviews'),
        this.element.removeAttribute('hidden'))
      return
    }
    let s = Math.ceil(r.average_score),
      i = 5 - s,
      n = ''
    for (let a = 0; a < s; a++) n += this.starSvg(!0)
    for (let a = 0; a < i; a++) n += this.starSvg(!1)
    ;((this.starsTarget.innerHTML = n),
      (this.countTarget.textContent = `(${e})`),
      this.element.removeAttribute('hidden'))
  }
  starSvg(r) {
    return `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 9 9" fill="none" height="9" width="9" aria-hidden="true"><title>${r ? 'Star Selected' : 'Star Unselected'}</title>${r ? '<path fill="currentColor" d="M4.5 0L5.51031 3.10942H8.77975L6.13472 5.03115L7.14503 8.14058L4.5 6.21885L1.85497 8.14058L2.86528 5.03115L0.220246 3.10942H3.48969L4.5 0Z"></path>' : '<path stroke="currentColor" stroke-width="0.5" d="M4.5 0.75L5.32 3.26H7.98L5.83 4.82L6.65 7.33L4.5 5.77L2.35 7.33L3.17 4.82L1.02 3.26H3.68L4.5 0.75Z"></path>'}</svg>`
  }
}
;(b(Kt, 'targets', ['stars', 'count']),
  b(Kt, 'values', {
    appKey: { type: String, default: '' },
    productId: { type: String, default: '' },
  }))
var sf = { 1: 'Too Small', 2: 'True to Size', 3: 'Too Big' },
  Xt = class extends _ {
    connect() {
      this.appKeyValue && this.productIdValue
        ? this.fetchAndRender()
        : console.warn(
            '[yotpo-customers-say] skipped: missing appKey or productId',
          )
    }
    async fetchAndRender() {
      let r = await li(this.appKeyValue, this.productIdValue)
      if (!r?.custom_fields_bottomline) return
      let e = Object.values(r.custom_fields_bottomline).find(
        (i) => i.title.toLowerCase() === 'customers say',
      )
      if (!e) return
      let s = sf[String(e.average_score)]
      s && this.render(`Runs ${s}`)
    }
    render(r) {
      this.hasLabelTarget &&
        ((this.labelTarget.textContent = r),
        this.element.removeAttribute('hidden'))
    }
  }
;(b(Xt, 'targets', ['label']),
  b(Xt, 'values', {
    appKey: { type: String, default: '' },
    productId: { type: String, default: '' },
  }))
var nf = 'https://js.klarna.com/web-sdk/v1/klarna.js',
  af = 'https://js.squarecdn.com/square-marketplace.js',
  As = null,
  Is = null
function of() {
  ;((As = null), (Is = null))
}
function sl(t, r) {
  let e = document.querySelector(`script[src="${t}"]`)
  return e
    ? e.getAttribute('data-loaded') === 'true'
      ? Promise.resolve()
      : new Promise((s, i) => {
          ;(e.addEventListener('load', () => s()),
            e.addEventListener('error', () =>
              i(new Error(`Script failed to load: ${t}`)),
            ))
        })
    : new Promise((s, i) => {
        let n = document.createElement('script')
        if (((n.src = t), (n.async = !0), r))
          for (let [a, l] of Object.entries(r)) n.setAttribute(a, l)
        ;(n.addEventListener('load', () => {
          ;(n.setAttribute('data-loaded', 'true'), s())
        }),
          n.addEventListener('error', () =>
            i(new Error(`Script failed to load: ${t}`)),
          ),
          document.body.appendChild(n))
      })
}
function lf(t) {
  return window.Klarna
    ? Promise.resolve()
    : As || ((As = sl(nf, { 'data-client-id': t })), As)
}
function cf() {
  return Is || ((Is = sl(af)), Is)
}
var Qt = class extends _ {
  static resetLoaders() {
    of()
  }
  connect() {
    this.loadAndRefresh()
  }
  async loadAndRefresh() {
    let r = []
    ;(this.klarnaClientIdValue && r.push(lf(this.klarnaClientIdValue)),
      this.element.querySelector('square-placement') && r.push(cf()))
    try {
      await Promise.all(r)
    } catch {
      return
    }
    ;(window.Klarna?.OnsiteMessaging?.refresh?.(), this.revealPlacements())
  }
  revealPlacements() {
    this.hasSkeletonTarget && this.skeletonTarget.remove()
    for (let r of this.placementTargets) r.classList.remove('hidden')
  }
}
;(b(Qt, 'targets', ['skeleton', 'placement']),
  b(Qt, 'values', { klarnaClientId: { type: String, default: '' } }))
var il = 'quick-add-ssr',
  Jt = class extends _ {
    constructor() {
      super(...arguments)
      b(this, 'panel')
      b(this, 'backdrop')
      b(this, 'content')
      b(this, 'skeleton', null)
      b(this, 'previouslyFocused', null)
      b(this, 'abortController', null)
      b(this, 'loaded', !1)
      b(
        this,
        'focusableSelectors',
        [
          'a[href]',
          'button:not([disabled])',
          'input:not([disabled])',
          'select:not([disabled])',
          'textarea:not([disabled])',
          '[tabindex]:not([tabindex="-1"])',
        ].join(', '),
      )
      b(this, 'onCartRefresh', () => {
        this.close()
      })
      b(this, 'onCloseClick', () => {
        this.close()
      })
      b(this, 'onPanelCloseClick', (e) => {
        let s = e.target
        s instanceof Element &&
          s.closest('[data-action*="quick-add#close"]') &&
          this.close()
      })
      b(this, 'onKeydown', (e) => {
        this.panel.hasAttribute('data-open') &&
          (e.key === 'Escape' && (e.stopPropagation(), this.close()),
          e.key === 'Tab' && this.handleTab(e))
      })
    }
    connect() {
      ;((this.panel = this.panelTarget),
        (this.backdrop = this.backdropTarget),
        (this.content = this.contentTarget),
        (this.skeleton = this.hasSkeletonTarget ? this.skeletonTarget : null),
        document.body.appendChild(this.backdrop),
        document.body.appendChild(this.panel),
        this.backdrop.addEventListener('click', this.onCloseClick),
        this.panel.addEventListener('click', this.onPanelCloseClick),
        document.addEventListener('keydown', this.onKeydown),
        document.addEventListener('cart:refresh', this.onCartRefresh))
    }
    disconnect() {
      ;(document.removeEventListener('keydown', this.onKeydown),
        document.removeEventListener('cart:refresh', this.onCartRefresh),
        this.backdrop.removeEventListener('click', this.onCloseClick),
        this.panel.removeEventListener('click', this.onPanelCloseClick),
        this.abortController?.abort(),
        this.restoreScroll(),
        (this.loaded = !1),
        this.backdrop.remove(),
        this.panel.remove())
    }
    open(e) {
      if (
        (e.preventDefault(),
        e.stopPropagation(),
        this.panel.hasAttribute('data-open'))
      )
        return
      let s = document.activeElement
      ;((this.previouslyFocused = s instanceof HTMLElement ? s : null),
        this.panel.removeAttribute('hidden'),
        requestAnimationFrame(() => {
          requestAnimationFrame(() => {
            ;(this.panel.setAttribute('data-open', ''),
              this.backdrop.setAttribute('data-open', ''),
              this.focusFirst(),
              this.panel.addEventListener(
                'transitionend',
                () => {
                  this.panel.hasAttribute('data-open') &&
                    (this.panel.style.translate = 'none')
                },
                { once: !0 },
              ))
          })
        }),
        this.lockScroll(),
        this.loaded || this.fetchContent())
    }
    close() {
      this.panel.hasAttribute('data-open') &&
        ((this.panel.style.translate = ''),
        this.panel.offsetHeight,
        this.panel.removeAttribute('data-open'),
        this.backdrop.removeAttribute('data-open'),
        this.previouslyFocused?.focus({ preventScroll: !0 }),
        (this.previouslyFocused = null),
        this.restoreScroll(),
        this.panel.addEventListener(
          'transitionend',
          () => {
            this.panel.hasAttribute('data-open') ||
              this.panel.setAttribute('hidden', '')
          },
          { once: !0 },
        ))
    }
    async fetchContent() {
      ;(this.abortController?.abort(),
        (this.abortController = new AbortController()),
        this.showSkeleton())
      try {
        let e = `${this.productUrlValue}?sections=${il}`,
          s = await ir(e, {
            strategy: 'SHORT',
            signal: this.abortController.signal,
          })
        if (!s.ok) throw new Error(`Failed to fetch quick add: ${s.status}`)
        let n = (await s.json())[il]
        if (!n) throw new Error('Empty quick-add section response')
        ;(this.injectContent(n), (this.loaded = !0))
      } catch (e) {
        if (e instanceof DOMException && e.name === 'AbortError') return
        console.error('[quick-add] Failed to load content:', e)
      }
    }
    injectContent(e) {
      let s = document.createElement('div')
      s.innerHTML = e
      let i = s.firstElementChild?.innerHTML ?? e
      ;((this.content.innerHTML = i),
        this.hideSkeleton(),
        this.forwardBeaconModule())
    }
    showSkeleton() {
      this.skeleton && this.skeleton.classList.remove('hidden')
    }
    hideSkeleton() {
      this.skeleton && this.skeleton.classList.add('hidden')
    }
    forwardBeaconModule() {
      let e = this.element.closest('[data-product-card-tracking-module-value]')
      if (!e) return
      let s = e.getAttribute('data-product-card-tracking-module-value')
      if (!s) return
      let i = this.content.querySelector('[data-controller~="product-cta"]')
      if (!i) return
      i.setAttribute('data-product-cta-beacon-module-value', s)
      let n = e.getAttribute('data-product-card-tracking-response-id-value')
      n && i.setAttribute('data-product-cta-beacon-response-id-value', n)
      let a = e.getAttribute('data-product-card-tracking-tag-value')
      a && i.setAttribute('data-product-cta-beacon-tag-value', a)
    }
    focusFirst() {
      this.getFocusableElements()[0]?.focus()
    }
    handleTab(e) {
      let s = this.getFocusableElements()
      if (s.length === 0) return
      let i = s[0],
        n = s[s.length - 1]
      e.shiftKey
        ? document.activeElement === i && (e.preventDefault(), n.focus())
        : document.activeElement === n && (e.preventDefault(), i.focus())
    }
    getFocusableElements() {
      return Array.from(
        this.panel.querySelectorAll(this.focusableSelectors),
      ).filter(
        (e) =>
          !e.closest('[hidden]') &&
          e.offsetParent !== null &&
          !e.closest('.hidden'),
      )
    }
    lockScroll() {
      wr(!0)
    }
    restoreScroll() {
      wr(!1)
    }
  }
;(b(Jt, 'targets', ['panel', 'backdrop', 'content', 'skeleton']),
  b(Jt, 'values', { productUrl: String, productTitle: String }))
async function nl(t) {
  t.responseId &&
    (await nt({
      module: t.module,
      event: 'impression',
      data:
        t.module === 'recommendations'
          ? {
              tag: t.tag ?? '',
              responseId: t.responseId,
              results: [t.product],
              banners: [],
            }
          : { responseId: t.responseId, results: [t.product], banners: [] },
    }))
}
async function al(t) {
  t.responseId &&
    (await nt({
      module: t.module,
      event: 'clickthrough',
      data:
        t.module === 'recommendations'
          ? { tag: t.tag ?? '', responseId: t.responseId, results: [t.product] }
          : { responseId: t.responseId, results: [t.product] },
    }))
}
var df = new Set(['search', 'category', 'autocomplete', 'recommendations']),
  Nr = class extends _ {
    constructor() {
      super(...arguments)
      b(this, 'observer', null)
      b(this, 'impressionFired', !1)
    }
    connect() {
      if (
        !(!this.responseIdValue || !this.uidValue) &&
        this.isValidModule(this.moduleValue)
      ) {
        if (typeof IntersectionObserver > 'u') {
          this.fireImpression()
          return
        }
        ;((this.observer = new IntersectionObserver(
          (e) => {
            for (let s of e)
              if (s.isIntersecting) {
                ;(this.fireImpression(),
                  this.observer?.disconnect(),
                  (this.observer = null))
                break
              }
          },
          { threshold: 0.5 },
        )),
          this.observer.observe(this.element))
      }
    }
    disconnect() {
      ;(this.observer?.disconnect(), (this.observer = null))
    }
    onClick() {
      if (
        !this.responseIdValue ||
        !this.uidValue ||
        !this.isValidModule(this.moduleValue)
      )
        return
      let e = this.moduleValue
      al({
        module: e,
        responseId: this.responseIdValue,
        product: this.buildProductRef(),
        tag: this.tagValue || void 0,
      })
    }
    fireImpression() {
      if (this.impressionFired) return
      this.impressionFired = !0
      let e = this.moduleValue
      nl({
        module: e,
        responseId: this.responseIdValue,
        product: this.buildProductRef(),
        tag: this.tagValue || void 0,
      })
    }
    buildProductRef() {
      let e = {
        type: 'product',
        parentId: this.parentIdValue || this.uidValue,
        uid: this.uidValue,
      }
      return (this.skuValue && (e.sku = this.skuValue), e)
    }
    isValidModule(e) {
      return df.has(e)
    }
  }
b(Nr, 'values', {
  module: { type: String, default: '' },
  responseId: { type: String, default: '' },
  tag: { type: String, default: '' },
  parentId: { type: String, default: '' },
  uid: { type: String, default: '' },
  sku: { type: String, default: '' },
  price: { type: Number, default: 0 },
})
var zr = class extends _ {
  constructor() {
    super(...arguments)
    b(this, 'onAdded', () => {
      Ar({
        message: this.addedMessageValue,
        variant: 'info',
        position: 'bottom-right',
        dedupe: !1,
      })
    })
    b(this, 'onRemoved', () => {
      Ar({
        message: this.removedMessageValue,
        variant: 'info',
        position: 'bottom-right',
        dedupe: !1,
      })
    })
  }
  connect() {
    ;(document.addEventListener('wk:wishlist:add:success', this.onAdded),
      document.addEventListener('wk:wishlist:remove:success', this.onRemoved))
  }
  disconnect() {
    ;(document.removeEventListener('wk:wishlist:add:success', this.onAdded),
      document.removeEventListener(
        'wk:wishlist:remove:success',
        this.onRemoved,
      ))
  }
}
b(zr, 'values', {
  addedMessage: { type: String, default: 'Added to wishlist' },
  removedMessage: { type: String, default: 'Removed from wishlist' },
})
var Y = _s.start()
Y.register('redirect', Hr)
Y.register('search-drawer', Lr)
Y.register('search-page', Rr)
Y.register('collection', Vt)
Y.register('collection-banner-swiper', ms)
Y.register('promo-message', _t)
Y.register('promo-banner', $t)
Y.register('drawer', Nt)
Y.register('sticky-nav', Ss)
Y.register('mobile-menu', Mr)
Y.register('product', vs)
Y.register('card-swiper', zt)
Y.register('product-card-swatch', Cr)
Y.register('product-cta', Ts)
Y.register('product-description', Pr)
Y.register('product-gallery', Ir)
Y.register('main-menu', kr)
Y.register('select', qt)
Y.register('variant-picker', Ut)
Y.register('sticky-mobile-cta', Or)
Y.register('video', At)
Y.register('fit-finder', Yt)
Y.register('back-to-top', jt)
Y.register('carousel', Wt)
Y.register('collapsible', Dr)
Y.register('cart-page-redirect', Br)
Y.register('localization-form', Es)
Y.register('currency-selector', Fr)
Y.register('cart-drawer', ws)
Y.register('toast', Vr)
Y.register('onetrust-toggle', Ms)
Y.register('size-guide', Ls)
Y.register('size-guide-loader', Cs)
Y.register('product-fit', _r)
Y.register('searchspring-recommendations', Pt)
Y.register('accordion', $r)
Y.register('yotpo-star-rating', Kt)
Y.register('yotpo-customers-say', Xt)
Y.register('bnpl', Qt)
Y.register('quick-add', Jt)
Y.register('product-card-tracking', Nr)
Y.register('wishlist-toast', zr)
window.Stimulus = Y
/*! Bundled license information:

dompurify/dist/purify.es.mjs:
  (*! @license DOMPurify 3.4.1 | (c) Cure53 and other contributors | Released under the Apache license 2.0 and Mozilla Public License 2.0 | github.com/cure53/DOMPurify/blob/3.4.1/LICENSE *)
*/
//# sourceMappingURL=application.js.map
